var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-59",
    cx: 250,
    cy: 329.98,
    rx: 244.16,
    ry: 157.22,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Garlands--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Festoon--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.3,48.94c-33,0-66.15-10.1-92.8-29.73l.57-.78C364.6,52,429.08,57.5,479.54,32.22l.43.86A153.51,153.51,0,0,1,411.3,48.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.07,25.2l-2.14,1.55-2.49-.87a.48.48,0,0,0-.62.6l.82,2.52L316,31.1a.48.48,0,0,0,.39.77h2.64l1.5,2.18a.48.48,0,0,0,.86-.13l.81-2.51,2.54-.76a.48.48,0,0,0,.14-.85l-2.14-1.55.07-2.65A.48.48,0,0,0,322.07,25.2Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,50.78l-.93,2.48-2.57.64a.47.47,0,0,0-.18.84L398,56.39,397.77,59a.49.49,0,0,0,.75.44L400.73,58l2.45,1a.49.49,0,0,0,.65-.58l-.7-2.55,1.7-2a.49.49,0,0,0-.35-.8l-2.64-.12-1.4-2.24A.48.48,0,0,0,399.58,50.78Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.48,37.05l-.91.67-1.06-.38a.21.21,0,0,0-.27.26l.35,1.07-.68.9a.2.2,0,0,0,.16.33h1.13l.64.93a.21.21,0,0,0,.37,0l.34-1.08,1.09-.32a.2.2,0,0,0,.06-.36l-.92-.67,0-1.12A.21.21,0,0,0,340.48,37.05Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.78,48.85l-.57,1-1.13.08a.21.21,0,0,0-.13.35l.75.84-.27,1.09a.21.21,0,0,0,.29.24l1-.45,1,.59a.2.2,0,0,0,.31-.2l-.11-1.12.86-.73a.21.21,0,0,0-.09-.36l-1.1-.24-.43-1A.21.21,0,0,0,376.78,48.85Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.57,51.12l-.56,1-1.13.09a.21.21,0,0,0-.14.34l.75.84-.26,1.1a.2.2,0,0,0,.28.23l1-.45,1,.59a.21.21,0,0,0,.31-.2l-.11-1.12.86-.73a.21.21,0,0,0-.09-.36l-1.11-.24-.43-1A.21.21,0,0,0,422.57,51.12Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.41,39.78l-.57,1-1.13.09a.21.21,0,0,0-.14.34l.76.84-.27,1.1a.21.21,0,0,0,.28.24l1-.46,1,.59a.2.2,0,0,0,.31-.19l-.11-1.13.86-.73a.21.21,0,0,0-.09-.36l-1.11-.24-.43-1A.2.2,0,0,0,474.41,39.78Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.91,42.15l-.8,2-2.12.48a.41.41,0,0,0-.17.7l1.67,1.39-.19,2.16a.4.4,0,0,0,.61.37l1.83-1.16,2,.86a.4.4,0,0,0,.54-.46l-.53-2.11,1.43-1.63a.4.4,0,0,0-.27-.66L357.74,44l-1.11-1.87A.41.41,0,0,0,355.91,42.15Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.32,47l-.8,2-2.12.48a.41.41,0,0,0-.17.7l1.67,1.39-.19,2.16a.39.39,0,0,0,.6.37L449.15,53l2,.85a.4.4,0,0,0,.54-.46l-.53-2.11,1.43-1.63a.4.4,0,0,0-.28-.66l-2.16-.14L449,47A.41.41,0,0,0,448.32,47Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.8,82.46c-30.13-11.63-57.16-31.28-76.48-57.16l-.87.65a172,172,0,0,0,60.82,50.39,177.52,177.52,0,0,0,16.53,7.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.08,84.09,474.76,87,477,89a.54.54,0,0,1-.24.94l-2.89.62-1.14,2.73a.54.54,0,0,1-1,.07l-1.48-2.57-3-.24a.54.54,0,0,1-.36-.9l2-2.2-.69-2.88a.55.55,0,0,1,.75-.63l2.7,1.21,2.53-1.54A.55.55,0,0,1,475.08,84.09Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.87,72.87l.08,1.26,1.08.65a.23.23,0,0,1,0,.42l-1.18.46-.28,1.23a.23.23,0,0,1-.4.1l-.81-1-1.26.11a.23.23,0,0,1-.22-.35l.68-1.07L449,73.54a.23.23,0,0,1,.27-.32l1.23.32.95-.83A.23.23,0,0,1,451.87,72.87Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.66,35.45l.08,1.26,1.08.65a.23.23,0,0,1,0,.42l-1.18.46-.28,1.23a.24.24,0,0,1-.41.1l-.8-1-1.26.11a.23.23,0,0,1-.22-.35l.68-1.07-.49-1.16a.23.23,0,0,1,.27-.32l1.22.32,1-.83A.23.23,0,0,1,405.66,35.45Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.15,60.9l-.21,2.42,1.89,1.55a.45.45,0,0,1-.19.78l-2.37.55-.89,2.27a.44.44,0,0,1-.79.06l-1.26-2.08-2.43-.15a.44.44,0,0,1-.31-.73l1.59-1.84-.61-2.36a.44.44,0,0,1,.6-.52l2.25.94,2.05-1.31A.45.45,0,0,1,433.15,60.9Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.24,28.18c-24.33,21.24-54.31,36-86.22,41l.17,1.07A172.11,172.11,0,0,0,96.13,40q7.35-5.26,14.16-11.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89,31.39,113.35,33,116.1,32a.55.55,0,0,1,.73.65L116,35.45l1.89,2.28a.54.54,0,0,1-.4.89l-3,.12L113,41.24a.54.54,0,0,1-1-.11l-1-2.78-2.87-.73a.54.54,0,0,1-.21-.95l2.33-1.83-.18-3A.54.54,0,0,1,110.89,31.39Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,42.12l1.15.52L99.68,42a.23.23,0,0,1,.35.22l-.14,1.26,1,.83a.23.23,0,0,1-.11.4L99.5,45,99,46.11a.23.23,0,0,1-.41,0L98,45l-1.26-.11a.23.23,0,0,1-.15-.38l.85-.94-.29-1.23A.23.23,0,0,1,97.44,42.12Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.63,72.74l1.15.52,1.08-.65a.23.23,0,0,1,.35.22l-.13,1.26,1,.82a.23.23,0,0,1-.1.4l-1.24.26-.49,1.17a.23.23,0,0,1-.41,0l-.63-1.1-1.26-.1a.23.23,0,0,1-.15-.39l.85-.93L32.31,73A.23.23,0,0,1,32.63,72.74Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.82,62.18l2,1.31,2.24-.94a.45.45,0,0,1,.61.52l-.62,2.36,1.59,1.84a.45.45,0,0,1-.31.74L63,68.15l-1.26,2.08a.45.45,0,0,1-.8-.07L60,67.89l-2.37-.55a.45.45,0,0,1-.18-.78L59.34,65l-.21-2.42A.45.45,0,0,1,59.82,62.18Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.17,47.54c-36.53,6-75,.82-108-16.06l.49-1c56.42,28.83,128.74,23.28,180-13.82l.63.88A172.06,172.06,0,0,1,136.17,47.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.19,37.45l-2.08,2.11L28.19,39a.54.54,0,0,0-.57.78L29,42.46l-1.4,2.61a.54.54,0,0,0,.57.79l2.92-.48,2,2.13a.54.54,0,0,0,.93-.29l.45-2.93L37.16,43a.55.55,0,0,0,0-1L34.52,40.7l-.4-2.94A.55.55,0,0,0,33.19,37.45Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54,51.71l-.58,2.9-2.72,1.17a.54.54,0,0,0,0,1l2.58,1.45.27,2.95a.54.54,0,0,0,.91.35l2.18-2,2.89.66a.54.54,0,0,0,.61-.76l-1.24-2.69,1.52-2.54a.54.54,0,0,0-.53-.82l-2.94.34-2-2.22A.54.54,0,0,0,123.54,51.71Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7,47.23l-.89.9-1.24-.23a.24.24,0,0,0-.25.34l.58,1.12-.59,1.12a.22.22,0,0,0,.24.33l1.25-.2.87.91a.23.23,0,0,0,.4-.13l.19-1.25,1.14-.55a.23.23,0,0,0,0-.41l-1.13-.57-.17-1.25A.23.23,0,0,0,55.7,47.23Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,53.7l-.45,1.18-1.23.3a.23.23,0,0,0-.09.4l1,.8-.09,1.26a.22.22,0,0,0,.35.21l1.06-.69,1.17.48a.23.23,0,0,0,.31-.27l-.33-1.22.82-1a.23.23,0,0,0-.16-.38l-1.27-.06-.66-1.08A.23.23,0,0,0,98,53.7Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,47.92l-.45,1.18-1.23.3a.23.23,0,0,0-.09.4l1,.8-.1,1.26a.24.24,0,0,0,.36.21l1.06-.69,1.17.48a.23.23,0,0,0,.31-.28l-.33-1.22.82-1a.23.23,0,0,0-.17-.38L150.11,49l-.66-1.07A.23.23,0,0,0,149,47.92Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.3,26l-.45,1.18-1.23.3a.23.23,0,0,0-.09.4l1,.8-.09,1.26a.23.23,0,0,0,.36.21l1.06-.69,1.16.48a.24.24,0,0,0,.32-.28L206,28.42l.82-1a.23.23,0,0,0-.17-.38L205.38,27l-.67-1.07A.23.23,0,0,0,204.3,26Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.79,52.55l-.53,2.38L78,55.84a.45.45,0,0,0-.06.8l2.1,1.23.17,2.43a.44.44,0,0,0,.74.3L82.78,59l2.37.59a.45.45,0,0,0,.51-.62l-1-2.23L86,54.67a.45.45,0,0,0-.42-.68l-2.43.23-1.56-1.86A.45.45,0,0,0,80.79,52.55Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.77,38.7l-.53,2.37L174,42a.45.45,0,0,0,0,.8L176,44l.18,2.43a.44.44,0,0,0,.74.3l1.82-1.61,2.36.58a.45.45,0,0,0,.52-.61l-1-2.23L182,40.81a.45.45,0,0,0-.43-.68l-2.42.24-1.57-1.86A.44.44,0,0,0,176.77,38.7Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-59",
    cx: 341.78,
    cy: 227.99,
    rx: 43.35,
    ry: 25.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M336.53,175.34a12.35,12.35,0,0,1,5.17.68,4.21,4.21,0,0,1,2.7,4.09A5,5,0,0,1,343,182.7c-3.21,3.44-8,4.67-12.46,6.27-9.5,3.46-18,9.23-26.34,14.9s-16.91,11.37-26.48,14.63-20.47,3.86-29.57-.56c-3-1.47-5.8-3.46-8.93-4.71-4.38-1.75-9.32-2-13.48-4.21a8.29,8.29,0,0,1-4.85-7.46c-.38-4.93,1.76-9.82,5-13.55a38.5,38.5,0,0,1,11.94-8.62,80.75,80.75,0,0,1,39.34-8.47c5.63.23,12.5.49,17.83,2.47C307.62,178.1,323.22,175.5,336.53,175.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M476.19,261.61a12.35,12.35,0,0,1,5.17.68,4.21,4.21,0,0,1,2.7,4.08,4.91,4.91,0,0,1-1.43,2.6c-3.21,3.44-8,4.66-12.46,6.27-9.5,3.45-18,9.23-26.34,14.9s-16.9,11.37-26.48,14.63-20.47,3.86-29.57-.56c-3-1.47-5.8-3.46-8.93-4.71-4.38-1.76-9.32-2-13.48-4.21a9.58,9.58,0,0,1-3.23-2.62,9.46,9.46,0,0,1-1.62-4.85c-.38-4.92,1.76-9.81,5-13.54a38.34,38.34,0,0,1,11.94-8.62,80.75,80.75,0,0,1,39.34-8.47c5.63.23,12.5.48,17.83,2.47C447.28,264.37,462.88,261.77,476.19,261.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-59",
    points: "465.56 371.19 298.71 467.4 43.44 320.04 210.28 223.83 465.56 371.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-59",
    cx: 102.82,
    cy: 240.5,
    rx: 62.63,
    ry: 36.16,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-59",
    cx: 409.57,
    cy: 434.55,
    rx: 17.92,
    ry: 10.35,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M452.6,410.94c7.36,4.25,7.36,11.15,0,15.4s-19.31,4.25-26.68,0-7.37-11.15,0-15.4S445.23,406.69,452.6,410.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-59",
    cx: 39.75,
    cy: 327.81,
    rx: 18.86,
    ry: 10.89,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M182.41,413.32c-10.54-4.85-25.09-8.47-31.25,4.6-1.88,4-2.43,8.47-2.69,12.87-.38,6.47-.17,13.07,1.78,19.25,3.75,11.83,14.45,18.75,25.34,23.4,12.29,5.26,27.47,4.91,40.42,2.7a120.11,120.11,0,0,0,37.76-13.63c7.78-4.31,18.26-10.43,16.79-20.78-1-7.25-7.17-9.55-13.67-10.46-5.2-.73-10.49-.33-15.74-.09-5.6.25-11.22.31-16.84.28-7.58,0-14.46-.88-20.91-4.92C196.39,422.15,190,416.8,182.41,413.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M90.28,368c-8.19-3.77-19.51-6.58-24.3,3.58a27.12,27.12,0,0,0-2.09,10,41.44,41.44,0,0,0,1.39,15c2.91,9.21,11.23,14.59,19.7,18.21,9.56,4.08,21.37,3.82,31.44,2.1a93.32,93.32,0,0,0,29.37-10.61c6.05-3.35,14.2-8.11,13.06-16.16-.79-5.64-5.58-7.43-10.63-8.14a66.71,66.71,0,0,0-12.24-.07c-4.36.2-8.73.25-13.1.22-5.9,0-11.25-.68-16.27-3.83C101.16,374.9,96.16,370.74,90.28,368Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.46,193.7s20.47-7.63,23-9.71c2.11-1.73.81-5.83,3.74-6.55,3.37-.83,5.8,1,8,2.94s4.75,2.71,9.8.93,9.91-4.31,12-3.33.69,2.57-8.12,6.71c-5.07,2.39-11.53,5.16-15.67,6.82a34.31,34.31,0,0,0-8.36,4.59c-5.39,3.82-6.37,4.63-12.75,8.51-12.74,7.75-20.25,9.82-30.44,7.95Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.61,186c4.1,2.32,6.08,4.9,6.35,9.41,0,0-2.74,2.15-7.07,5.19-5.19,3.65-17.76,12-26.18,12.86-14.76,1.56-19.45-2.9-19.45-2.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.42,188.9c-6.62,11.31-22.93,18.43-28.05,19,1.8-1.5,4.43-6.57,6.92-12.07l17.32-9.8A15.33,15.33,0,0,1,300.42,188.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.71,177a2.75,2.75,0,0,0-.5-2.34,17,17,0,0,0-5.71-4,12.6,12.6,0,0,0-6.12-1.1c-4,.26-7.44,3.28-11.44,3.54-3,.19-5.72-1.32-8.64-2a9.42,9.42,0,0,0-2.81-.22,3.17,3.17,0,0,0-2.35,1.3,3.48,3.48,0,0,0-.2,2.58,7,7,0,0,0,2.1,2.12,14,14,0,0,0,4.1,1.45C311.26,179.49,329.67,179.8,338.71,177Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.34,182.87c0,.37-.06.72-.09,1.09s.22.65.63.93c1.7,1.14,3.83,1,5.75.67a12.61,12.61,0,0,1,4.51-.42c1.79.34,3.22,1.63,4.56,2.87a3.54,3.54,0,0,1,.73.93s10.31-4.48,15-7c2.38-1.27,5.12-2.47,7-4.47.1-.11-.46-.81-.52-.87a4.41,4.41,0,0,0-2.39-1.32A12.2,12.2,0,0,0,331,175c-2.32.36-4.56,1-6.85,1.46a59.76,59.76,0,0,1-6.22.91,47.33,47.33,0,0,1-6.84.16,17,17,0,0,1-6.23-1.28,8.87,8.87,0,0,1-2.15-1.3,6.29,6.29,0,0,1-1-1.25c-.33-.45-.53-1.22-.85-.57a12.22,12.22,0,0,0-.8,5.7c.08,1.2.25,2.39.3,3.59A3.38,3.38,0,0,1,300.34,182.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.81,185.25c3.06-9.89,10.83-16.13,18.37-22.54S266,148.11,266,148.11h0l40.12-8.36c2.7,5.42,7.9,15.28,8,23.19.05,7.38-2.13,17.28-15,26.94-7.8,5.87-14,10.47-19.6,14.07-5.9,3.81-18.94,10.53-26.68,8-5.32-1.76-6.53-6.81-6.51-11.68h0c-.91.09-1.81.14-2.65.16s-1.88,0-2.58,0a21.55,21.55,0,0,1-7.53-1.09A11.62,11.62,0,0,1,226.81,185.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.19,200.39c.84,0,1.25-.06,2.16-.15.88-10.36,31.49-31.61,31.49-31.61-2.12-1-7-3.6-8.69-6.54.69,3.75,2.86,5.64,5,7.15-3.19,2.9-17.23,13.62-20.8,17.06C249.55,189.92,244.74,192.66,244.19,200.39Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.23,137.07c-2.67.73-5.53-.11-9.09,1.56s-4.94,2.9-6.71,3.38c-2.76.75-1.61,2.61.92,2.86a23.12,23.12,0,0,0,5.55-.69,14.06,14.06,0,0,0-3.9,6.6c-.75,3.37.25,6.76,2,8.15s5,2.63,6.56-1.3,1.84-7.06,5.39-9.06S237.23,137.07,237.23,137.07Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.23,89.73c-5.57.25-10.25,3-13.15,10.82s-6.69,26-7.77,27.72-13.88,8.86-13.88,8.86l1.85,11.55s22.47-6.45,26.55-10,4.83-9.24,6-14.57S271.23,89.73,271.23,89.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.23,155.35c8.65-5.54,8.71-13.93,8.71-13.93a60.93,60.93,0,0,1-1.32-13.53c-8.41-6.23-4.42-13.93-1.77-19.91,5.31-12,9-17.07,12.51-17.89l19.25-.6s12.36,2.59,16.52,3.89c7,2.2,4.46,12.62,3.81,16.49-1.77,10.51-2.24,14.15-2.94,18.49-1,6.26-.34,9.54.93,14.37.93,3.54,6.85,16.43,4,27.3s-8,16.06-29.51,31.65c0,0-10-15.33-24.46-23.69-13.11-7.58-17.66-8.14-23.49-7.52A91.73,91.73,0,0,1,254.23,155.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18,127.9a11.41,11.41,0,0,0,11.28,5.16,12.06,12.06,0,0,0,9.71-7.19s.34,8.41-9.56,9.2S276.18,127.9,276.18,127.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.06,85c1.48-1.6,2.45-4.84,5.94-8.44,4.85-5,7.94-13.47,2.44-20.76s-16.25-8.2-23.51-6.9c-9.79,1.76-10.61,13.32-10.61,13.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,69.93c-2.73-11-10.13-15-18.35-14.91-4.09.06-8.74.72-9.07,13.5-.25,10,3.07,14.82,4.72,15.81s3.73,1.34,7.08,1.22l-.38,5.66s-4.65,3.38-2.68,8.71a33.74,33.74,0,0,0,9.46-2c6.8-2.82,7.64-5.76,7.64-5.76L291.69,77S292.61,72.18,292.05,69.93Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.87,66.27a1.64,1.64,0,0,0,1.31,1.86A1.55,1.55,0,0,0,282,66.87,1.65,1.65,0,0,0,280.69,65,1.54,1.54,0,0,0,278.87,66.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.05,62.83l3.54-1.37a1.83,1.83,0,0,0-2.4-1.12A2,2,0,0,0,267.05,62.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.11,61.62l3.23,2a1.81,1.81,0,0,0-.55-2.58A2,2,0,0,0,280.11,61.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,65.73a1.65,1.65,0,0,0,1.31,1.86,1.55,1.55,0,0,0,1.83-1.26,1.63,1.63,0,0,0-1.31-1.85A1.53,1.53,0,0,0,268,65.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.41,64l-1.18,9.16-4.86-.79A16.69,16.69,0,0,1,276.41,64Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.3,75.22,275.11,77a2.69,2.69,0,0,0,3.44,1.8A2.87,2.87,0,0,0,280.3,75.22Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.55,78.81a2.84,2.84,0,0,0,1.88-2.48l-.34,0a3.72,3.72,0,0,0-3.48,2.4A2.59,2.59,0,0,0,278.55,78.81Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,81.18c-.27,1.69.24,6.3,1,7.46s2,1.72,2.1,3.81L299.07,92s-3.54,9.09-13.6,16.81-16.37,5.27-17.33,1.43c-1.36-5.42,1.58-16.84,2.59-19.4s2.2-2.91,2.2-2.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,81.18c-.27,1.69.24,6.3,1,7.46s2,1.72,2.1,3.81L299.07,92s-3.54,9.09-13.6,16.81-16.37,5.27-17.33,1.43c-1.36-5.42,1.58-16.84,2.59-19.4s2.2-2.91,2.2-2.91Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.13,81.18a16.34,16.34,0,0,1-3.61,10.12c-3.95,5.23-11.72,7.47-17.95,6s-7.28-4.41-4.63-6.87S299.13,81.18,299.13,81.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.59,92.85a2.47,2.47,0,0,0,1,1.35c1,.78,3,1.67,6.76,2a18.74,18.74,0,0,0,7-.72h0c6.08-1.85,12-7.28,12.08-19.63h0a8.26,8.26,0,0,1-2.08,2c-3.65,2.44-5.65-.83-5.65-.83-1.11,2.87-1.68,4.47-4.5,6.28-3.56,2.28-10.76,2.23-10.76,2.23l-.93,0a20.16,20.16,0,0,1-2.08-.07l-.44,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.59,92.85a2.47,2.47,0,0,0,1,1.35c1,.78,3,1.67,6.76,2a18.74,18.74,0,0,0,7-.72h0c6.08-1.85,12-7.28,12.08-19.63h0a8.26,8.26,0,0,1-2.08,2c-3.65,2.44-5.65-.83-5.65-.83-1.11,2.87-1.68,4.47-4.5,6.28-3.56,2.28-10.76,2.23-10.76,2.23l-.93,0a20.16,20.16,0,0,1-2.08-.07l-.44,0h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,69.93s.26-10.77-4.77-15.43S272,50,269.43,52.41s-5.95,11.92-4.2,23.74c0,0-2.05-5.13-.77-16.32s10.25-17.51,19.78-16.73,15.43,4.51,19.29,12.57,4.6,37.71,4.6,37.71a16.42,16.42,0,0,0-4.33-.63C293.63,93,291.21,86,291.7,76.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,69.93s.26-10.77-4.77-15.43S272,50,269.43,52.41c-1.78,1.72-4,6.85-4.54,13.8a43.4,43.4,0,0,0,.34,9.94s-2.05-5.13-.77-16.32,10.25-17.51,19.78-16.73,15.43,4.51,19.29,12.57,4.6,37.71,4.6,37.71a16.42,16.42,0,0,0-4.33-.63C293.63,93,291.21,86,291.7,76.63Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gola-kabab--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plate--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.66,137.84c-10.69-6.17-28-6.17-38.7,0-5.34,3.08-8,7.12-8,11.17v2c0,4,2.66,8.09,8,11.17,10.69,6.17,28,6.17,38.7,0,5.34-3.08,8-7.12,8-11.17v-2C280.67,145,278,140.92,272.66,137.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.31,
    cy: 149.01,
    rx: 27.36,
    ry: 15.8,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.31,137.07c6.64,0,12.83,1.46,17.42,4.11,3.92,2.27,6.08,5,6.08,7.83s-2.16,5.55-6.08,7.82c-4.59,2.65-10.78,4.11-17.42,4.11s-12.82-1.46-17.41-4.11c-3.92-2.27-6.08-5-6.08-7.82s2.16-5.56,6.08-7.83c4.59-2.65,10.77-4.11,17.41-4.11m0-1.54c-6.91,0-13.37,1.53-18.19,4.31-4.42,2.56-6.85,5.81-6.85,9.17s2.43,6.61,6.85,9.16c4.82,2.78,11.28,4.31,18.19,4.31s13.37-1.53,18.19-4.31c4.42-2.55,6.85-5.81,6.85-9.16s-2.43-6.61-6.85-9.17c-4.82-2.78-11.28-4.31-18.19-4.31Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lettuce--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letuce--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.17,146.54c-.09-.06-.64.39-.69.48a1,1,0,0,0-.1.62c.05.52.4,1,.38,1.53a2.76,2.76,0,0,1-.85,2.14c-.69.61-1.63.71-2.19,1.48s-.8,1.74-1.31,2.53c-1.1,1.71-3.1,0-4.37,1.08a4.14,4.14,0,0,0-.76,1.32,2.88,2.88,0,0,1-1,1.07,4.73,4.73,0,0,1-3.22.93,6.86,6.86,0,0,0-1.73-.23,4.09,4.09,0,0,0-2.15,1.52,4.86,4.86,0,0,1-2.81,1.65c-1.14.09-2.3-.28-3.42.05-.44.13-.85.36-1.29.52a3.89,3.89,0,0,1-2.19.15,7.52,7.52,0,0,0-2.3-.49,9.56,9.56,0,0,0-1.17.3,3.2,3.2,0,0,1-3.93-2.94c0-.42,0-.84,0-1.26-.05-1.06-.81-1.86-.67-3a3.39,3.39,0,0,1,1.71-2.44,15.88,15.88,0,0,0,1.45-.82,1.84,1.84,0,0,0,.83-1.33,5.52,5.52,0,0,1,.18-1.81,3.06,3.06,0,0,1,1.75-1.67,7.41,7.41,0,0,1,2.43-.44,3,3,0,0,0,2-.56,6.29,6.29,0,0,0,.5-.63,3.78,3.78,0,0,1,2.93-1.24,16.32,16.32,0,0,1,3.25.46,2.81,2.81,0,0,0,1.65-.05,5.58,5.58,0,0,0,1-.78,4.52,4.52,0,0,1,3.74-.5,6.31,6.31,0,0,0,2.83.38,18.68,18.68,0,0,1,2.07-.79,4.69,4.69,0,0,1,2.49.81,3.7,3.7,0,0,0,2.63.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.17,146.54c-.09-.06-.64.39-.69.48a1,1,0,0,0-.1.62c.05.52.4,1,.38,1.53a2.76,2.76,0,0,1-.85,2.14c-.69.61-1.63.71-2.19,1.48s-.8,1.74-1.31,2.53c-1.1,1.71-3.1,0-4.37,1.08a4.14,4.14,0,0,0-.76,1.32,2.88,2.88,0,0,1-1,1.07,4.73,4.73,0,0,1-3.22.93,6.86,6.86,0,0,0-1.73-.23,4.09,4.09,0,0,0-2.15,1.52,4.86,4.86,0,0,1-2.81,1.65c-1.14.09-2.3-.28-3.42.05-.44.13-.85.36-1.29.52a3.89,3.89,0,0,1-2.19.15,7.52,7.52,0,0,0-2.3-.49,9.56,9.56,0,0,0-1.17.3,3.2,3.2,0,0,1-3.93-2.94c0-.42,0-.84,0-1.26-.05-1.06-.81-1.86-.67-3a3.39,3.39,0,0,1,1.71-2.44,15.88,15.88,0,0,0,1.45-.82,1.84,1.84,0,0,0,.83-1.33,5.52,5.52,0,0,1,.18-1.81,3.06,3.06,0,0,1,1.75-1.67,7.41,7.41,0,0,1,2.43-.44,3,3,0,0,0,2-.56,6.29,6.29,0,0,0,.5-.63,3.78,3.78,0,0,1,2.93-1.24,16.32,16.32,0,0,1,3.25.46,2.81,2.81,0,0,0,1.65-.05,5.58,5.58,0,0,0,1-.78,4.52,4.52,0,0,1,3.74-.5,6.31,6.31,0,0,0,2.83.38,18.68,18.68,0,0,1,2.07-.79,4.69,4.69,0,0,1,2.49.81,3.7,3.7,0,0,0,2.63.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.84,156.29a7.7,7.7,0,0,1-2.44-.45,1,1,0,0,0,.35,0h.42l.81,0c.53,0,1.07-.06,1.6-.1s1.07-.11,1.6-.18a8.75,8.75,0,0,0,1.45-.22c.32-.1.63-.21,1-.28s.84-.28,1.26-.41a1,1,0,0,0-.34,0,8.68,8.68,0,0,1-1,0l-1-.08a1.35,1.35,0,0,0-.49,0,4.36,4.36,0,0,1,.62-.07c.27,0,.54-.08.81-.13l1.13-.17a14.22,14.22,0,0,0,1.7-.46l.89-.28.46-.15c.07,0,.38-.17.43-.14a.6.6,0,0,0-.2,0l-.91,0a7.69,7.69,0,0,1-1.66-.2c.15-.14.59-.14.78-.17s.48-.16.72-.2a5.25,5.25,0,0,0-.71-.13c-.61-.14-1.23-.28-1.85-.39l-1-.2a4.13,4.13,0,0,1-.77-.19,1.68,1.68,0,0,1,.55,0c.35,0,.71,0,1.07,0,.65,0,1.3,0,2,0s1.1-.05,1.65-.1c.17,0,.93,0,1-.15a10.18,10.18,0,0,0-1.12-.28c-.28-.09-.57-.22-.84-.29.74,0,1.47.15,2.21.13a18.4,18.4,0,0,0,2.23-.11l1.47-.2a5.41,5.41,0,0,0,1.14-.17,1.79,1.79,0,0,0-.58-.18,6.8,6.8,0,0,1-1.16-.37,12.46,12.46,0,0,1-2-.83c.7.07,1.4.25,2.1.34a13.73,13.73,0,0,0,3.62.12,3.07,3.07,0,0,0,1.83-.53,2.88,2.88,0,0,0-1.1-.15c-.35,0-1,0-1.29-.27a1.55,1.55,0,0,1,.43,0,4.36,4.36,0,0,0,.72-.05,4,4,0,0,0,.71-.12,3,3,0,0,0-.59-.22A1.33,1.33,0,0,1,268,148l.69-.08a3.94,3.94,0,0,0,.7-.09,1.44,1.44,0,0,0-.47-.15,12.84,12.84,0,0,1-1.36-.47c-.33-.15-.65-.26-1-.38-.11,0-.42-.12-.44-.25a1.82,1.82,0,0,1,.46.11,6.91,6.91,0,0,0,.9.21c.53.09,1.07.14,1.6.21a12.32,12.32,0,0,0,1.92.15,15.74,15.74,0,0,0,1.82-.11c.34-.05.67-.13,1-.15.12,0,.36-.06.34.11s-.21.28-.26.34c-.16.25-.33.49-.5.73a34.73,34.73,0,0,0-2,3.12,13.06,13.06,0,0,1,.44-1.51,5,5,0,0,0,.26-.91c-.27.1-.44.36-.68.47a3.81,3.81,0,0,1,.47-.8,5.79,5.79,0,0,1,.45-.65c-.42,0-.91.45-1.27.65s-.95.53-1.41.82a7.86,7.86,0,0,0-1.2.88,17.76,17.76,0,0,0-1.88,1.9,2.1,2.1,0,0,1-.37.36c.16-.44.35-.87.53-1.3s.28-.57.43-.84.2-.31.3-.47a1.28,1.28,0,0,0,.19-.34,4.27,4.27,0,0,0-.66.45,10.66,10.66,0,0,0-.91.72c-.31.27-.63.55-.93.83a5.39,5.39,0,0,0-.6.57,10.71,10.71,0,0,1-1.05,1.08,2.18,2.18,0,0,0,.11-.27c.11-.23.24-.44.36-.66s.28-.51.43-.75a1.56,1.56,0,0,0,.34-.6,9.38,9.38,0,0,0-2.08,1,10.16,10.16,0,0,0-1.1.86c-.28.24-.56.5-.84.76a7.84,7.84,0,0,1-.65.64,3.46,3.46,0,0,1,.39-.93c.11-.19.25-.37.37-.55a.37.37,0,0,0,.1-.21,1.7,1.7,0,0,0-.61.45l-.78.79c-.42.41-.8.85-1.22,1.25s-.77.79-1.17,1.17-.47.54-.74.76a4.86,4.86,0,0,1,.8-1.61,16.21,16.21,0,0,1,1.12-1.59c-.06.08-.33.15-.43.21l-.46.25c-.33.15-.68.22-1,.38s-.87.5-1.31.74a7.36,7.36,0,0,0-1.14.69l-.71.59c-.57.49-1.1,1-1.64,1.54a8.79,8.79,0,0,0-.8.92,8.32,8.32,0,0,0-.59.74,2.41,2.41,0,0,0,.21-.55c.19-.44.38-.89.61-1.31s.56-.86.85-1.28c0-.08.22-.22.22-.32l-.37,0C251.13,156.3,250.48,156.34,249.84,156.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.84,160.06c9.89-6.11,25.71-12.35,30.33-13.52a4.17,4.17,0,0,0-2.36-1.65S256,153.1,246.84,160.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.84,160.06c9.89-6.11,25.71-12.35,30.33-13.52a4.17,4.17,0,0,0-2.36-1.65S256,153.1,246.84,160.06Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,146.3a5.27,5.27,0,0,0-1.54-1.2,197.07,197.07,0,0,0-24.37,12.28C261.7,151.77,273.91,146.94,277,146.3Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.18,156.33a3.49,3.49,0,0,0-.81.72c-.2.22-.38.47-.56.7a6.87,6.87,0,0,0-.74,1.18,15.2,15.2,0,0,0-.76,1.82c-.08.23-.18.48-.29.74a11.53,11.53,0,0,1,.18-1.67,8.6,8.6,0,0,1,.46-1.57c-.63.34-.88,1.31-1.13,1.94s-.51,1.43-.78,2.15c-.11.31-.22.64-.35,1l.22-.08c.44-.16.85-.39,1.29-.52a5.7,5.7,0,0,1,2.14-.08,2.76,2.76,0,0,1-.08-.27,2.8,2.8,0,0,1,0-1,8.81,8.81,0,0,1,.25-1.22,7.35,7.35,0,0,1,.59-1.48,2.82,2.82,0,0,0-.7.76,3.55,3.55,0,0,0-.53.9c0-.24.07-.41.1-.6a7.07,7.07,0,0,1,.22-.88,9.94,9.94,0,0,1,.39-1.12,6.8,6.8,0,0,1,.38-.7C255.81,156.82,256,156.44,256.18,156.33Zm-7,4.07a7.44,7.44,0,0,1,.74-1.35c-1,.41-1.74,1.83-2.17,2.78a5.39,5.39,0,0,1,.05-1.27,9.44,9.44,0,0,0-1.33,2.49,3.2,3.2,0,0,1,.68-.16,4,4,0,0,1,1.63.3h0A6,6,0,0,1,249.16,160.4Zm13.26-2.64c-.25.35-.36.47-.63.91a21.71,21.71,0,0,1,.6-2.85,12.25,12.25,0,0,1,1-2.66,17.77,17.77,0,0,0-2.43,3.7,12.1,12.1,0,0,0-.86,1.82c-.11.32-.29.86-.38,1.1a7,7,0,0,1,.05-2.16,6.63,6.63,0,0,0-.89,1.69c-.27.67-.56,1.33-.8,2a5.46,5.46,0,0,1-.35.82,8.05,8.05,0,0,0,1.37-1.14,4.09,4.09,0,0,1,2.15-1.52,5.26,5.26,0,0,1,1.51.19.34.34,0,0,1,0-.1,13.53,13.53,0,0,1,.21-1.68,10,10,0,0,1,.28-1.11A4.8,4.8,0,0,0,262.42,157.76Zm13.48-9.42a5.14,5.14,0,0,0-1.22,2c-.1.3-.39,1.17-.55,1.62a5.64,5.64,0,0,1,0-1.94,9.73,9.73,0,0,0-.58,2c-.14.56-.23,1.13-.34,1.7a5.61,5.61,0,0,1,.49-.86,3.27,3.27,0,0,1,1.35-.95A12.71,12.71,0,0,1,275.9,148.34Zm-5.54,6.32a10.55,10.55,0,0,1,.66-2,2.91,2.91,0,0,0-1,1.34,12.35,12.35,0,0,1,.72-3.58,9.76,9.76,0,0,0-2,3.23c-.21.51-.44,1-.6,1.55a1.87,1.87,0,0,1-.14.4c0-.35,0-.75,0-1.07a32.62,32.62,0,0,1-2,4.37L266,159l.28-.18a2.88,2.88,0,0,0,1-1.07,4.14,4.14,0,0,1,.76-1.32,2.72,2.72,0,0,1,2.19-.32A5.69,5.69,0,0,1,270.36,154.66Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.83,150a25.31,25.31,0,0,1-5.88-1.65,13.73,13.73,0,0,1-2.76-1.32,7.89,7.89,0,0,1-1-.78l0,0a6.29,6.29,0,0,1-.5.63,3,3,0,0,1-2,.56c-.32,0-.65,0-1,.08a10.06,10.06,0,0,1,1.62.31c1.27.36,2.46,1,3.7,1.4a12.86,12.86,0,0,0,3.4.75,11,11,0,0,1-3.15-1.44C258.5,150,261.33,150.12,261.83,150Zm-15.14,1.4a5.46,5.46,0,0,1-1.31-.63c0,.21,0,.42,0,.63a1.84,1.84,0,0,1-.83,1.33,15.88,15.88,0,0,1-1.45.82l-.11.07a7.17,7.17,0,0,1,.81,0c2,.09,5,.73,6.91.34a11.17,11.17,0,0,1-4.09-.9,20.16,20.16,0,0,0,3.9.37c1.68,0,3.29-.22,5-.31-1.24-.09-2.48-.13-3.71-.24a22.75,22.75,0,0,1-3.1-.53,10.53,10.53,0,0,0,3.28-.45A14.07,14.07,0,0,1,246.69,151.41ZM242,157.27l-.53-.13a7.3,7.3,0,0,1,.54,1.85c0,.37,0,.74,0,1.11.38-.15.76-.29,1.16-.41.77-.23,1.55-.42,2.32-.67a6.81,6.81,0,0,0,2.08-.8,9,9,0,0,1-2.25.39,8,8,0,0,1-2-.22,12.49,12.49,0,0,0,2.46-.36,18.06,18.06,0,0,0,2.27-.82,19.32,19.32,0,0,1-2.65.32A14.08,14.08,0,0,1,242,157.27Zm28.78-11.56a12.64,12.64,0,0,1-1.89-.74,8.18,8.18,0,0,1-.92-.53l-.39.13a5.23,5.23,0,0,1-2.49-.29c.9.51,1.68.9,2.65,1.34a13.7,13.7,0,0,0,3,.94,6.36,6.36,0,0,1-2.35-1.34A7.8,7.8,0,0,0,270.82,145.71Zm-3.72,2.11a11,11,0,0,1-4.36-1.79,6.85,6.85,0,0,1-1.41-1.52,2.2,2.2,0,0,0-.28.18,5.58,5.58,0,0,1-1,.78,2,2,0,0,1-1,.14l2.48,1.36a10.44,10.44,0,0,0,4.26,1.55,8.62,8.62,0,0,1-3.38-1.77A12.66,12.66,0,0,0,267.1,147.82Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lettuce--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--letuce--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.45,151.32c0-.1.74-.14.83-.11a1,1,0,0,1,.49.4c.32.41.38,1,.75,1.38a2.77,2.77,0,0,0,2.07,1c.92,0,1.68-.57,2.61-.37s1.77.75,2.68,1c2,.53,2.29-2.09,4-2.13a3.7,3.7,0,0,1,1.44.47,2.94,2.94,0,0,0,1.5.09,4.76,4.76,0,0,0,3-1.48,6.86,6.86,0,0,1,1.13-1.33,4.12,4.12,0,0,1,2.61-.32,4.89,4.89,0,0,0,3.19-.65c.9-.7,1.51-1.76,2.56-2.27.42-.2.88-.3,1.31-.47a3.94,3.94,0,0,0,1.73-1.37,7.31,7.31,0,0,1,1.37-1.91,9.08,9.08,0,0,1,1.07-.56,3.21,3.21,0,0,0,.94-4.82c-.27-.32-.59-.6-.86-.92-.68-.82-.66-1.92-1.52-2.66a3.36,3.36,0,0,0-2.9-.66,15.68,15.68,0,0,1-1.62.36,1.79,1.79,0,0,1-1.51-.43,5.82,5.82,0,0,0-1.36-1.21,3,3,0,0,0-2.41-.06,7.37,7.37,0,0,0-2.1,1.3,3,3,0,0,1-1.83.9,6.85,6.85,0,0,1-.79-.13,3.78,3.78,0,0,0-3,1,15.87,15.87,0,0,0-2.1,2.52,2.77,2.77,0,0,1-1.26,1.07,5.54,5.54,0,0,1-1.29.12,4.51,4.51,0,0,0-3.1,2.14,6.24,6.24,0,0,1-1.85,2.18,18.35,18.35,0,0,0-2.06.81,4.67,4.67,0,0,0-1.3,2.27,3.66,3.66,0,0,1-1.75,2S227.46,151.31,227.45,151.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.45,151.32c0-.1.74-.14.83-.11a1,1,0,0,1,.49.4c.32.41.38,1,.75,1.38a2.77,2.77,0,0,0,2.07,1c.92,0,1.68-.57,2.61-.37s1.77.75,2.68,1c2,.53,2.29-2.09,4-2.13a3.7,3.7,0,0,1,1.44.47,2.94,2.94,0,0,0,1.5.09,4.76,4.76,0,0,0,3-1.48,6.86,6.86,0,0,1,1.13-1.33,4.12,4.12,0,0,1,2.61-.32,4.89,4.89,0,0,0,3.19-.65c.9-.7,1.51-1.76,2.56-2.27.42-.2.88-.3,1.31-.47a3.94,3.94,0,0,0,1.73-1.37,7.31,7.31,0,0,1,1.37-1.91,9.08,9.08,0,0,1,1.07-.56,3.21,3.21,0,0,0,.94-4.82c-.27-.32-.59-.6-.86-.92-.68-.82-.66-1.92-1.52-2.66a3.36,3.36,0,0,0-2.9-.66,15.68,15.68,0,0,1-1.62.36,1.79,1.79,0,0,1-1.51-.43,5.82,5.82,0,0,0-1.36-1.21,3,3,0,0,0-2.41-.06,7.37,7.37,0,0,0-2.1,1.3,3,3,0,0,1-1.83.9,6.85,6.85,0,0,1-.79-.13,3.78,3.78,0,0,0-3,1,15.87,15.87,0,0,0-2.1,2.52,2.77,2.77,0,0,1-1.26,1.07,5.54,5.54,0,0,1-1.29.12,4.51,4.51,0,0,0-3.1,2.14,6.24,6.24,0,0,1-1.85,2.18,18.35,18.35,0,0,0-2.06.81,4.67,4.67,0,0,0-1.3,2.27,3.66,3.66,0,0,1-1.75,2S227.46,151.31,227.45,151.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.25,140.19a8,8,0,0,0,1.51-2c0,.08-.2.18-.26.24l-.32.28-.61.52c-.41.35-.83.68-1.25,1s-.86.64-1.3,1a10.15,10.15,0,0,1-1.24.81c-.29.14-.6.27-.89.43s-.81.36-1.21.55a.91.91,0,0,1,.24-.24,9.94,9.94,0,0,0,.76-.68l.65-.7c.1-.11.21-.29.35-.35a3.68,3.68,0,0,0-.51.37c-.22.16-.46.29-.69.44l-.95.64c-.5.31-1,.54-1.57.8l-.85.39-.44.2c-.06,0-.39.12-.41.18a.48.48,0,0,1,.13-.16l.65-.64a7.25,7.25,0,0,0,1.09-1.26c-.2,0-.53.29-.7.4s-.45.2-.66.33a5.79,5.79,0,0,1,.44-.57c.36-.52.72-1,1.1-1.54l.62-.82a3.3,3.3,0,0,0,.44-.66,1.74,1.74,0,0,0-.42.35c-.26.24-.54.46-.79.71-.47.46-1,.89-1.46,1.32s-.84.71-1.28,1c-.14.1-.69.64-.85.56a9.54,9.54,0,0,1,.65-1c.14-.26.27-.54.42-.78-.54.5-1,1.1-1.55,1.58a21.25,21.25,0,0,1-1.72,1.42l-1.23.84a6.17,6.17,0,0,1-1,.64,1.79,1.79,0,0,1,.31-.53,6.84,6.84,0,0,0,.61-1,12.06,12.06,0,0,0,.92-2c-.47.53-.87,1.14-1.33,1.68a14.37,14.37,0,0,1-2.6,2.51,3.11,3.11,0,0,1-1.72.84c.1-.32.51-.62.73-.85s.73-.7.77-1.07a1.75,1.75,0,0,0-.32.29,6.26,6.26,0,0,1-.57.45,4.85,4.85,0,0,1-.61.39,3.06,3.06,0,0,1,.29-.57c-.13,0-.25.18-.37.26s-.38.28-.57.41a4,4,0,0,1-.58.4,1.72,1.72,0,0,1,.25-.43,11.89,11.89,0,0,0,.7-1.26,10.3,10.3,0,0,1,.47-.94c.06-.11.24-.37.16-.48a1.33,1.33,0,0,0-.26.39c-.16.26-.35.52-.53.76-.33.42-.7.82-1,1.23a14.61,14.61,0,0,1-1.33,1.4,17.27,17.27,0,0,1-1.42,1.14c-.28.19-.59.35-.85.56-.09.08-.3.2-.18.31a1.82,1.82,0,0,0,.43.09l.85.19a35.91,35.91,0,0,1,3.55,1,13,13,0,0,0-1.34-.83,4.63,4.63,0,0,1-.8-.49c.26-.11.57,0,.82-.11a3.76,3.76,0,0,0-.88-.28,6.76,6.76,0,0,0-.78-.17,3.78,3.78,0,0,1,1.38-.38c.53-.14,1.06-.24,1.6-.34a9.06,9.06,0,0,1,1.47-.16,21.89,21.89,0,0,1,2.68.15,1.75,1.75,0,0,0,.51,0c-.41-.22-.84-.41-1.27-.61s-.58-.22-.88-.33-.36-.1-.54-.15a1.23,1.23,0,0,1-.37-.12,4.17,4.17,0,0,1,.8-.11,11.11,11.11,0,0,1,1.15-.08h1.25a7.61,7.61,0,0,1,.83,0,10.7,10.7,0,0,0,1.5.1c-.09,0-.17-.09-.26-.13s-.48-.16-.72-.25-.54-.19-.81-.26a1.57,1.57,0,0,1-.66-.22,9.62,9.62,0,0,1,2.23-.63,9.29,9.29,0,0,1,1.39-.1h1.14a7,7,0,0,0,.91,0,3.34,3.34,0,0,0-.92-.42c-.21-.07-.43-.11-.64-.16a.4.4,0,0,1-.21-.09,1.61,1.61,0,0,1,.76-.08l1.11.06c.58,0,1.15.1,1.74.1s1.1.08,1.65.09c.35,0,.71.09,1.06.07a4.88,4.88,0,0,0-1.68-.66,15.74,15.74,0,0,0-1.9-.42,2.69,2.69,0,0,0,.46-.14l.51-.12c.34-.11.66-.3,1-.4s1-.21,1.47-.33a6.49,6.49,0,0,1,1.3-.25c.31,0,.62,0,.93,0,.75,0,1.49,0,2.24,0a8.29,8.29,0,0,1,1.22.14,9.28,9.28,0,0,1,.92.15,2.53,2.53,0,0,1-.52-.26c-.43-.2-.88-.41-1.33-.57a14.74,14.74,0,0,0-1.49-.37c-.09,0-.31,0-.37-.09s.17-.19.25-.28C253.3,141.07,253.81,140.66,254.25,140.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,141c-11.44,2.12-27.35,8.12-31.56,10.35a4.22,4.22,0,0,1,.64-2.81S247.54,142,259,141Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,141c-11.44,2.12-27.35,8.12-31.56,10.35a4.22,4.22,0,0,1,.64-2.81S247.54,142,259,141Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.45,151a5.14,5.14,0,0,1,.33-1.92,197.76,197.76,0,0,1,26.3-7.27C242.43,144.8,230.14,149.43,227.45,151Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.4,144.67c.25.09.51.15.75.26a9.48,9.48,0,0,1,1,.57,8.14,8.14,0,0,1,.75.5c.16.12.28.24.48.38a3.42,3.42,0,0,0-1-.31,2.93,2.93,0,0,0-1-.09,8.39,8.39,0,0,1,2.44,1.44,2.46,2.46,0,0,1,.68.72,2,2,0,0,1,.13.25,5.82,5.82,0,0,1,1.63-1.38c.42-.2.88-.3,1.31-.47l.22-.1c-.32-.15-.62-.33-.91-.48-.68-.35-1.34-.73-2-1.07s-1.43-.85-2.14-.68a8.17,8.17,0,0,1,1.4.85,10.2,10.2,0,0,1,1.25,1.12c-.25-.12-.49-.23-.71-.35a14.46,14.46,0,0,0-1.78-.84,7,7,0,0,0-1.34-.38c-.29,0-.59-.12-.88-.14a3.62,3.62,0,0,0-1.09,0A1.7,1.7,0,0,1,250.4,144.67Zm9.28-.09h0a4.08,4.08,0,0,1,1-1.33,3.65,3.65,0,0,1,.61-.34,9.8,9.8,0,0,0-2.65-.95,5.15,5.15,0,0,1,.88.91c-.95-.42-2.44-1-3.48-.6a7.44,7.44,0,0,1,1.46.5A6,6,0,0,1,259.68,144.58Zm-15.07,5a8.63,8.63,0,0,1,.95.64,12.28,12.28,0,0,1,1.29,1.1.46.46,0,0,1,.07.07,5.1,5.1,0,0,1,1-1.16,4.12,4.12,0,0,1,2.61-.32,8.22,8.22,0,0,0,1.78-.07,5.9,5.9,0,0,1-.81-.38c-.64-.35-1.3-.63-2-.95a6.8,6.8,0,0,0-1.79-.66,7,7,0,0,1,1.49,1.57l-1-.56a12.45,12.45,0,0,0-1.85-.77,17.34,17.34,0,0,0-4.3-1.11,12.82,12.82,0,0,1,2.57,1.27A21.28,21.28,0,0,1,247,150c-.49-.14-.66-.16-1.07-.25A4.86,4.86,0,0,0,244.61,149.6Zm-12,4.24a3.22,3.22,0,0,1,1.63-.2,5.28,5.28,0,0,1,1,.31c-.46-.35-.92-.71-1.4-1a9,9,0,0,0-1.75-1.08,5.73,5.73,0,0,1,1.32,1.43l-1.5-.83a5.27,5.27,0,0,0-2.22-.64A13.09,13.09,0,0,1,232.57,153.84Zm6.44-.11c.52-.58,1-1.21,1.83-1.23a3.7,3.7,0,0,1,1.44.47,2.94,2.94,0,0,0,1.5.09l.32-.06-.12,0a33,33,0,0,1-4.42-1.89c.18.27.5.52.72.79a1.22,1.22,0,0,1-.37-.2c-.48-.28-1-.51-1.5-.74a9.51,9.51,0,0,0-3.62-1.08,12.4,12.4,0,0,1,2.94,2.16,2.91,2.91,0,0,0-1.64-.31,10.21,10.21,0,0,1,1.86,1.06A5.77,5.77,0,0,1,239,153.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.76,137.5a10.78,10.78,0,0,1-1.37,3.18,13,13,0,0,0,2-2.84c.62-1.15,1.1-2.4,1.8-3.52a9.09,9.09,0,0,1,1-1.32q-.4.28-.78.6a3,3,0,0,1-1.83.9,6.85,6.85,0,0,1-.79-.13h-.05a7.83,7.83,0,0,1-.19,1.22,12.78,12.78,0,0,1-1.17,2.84,24.37,24.37,0,0,1-3.24,5.17C241.6,143.34,243.6,141.35,245.76,137.5Zm4,.86a10.78,10.78,0,0,0,2.74-1.88,23.82,23.82,0,0,1-1.95,2.48c-.84.91-1.72,1.77-2.58,2.66,1.29-1.05,2.66-1.94,3.88-3.1a20.31,20.31,0,0,0,2.64-2.89,11.21,11.21,0,0,1-2.42,3.42c1.72-1,3.47-3.5,4.89-4.9a7,7,0,0,1,.61-.53l-.13,0a15.68,15.68,0,0,1-1.62.36,1.79,1.79,0,0,1-1.51-.43l-.44-.46a5.15,5.15,0,0,1-.55,1.35A13.83,13.83,0,0,1,249.74,138.36Zm8.63-.23a20.35,20.35,0,0,1-2.19,1.55,19.81,19.81,0,0,0,2.24-.91,13.27,13.27,0,0,0,2.06-1.39,7.77,7.77,0,0,1-1.34,1.51,9.25,9.25,0,0,1-1.93,1.22,7.05,7.05,0,0,0,2.08-.8c.74-.33,1.44-.72,2.17-1.06a11.44,11.44,0,0,1,1.14-.48c-.24-.28-.53-.53-.76-.81a7.31,7.31,0,0,1-.85-1.73l-.3.44A13.53,13.53,0,0,1,258.37,138.13Zm-25.3,6.32a6.35,6.35,0,0,1-.84,2.57,13.34,13.34,0,0,0,1.56-2.69,29.18,29.18,0,0,0,1.06-2.77,5,5,0,0,1-1.65,1.89,2.43,2.43,0,0,1-.37.16,8.06,8.06,0,0,1-.33,1,12.94,12.94,0,0,1-.9,1.81A8.19,8.19,0,0,0,233.07,144.45Zm5.51-2.93a8.56,8.56,0,0,1-1.31,3.58,10.39,10.39,0,0,0,2.11-4c.32-.89.61-1.78.92-2.68a2,2,0,0,1-.86.6,5.54,5.54,0,0,1-1.29.12l-.33.05a7.39,7.39,0,0,1,0,2.07,11.24,11.24,0,0,1-2,4.26A12.8,12.8,0,0,0,238.58,141.52Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Onions--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.37,154.09a2.93,2.93,0,0,0-1.82-2.36,8.37,8.37,0,0,0-8.07.79,3.25,3.25,0,0,0-1.53,2.69c0,.13,0,.65,0,.78a2.92,2.92,0,0,0,1.82,2.36,8.36,8.36,0,0,0,8.08-.79,3.21,3.21,0,0,0,1.52-2.69Zm-1.88,2a7.44,7.44,0,0,1-3.68,1.32,7,7,0,0,1-3.78-.59,2.64,2.64,0,0,1-1.4-1.43,2.85,2.85,0,0,1,1.23-1.69,7.32,7.32,0,0,1,3.67-1.33,7.06,7.06,0,0,1,3.78.6,2.55,2.55,0,0,1,1.4,1.43A2.93,2.93,0,0,1,266.49,156.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.37,154.09a2.93,2.93,0,0,0-1.82-2.36,8.37,8.37,0,0,0-8.07.79,3.25,3.25,0,0,0-1.53,2.69c0,.13,0,.65,0,.78a2.92,2.92,0,0,0,1.82,2.36,8.36,8.36,0,0,0,8.08-.79,3.21,3.21,0,0,0,1.52-2.69Zm-1.88,2a7.44,7.44,0,0,1-3.68,1.32,7,7,0,0,1-3.78-.59,2.64,2.64,0,0,1-1.4-1.43,2.85,2.85,0,0,1,1.23-1.69,7.32,7.32,0,0,1,3.67-1.33,7.06,7.06,0,0,1,3.78.6,2.55,2.55,0,0,1,1.4,1.43A2.93,2.93,0,0,1,266.49,156.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.55,157.53l-.21.09.05.78.2-.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.32,158l-.2,0,0,.78.21,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.92,159l.21,0,0-.78-.21,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.79,156.69l.19-.28,0-.78a2.83,2.83,0,0,1-.2.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,157.7l.22.19,0-.78-.22-.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.76,156.84l-.2.14,0,.78.2-.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.16,158.51l.21.09,0-.78-.22-.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,158.27h-.21l.05.78h.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.59,158.16l-.21,0,.05.77.21,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.86,153.66a7.32,7.32,0,0,1,3.67-1.33,7.06,7.06,0,0,1,3.78.6,2.55,2.55,0,0,1,1.4,1.43,1.29,1.29,0,0,0,0-.39,2.33,2.33,0,0,0-1.48-1.82,7,7,0,0,0-3.78-.59,7.41,7.41,0,0,0-3.67,1.32,2.59,2.59,0,0,0-1.25,2.08,1.78,1.78,0,0,0,.07.39A2.85,2.85,0,0,1,258.86,153.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.86,153.66a7.32,7.32,0,0,1,3.67-1.33,7.06,7.06,0,0,1,3.78.6,2.55,2.55,0,0,1,1.4,1.43,1.29,1.29,0,0,0,0-.39,2.33,2.33,0,0,0-1.48-1.82,7,7,0,0,0-3.78-.59,7.41,7.41,0,0,0-3.67,1.32,2.59,2.59,0,0,0-1.25,2.08,1.78,1.78,0,0,0,.07.39A2.85,2.85,0,0,1,258.86,153.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.55,151.73a8.37,8.37,0,0,0-8.07.79,3.25,3.25,0,0,0-1.53,2.69,2.93,2.93,0,0,0,1.82,2.37,8.37,8.37,0,0,0,8.07-.8,3.23,3.23,0,0,0,1.53-2.69A2.93,2.93,0,0,0,266.55,151.73Zm-.06,4.32a7.44,7.44,0,0,1-3.68,1.32,7,7,0,0,1-3.78-.59,2.33,2.33,0,0,1-1.47-1.82,2.59,2.59,0,0,1,1.25-2.08,7.41,7.41,0,0,1,3.67-1.32,7,7,0,0,1,3.78.59,2.33,2.33,0,0,1,1.48,1.82A2.61,2.61,0,0,1,266.49,156.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.55,151.73a8.37,8.37,0,0,0-8.07.79,3.25,3.25,0,0,0-1.53,2.69,2.93,2.93,0,0,0,1.82,2.37,8.37,8.37,0,0,0,8.07-.8,3.23,3.23,0,0,0,1.53-2.69A2.93,2.93,0,0,0,266.55,151.73Zm-.06,4.32a7.44,7.44,0,0,1-3.68,1.32,7,7,0,0,1-3.78-.59,2.33,2.33,0,0,1-1.47-1.82,2.59,2.59,0,0,1,1.25-2.08,7.41,7.41,0,0,1,3.67-1.32,7,7,0,0,1,3.78.59,2.33,2.33,0,0,1,1.48,1.82A2.61,2.61,0,0,1,266.49,156.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.46,151.2a7.5,7.5,0,0,1,4,.64,2.85,2.85,0,0,1,1.76,2.26,3.14,3.14,0,0,1-1.48,2.58,7.79,7.79,0,0,1-3.92,1.42,7.41,7.41,0,0,1-4-.64,2.82,2.82,0,0,1-1.76-2.26,3.13,3.13,0,0,1,1.48-2.58,7.89,7.89,0,0,1,3.92-1.42m0-.12a7.93,7.93,0,0,0-4,1.44,3.25,3.25,0,0,0-1.53,2.69,2.93,2.93,0,0,0,1.82,2.37,7.66,7.66,0,0,0,4.09.65,8,8,0,0,0,4-1.45,3.23,3.23,0,0,0,1.53-2.69,2.93,2.93,0,0,0-1.82-2.36,7.58,7.58,0,0,0-4.1-.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.46,151.2a7.5,7.5,0,0,1,4,.64,2.85,2.85,0,0,1,1.76,2.26,3.14,3.14,0,0,1-1.48,2.58,7.79,7.79,0,0,1-3.92,1.42,7.41,7.41,0,0,1-4-.64,2.82,2.82,0,0,1-1.76-2.26,3.13,3.13,0,0,1,1.48-2.58,7.89,7.89,0,0,1,3.92-1.42m0-.12a7.93,7.93,0,0,0-4,1.44,3.25,3.25,0,0,0-1.53,2.69,2.93,2.93,0,0,0,1.82,2.37,7.66,7.66,0,0,0,4.09.65,8,8,0,0,0,4-1.45,3.23,3.23,0,0,0,1.53-2.69,2.93,2.93,0,0,0-1.82-2.36,7.58,7.58,0,0,0-4.1-.65Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278,153.27a2.45,2.45,0,0,0-1.41-2.37,10.46,10.46,0,0,0-8.64-.65c-1.3.53-2,1.29-2.17,2.1l-.12.69a2.47,2.47,0,0,0,1.42,2.37,10.45,10.45,0,0,0,8.64.65c1.3-.53,2-1.29,2.17-2.1Zm-2.39,1.4a9.35,9.35,0,0,1-4.13.55,8.37,8.37,0,0,1-3.84-1.15,2.29,2.29,0,0,1-1.17-1.49,3,3,0,0,1,1.64-1.27,9.37,9.37,0,0,1,4.13-.55,8.21,8.21,0,0,1,3.84,1.15,2.31,2.31,0,0,1,1.18,1.48A3,3,0,0,1,275.58,154.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278,153.27a2.45,2.45,0,0,0-1.41-2.37,10.46,10.46,0,0,0-8.64-.65c-1.3.53-2,1.29-2.17,2.1l-.12.69a2.47,2.47,0,0,0,1.42,2.37,10.45,10.45,0,0,0,8.64.65c1.3-.53,2-1.29,2.17-2.1Zm-2.39,1.4a9.35,9.35,0,0,1-4.13.55,8.37,8.37,0,0,1-3.84-1.15,2.29,2.29,0,0,1-1.17-1.49,3,3,0,0,1,1.64-1.27,9.37,9.37,0,0,1,4.13-.55,8.21,8.21,0,0,1,3.84,1.15,2.31,2.31,0,0,1,1.18,1.48A3,3,0,0,1,275.58,154.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.29,155.82l-.23,0-.12.68.23,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.91,156h-.22l-.12.69h.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.23,156.67h.22l.12-.69h-.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.82,155.45l.26-.21.12-.69-.27.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.19,154.69l.19.2.11-.69-.19-.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7,155.41l-.24.09-.11.69.24-.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.38,155.61l.2.11.12-.69-.21-.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.25,155.84l-.21,0-.12.69.22,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,155.54l-.21-.07-.12.69.21.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08,151.31a9.37,9.37,0,0,1,4.13-.55,8.21,8.21,0,0,1,3.84,1.15,2.31,2.31,0,0,1,1.18,1.48,1.35,1.35,0,0,0,.11-.34c.1-.62-.31-1.27-1.17-1.83a8.37,8.37,0,0,0-3.84-1.15,9.35,9.35,0,0,0-4.13.55c-1,.42-1.65,1-1.76,1.62a1.29,1.29,0,0,0,0,.34A3,3,0,0,1,268.08,151.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.08,151.31a9.37,9.37,0,0,1,4.13-.55,8.21,8.21,0,0,1,3.84,1.15,2.31,2.31,0,0,1,1.18,1.48,1.35,1.35,0,0,0,.11-.34c.1-.62-.31-1.27-1.17-1.83a8.37,8.37,0,0,0-3.84-1.15,9.35,9.35,0,0,0-4.13.55c-1,.42-1.65,1-1.76,1.62a1.29,1.29,0,0,0,0,.34A3,3,0,0,1,268.08,151.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276.56,150.9a10.46,10.46,0,0,0-8.64-.65c-1.3.53-2,1.29-2.17,2.1a2.47,2.47,0,0,0,1.41,2.38,10.5,10.5,0,0,0,8.64.64c1.3-.52,2-1.29,2.17-2.1A2.45,2.45,0,0,0,276.56,150.9Zm-1,3.77a9.35,9.35,0,0,1-4.13.55,8.37,8.37,0,0,1-3.84-1.15c-.86-.56-1.27-1.21-1.17-1.83s.73-1.2,1.76-1.62a9.35,9.35,0,0,1,4.13-.55,8.37,8.37,0,0,1,3.84,1.15c.86.56,1.27,1.21,1.17,1.83S276.61,154.25,275.58,154.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.56,150.9a10.46,10.46,0,0,0-8.64-.65c-1.3.53-2,1.29-2.17,2.1a2.47,2.47,0,0,0,1.41,2.38,10.5,10.5,0,0,0,8.64.64c1.3-.52,2-1.29,2.17-2.1A2.45,2.45,0,0,0,276.56,150.9Zm-1,3.77a9.35,9.35,0,0,1-4.13.55,8.37,8.37,0,0,1-3.84-1.15c-.86-.56-1.27-1.21-1.17-1.83s.73-1.2,1.76-1.62a9.35,9.35,0,0,1,4.13-.55,8.37,8.37,0,0,1,3.84,1.15c.86.56,1.27,1.21,1.17,1.83S276.61,154.25,275.58,154.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.38,149.76a8.9,8.9,0,0,1,4.1,1.23c1,.66,1.51,1.47,1.37,2.27s-.88,1.52-2.09,2a9.92,9.92,0,0,1-4.42.6,8.93,8.93,0,0,1-4.1-1.23,2.39,2.39,0,0,1-1.37-2.28c.14-.8.88-1.52,2.1-2a10,10,0,0,1,4.41-.59m0-.11a10.13,10.13,0,0,0-4.48.6c-1.3.53-2,1.29-2.17,2.1a2.47,2.47,0,0,0,1.41,2.38,9.22,9.22,0,0,0,4.17,1.25,10.23,10.23,0,0,0,4.47-.61c1.3-.52,2-1.29,2.17-2.1a2.45,2.45,0,0,0-1.41-2.37,9.09,9.09,0,0,0-4.16-1.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.38,149.76a8.9,8.9,0,0,1,4.1,1.23c1,.66,1.51,1.47,1.37,2.27s-.88,1.52-2.09,2a9.92,9.92,0,0,1-4.42.6,8.93,8.93,0,0,1-4.1-1.23,2.39,2.39,0,0,1-1.37-2.28c.14-.8.88-1.52,2.1-2a10,10,0,0,1,4.41-.59m0-.11a10.13,10.13,0,0,0-4.48.6c-1.3.53-2,1.29-2.17,2.1a2.47,2.47,0,0,0,1.41,2.38,9.22,9.22,0,0,0,4.17,1.25,10.23,10.23,0,0,0,4.47-.61c1.3-.52,2-1.29,2.17-2.1a2.45,2.45,0,0,0-1.41-2.37,9.09,9.09,0,0,0-4.16-1.25Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.72,156a3,3,0,0,0-2-2.21,9.35,9.35,0,0,0-8.37,1,3,3,0,0,0-1.44,2.63l.09.74a3,3,0,0,0,2,2.21,9.33,9.33,0,0,0,8.38-1,3,3,0,0,0,1.44-2.63Zm-1.86,1.93a8,8,0,0,1-3.75,1.38,7.83,7.83,0,0,1-4-.45,2.66,2.66,0,0,1-1.54-1.32,2.69,2.69,0,0,1,1.18-1.66,7.86,7.86,0,0,1,3.75-1.38,8,8,0,0,1,4,.44,2.76,2.76,0,0,1,1.55,1.33A2.74,2.74,0,0,1,271.86,157.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.72,156a3,3,0,0,0-2-2.21,9.35,9.35,0,0,0-8.37,1,3,3,0,0,0-1.44,2.63l.09.74a3,3,0,0,0,2,2.21,9.33,9.33,0,0,0,8.38-1,3,3,0,0,0,1.44-2.63Zm-1.86,1.93a8,8,0,0,1-3.75,1.38,7.83,7.83,0,0,1-4-.45,2.66,2.66,0,0,1-1.54-1.32,2.69,2.69,0,0,1,1.18-1.66,7.86,7.86,0,0,1,3.75-1.38,8,8,0,0,1,4,.44,2.76,2.76,0,0,1,1.55,1.33A2.74,2.74,0,0,1,271.86,157.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271,159.35l-.21.09.09.74.21-.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.72,159.8l-.21.06.09.74.21,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.32,160.84l.21,0-.09-.74-.21,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.26,158.47a2.11,2.11,0,0,0,.18-.27l-.09-.74a2.11,2.11,0,0,1-.18.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,159.76a2.07,2.07,0,0,0,.24.17l-.09-.74-.24-.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.19,158.65l-.2.14.09.75.2-.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.36,160.49l.23.08-.09-.75-.23-.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.16,160.17h-.22l.09.75h.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.84,160.11l-.22,0,.09.75.22,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.78,155.85a7.86,7.86,0,0,1,3.75-1.38,8,8,0,0,1,4,.44,2.76,2.76,0,0,1,1.55,1.33,1.53,1.53,0,0,0,0-.37c-.08-.68-.66-1.28-1.64-1.7a8,8,0,0,0-4-.44,7.76,7.76,0,0,0-3.75,1.38,2.36,2.36,0,0,0-1.19,2,1.56,1.56,0,0,0,.1.37A2.69,2.69,0,0,1,263.78,155.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.78,155.85a7.86,7.86,0,0,1,3.75-1.38,8,8,0,0,1,4,.44,2.76,2.76,0,0,1,1.55,1.33,1.53,1.53,0,0,0,0-.37c-.08-.68-.66-1.28-1.64-1.7a8,8,0,0,0-4-.44,7.76,7.76,0,0,0-3.75,1.38,2.36,2.36,0,0,0-1.19,2,1.56,1.56,0,0,0,.1.37A2.69,2.69,0,0,1,263.78,155.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.69,153.76a9.35,9.35,0,0,0-8.37,1,2.57,2.57,0,0,0,.59,4.84,9.32,9.32,0,0,0,8.37-1,2.57,2.57,0,0,0-.59-4.83Zm.17,4.14a8,8,0,0,1-3.75,1.38,7.83,7.83,0,0,1-4-.45c-1-.41-1.56-1-1.64-1.69a2.36,2.36,0,0,1,1.19-2,7.76,7.76,0,0,1,3.75-1.38,8,8,0,0,1,4,.44c1,.42,1.56,1,1.64,1.7A2.37,2.37,0,0,1,271.86,157.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.69,153.76a9.35,9.35,0,0,0-8.37,1,2.57,2.57,0,0,0,.59,4.84,9.32,9.32,0,0,0,8.37-1,2.57,2.57,0,0,0-.59-4.83Zm.17,4.14a8,8,0,0,1-3.75,1.38,7.83,7.83,0,0,1-4-.45c-1-.41-1.56-1-1.64-1.69a2.36,2.36,0,0,1,1.19-2,7.76,7.76,0,0,1,3.75-1.38,8,8,0,0,1,4,.44c1,.42,1.56,1,1.64,1.7A2.37,2.37,0,0,1,271.86,157.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.4,153.39a8.49,8.49,0,0,1,4.25.48,2.46,2.46,0,0,1,.56,4.63,9.26,9.26,0,0,1-8.26,1,2.46,2.46,0,0,1-.56-4.63,8.38,8.38,0,0,1,4-1.48m0-.12a8.68,8.68,0,0,0-4.06,1.5,2.57,2.57,0,0,0,.59,4.84,8.49,8.49,0,0,0,4.3.49,8.58,8.58,0,0,0,4.07-1.51,2.57,2.57,0,0,0-.59-4.83,8.51,8.51,0,0,0-4.31-.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.4,153.39a8.49,8.49,0,0,1,4.25.48,2.46,2.46,0,0,1,.56,4.63,9.26,9.26,0,0,1-8.26,1,2.46,2.46,0,0,1-.56-4.63,8.38,8.38,0,0,1,4-1.48m0-.12a8.68,8.68,0,0,0-4.06,1.5,2.57,2.57,0,0,0,.59,4.84,8.49,8.49,0,0,0,4.3.49,8.58,8.58,0,0,0,4.07-1.51,2.57,2.57,0,0,0-.59-4.83,8.51,8.51,0,0,0-4.31-.49Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Kabab--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224,150l48.35-11.89a.67.67,0,0,1,.16.94l-48,13.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,150c-.84.21-.3,2.44.49,2.22S224.7,149.85,224,150Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.36,148.45a2.93,2.93,0,0,1,0-2.12c.23-.41.81-.51,1.09-.88.43-.53.48-1.36.9-1.92a3.08,3.08,0,0,1,2.08-.94,7.05,7.05,0,0,1,2.15.1c.7.12,1.43.07,2.14.12a3.3,3.3,0,0,1,1.64.62c.95.63,1.17,1.69,1.55,2.69a6.56,6.56,0,0,1,.63,1.77,4.46,4.46,0,0,1-.47,2,4,4,0,0,1-.21.61,5.5,5.5,0,0,1-.67.79c-.3.37-.5.77-.77,1.16a1.56,1.56,0,0,1-.93.68,6.37,6.37,0,0,1-5.24.24c-.71-.14-1.72-.12-2.22-.73-.14-.16-.2-.3-.35-.45a2.23,2.23,0,0,1-.42-.45,1.73,1.73,0,0,1-.24-1.32A1.32,1.32,0,0,0,230.36,148.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.36,148.45a2.93,2.93,0,0,1,0-2.12c.23-.41.81-.51,1.09-.88.43-.53.48-1.36.9-1.92a3.08,3.08,0,0,1,2.08-.94,7.05,7.05,0,0,1,2.15.1c.7.12,1.43.07,2.14.12a3.3,3.3,0,0,1,1.64.62c.95.63,1.17,1.69,1.55,2.69a6.56,6.56,0,0,1,.63,1.77,4.46,4.46,0,0,1-.47,2,4,4,0,0,1-.21.61,5.5,5.5,0,0,1-.67.79c-.3.37-.5.77-.77,1.16a1.56,1.56,0,0,1-.93.68,6.37,6.37,0,0,1-5.24.24c-.71-.14-1.72-.12-2.22-.73-.14-.16-.2-.3-.35-.45a2.23,2.23,0,0,1-.42-.45,1.73,1.73,0,0,1-.24-1.32A1.32,1.32,0,0,0,230.36,148.45Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,153.78a11,11,0,0,0,2.5-.68,1.55,1.55,0,0,0,.94-.68c.27-.39.47-.79.77-1.16a5.5,5.5,0,0,0,.67-.79s0-.08,0-.11c-.49.14-1,.2-1.5.39-1,.4-1.55,1.22-2.69,1.15a1.5,1.5,0,0,1-1.11-.52,4,4,0,0,0-.83-1,3.49,3.49,0,0,0-1.31-.57c-.39-.06-.85,0-1.15-.29a3.08,3.08,0,0,1-.83-2.08c.07-.43.29-.82.34-1.24a5.3,5.3,0,0,0-.14-1.06,2.38,2.38,0,0,1,.7-1.82,2.82,2.82,0,0,1,.74-.69,2.79,2.79,0,0,0-1.78.9c-.42.56-.47,1.39-.9,1.92-.28.37-.86.47-1.09.88a2.93,2.93,0,0,0,0,2.12,1.32,1.32,0,0,1,.64,1.94,1.73,1.73,0,0,0,.24,1.32,2.23,2.23,0,0,0,.42.45c.15.15.21.29.35.45.5.61,1.51.59,2.22.73A11,11,0,0,0,237,153.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9,145.37a4,4,0,0,1,.16-3.07c.34-.56.89-.9,1.21-1.48a2.82,2.82,0,0,1,2.25-1.57,9.43,9.43,0,0,1,1.84,0c.53.07,1,.29,1.54.39a3,3,0,0,1,1.21.51,13.35,13.35,0,0,1,2,1.63,4.33,4.33,0,0,1,1,2.49,10.29,10.29,0,0,1,0,1.47,4.79,4.79,0,0,1-.06,1.2,5.64,5.64,0,0,1-.38,1,12.3,12.3,0,0,1-.68,1.17,1.64,1.64,0,0,1-.94.67,11.53,11.53,0,0,1-2.51.69,10.53,10.53,0,0,1-2.72-.45c-.71-.14-1.72-.12-2.22-.72a4.06,4.06,0,0,0-.36-.46,2.49,2.49,0,0,1-.41-.45,1.73,1.73,0,0,1-.24-1.32A1,1,0,0,0,242.9,145.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9,145.37a4,4,0,0,1,.16-3.07c.34-.56.89-.9,1.21-1.48a2.82,2.82,0,0,1,2.25-1.57,9.43,9.43,0,0,1,1.84,0c.53.07,1,.29,1.54.39a3,3,0,0,1,1.21.51,13.35,13.35,0,0,1,2,1.63,4.33,4.33,0,0,1,1,2.49,10.29,10.29,0,0,1,0,1.47,4.79,4.79,0,0,1-.06,1.2,5.64,5.64,0,0,1-.38,1,12.3,12.3,0,0,1-.68,1.17,1.64,1.64,0,0,1-.94.67,11.53,11.53,0,0,1-2.51.69,10.53,10.53,0,0,1-2.72-.45c-.71-.14-1.72-.12-2.22-.72a4.06,4.06,0,0,0-.36-.46,2.49,2.49,0,0,1-.41-.45,1.73,1.73,0,0,1-.24-1.32A1,1,0,0,0,242.9,145.37Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,147.37a4.5,4.5,0,0,0-.63.07c-.32.09-.46.3-.73.47a2,2,0,0,1-1.74.12,2.4,2.4,0,0,0-.75-.27c-.31,0-.61.06-.92,0-.75,0-1.11-.35-1.1-1.11,0-.54.28-1.14-.06-1.64s-.69-.44-.75-1a1.62,1.62,0,0,0-.2-.81,2.31,2.31,0,0,1-.35-.68c-.24-1.24,1.14-2.23,2.12-2.63a5.06,5.06,0,0,1,2.14-.4c.34,0,.68.14,1,.19l-.18-.05c-.52-.1-1-.32-1.54-.39a9.43,9.43,0,0,0-1.84,0,2.82,2.82,0,0,0-2.25,1.57c-.32.58-.87.92-1.22,1.48a4,4,0,0,0-.15,3.07,1,1,0,0,1,.59,1.66,1.73,1.73,0,0,0,.24,1.32,2.49,2.49,0,0,0,.41.45,4.06,4.06,0,0,1,.36.46c.5.6,1.51.58,2.22.72a10.53,10.53,0,0,0,2.72.45,11.53,11.53,0,0,0,2.51-.69,1.64,1.64,0,0,0,.94-.67,12.3,12.3,0,0,0,.68-1.17,5.64,5.64,0,0,0,.38-1,2.25,2.25,0,0,0,.07-.64,2.19,2.19,0,0,1-.21.23A2.89,2.89,0,0,1,252,147.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,140.59c0-.16,0-.32.08-.48a7.35,7.35,0,0,1,.81-2.18,3.29,3.29,0,0,1,2.48-1.6,18.2,18.2,0,0,1,2.94-.3,3.1,3.1,0,0,1,2,.6,14.47,14.47,0,0,1,1.31,1.16,6.06,6.06,0,0,1,1.26,1.37,4,4,0,0,1-.19,3.68,9.53,9.53,0,0,1-1,1.43,7.79,7.79,0,0,1-.93,1.23,5.85,5.85,0,0,1-2.64,1,5.47,5.47,0,0,1-4.43-1.29,2.62,2.62,0,0,1-.7-.67c-.09-.17-.46-.61-.33-.83,0-.05.13-.08.19-.11a.62.62,0,0,0,.25-.59.92.92,0,0,0-.48-.66c-.1,0-.24,0-.32,0s-.25-.59-.28-.79A3.86,3.86,0,0,1,254.86,140.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,140.59c0-.16,0-.32.08-.48a7.35,7.35,0,0,1,.81-2.18,3.29,3.29,0,0,1,2.48-1.6,18.2,18.2,0,0,1,2.94-.3,3.1,3.1,0,0,1,2,.6,14.47,14.47,0,0,1,1.31,1.16,6.06,6.06,0,0,1,1.26,1.37,4,4,0,0,1-.19,3.68,9.53,9.53,0,0,1-1,1.43,7.79,7.79,0,0,1-.93,1.23,5.85,5.85,0,0,1-2.64,1,5.47,5.47,0,0,1-4.43-1.29,2.62,2.62,0,0,1-.7-.67c-.09-.17-.46-.61-.33-.83,0-.05.13-.08.19-.11a.62.62,0,0,0,.25-.59.92.92,0,0,0-.48-.66c-.1,0-.24,0-.32,0s-.25-.59-.28-.79A3.86,3.86,0,0,1,254.86,140.59Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,144.36a8.9,8.9,0,0,0-.95.3,7.25,7.25,0,0,0-.95.51,2,2,0,0,1-1.3.14A6.52,6.52,0,0,0,260,145c-.46,0-.81.27-1.18-.09a3,3,0,0,1-.6-1.06,1.63,1.63,0,0,1,0-1.13,1.08,1.08,0,0,0-.12-1.07c-.27-.3-.71-.32-1-.63a10.77,10.77,0,0,1-.58-.91c-.69-1.09.41-2.44,1.34-3a10.45,10.45,0,0,1,1.72-.64,1.55,1.55,0,0,0,.66-.42,19.26,19.26,0,0,0-2,.26,3.29,3.29,0,0,0-2.48,1.6,7.35,7.35,0,0,0-.81,2.18c0,.16-.06.32-.08.48a3.86,3.86,0,0,0,0,1c0,.2.07.7.28.79s.22,0,.32,0a.92.92,0,0,1,.48.66.62.62,0,0,1-.25.59c-.06,0-.16.06-.19.11-.13.22.24.66.33.83a2.62,2.62,0,0,0,.7.67,5.47,5.47,0,0,0,4.43,1.29,5.85,5.85,0,0,0,2.64-1A6.75,6.75,0,0,0,264.45,144.36Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--kabab--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.37,156.31l48.06-13a.68.68,0,0,1,.19.93l-47.7,14.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.37,156.31c-.83.23-.23,2.45.55,2.21S230.08,156.12,229.37,156.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,154.6a2.94,2.94,0,0,1-.07-2.12c.22-.42.8-.54,1.07-.91.41-.55.45-1.37.86-1.94a3,3,0,0,1,2.05-1,7,7,0,0,1,2.15.06c.71.1,1.43,0,2.14.07a3.37,3.37,0,0,1,1.65.57,4.89,4.89,0,0,1,1.62,2.66,6.35,6.35,0,0,1,.67,1.76,18.22,18.22,0,0,1-.61,2.59,6.4,6.4,0,0,1-.65.81,13.08,13.08,0,0,0-.75,1.18,1.53,1.53,0,0,1-.92.69,10.36,10.36,0,0,1-2.49.75,10.53,10.53,0,0,1-2.73-.39c-.72-.11-1.73-.07-2.24-.66a3.28,3.28,0,0,0-.37-.45,2.89,2.89,0,0,1-.42-.44,1.72,1.72,0,0,1-.27-1.31A1.32,1.32,0,0,0,235.7,154.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,154.6a2.94,2.94,0,0,1-.07-2.12c.22-.42.8-.54,1.07-.91.41-.55.45-1.37.86-1.94a3,3,0,0,1,2.05-1,7,7,0,0,1,2.15.06c.71.1,1.43,0,2.14.07a3.37,3.37,0,0,1,1.65.57,4.89,4.89,0,0,1,1.62,2.66,6.35,6.35,0,0,1,.67,1.76,18.22,18.22,0,0,1-.61,2.59,6.4,6.4,0,0,1-.65.81,13.08,13.08,0,0,0-.75,1.18,1.53,1.53,0,0,1-.92.69,10.36,10.36,0,0,1-2.49.75,10.53,10.53,0,0,1-2.73-.39c-.72-.11-1.73-.07-2.24-.66a3.28,3.28,0,0,0-.37-.45,2.89,2.89,0,0,1-.42-.44,1.72,1.72,0,0,1-.27-1.31A1.32,1.32,0,0,0,235.7,154.6Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.42,159.77a10.36,10.36,0,0,0,2.49-.75,1.53,1.53,0,0,0,.92-.69,13.08,13.08,0,0,1,.75-1.18,6.4,6.4,0,0,0,.65-.81.49.49,0,0,0,0-.11,12.7,12.7,0,0,0-1.49.43c-1,.42-1.52,1.25-2.66,1.21a1.52,1.52,0,0,1-1.13-.5,4.16,4.16,0,0,0-.85-1,3.31,3.31,0,0,0-1.32-.53c-.39-.05-.85,0-1.16-.27a3.11,3.11,0,0,1-.88-2.06c.06-.43.28-.83.31-1.25a4.77,4.77,0,0,0-.16-1.06,2.36,2.36,0,0,1,.66-1.83,2.73,2.73,0,0,1,.73-.71,2.79,2.79,0,0,0-1.76.95c-.41.57-.45,1.39-.86,1.94-.27.37-.85.49-1.07.91a2.94,2.94,0,0,0,.07,2.12,1.32,1.32,0,0,1,.69,1.92,1.72,1.72,0,0,0,.27,1.31,2.89,2.89,0,0,0,.42.44,3.28,3.28,0,0,1,.37.45c.51.59,1.52.55,2.24.66A10.53,10.53,0,0,0,242.42,159.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.17,151.22a4,4,0,0,1,.08-3.08c.33-.56.87-.92,1.18-1.5a2.82,2.82,0,0,1,2.21-1.63,9.43,9.43,0,0,1,1.84,0c.53.06,1,.27,1.55.36a2.92,2.92,0,0,1,1.22.48,12.68,12.68,0,0,1,2,1.58,4.32,4.32,0,0,1,1,2.47,10.31,10.31,0,0,1,0,1.47,4.81,4.81,0,0,1,0,1.2,7.1,7.1,0,0,1-.36,1c-.19.39-.42.81-.65,1.18a1.58,1.58,0,0,1-.92.69,6.24,6.24,0,0,1-5.23.36c-.71-.11-1.72-.07-2.24-.66a4.06,4.06,0,0,0-.36-.46,2.24,2.24,0,0,1-.43-.44,1.69,1.69,0,0,1-.27-1.3A1,1,0,0,0,248.17,151.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.17,151.22a4,4,0,0,1,.08-3.08c.33-.56.87-.92,1.18-1.5a2.82,2.82,0,0,1,2.21-1.63,9.43,9.43,0,0,1,1.84,0c.53.06,1,.27,1.55.36a2.92,2.92,0,0,1,1.22.48,12.68,12.68,0,0,1,2,1.58,4.32,4.32,0,0,1,1,2.47,10.31,10.31,0,0,1,0,1.47,4.81,4.81,0,0,1,0,1.2,7.1,7.1,0,0,1-.36,1c-.19.39-.42.81-.65,1.18a1.58,1.58,0,0,1-.92.69,6.24,6.24,0,0,1-5.23.36c-.71-.11-1.72-.07-2.24-.66a4.06,4.06,0,0,0-.36-.46,2.24,2.24,0,0,1-.43-.44,1.69,1.69,0,0,1-.27-1.3A1,1,0,0,0,248.17,151.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,153a4.55,4.55,0,0,0-.63.09c-.32.09-.45.3-.72.48a2,2,0,0,1-1.74.17,2,2,0,0,0-.75-.25c-.31,0-.61.06-.92,0-.75,0-1.12-.32-1.12-1.08,0-.54.24-1.15-.11-1.64s-.7-.42-.77-1a1.65,1.65,0,0,0-.22-.82,2.07,2.07,0,0,1-.36-.67c-.27-1.23,1.09-2.25,2.05-2.67a5.08,5.08,0,0,1,2.14-.45c.33,0,.68.12,1,.16l-.18,0c-.53-.09-1-.3-1.55-.36a9.43,9.43,0,0,0-1.84,0,2.82,2.82,0,0,0-2.21,1.63c-.31.58-.85.94-1.18,1.5a4,4,0,0,0-.08,3.08,1,1,0,0,1,.62,1.65,1.69,1.69,0,0,0,.27,1.3,2.24,2.24,0,0,0,.43.44,4.06,4.06,0,0,1,.36.46c.52.59,1.53.55,2.24.66a6.24,6.24,0,0,0,5.23-.36,1.58,1.58,0,0,0,.92-.69c.23-.37.46-.79.65-1.18a7.1,7.1,0,0,0,.36-1,1.94,1.94,0,0,0,.05-.64c-.06.07-.12.15-.2.23A2.91,2.91,0,0,1,257.34,153Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,146.15c0-.15,0-.32.07-.48a7.13,7.13,0,0,1,.76-2.19,3.26,3.26,0,0,1,2.44-1.66,19.24,19.24,0,0,1,2.93-.37,3.1,3.1,0,0,1,2,.55,14.65,14.65,0,0,1,1.34,1.14,6,6,0,0,1,1.29,1.33,4,4,0,0,1-.1,3.69,10.85,10.85,0,0,1-1,1.45,7.82,7.82,0,0,1-.91,1.25,5.77,5.77,0,0,1-2.62,1.1,5.42,5.42,0,0,1-4.45-1.19,2.3,2.3,0,0,1-.71-.64c-.1-.17-.48-.61-.36-.83,0-.05.13-.08.18-.11a.6.6,0,0,0,.24-.6.93.93,0,0,0-.49-.65c-.1,0-.24,0-.33,0s-.26-.58-.29-.78A3.5,3.5,0,0,1,260,146.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,146.15c0-.15,0-.32.07-.48a7.13,7.13,0,0,1,.76-2.19,3.26,3.26,0,0,1,2.44-1.66,19.24,19.24,0,0,1,2.93-.37,3.1,3.1,0,0,1,2,.55,14.65,14.65,0,0,1,1.34,1.14,6,6,0,0,1,1.29,1.33,4,4,0,0,1-.1,3.69,10.85,10.85,0,0,1-1,1.45,7.82,7.82,0,0,1-.91,1.25,5.77,5.77,0,0,1-2.62,1.1,5.42,5.42,0,0,1-4.45-1.19,2.3,2.3,0,0,1-.71-.64c-.1-.17-.48-.61-.36-.83,0-.05.13-.08.18-.11a.6.6,0,0,0,.24-.6.93.93,0,0,0-.49-.65c-.1,0-.24,0-.33,0s-.26-.58-.29-.78A3.5,3.5,0,0,1,260,146.15Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.68,149.7c-.32.07-.68.24-.94.32a8.7,8.7,0,0,0-.94.53,2,2,0,0,1-1.29.18,6.73,6.73,0,0,0-1.24-.28c-.46,0-.8.28-1.18-.07a2.75,2.75,0,0,1-.62-1,1.63,1.63,0,0,1-.05-1.13,1.11,1.11,0,0,0-.15-1.07c-.27-.3-.71-.3-1-.61a10.77,10.77,0,0,1-.61-.89c-.71-1.08.36-2.45,1.27-3a10.87,10.87,0,0,1,1.71-.68,1.67,1.67,0,0,0,.65-.44,18.7,18.7,0,0,0-2,.31,3.26,3.26,0,0,0-2.44,1.66,7.13,7.13,0,0,0-.76,2.19c0,.16-.05.33-.07.48a3.5,3.5,0,0,0,0,1c0,.2.08.69.29.78s.23,0,.33,0a.93.93,0,0,1,.49.65.6.6,0,0,1-.24.6c-.05,0-.15.06-.18.11-.12.22.26.66.36.83a2.3,2.3,0,0,0,.71.64,5.42,5.42,0,0,0,4.45,1.19,5.77,5.77,0,0,0,2.62-1.1A6.71,6.71,0,0,0,269.68,149.7Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M322.13,138.45c-.17-7.95-.35-15.74-1.21-27-.82-10.57-2.28-14.89-12.81-18.05-7,6-4.57,23.53-4.57,23.53l1.52,22.84s-7.55,6.49-14.76,9.39a59,59,0,0,1-7.29,2.65,53.24,53.24,0,0,1-6.12,1.19c-2.34.26-4.37.89-6.27.8-2.09-.09-3.69-.57-3.9-.26A2.54,2.54,0,0,0,268,157a14.48,14.48,0,0,0,6.79,1.31,7.91,7.91,0,0,1-2.8,3.15c-2.29,1.72-7.46,2.91-9.41,3-1.16,0-1.47,1.7-.21,2.58a4.13,4.13,0,0,0,2.09.61s2.77,4.14,9.07,3.54,10.53-3.83,13.5-6.33A29.24,29.24,0,0,1,293.6,161c5.29-2.07,19.3-7.45,24.28-10.23C322.53,148.17,322.26,144.66,322.13,138.45Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.06,139.75c2.64-1.42,7.25-1.86,11.08-.92-1.67-2-7.86-2.47-11.24-1.46Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,93.05c3.56.53,8,2.32,10.27,4.46s3.75,5.51,4.92,23.84,1.29,20.27,1.05,24.8c-.12,2.13-.34,4.8-7.09,7.64-4.91,2.08-11.81,5.81-16.66,7.13a6.09,6.09,0,0,1-4.53-.46c1.64-2.84-.13-10.74-3.58-11.78a3.23,3.23,0,0,1,1.68-3.09c2-1.29,10.9-6.39,10.9-6.39s-1.12-22.08-1.66-25.36S301.07,99,307,93.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.37,148.68l-4.28,1.75s2.61.74,3.76,5,.29,6.73.29,6.73l4.25-1.69s1.78-2.06.18-7.47A5.76,5.76,0,0,0,291.37,148.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34,167.6a10.78,10.78,0,0,0,2.78,0,21,21,0,0,0,2.74-.53,20.57,20.57,0,0,0,2.64-.91,12.3,12.3,0,0,0,2.44-1.34c-.84.38-1.71.7-2.57,1s-1.75.56-2.63.79-1.78.44-2.68.63A22.55,22.55,0,0,1,265.34,167.6Z",
    style: {
      fill: "#af6152"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.06,225.68l-5.58-8.93-9.55,6.89,11.3,12s7.33-.27,8.2-3.4S336.72,226.67,335.06,225.68Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.76,218.31l1.4,2.17a10.8,10.8,0,0,1-3.6,4.76,13.29,13.29,0,0,1-4.81,2.7l-3.53-3.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.47,228.47l.73.77s1.73.72,4.84-1a6.94,6.94,0,0,0,3.39-5.16l-.64-1.06s.51-1,1.57.69,2,3.52,3.56,4.29,3.1,1,4.39,3.17.1,4.13,1.43,6.73,3.45,7.32.45,13.21-6.6,6.36-8.25,5.65-2.94-2.21-2.63-7.27-.71-9.27-2.74-11.88-4.54-5.14-5.49-6.23S324,229,324.47,228.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.4 228.55 323.83 232.84 320.43 235.33 325.65 243.28 336.69 236.99 329.4 228.55",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.75,227.89l-2.22,1.71a11.65,11.65,0,0,0,1.63,5.87c1.8,3.44,3.13,4.4,3.13,4.4l3.59-2.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.4,231.63l-.52.41s-1.2,2.07.58,5.67,4.06,3.37,4.06,3.37l1-.56s.53.56-1.09,1.54-5.09,2.33-6.71,3.33-4.62,2.85-7.17,4.66-5.17,3.85-10.55,2.17c-5.92-1.84-5.68-7.4-1.29-10.4,4.18-2.85,5.52-2.6,9.7-4.35A91.39,91.39,0,0,0,324,231.74C325.15,231,325.4,231.63,325.4,231.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.22,193.57s-18-3.47-27.18-2.84c-10,.69-11.6,5.76-10.83,12.05.88,7.17,12.5,18.42,16.91,22.46a3.31,3.31,0,0,0,3.73.39,16.21,16.21,0,0,0,7.78-7,1.68,1.68,0,0,0-.06-1.73l-.82-1.28,9.07,3.7,1.4-1.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.06,206.77c2.5,3.73,5.24,7.95,6.23,9.86l-2.54-1c-3.61-6.36-5.19-11.66-11.87-15C317.88,200.56,322.34,201.23,326.06,206.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.22,195.12l39.72,9.29s1.87,12.74-1.14,20.58-11.25,9.85-15,9.85c-4.58,0-11.41-2.3-11.41-2.3s-1.46,1.58-6.27,3.7c-2,.86-5.77,2-8.24,2.82a3.8,3.8,0,0,1-4.18-1.32,21,21,0,0,1-4.25-9,3.81,3.81,0,0,1,1.37-3.6l9.44-7.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,232.33c3.4.45,10.91-.93,13.87-7.35s2-15.07,1.37-21.52l1.09.26,3,.69h0s1.87,12.74-1.14,20.58-11.25,9.85-15,9.85c-4.58,0-11.41-2.3-11.41-2.3a15.23,15.23,0,0,0,2.89-4s-.3,1.53-.62,2.61A33.1,33.1,0,0,0,360.63,232.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.3,219.13s2.51-2.11,4.12-3.39c2.76-2.2,3.4-3.06,7.25-3.14,5.55-.1,16.22,1.18,16.22,1.18s-11.2-2.67-15.05-3.31-6.24-.26-8.43,1.68-6.2,6.08-6.2,6.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.78,214a11.42,11.42,0,0,1-1.56-7.19s-2.47,4.72-.8,9.59Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.63,180c5.77,2.92,9.18,3.93,7.83,2.59-.84-.84-4-3.46-3-4.66s4.09.8,6.74,2.45a13.46,13.46,0,0,0,5,2.15c7.09.21,18.78-2.8,18.78-2.8s7.47-11,14.1-20.38c3.79-5.39,11.05-6.21,11.05-6.21,3.8,8.49,2.21,14.29-1.29,19s-10.66,15.42-10.66,15.42c-3.16,3.63-3.56,3.91-9.69,5a108.4,108.4,0,0,1-26.61,1.61c-5.1-.39-8.41-1.33-10.65-3.15C283.9,186.57,283,177.58,287.63,180Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.41,152.72c-4,.28-8.18.86-12.65,6.33s-13.74,20-13.74,20l-12.76,3.06s1.68,1.23,2.44,5.25a8.51,8.51,0,0,1-1.82,6.86s7.13-.49,13.31-.94,8.59-1.22,10.76-3.49,14.46-20.57,14.46-20.57S352.81,160.87,349.41,152.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.41,152.72c-4,.28-8.18.86-12.65,6.33s-13.74,20-13.74,20l-12.76,3.06s1.68,1.23,2.44,5.25a8.51,8.51,0,0,1-1.82,6.86s7.13-.49,13.31-.94,8.59-1.22,10.76-3.49,14.46-20.57,14.46-20.57S352.81,160.87,349.41,152.72Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.54,157.16c3.9,1.63,4.15,16.21,3.8,51.19-9.86,6.83-39.91,1.57-41.95-11.68-.54-6.16-.35-20.37,0-26.42.42-7.29,1.55-11.77,5.06-14.54,6.24-4.91,12.45-3.49,18.06-2.57A70.84,70.84,0,0,1,376.54,157.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.45,155.71c-2.61,2.06-3.9,5.06-4.56,9.44,8.61,5.29,31.07,10.45,41.22,6.43-.48-9.11-1.52-13.56-3.57-14.42a70.84,70.84,0,0,0-15-4C355.9,152.22,349.69,150.8,343.45,155.71Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,148.14c3.18-3.38,7.46-5.68,9.35-11.74,2.12-6.81.19-13.2-3.86-14.43,0,0-.22-5-6.46-7.69-4.93-2.11-12.47-1.48-17.09,1.17a14.22,14.22,0,0,0-5.93,5.79,13.93,13.93,0,0,0-1.13,9.23,9.28,9.28,0,0,0,3.84,5,20.85,20.85,0,0,0,5.89,2.59c1.28.39,2.57.73,3.85,1.13a9.53,9.53,0,0,1,2,.67,6.88,6.88,0,0,1,1.11,1.05l6.36,6A4.61,4.61,0,0,0,364.81,148.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.15,135.14c.53-.21.59-.56,1.49-1.27a3.18,3.18,0,0,1,3.37-.09c2.35,1.56,2.58,6.94-1.56,8.9a2.77,2.77,0,0,1-2.4-.31c.05,3.06,0,6.14,0,9.21v2.64c0,.22.12.85,0,1,0,0-1.22,3.15-7.08,4.65-7.09,1.82-9.44-1.84-7.44-4.24l-.06-3.77a17,17,0,0,1-5.26-.72,10,10,0,0,1-6.58-7.85c-.49-2.56.28-4.85.25-7.45,0-1.55-.15-4-.12-5,0-1.23-.11-4.89,1.41-6.84,2.37,1.15,9,3.55,18.2.9-.32,2.64.25,4.32,1.52,5.61a8.58,8.58,0,0,0,1.65,1.37c.44.25.72.31.79.87.08.78-.52,1.76.35,2.3A1.38,1.38,0,0,0,366.15,135.14Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.5,140.07c.88-3.67-3.11-14.73-15.32-19.11s-16.72.89-16.72.89,1.71-6.71,12.65-8.83c11.45-2.22,20.92,6.71,21.92,14.37S373.84,138.52,372.5,140.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.28,131.52l3.63,1.68a2.11,2.11,0,0,0-1-2.72A2,2,0,0,0,355.28,131.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.71,142.37l-5.3,1.12a2.85,2.85,0,0,0,3.31,2.13A2.64,2.64,0,0,0,354.71,142.37Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.14,143.45a2.14,2.14,0,0,1,.58.14,2.59,2.59,0,0,1-2,2,3,3,0,0,1-.59.06,2.16,2.16,0,0,1,0-.44A1.91,1.91,0,0,1,354.14,143.45Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.87,135.33a1.64,1.64,0,1,1-1.53-1.74A1.64,1.64,0,0,1,357.87,135.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.18,134.59a1.64,1.64,0,1,1-1.53-1.75A1.65,1.65,0,0,1,346.18,134.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.23,131.84l3.88-1.07a1.92,1.92,0,0,0-2.4-1.44A2.11,2.11,0,0,0,342.23,131.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.19 133.2 349.4 140.72 345.26 139.31 350.19 133.2",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.47,151.9a26.48,26.48,0,0,0,9.79-3,9.82,9.82,0,0,0,3.57-4.66,12.32,12.32,0,0,1-2.15,4.82c-3.93,4.36-11.16,4.77-11.16,4.77Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.16,146.5Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.13,145.9h0S356.19,145.92,356.13,145.9Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.92,221.88c5.92-2.61,8.86-4.61,7-4.42-1.18.13-5.23.94-5.49-.65s3.21-2.66,6.17-3.67a13.51,13.51,0,0,0,4.84-2.51c4.65-5.35,9.72-16.31,9.72-16.31s-5.49-18-6.31-24.46,3.27-12.73,3.27-12.73c9,2.43,10.19,6.27,11.61,12s4.46,17.8,4.46,17.8c.8,4.75,1.13,7.3-1.27,12.53a83.13,83.13,0,0,1-15.25,21.91c-3.53,3.7-6.35,5.67-9.17,6.25C359.68,229,352.14,224,356.92,221.88Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.75,156.82a38.1,38.1,0,0,1,6.34,2.53c2.8,1.44,4.45,2.44,7.06,13.06s3.8,16.41,4.13,18.24,1.17,3.53-1.45,8.38a109,109,0,0,1-6.47,10.18s-2.53,0-6.38-2.45-4-5.35-4-5.35l3.37-7.23s-4.91-16.93-6.06-20.23S371.62,162.1,375.75,156.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.75,156.82a38.1,38.1,0,0,1,6.34,2.53c2.8,1.44,4.45,2.44,7.06,13.06s3.8,16.41,4.13,18.24,1.17,3.53-1.45,8.38a109,109,0,0,1-6.47,10.18s-2.53,0-6.38-2.45-4-5.35-4-5.35l3.37-7.23s-4.91-16.93-6.06-20.23S371.62,162.1,375.75,156.82Z",
    style: {
      opacity: 0.25
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-6--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419,281.35s20.71-7.81,23.27-10c2.13-1.79.85-6.07,3.81-6.8,3.41-.84,5.85,1,8,3.12s4.78,2.85,9.89,1,10-4.41,12.1-3.38.69,2.68-8.24,6.93c-5.14,2.45-11.67,5.29-15.86,7a34.46,34.46,0,0,0-8.48,4.72,156.06,156.06,0,0,1-12.92,8.77c-12.92,8-20.52,10.08-30.79,8.07Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.39,274c4.11,2.37,6.1,5,6.34,9.55,0,0-2.78,2.15-7.17,5.19-5.27,3.65-18,11.94-26.53,12.81-13.19,1.35-17.71-2.05-17.71-2.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.21,276.51c-6.76,11.73-23.27,19-28.45,19.57,1.83-1.55,4.52-6.81,7.07-12.52l17.56-10.08A15.71,15.71,0,0,1,442.21,276.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481,264.4a3,3,0,0,0-.49-2.44,16.92,16.92,0,0,0-5.74-4.22,12.27,12.27,0,0,0-6.17-1.19c-4.05.25-7.53,3.36-11.58,3.6-3,.18-5.77-1.4-8.71-2.14a9.06,9.06,0,0,0-2.83-.25,3.14,3.14,0,0,0-2.38,1.33,3.71,3.71,0,0,0-.22,2.68,7,7,0,0,0,2.11,2.22,13.45,13.45,0,0,0,4.13,1.54C453.21,266.79,471.8,267.24,481,264.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.17,270.23c0,.38-.06.75-.1,1.13s.21.68.63,1c1.71,1.2,3.86,1.08,5.8.73a12.23,12.23,0,0,1,4.56-.4c1.8.36,3.24,1.72,4.58,3a4,4,0,0,1,.73,1s10.44-4.59,15.2-7.18c2.4-1.31,5.18-2.54,7.07-4.61.11-.11-.46-.84-.51-.91a4.54,4.54,0,0,0-2.41-1.39,12.28,12.28,0,0,0-4.59-.32c-2.33.36-4.61,1-6.92,1.47a58.46,58.46,0,0,1-6.29.91,46.74,46.74,0,0,1-6.9.12,16.86,16.86,0,0,1-6.29-1.38,9,9,0,0,1-2.16-1.36,7,7,0,0,1-1-1.31c-.33-.48-.52-1.28-.85-.6a13,13,0,0,0-.85,5.92c.08,1.25.24,2.49.28,3.74C442.18,269.92,442.17,270.08,442.17,270.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.17,270.23c0,.38-.06.75-.1,1.13s.21.68.63,1c1.71,1.2,3.86,1.08,5.8.73a12.23,12.23,0,0,1,4.56-.4c1.8.36,3.24,1.72,4.58,3a4,4,0,0,1,.73,1s10.44-4.59,15.2-7.18c2.4-1.31,5.18-2.54,7.07-4.61.11-.11-.46-.84-.51-.91a4.54,4.54,0,0,0-2.41-1.39,12.28,12.28,0,0,0-4.59-.32c-2.33.36-4.61,1-6.92,1.47a58.46,58.46,0,0,1-6.29.91,46.74,46.74,0,0,1-6.9.12,16.86,16.86,0,0,1-6.29-1.38,9,9,0,0,1-2.16-1.36,7,7,0,0,1-1-1.31c-.33-.48-.52-1.28-.85-.6a13,13,0,0,0-.85,5.92c.08,1.25.24,2.49.28,3.74C442.18,269.92,442.17,270.08,442.17,270.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.38,263c1.95,2.76,1.94,7.65,1.94,7.65a73.47,73.47,0,0,0,6.64-3.35c3.16-1.82,3-2.86,3-2.86A2.94,2.94,0,0,0,480,263a5.73,5.73,0,0,0-4.25-1.31A26.34,26.34,0,0,0,469.38,263Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.52,269a5.7,5.7,0,0,1,.2,2.43,2.73,2.73,0,0,1-1,.5,10.1,10.1,0,0,0-.25-2.49C468.21,268.69,469.28,268.3,469.52,269Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.34,270.47a5.64,5.64,0,0,1,.22,2.43,2.78,2.78,0,0,1-1.05.49,9.4,9.4,0,0,0-.25-2.48C465,270.2,466.11,269.8,466.34,270.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.17,272a5.76,5.76,0,0,1,.2,2.41,2.65,2.65,0,0,1-1,.52,10.14,10.14,0,0,0-.25-2.49C461.86,271.7,462.93,271.3,463.17,272Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.74,260.1a2,2,0,0,1,.31-1s1,2.21,4.78,3.49c3.54,1.22,8.6,1.81,15.91.06s11.52-3.35,14.82-2S481,264.4,481,264.4s-1.58-3-6.21-2.44c-4.47.54-11,3-17.15,3.21C451.21,265.42,444.76,264.58,442.74,260.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.86,272.41c2-7.27,8-12.55,17.08-20.12,7.66-6.42,21.82-16.82,21.82-16.82h0l40.35-8c1.64,7.36,7,12.56,7,22.8,0,7.45-1.17,18-14.2,27.63C433,283.74,426.7,288.35,421,292c-6,3.8-19.51,11.29-27,7.87-5.72-2.62-6.71-7.65-6.5-11.84h0c-.92.08-1.83.13-2.68.14s-1.89,0-2.6,0a17.84,17.84,0,0,1-7.74-1.95C369.62,283.68,367.23,278.24,368.86,272.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.86,288.12c.85,0,1.77-.06,2.69-.14,1.31-8.15,32-31.71,32-31.71-2.14-1-7.08-3.68-8.74-6.66.68,3.79,2.85,5.72,5,7.25-3.24,2.91-16.86,14.39-20.49,17.84C391.46,278.33,386.71,283,384.86,288.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.27,182.26a7.63,7.63,0,0,1-.09-.95c-.2-4.52,2.58-8.83,6.37-11.29,3.41-2.21,7-3.84,10-6.65l-8.87-5.6c-5.43-3-5.15-8-3.77-11.69,3.07-8.25,12.07-11.24,17.62-11.47,10.53-.43,15.63,2.36,16.64,7.82,3.88-.27,7.28,3.9,7.79,15.66a22.07,22.07,0,0,0,1.19,6.74,9.36,9.36,0,0,0,3.49,4.51c3,2.32,6.74,4.1,8.74,7.5a9.8,9.8,0,0,1,1.12,6.91,8.86,8.86,0,0,1-2.13,4,3.5,3.5,0,0,0-.71,3.62,10.07,10.07,0,0,1-1.74,9.16,12.24,12.24,0,0,1-7.55,4,22,22,0,0,1-8.51-1.28,17.27,17.27,0,0,0-5.92-1c-2.41,0-4.77,1-7.06,1.7-2.76.8-5.46,1.92-8.4,1.57a13,13,0,0,1-7.36-3.81,9.29,9.29,0,0,1-2.42-4.25c-.18-.62-.89-7.16-.12-7.13C408.39,190.19,404.9,186.42,404.27,182.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.5,179.41c-3.78-5.47-4.06-11.88-2.15-22.51l1.34.87,13.47,2.28-2.64,18.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.18,188.33a4.2,4.2,0,0,1,2.43-.58,27.79,27.79,0,0,1,4,.81c2,.39,5.34,1.05,7.33.31.4-.15,1.2-.58.48-.91a17.13,17.13,0,0,1-2.78-1.38A3.71,3.71,0,0,1,358,184.1a1.22,1.22,0,0,1,.17-.9c.25-.36.54-.28.87-.16a9.28,9.28,0,0,0,1.07.26q1.13.22,2.25.48c4.35,1,8.81,2.3,12.18,5.36.49.45,3.76,4.14,5.76,6.17,1.7,1.88,13.66,13.3,13.66,13.3l9.24-17.4c2.05-4,4.07-7.62,6.62-9.2,4.8-3,8.08-2.74,8.08-2.74L416.12,203s-10.77,15.22-12.33,17.33c-2.31,3.14-7.19,8.59-11.35,5.86-5.64-3.7-9.92-10.27-13.57-15.16s-5.73-7.91-7.42-9.46-3.51-1.11-4.88-1.1a20.46,20.46,0,0,1-5.62-.57,18.93,18.93,0,0,1-4.69-1.58,5.83,5.83,0,0,1-2-1.29c-.39-.54-.49-1.24-1-1.76s-1.3-.91-1.75-1.56a6.69,6.69,0,0,1-.67-1.71,3.13,3.13,0,0,0-1.93-1.66,3,3,0,0,1-1.13-.71C347.36,189.09,347.69,188.64,348.18,188.33Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.55,178.64c-5.1.2-9.81,2.85-12,6.09-2.43,3.55-13.22,21.43-13.22,21.43l-9.82-7.67a11.67,11.67,0,0,1-3,7.37c-3.25,3.59-5.21,3.66-5.21,3.66s7.6,9.21,12.73,14,7.6,6.12,12.15,2,18.37-23.46,18.37-23.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.55,178.64c-5.1.2-9.81,2.85-12,6.09-2.43,3.55-13.22,21.43-13.22,21.43l-9.82-7.67a11.67,11.67,0,0,1-3,7.37c-3.25,3.59-5.21,3.66-5.21,3.66s7.6,9.21,12.73,14,7.6,6.12,12.15,2,18.37-23.46,18.37-23.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,189.89a13.69,13.69,0,0,0,6.31,4.22,5.64,5.64,0,0,1-3.89-.64A5.26,5.26,0,0,1,364.82,189.89Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.31,206.16c3.54,3.21,5.87,8.05,6.23,10.79a14.06,14.06,0,0,0-5.19-12.53Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.19,244.93l6.84-5.19,5.74-4.26,7.2-40.16H403.85a86.24,86.24,0,0,0-2.46,19.2C401.17,225.64,398.78,241.34,395.19,244.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.22,179.63s-1.68-.63-16-1l-2.72,0s-8.24,6.38-11.94,12.13-5.62,13.65,0,21l.4,15.65-3.49,11s0,9.09,12.19,12.32c12.68,3.38,29.51-5.12,29.51-5.12s1.84,5,9.9,5.73c0,0,.23-7.68-1.12-12.07-2.54-8.33-5.16-10.26-5.37-14.28s1.69-13.07,1.69-13.07-3.93-3.5-5.33-12c-1.82-11,.87-17.91.87-17.91Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.09,180.94c-5.19,3.8-15.34,11.3-17.15,22.17S402,239.74,402,239.74l-6.84,5.19s3.31-8.53,3.83-15-1.09-25.25,4-35.69a34.31,34.31,0,0,1,15.52-15.57h3.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.09,180.94c-5.19,3.8-15.34,11.3-17.15,22.17S402,239.74,402,239.74l-6.84,5.19s3.31-8.53,3.83-15-1.09-25.25,4-35.69a34.31,34.31,0,0,1,15.52-15.57h3.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.68,180.75a47.7,47.7,0,0,1-2.34,11.3c-2.21,7.14-5.22,16.33-4.65,30.91s4,30.14,1.94,40.64c4.23,4.24,19.34-.26,22.49-1.45,3-9.8,2.74-17.56,0-29.48s-8-46.36-7.82-50.41l-9.62-3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.68,180.75a47.7,47.7,0,0,1-2.34,11.3c-2.21,7.14-5.22,16.33-4.65,30.91s4,30.14,1.94,40.64c4.23,4.24,19.34-.26,22.49-1.45,3-9.8,2.74-17.56,0-29.48s-8-46.36-7.82-50.41l-9.62-3Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.75,167.53a5.39,5.39,0,0,0,4.79-2c2.47-2.87,2.64-5.73,1.4-7.6-1-1.54-3.45-2.47-5.11-1.37s-1.8,2.1-2.45,3.39-3.29,1.25-4.05-3.88c-.71-4.79-1.56-9.18-4-11.29-3.6-3.15-7.49-2.52-8.84-.57-1.49-2.2-3.7-3.05-6.07-1.71s-4.1,5-4.69,14.12c-.6,9.31,1.5,15.85,3.67,17.35,1.65,1.15,3.71,1.35,7.2,1.42l-.23,5.44s-7.32,11,4.53,8.74A16.56,16.56,0,0,0,438,181.38l.72-15.26S438.94,167.24,440.75,167.53Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,157.1a1.54,1.54,0,1,0,.95-2A1.57,1.57,0,0,0,426,157.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.94,153l3.23-1.75a1.78,1.78,0,0,0-2.44-.78A1.93,1.93,0,0,0,413.94,153Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.86,156.81a1.54,1.54,0,1,1-.95-2A1.56,1.56,0,0,1,417.86,156.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.13,151.56l3.38,2a1.88,1.88,0,0,0-.62-2.66A2.06,2.06,0,0,0,427.13,151.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.36,164.76l-5.08,1.57a2.67,2.67,0,0,0,3.57,1.66A2.49,2.49,0,0,0,427.36,164.76Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.39,168.13a2.78,2.78,0,0,1,2.83-2.45,2.3,2.3,0,0,1,.26,0,2.34,2.34,0,0,1-1.63,2.28A3,3,0,0,1,424.39,168.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.83 153.87 422.02 163.02 417.01 161.25 422.83 153.87",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.64,175.42a32.79,32.79,0,0,0,9.88-2.09c1.14-.49,2.7-2.57,4-4.89,0,0-.9,4.58-3.38,6.14-3.78,2.39-10.55,2.94-10.55,2.94Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.42,220.56c-2-8.7-5.72-23.08-8.06-29s-6.3-8.33-14.52-9.58c-7.56,9.9-1.74,25-1.74,25L449.82,222,443,230.57s1.86,1.64,5.4,4.24c4.14,3,7.16,4.81,11.3,5.15s8.53-.55,9.31-2C470.85,234.72,470.14,228,468.42,220.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.42,220.56c-2-8.7-5.72-23.08-8.06-29s-6.3-8.33-14.52-9.58c-7.56,9.9-1.74,25-1.74,25L449.82,222,443,230.57s1.86,1.64,5.4,4.24c4.14,3,7.16,4.81,11.3,5.15s8.53-.55,9.31-2C470.85,234.72,470.14,228,468.42,220.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,219.62c1.31,1.87,2.84,2.63,6.17,4.24,3.11,1.51,6.71,2.95,8.55,6.37-.5-3.15-2.2-4.72-6.07-7s-9.54-4.92-9.54-4.92Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.43,222.39c1.56-1.36,1.93-2.84,4.19-3.93s3.61-1,6-2,4.3-1.49,6-.81,1.36,1.67,0,2.4-3.69,1.67-5.33,2.7-3.21,1.58-3.35,3.56a88.1,88.1,0,0,0,.06,9.41c.2,3.35.67,6.08.4,6.42s-1.71.4-2.46-1.51-1.42-8.73-1.42-8.73-1,4.64-1.44,7.84-.76,5.66-.9,6.35-2.39,0-2.59-2.46.77-9.64.77-9.64l-3.49,5.2c-1.37,2-3.08,4.84-3.62,5.52s-1.91-.69-1.43-2.6,3.28-6.47,3.28-6.47-3.21,2.93-3.76,3.2-2.12-.09-1.43-2.19c.47-1.4,1.44-2.25,4-4.84s2.64-3.73,3.48-4.94C444.53,223.31,445.3,223.38,446.43,222.39Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.33,223.92c-2.47.9-4.74-.34-5-1C447.35,224.62,450.57,225.81,452.33,223.92Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.77,235.91a1.09,1.09,0,0,0,1.52,0,40.08,40.08,0,0,0,3-2.76c.73-.72,3.23-3.3,3.23-3.3l-2.38,3.82s-3.21,2.93-3.76,3.2A1.17,1.17,0,0,1,435.77,235.91Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.32,135c10.71.46,15.22,5,17.51,16.57s.31,19-2.05,23.73-11.16,9.19-15.26,3.25c-5.56-.81-9.53.19-11.85,1.86-1.21,6.94-3.15,16.08,8.17,22.93s32.27-2.25,35.34-15.43-1.44-19.15-2.51-25-.84-15.42-6.51-21.36S431.34,131.07,422.32,135Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leg--inject-59"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.44,234.2a3.52,3.52,0,0,1-1.55,3,16.62,16.62,0,0,1-12.37,1c-4.67-1.44-6.78-3.87-7.69-7.06s-.66-6.74.64-11c.85-2.76.26-6.5-.08-9.31-.59-4.77-.14-7.64,1.41-9.83a6.75,6.75,0,0,1,7.68-2.57l-.92,32.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.7,219.66c0,4.29,1,5.85,2.84,8.4,1.65,2.24,5.95,5.77.44,8.47-4.28,2.11-14.94,1.88-17.78-5.21-2.21-5.51,1.12-10.67.29-17.9-.55-4.85-.12-13.31,5.51-14.61,3.08-.71,4.08-.65,8.9,1.82,3.35,1.71,3.63,2.49,3.5,2.94l-.82-.38a6.15,6.15,0,0,0-6.41,2.75c-1.94,3-2.18,7.53-.09,10.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,173,97.8,166.52c-1.24,5.11-2,15.19.12,22.89S107.18,210,107.18,210L89.62,201s-3.63-.33-6.32,4.52c-4.24,7.67-.24,15.36-.24,15.36s20.86,12.31,34.09,20.27c13.08,7.87,21.35,10.32,28.49,4.62,4.22-3.37,5.12-9.61,3.48-18.55C146.34,212.08,124.44,173,124.44,173Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,173,97.8,166.52c-1.24,5.11-2,15.19.12,22.89S107.18,210,107.18,210L89.62,201s-3.63-.33-6.32,4.52c-4.24,7.67-.24,15.36-.24,15.36s20.86,12.31,34.09,20.27c13.08,7.87,21.35,10.32,28.49,4.62,4.22-3.37,5.12-9.61,3.48-18.55C146.34,212.08,124.44,173,124.44,173Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15,241.17c-13.23-8-34.09-20.27-34.09-20.27s-4-7.69.24-15.36C86,200.73,89.55,201,89.61,201h0L107.18,210h0s-3.24-5.84-6-12v0h0l-.34-.76h0l0,0-.31-.72,0,0c-.49-1.14-1-2.28-1.37-3.38l0-.07c-.14-.35-.27-.71-.39-1l24-6.3c-1.37,7.9-9.81,14.47-9.81,14.47s8.82,23.07,13.16,34.36c3.41,8.87,11.26,11.49,16.91,10.12a8.76,8.76,0,0,0,6.54-5.6h0A15.94,15.94,0,0,1,149,241h0c-.12.32-.24.64-.38.94,0,0,0,0,0,.05q-.2.44-.42.84l-.07.11c-.14.25-.29.48-.44.71l-.16.21c-.14.19-.28.38-.43.56l-.3.33c-.12.13-.23.26-.36.38a9.13,9.13,0,0,1-.73.65,14.93,14.93,0,0,1-2.74,1.76,12.59,12.59,0,0,1-2.15.84,13.14,13.14,0,0,1-3.82.52h0c-.5,0-1,0-1.54-.09a21.52,21.52,0,0,1-3.51-.66c-.89-.25-1.82-.55-2.78-.91-.64-.24-1.29-.5-2-.79a85.71,85.71,0,0,1-10-5.29Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,220.8c-5.19-6.66-19.57-15.78-22.74-17.86A6.17,6.17,0,0,1,89.61,201h0l8.78,4.47,8.78,4.47s8.49,18.37,15.4,21.16A32.7,32.7,0,0,1,108,220.8Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Le--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.82,248a3.53,3.53,0,0,1-1.55,3,16.69,16.69,0,0,1-12.38,1c-4.66-1.45-6.77-3.88-7.68-7.07s-.67-6.74.64-11c.85-2.76.26-6.5-.08-9.3-.59-4.78-.14-7.65,1.41-9.84a6.74,6.74,0,0,1,7.68-2.56l-.92,32.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.08,233.41c0,4.3,1,5.85,2.84,8.4,1.65,2.24,6,5.77.44,8.48-4.28,2.1-14.94,1.88-17.78-5.22-2.21-5.51,1.12-10.67.29-17.9-.55-4.85-.12-13.31,5.51-14.6,3.07-.71,4.08-.65,8.9,1.81,3.35,1.72,3.63,2.49,3.5,2.94L68,217a6.13,6.13,0,0,0-6.41,2.74c-1.94,3-2.18,7.53-.09,10.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,219.09a7.36,7.36,0,0,1,8.82-3.83l13.19,7.27s-7.67-12.56-10.59-20c-3.45-8.81-4.71-14-3.18-26.76l35.62-.62,21.18-.33a28.11,28.11,0,0,1-15.31,24.43s11.91,29.41,14.29,39.34c2.25,9.36.66,16.4-3.56,19.77-7.14,5.7-16.41,4.8-29.49-3.06-13.23-8-31.77-21.09-31.77-21.09A17.12,17.12,0,0,1,60,219.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,219.09a7.36,7.36,0,0,1,8.82-3.83l13.19,7.27s-7.67-12.56-10.59-20c-3.45-8.81-4.71-14-3.18-26.76l35.62-.62,21.18-.33a28.11,28.11,0,0,1-15.31,24.43s11.91,29.41,14.29,39.34c2.25,9.36.66,16.4-3.56,19.77-7.14,5.7-16.41,4.8-29.49-3.06-13.23-8-31.77-21.09-31.77-21.09A17.12,17.12,0,0,1,60,219.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.87,233.37c-8.06-11.07-15.27-15.66-19-17.92a7.94,7.94,0,0,1,5-.19h0l13.19,7.27s8.49,18.37,15.4,21.16A29.63,29.63,0,0,1,82.87,233.37Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.51,113.06c13-3.1,17,1.16,23.75,7.35,5.4,4.91,16.71,16.38,16.71,16.38s15.38-11.82,17.84-15.18c1.35-1.84,1.09-1.89,2-4.5.38-1.11,2.28-1.68,2.83-2.44,1.94-2.72,4.4-4.6,5.38-6.91.77-1.84,3.64-.53,2.7,3.1a17.47,17.47,0,0,1-1.32,3,13.19,13.19,0,0,0,3.26-3c2.12-3.26,3-7.55,6.42-9.41,1.47-.79,2.22.31,1.48,2.66a2,2,0,0,1,1.9,2.26c1-.1,2,1.59,1.55,3.28.71.47,2,1.77.11,6.79a26.47,26.47,0,0,1-3.86,6.22,50.51,50.51,0,0,1-7,5.29,36.83,36.83,0,0,0-7.75,6.22c-3.39,3.29-11.55,12.61-19.3,19.57-6.46,5.78-10.28,2.31-16.51-3-4.12-3.51-17.53-15.08-17.53-15.08C122.79,128,116,119.53,116.51,113.06Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,146.46s-12.61-10.75-15.11-13.23-1.35-15.71-.73-24.59c4.2.57,6.87,2.18,11,5.93,4.79,4.38,22.33,21.56,22.33,21.56l6.09-4.47s-.78,3.78,2.63,8.4,7.34,4.72,7.34,4.72S168,150.56,162.93,155s-7.86,3-11.69.33S139.81,146.46,139.81,146.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.26,136.13c-2.62,2.08-4,7.67-2.18,11.41a9.58,9.58,0,0,1,.6-13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.12,118.64c-5.14.11-9.29,4-9.34,8.23a5.85,5.85,0,0,1,1.34-6.24C184.6,119,188.12,117.91,191.12,118.64Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.46,105.38,182.2,124h0a2.63,2.63,0,0,0,.22.94,4.56,4.56,0,0,0,2,2,12.23,12.23,0,0,0,10.72,0,4.53,4.53,0,0,0,2-2,2.7,2.7,0,0,0,.22-.82h0a1,1,0,0,0,0-.24h0l.74-18.46a3.39,3.39,0,0,0,.62-1.78l-.89,23.16V127a4.12,4.12,0,0,1-2.34,3.07,12.54,12.54,0,0,1-11.38,0,4,4,0,0,1-2.35-3.2v-.08l-.89-23.21A3.35,3.35,0,0,0,181.46,105.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46,105.38,182.2,124h0a2.63,2.63,0,0,0,.22.94,4.56,4.56,0,0,0,2,2,12.23,12.23,0,0,0,10.72,0,4.53,4.53,0,0,0,2-2,2.7,2.7,0,0,0,.22-.82h0a1,1,0,0,0,0-.24h0l.74-18.46a3.39,3.39,0,0,0,.62-1.78l-.89,23.16V127a4.12,4.12,0,0,1-2.34,3.07,12.54,12.54,0,0,1-11.38,0,4,4,0,0,1-2.35-3.2v-.08l-.89-23.21A3.35,3.35,0,0,0,181.46,105.38Z",
    style: {
      fill: "#fff",
      opacity: 0.8300000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.46,107.14a13.94,13.94,0,0,0,12.64,0,6.07,6.07,0,0,0,2-1.74l-.74,18.46h0v.24h0a2.7,2.7,0,0,1-.22.82,4.53,4.53,0,0,1-2,2,12.23,12.23,0,0,1-10.72,0,4.56,4.56,0,0,1-2-2,2.63,2.63,0,0,1-.22-.94h0l-.74-18.62A6,6,0,0,0,183.46,107.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.46,107.14a13.94,13.94,0,0,0,12.64,0,6.07,6.07,0,0,0,2-1.74l-.74,18.46h0v.24h0a2.7,2.7,0,0,1-.22.82,4.53,4.53,0,0,1-2,2,12.23,12.23,0,0,1-10.72,0,4.56,4.56,0,0,1-2-2,2.63,2.63,0,0,1-.22-.94h0l-.74-18.62A6,6,0,0,0,183.46,107.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.35,124.06a3.73,3.73,0,0,1-2.21,2.85,12.16,12.16,0,0,1-10.72,0,3.77,3.77,0,0,1-2.22-2.85l-.62-15.46c-.07-1.21.73-2.44,2.39-3.36a13.29,13.29,0,0,1,11.61,0c1.67.92,2.47,2.15,2.4,3.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14,126.91a12.16,12.16,0,0,1-10.72,0c-3-1.66-3-4.34,0-6a12.16,12.16,0,0,1,10.72,0C198.1,122.57,198.1,125.25,195.14,126.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.35,124.06a3.73,3.73,0,0,1-2.21,2.85,12.16,12.16,0,0,1-10.72,0,3.77,3.77,0,0,1-2.22-2.85l-.62-15.46c-.07-1.21.73-2.44,2.39-3.36a13.29,13.29,0,0,1,11.61,0c1.67.92,2.47,2.15,2.4,3.36Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.58,111.68a13.36,13.36,0,0,1-11.61,0c-3.2-1.78-3.2-4.66,0-6.44a13.29,13.29,0,0,1,11.61,0C198.78,107,198.78,109.9,195.58,111.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,111.68a13.49,13.49,0,0,0,10.22.61c-4.42.77-8.58-1.29-8.21-4a.55.55,0,0,1,0-.17,10.23,10.23,0,0,1-2.56-1,6.89,6.89,0,0,1-1-.71C180.9,108.13,181.42,110.26,184,111.68Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.84,103.58v0a3.35,3.35,0,0,0,.62,1.76,6,6,0,0,0,2,1.76,13.94,13.94,0,0,0,12.64,0,6.07,6.07,0,0,0,2-1.74,3.39,3.39,0,0,0,.62-1.78c.06-1.37-.81-2.74-2.61-3.78a14,14,0,0,0-12.64,0C181.67,100.87,180.8,102.23,180.84,103.58Zm3-3.37a13.52,13.52,0,0,1,11.84,0c3.27,1.81,3.27,4.75,0,6.57a13.59,13.59,0,0,1-11.84,0C180.59,105,180.59,102,183.86,100.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.84,103.58v0a3.35,3.35,0,0,0,.62,1.76,6,6,0,0,0,2,1.76,13.94,13.94,0,0,0,12.64,0,6.07,6.07,0,0,0,2-1.74,3.39,3.39,0,0,0,.62-1.78c.06-1.37-.81-2.74-2.61-3.78a14,14,0,0,0-12.64,0C181.67,100.87,180.8,102.23,180.84,103.58Zm3-3.37a13.52,13.52,0,0,1,11.84,0c3.27,1.81,3.27,4.75,0,6.57a13.59,13.59,0,0,1-11.84,0C180.59,105,180.59,102,183.86,100.21Z",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86,106.78a13.59,13.59,0,0,0,11.84,0c3.27-1.82,3.27-4.76,0-6.57a13.52,13.52,0,0,0-11.84,0C180.59,102,180.59,105,183.86,106.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86,106.78a13.59,13.59,0,0,0,11.84,0c3.27-1.82,3.27-4.76,0-6.57a13.52,13.52,0,0,0-11.84,0C180.59,102,180.59,105,183.86,106.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.75,106.06a7.4,7.4,0,0,1-1.05.72,13.59,13.59,0,0,1-11.84,0,7.53,7.53,0,0,1-1.06-.72,6.7,6.7,0,0,1,1.17-.82,13.29,13.29,0,0,1,11.61,0A6,6,0,0,1,196.75,106.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.75,106.06a7.4,7.4,0,0,1-1.05.72,13.59,13.59,0,0,1-11.84,0,7.53,7.53,0,0,1-1.06-.72,6.7,6.7,0,0,1,1.17-.82,13.29,13.29,0,0,1,11.61,0A6,6,0,0,1,196.75,106.06Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.58,105.24l-.31-.16h0l-.5-.23a12.12,12.12,0,0,0-3-.8c-.29,0-.57-.07-.86-.09l-.74,0h-.41c-.27,0-.53,0-.79,0a13,13,0,0,0-2.67.4,9.91,9.91,0,0,0-2.34.91l-.32.18-.06,0-.25.17,0,0-.25.19h0l-.25.21a7.53,7.53,0,0,0,1.06.72,10.19,10.19,0,0,0,2.32.91C187.2,105.42,191.78,104.1,195.58,105.24Z",
    style: {
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.24,125.14l0,1.49v.1c.1,2.21,3.42,4,7.49,4s7.37-1.76,7.49-4v-.13l0-1.5c-.4,2.08-3.63,3.7-7.54,3.7S182.65,127.21,182.24,125.14Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,127.06a12.25,12.25,0,0,1-10.42-.15,3.77,3.77,0,0,1-2.22-2.85l-.61-15.13h0a3.57,3.57,0,0,0,1.26,2c.27,6,.33,11,2,13S190.77,128.57,194.84,127.06Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M176.46,118.41c1-4.35,2.64-5.42,4.14-6.9s4-4.76,4.69-1.75c.84,3.39-1.51,5.13-2.49,7.21a15.32,15.32,0,0,0-1.23,5.63Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.57,97.21c.14-2.58-4.24-9.24-6.09-12.76s-3.57-13.91,3-16.39c-.85-5.65,7.31-9.92,14.53-11,10.22-1.54,18.39,3.26,20.38,9.26s-1.59,9.42-1.59,9.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.25,80.8a18.27,18.27,0,0,1-3.49-8.34c2-8.81,9.17-18.42,23.58-19.47a19.66,19.66,0,0,1,10.16,5.12A29.5,29.5,0,0,0,95,66.26C86.34,74.26,86.25,80.8,86.25,80.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,91.42c2.69,1.93,4.2.28,4.2.28l-.3,12.89c.47,2.21,4.53,17.45,17.39,17.11,6.29-.17,6.08-12.49,2-15.93l.1-2.8a25.32,25.32,0,0,0,3.75-.12c3.47-.36,5.77-3,7-6.65,2-5.91,1.85-14.21.86-25.76-3.7-3.19-16.56-4-24.92.68,0,6.87-.14,9.25-1.3,11.76-.69,1.5-1.12,2-2.27,2.12-1.66.17-2.65-2.76-3.65-3.93s-4.39-2.83-6.29.71S86.67,89.76,89,91.42Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.38,97.27a.74.74,0,0,0,.12.13c.56.5,1.51.2,2.13,0,.21-.07.41-.15.61,0a1.6,1.6,0,0,1,.44.74,3.61,3.61,0,0,1,.24,2.15c-.16.57-.38,1.06-1,1.13a1.07,1.07,0,0,1-.47,0c-.06,0-.11-.09-.17-.11s-.17,0-.3.13a1.47,1.47,0,0,1-1,.62,1.63,1.63,0,0,1-.87-.15c-.15-.09-.18-.28-.33-.27s-.27.15-.37.19a1.39,1.39,0,0,1-.53.14,1,1,0,0,1-1-1c-.17.07-.32.17-.5.23a1.65,1.65,0,0,1-1,0,1.07,1.07,0,0,1-.73-1c-.34,0-.76.2-1-.18s-.06-.82,0-1.16a5,5,0,0,1,.68-1.59c.12-.21.37-.77.65-.78s.28.14.4.23a2.58,2.58,0,0,0,.94.46,1.41,1.41,0,0,0,1-.08.87.87,0,0,0,.26-.91,3,3,0,0,0,.71.24,2.68,2.68,0,0,0,1,.06,2.22,2.22,0,0,0-.07.31A.63.63,0,0,0,112.38,97.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.4,103c-4.51-.34-12.41-2.21-14.11-5.28a26.93,26.93,0,0,1-2.38-5.62S95.72,97,98.29,100s8.37,4.14,14,5.09Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,81.35a1.54,1.54,0,1,1-1.47-1.68A1.59,1.59,0,0,1,109.22,81.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.35,77.09l-3.29,1.83a2,2,0,0,1,.76-2.63A1.83,1.83,0,0,1,108.35,77.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.51,78.38l-3.64-1.07a1.82,1.82,0,0,1,2.3-1.32A2,2,0,0,1,122.51,78.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,81.38a1.54,1.54,0,1,1-1.46-1.68A1.59,1.59,0,0,1,121.6,81.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.67,78.07l.48,10.84,6.09-1.29C117.61,84,115.14,81,112.67,78.07Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.56,91.54l5.71.85a2.83,2.83,0,0,1-3.22,2.52A3,3,0,0,1,109.56,91.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.29,92.41a3.11,3.11,0,0,0-.69.06,3,3,0,0,0,2.45,2.44,2.57,2.57,0,0,0,.92,0A2.65,2.65,0,0,0,110.29,92.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.88,104.6C91.25,105.66,77.57,109,77.57,109s-5.18,14.72-8.09,49.37c-.38,8-2.14,14.33-2.15,26.38,0,0,2.36,3,27.87,3.79S127,177.45,127,177.45a168.29,168.29,0,0,1,.1-23.5c3.08-31.2,1.84-42.66-2.38-45-2.64-1.45-12.4-3.2-12.4-3.2s3.06,6.48-4.15,6.44C95.11,112.13,92.88,104.6,92.88,104.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,105.3a27.48,27.48,0,0,0,.93-4.17c.14-1.56.83-1.1.83-1.1A7.75,7.75,0,0,0,94.82,105c2,2.53,9.66,3.93,11,4.22a20.16,20.16,0,0,1,2.23,2.45,28.7,28.7,0,0,0,1.5-2.75,3.76,3.76,0,0,0,2.74-3.82l.07-2.08s.44.27.85,1.7,1.22,4.12,0,6.35a5,5,0,0,1-2.79,2.31s1.89,11.63,2,14.47a14.07,14.07,0,0,1-1.6,6.17s-3-2.73-3.76-5.58-1.85-14.32-1.85-14.32a25.81,25.81,0,0,1-7.89-2.33C93.12,109.72,91.74,107,91.23,105.3Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.57,122.68c3.83-10.14,10-11.42,14.88-12.92,6.21,7.25,5.24,18.08.81,31.63-3.12,9.55-7.06,21.82-7.06,21.82s16.83,4.35,21.88,2a16.66,16.66,0,0,0,4.23-2.34c3-1.93,4.19-2.22,7-3.91,2.21-1.33,3-2.72,3.53-2.36a3,3,0,0,1,.47,4,13.56,13.56,0,0,1-2.64,3.12,47.59,47.59,0,0,0,8.38-2.7c3.67-1.57,5.4-3.06,6.72-1.74.84.83.19,2.06,0,3-.25,1.1.26,2.35-.17,3.39-.25.6-.83,1-1,1.65s.2,1.52.1,2.28A3.34,3.34,0,0,1,119,171c-1,1.4-2.17,3.36-3.57,4.41a14.22,14.22,0,0,1-3.12,1.42,52,52,0,0,1-9.36,2.37c-5.89,1-9.33.55-15.15.82-10.88.49-24.1-.63-29.45-1.69-6-1.2-6.91-5.44-7.27-10.46C50.44,159.13,59.55,130.69,62.57,122.68Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.57,109c-6.36,1.34-10.22,2.93-14.19,9.74S53.75,148,52.16,154.94s-2.38,10.71-2.42,16.6c0,4.37,2.42,6.6,8.13,7.59,4,.69,14.56,1,14.56,1a40.14,40.14,0,0,1,.56-8.57,9.68,9.68,0,0,1,5-7.31L71.85,163l7.7-23.36S87,116.16,77.57,109Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.44,168c1.62-2.08,8.19-5,11.41-5l.8-2.43A13.78,13.78,0,0,0,60.44,168Z",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-59"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "444.13 314.09 444.13 372.89 438.78 369.8 438.77 311 444.13 314.09",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.13 314.09 444.13 372.89 449.49 369.8 449.49 311 444.13 314.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.85 399.05 296.85 457.85 291.49 454.76 291.49 395.96 296.85 399.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.85 399.05 296.85 457.85 302.2 454.76 302.2 395.96 296.85 399.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.46 181.52 214.46 240.33 209.1 237.23 209.1 178.43 214.46 181.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.46 181.52 214.46 240.33 219.81 237.23 219.81 178.43 214.46 181.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.17 266.48 67.17 325.28 61.82 322.19 61.82 263.39 67.17 266.48",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.17 266.48 67.17 325.28 72.53 322.19 72.53 263.39 67.17 266.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.85 411.26 456.65 319.11 456.65 306.87 296.85 399.02 296.85 411.26",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.85 411.26 52.34 270.12 52.34 257.88 296.85 399.02 296.85 411.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.65 306.87 296.85 399.02 52.34 257.88 212.14 165.73 456.65 306.87",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Food--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dates--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.39,251.85c10.21,5.89,10.21,15.45,0,21.35s-26.77,5.89-37,0-10.21-15.46,0-21.35S340.18,246,350.39,251.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plate--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.65,251.43c-9.8-5.66-25.7-5.66-35.5,0h0v-1c-5.13,3-7.57,6.88-7.34,10.76-.23,3.88,2.21,7.8,7.34,10.76,9.8,5.66,25.7,5.66,35.5,0S359.46,257.09,349.65,251.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.65,250.41c9.81,5.66,9.81,14.84,0,20.5s-25.7,5.66-35.5,0-9.81-14.84,0-20.5S339.85,244.75,349.65,250.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.65,250.41c9.81,5.66,9.81,14.84,0,20.5s-25.7,5.66-35.5,0-9.81-14.84,0-20.5S339.85,244.75,349.65,250.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.86,254.64c-6.74,3.89-6.74,10.2,0,14.09s17.66,3.89,24.4,0,6.74-10.2,0-14.09S326.6,250.75,319.86,254.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.69,255.12c-6.28,3.62-6.28,9.5,0,13.13s16.46,3.62,22.74,0,6.28-9.51,0-13.13S327,251.49,320.69,255.12Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dates--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M339.29,266.74c-3.76,0-6.8,1.36-6.8,3s3,3.05,6.8,3.05,6.8-1.37,6.8-3.05S343.05,266.74,339.29,266.74Zm-4-1.32c0-1.32-2.4-2.38-5.35-2.38s-5.36,1.06-5.36,2.38a1.13,1.13,0,0,0,.14.53h-.42c-3,0-5.35,1.07-5.35,2.38s2.4,2.39,5.35,2.39,5.35-1.07,5.35-2.39a1.21,1.21,0,0,0-.13-.52h.42C332.88,267.8,335.28,266.74,335.28,265.42Zm8.53-4.58c-3,0-5.35,1.06-5.35,2.38s2.39,2.38,5.35,2.38,5.35-1.06,5.35-2.38S346.77,260.84,343.81,260.84Zm-22.23.09c0-1.32-2.4-2.38-5.35-2.38s-5.35,1.06-5.35,2.38,2.39,2.38,5.35,2.38S321.58,262.25,321.58,260.93Zm15-2.51c3,0,5.35-1.07,5.35-2.39s-2.39-2.38-5.35-2.38-5.35,1.07-5.35,2.38S333.67,258.42,336.62,258.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.8,255.36c-1.14,2.45-4.83,3.16-8.22,1.57s-5.22-4.87-4.07-7.32,4.83-3.16,8.23-1.58S341,252.9,339.8,255.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,249.35a9.25,9.25,0,0,0-2.05-1.32,7.66,7.66,0,0,0-6.19-.34,3.92,3.92,0,0,0-2,1.92c-.57,1.21.21,2.5,1.57,3.64a6.47,6.47,0,0,1,3.26.84A5.38,5.38,0,0,1,334.6,256c1.13,0,2.2-1.33,3.08-1.63C339.05,253.94,340.1,251.86,337.79,249.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.56,254.07c-.49,0-.77-.41-1-.8a1.91,1.91,0,0,0-.92-1,2.58,2.58,0,0,0-1.2.08,2.22,2.22,0,0,1-1,0,1.12,1.12,0,0,1-.44-.27c-.11-.1-.23-.3-.36-.36a.16.16,0,0,0-.15,0,.15.15,0,0,0,0,.11.88.88,0,0,0,.05.15,1.58,1.58,0,0,0,1.32.88c.45,0,.84-.24,1.3-.24a1.37,1.37,0,0,1,1,.61c.32.38.33.87.86,1.12a2.44,2.44,0,0,0,1.71-.24c.1,0,.11-.28,0-.28C336.36,253.87,336,254.05,335.56,254.07Zm.46-4c-.36-.33-.25-.91-.71-1.2a1.55,1.55,0,0,0-1.18-.06c-.8.16-.89.26-1.69-.36s-1.14-.85-2-.28c0,0-.07.17,0,.14a1.64,1.64,0,0,1,1.77.25c.24.18.37.49.65.64.62.34.88,0,1.49-.07,1.24-.12,1.12,1.13,1.94,1.59a2.2,2.2,0,0,0,.71.19l.37.05c.07,0,.26,0,.3-.08s0-.2-.08-.25a1.57,1.57,0,0,0-.78-.22A1.61,1.61,0,0,1,336,250.07Zm-1.2.81a1.74,1.74,0,0,0-1.22-.25,2,2,0,0,1-2.07-.72,1.55,1.55,0,0,0-2-.45c-.06,0-.1.17,0,.15,1.43-.28,1.42.35,2.35,1.08a2.11,2.11,0,0,0,1.39.36,2.65,2.65,0,0,1,.89-.1,1.8,1.8,0,0,1,1.13,1c.2.21.23.35.48.51a1.77,1.77,0,0,0,1.09.17,3.63,3.63,0,0,1,.57,0c.09,0,.35,0,.32-.12s-.21-.21-.35-.21h-.56C335.49,252.15,335.64,251.43,334.82,250.88Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.58,259c.76,2.6,4.29,3.87,7.89,2.82s5.9-4,5.15-6.61-4.29-3.86-7.89-2.82S310.83,256.37,311.58,259Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5,253.34a9.19,9.19,0,0,1,2.23-1,7.65,7.65,0,0,1,6.17.62,3.94,3.94,0,0,1,1.72,2.2c.37,1.29-.6,2.45-2.11,3.36a6.48,6.48,0,0,0-3.47,0,13.94,13.94,0,0,0-3.16,1.55,3.59,3.59,0,0,1-2.57-1.49A4,4,0,0,1,314.5,253.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,258c-.12,0-.15.22-.05.27.47.26,1.1.66,1.66.5s.64-.64,1-1a1.35,1.35,0,0,1,1.13-.44c.45.07.8.37,1.25.44a1.56,1.56,0,0,0,1.44-.67.59.59,0,0,0,.06-.14.13.13,0,0,0,0-.12.14.14,0,0,0-.14,0c-.14,0-.29.22-.41.3a1.2,1.2,0,0,1-.48.2,2.56,2.56,0,0,1-.95-.12,2.55,2.55,0,0,0-1.18-.27,1.92,1.92,0,0,0-1.05.81c-.29.35-.63.72-1.12.63S315.22,258,314.81,258Zm.5-3.42a1.66,1.66,0,0,0-.8.1c-.07.05-.15.15-.12.24s.22.11.29.12a2.32,2.32,0,0,0,.37,0,2,2,0,0,0,.73-.08c.88-.33,1-1.58,2.17-1.27.58.15.79.54,1.46.3.3-.11.47-.39.74-.53a1.62,1.62,0,0,1,1.79,0c.08,0,.07-.11,0-.14-.78-.7-1.25-.48-2.05,0s-.95.38-1.72.1a1.53,1.53,0,0,0-1.18-.12c-.49.21-.47.8-.88,1.07A1.71,1.71,0,0,1,315.31,254.54Zm-.3,1.78-.56-.08c-.13,0-.32,0-.37.16s.21.15.29.16.38.08.57.12a1.73,1.73,0,0,0,1.1,0c.27-.12.32-.26.54-.43a1.85,1.85,0,0,1,1.27-.76,2.79,2.79,0,0,1,.87.23,2.09,2.09,0,0,0,1.43-.14c1-.58,1.12-1.2,2.49-.7.09,0,.07-.12,0-.15a1.54,1.54,0,0,0-2.06.14,2,2,0,0,1-2.16.39,1.76,1.76,0,0,0-1.24.05C316.31,255.73,316.34,256.47,315,256.32Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.54,266.52c-2.5,1.05-5.7-.91-7.15-4.37s-.58-7.11,1.92-8.15,5.7.91,7.15,4.37S335,265.48,332.54,266.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,260.72a9.44,9.44,0,0,0-.63-2.35,7.68,7.68,0,0,0-4.35-4.42,3.91,3.91,0,0,0-2.8.05c-2,.84-1.52,4.28-.28,7.26.83,2,2.89,4,4.69,3.7C332.5,264.84,332.53,261.46,335.09,260.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.27,262.71c-.38-.32-.3-.82-.21-1.26a1.87,1.87,0,0,0,0-1.32c-.22-.4-.6-.51-.95-.76a2.41,2.41,0,0,1-.69-.66,1.11,1.11,0,0,1-.14-.5c0-.14,0-.38,0-.51a.13.13,0,0,0-.11-.08.14.14,0,0,0-.11.05.35.35,0,0,0-.06.14,1.56,1.56,0,0,0,.38,1.54c.33.31.78.39,1.12.7a1.32,1.32,0,0,1,.37,1.15c0,.5-.34.87-.11,1.41s.93.77,1.43,1c.09,0,.26-.13.17-.22C331,263.1,330.58,263,330.27,262.71Zm3-2.65c-.05-.48.42-.84.28-1.36s-.49-.63-.84-.84c-.7-.42-.83-.41-1-1.4s-.28-1.4-1.32-1.57c-.05,0-.17.08-.08.11a1.64,1.64,0,0,1,1.14,1.38,7,7,0,0,0,0,.91c.24.67.67.58,1.15.94,1,.75.08,1.6.37,2.49a1.38,1.38,0,0,0,.39.56,2.34,2.34,0,0,1,.24.31,3.26,3.26,0,0,1,.33-.31A2.34,2.34,0,0,1,333.3,260.06Zm-1.43-.21a1.81,1.81,0,0,0-.74-1,2,2,0,0,1-1.05-1.92,1.56,1.56,0,0,0-1.19-1.69c-.05,0-.18.06-.1.11,1.25.75.82,1.22,1,2.38a2.11,2.11,0,0,0,.78,1.2,2.86,2.86,0,0,1,.73.52,1.84,1.84,0,0,1,.2,1.47,2.35,2.35,0,0,0,0,.7c.16.6.87.91,1.26,1.34l.15-.31c-.14-.15-.31-.28-.49-.46C331.51,261.25,332.1,260.81,331.87,259.85Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.45,261.26c-.75,2.61-4.28,3.87-7.88,2.82s-5.91-4-5.15-6.6,4.29-3.87,7.89-2.83S349.21,258.66,348.45,261.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.53,255.63a9.52,9.52,0,0,0-2.22-1,7.65,7.65,0,0,0-6.17.62,3.88,3.88,0,0,0-1.72,2.21c-.37,1.28.59,2.44,2.11,3.35a6.58,6.58,0,0,1,3.47,0,14.15,14.15,0,0,1,3.16,1.55,3.57,3.57,0,0,0,2.56-1.49A3.94,3.94,0,0,0,345.53,255.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.06,260.64c-.48.1-.83-.28-1.11-.63a1.92,1.92,0,0,0-1.05-.81,2.52,2.52,0,0,0-1.18.27,2.62,2.62,0,0,1-1,.12,1.16,1.16,0,0,1-.47-.2c-.12-.08-.27-.27-.41-.3a.14.14,0,0,0-.14,0,.12.12,0,0,0,0,.12.42.42,0,0,0,.07.13,1.56,1.56,0,0,0,1.44.67c.45-.07.79-.37,1.25-.43a1.32,1.32,0,0,1,1.13.43c.38.33.46.81,1,1s1.19-.24,1.66-.5c.09,0,.07-.29-.06-.27C344.82,260.32,344.47,260.56,344.06,260.64Zm-.16-4c-.41-.27-.39-.86-.89-1.07a1.5,1.5,0,0,0-1.17.12c-.77.28-.85.39-1.72-.1s-1.27-.66-2.06,0c0,0,0,.18,0,.14a1.62,1.62,0,0,1,1.79,0c.27.14.44.42.74.53.67.24.87-.15,1.46-.3,1.21-.31,1.29.94,2.17,1.28a2.18,2.18,0,0,0,.72.07,2.26,2.26,0,0,0,.37,0c.08,0,.27,0,.3-.12s0-.19-.12-.24a1.58,1.58,0,0,0-.81-.09A1.71,1.71,0,0,1,343.9,256.62Zm-1.06,1a1.79,1.79,0,0,0-1.25-.05,2,2,0,0,1-2.15-.39,1.54,1.54,0,0,0-2.06-.14c-.05,0-.07.18,0,.15,1.37-.5,1.46.13,2.49.7a2.07,2.07,0,0,0,1.43.14,2.81,2.81,0,0,1,.86-.23,1.79,1.79,0,0,1,1.27.77c.23.17.28.3.55.42a1.73,1.73,0,0,0,1.1,0c.19,0,.38-.09.57-.12s.35,0,.29-.16-.24-.18-.37-.16l-.57.08C343.7,258.76,343.73,258,342.84,257.6Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.94,266.36c-.76,2.61-4.29,3.87-7.89,2.83s-5.9-4-5.15-6.61,4.29-3.87,7.89-2.83S329.69,263.76,328.94,266.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,260.74a9.14,9.14,0,0,0-2.22-1,7.65,7.65,0,0,0-6.17.62,3.88,3.88,0,0,0-1.72,2.21c-.37,1.28.6,2.44,2.11,3.35a9.88,9.88,0,0,0,6.63,1.58A3.57,3.57,0,0,0,327.2,266,3.93,3.93,0,0,0,326,260.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.55,265.74c-.49.1-.84-.28-1.12-.63a1.92,1.92,0,0,0-1.05-.81,2.55,2.55,0,0,0-1.18.27,2.37,2.37,0,0,1-.95.12,1.2,1.2,0,0,1-.48-.2c-.12-.08-.27-.27-.41-.3a.14.14,0,0,0-.14,0,.12.12,0,0,0,0,.12.38.38,0,0,0,.06.13,1.56,1.56,0,0,0,1.44.67c.45-.07.8-.37,1.25-.43a1.32,1.32,0,0,1,1.13.43c.38.33.46.81,1,1s1.19-.24,1.66-.5c.09-.05.07-.29-.06-.26C325.3,265.42,325,265.66,324.55,265.74Zm-.17-4c-.41-.27-.39-.86-.88-1.07a1.53,1.53,0,0,0-1.18.12c-.77.28-.84.39-1.72-.1s-1.27-.66-2.05,0c0,0-.05.18,0,.14a1.62,1.62,0,0,1,1.79,0c.27.14.44.42.74.53.67.24.88-.15,1.46-.3,1.21-.31,1.29.94,2.17,1.28a2.24,2.24,0,0,0,.73.07,2.32,2.32,0,0,0,.37,0c.07,0,.26,0,.29-.12s-.05-.19-.12-.23a1.56,1.56,0,0,0-.8-.1A1.61,1.61,0,0,1,324.38,261.72Zm-1.06,1a1.77,1.77,0,0,0-1.24-.05,2,2,0,0,1-2.16-.39,1.54,1.54,0,0,0-2.06-.14c-.05,0-.07.18,0,.15,1.37-.5,1.47.13,2.49.7a2.08,2.08,0,0,0,1.43.15,2.56,2.56,0,0,1,.87-.24,1.82,1.82,0,0,1,1.26.77c.23.17.28.3.55.42a1.73,1.73,0,0,0,1.1,0l.57-.12c.08,0,.35,0,.29-.16s-.24-.18-.37-.16l-.56.08C324.18,263.86,324.21,263.13,323.32,262.7Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.68,268.57c-.93,2.55-4.54,3.56-8.06,2.28s-5.62-4.4-4.68-7,4.54-3.56,8.06-2.28S346.61,266,345.68,268.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.21,264.73c.53-1.44,2.79-1.94,5.06-1.11s3.66,2.67,3.13,4.12-2.79,1.94-5,1.11S334.68,266.18,335.21,264.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.21,264.73c.53-1.44,2.79-1.94,5.06-1.11s3.66,2.67,3.13,4.12-2.79,1.94-5,1.11S334.68,266.18,335.21,264.73Z",
    style: {
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.27,263.62a5.12,5.12,0,0,0-4.09,0c-.21,1.36.95,2.88,2.77,3.55s3.69.25,4.41-.92A5.14,5.14,0,0,0,340.27,263.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.82,264.84a13.94,13.94,0,0,1,2.63,1.3,5.14,5.14,0,0,0-5.48-2A13.63,13.63,0,0,1,339.82,264.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dates--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.56,241.57c10.21,5.89,10.21,15.45,0,21.35s-26.77,5.89-37,0-10.21-15.46,0-21.35S208.35,235.67,218.56,241.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plate--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.82,241.15c-9.8-5.66-25.7-5.66-35.5,0h0v-1c-5.13,3-7.57,6.88-7.34,10.76-.23,3.88,2.21,7.8,7.33,10.76,9.81,5.66,25.71,5.66,35.51,0S227.63,246.81,217.82,241.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82,240.13c9.81,5.66,9.81,14.84,0,20.5s-25.7,5.66-35.51,0-9.8-14.84,0-20.5S208,234.47,217.82,240.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82,240.13c9.81,5.66,9.81,14.84,0,20.5s-25.7,5.66-35.51,0-9.8-14.84,0-20.5S208,234.47,217.82,240.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,244.36c-6.74,3.89-6.74,10.19,0,14.08s17.66,3.89,24.4,0,6.74-10.19,0-14.08S194.77,240.47,188,244.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86,244.83c-6.28,3.63-6.28,9.51,0,13.13s16.46,3.63,22.74,0,6.28-9.5,0-13.12S195.14,241.21,188.86,244.83Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dates--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M207.46,256.45c-3.76,0-6.8,1.37-6.8,3.05s3,3,6.8,3,6.8-1.36,6.8-3S211.22,256.45,207.46,256.45Zm-4-1.31c0-1.32-2.4-2.38-5.36-2.38s-5.35,1.06-5.35,2.38a1.13,1.13,0,0,0,.14.53h-.42c-3,0-5.35,1.06-5.35,2.38s2.4,2.38,5.35,2.38,5.35-1.06,5.35-2.38a1.25,1.25,0,0,0-.13-.53h.41C201.05,257.52,203.45,256.46,203.45,255.14Zm8.53-4.58c-3,0-5.35,1.06-5.35,2.38s2.39,2.38,5.35,2.38,5.35-1.06,5.35-2.38S214.93,250.56,212,250.56Zm-22.23.09c0-1.32-2.4-2.39-5.35-2.39s-5.35,1.07-5.35,2.39,2.39,2.38,5.35,2.38S189.75,252,189.75,250.65Zm15-2.51c3,0,5.35-1.07,5.35-2.39s-2.39-2.38-5.35-2.38-5.35,1.07-5.35,2.38S201.84,248.14,204.79,248.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.83,
    cy: 242.2,
    rx: 4.91,
    ry: 6.79,
    transform: "translate(-103.08 322.38) rotate(-64.93)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,239.07a8.9,8.9,0,0,0-2.05-1.32,7.66,7.66,0,0,0-6.19-.34,3.9,3.9,0,0,0-2,1.91c-.57,1.22.21,2.51,1.57,3.64a6.6,6.6,0,0,1,3.26.85,5.38,5.38,0,0,1,2.26,1.94c1.13,0,2.19-1.34,3.08-1.63C207.22,243.66,208.27,241.58,206,239.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.73,243.79c-.49,0-.78-.41-1-.8a1.91,1.91,0,0,0-.92-1,2.57,2.57,0,0,0-1.2.08,2.39,2.39,0,0,1-1,0,1.12,1.12,0,0,1-.44-.27c-.11-.1-.23-.3-.36-.36a.14.14,0,0,0-.15,0,.15.15,0,0,0,0,.11.58.58,0,0,0,.05.14,1.55,1.55,0,0,0,1.32.89c.45,0,.84-.24,1.3-.24a1.37,1.37,0,0,1,1,.61c.32.38.33.87.86,1.11a2.34,2.34,0,0,0,1.71-.24c.1,0,.11-.27,0-.27C204.53,243.59,204.14,243.77,203.73,243.79Zm.46-4c-.36-.32-.25-.9-.71-1.19a1.55,1.55,0,0,0-1.18-.06c-.8.16-.89.26-1.69-.36s-1.15-.85-2-.28c0,0-.07.17,0,.14a1.63,1.63,0,0,1,1.78.25c.24.18.37.48.65.64.62.34.88,0,1.49-.08,1.24-.11,1.12,1.13,1.94,1.6a2.13,2.13,0,0,0,.71.19,2.21,2.21,0,0,0,.37,0c.07,0,.26,0,.3-.07s0-.2-.08-.25a1.57,1.57,0,0,0-.78-.22A1.63,1.63,0,0,1,204.19,239.78Zm-1.2.81a1.78,1.78,0,0,0-1.22-.24,2,2,0,0,1-2.07-.72,1.55,1.55,0,0,0-2-.45c-.06,0-.1.16,0,.15,1.44-.28,1.43.35,2.36,1.07a2.07,2.07,0,0,0,1.39.37,2.42,2.42,0,0,1,.89-.1,1.8,1.8,0,0,1,1.13,1c.2.2.23.34.48.51a1.7,1.7,0,0,0,1.09.16l.57,0c.09,0,.35.06.32-.11s-.21-.21-.35-.22H205C203.66,241.87,203.81,241.15,203,240.59Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.75,248.69c.76,2.6,4.29,3.87,7.89,2.82s5.9-4,5.15-6.61-4.29-3.86-7.89-2.82S179,246.08,179.75,248.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,243.06a9.19,9.19,0,0,1,2.23-1,7.62,7.62,0,0,1,6.16.61,4,4,0,0,1,1.73,2.21c.37,1.29-.6,2.44-2.11,3.36a6.57,6.57,0,0,0-3.47,0,14,14,0,0,0-3.16,1.56,3.63,3.63,0,0,1-2.57-1.49A4,4,0,0,1,182.67,243.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,247.68c-.12,0-.15.22,0,.27.47.25,1.1.66,1.65.5s.65-.64,1-1a1.32,1.32,0,0,1,1.13-.44c.45.07.8.37,1.25.44a1.59,1.59,0,0,0,1.44-.67.59.59,0,0,0,.06-.14.13.13,0,0,0,0-.12.14.14,0,0,0-.14,0c-.14,0-.29.22-.41.31a1.18,1.18,0,0,1-.48.19,2.21,2.21,0,0,1-.95-.12,2.67,2.67,0,0,0-1.18-.26,1.92,1.92,0,0,0-1.05.81c-.29.35-.63.72-1.12.63S183.39,247.75,183,247.68Zm.5-3.42a1.66,1.66,0,0,0-.8.1.24.24,0,0,0-.12.24c0,.08.22.11.29.12h.37a2,2,0,0,0,.73-.08c.88-.33,1-1.58,2.17-1.27.58.14.79.54,1.46.3.3-.11.47-.39.74-.53a1.62,1.62,0,0,1,1.79,0c.07,0,.07-.11,0-.14-.78-.7-1.25-.48-2,0s-1,.38-1.72.1a1.58,1.58,0,0,0-1.18-.13c-.49.22-.48.81-.88,1.07A1.61,1.61,0,0,1,183.48,244.26Zm-.3,1.78-.56-.08c-.14,0-.32,0-.37.15s.21.15.29.17a5.05,5.05,0,0,1,.56.12,1.76,1.76,0,0,0,1.11,0c.27-.12.32-.26.54-.43a1.82,1.82,0,0,1,1.27-.76,2.61,2.61,0,0,1,.87.23,2.14,2.14,0,0,0,1.43-.14c1-.58,1.12-1.2,2.49-.7.08,0,.07-.12,0-.15a1.55,1.55,0,0,0-2.06.13,2,2,0,0,1-2.16.4,1.76,1.76,0,0,0-1.24.05C184.48,245.45,184.51,246.18,183.18,246Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.09,
    cy: 249.98,
    rx: 4.91,
    ry: 6.79,
    transform: "translate(-81.05 95.68) rotate(-22.67)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,250.43a9.36,9.36,0,0,0-.63-2.34,7.65,7.65,0,0,0-4.35-4.42,3.9,3.9,0,0,0-2.8.05c-2,.84-1.52,4.27-.28,7.26.83,2,2.89,4,4.69,3.7C200.67,254.56,200.7,251.17,203.26,250.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.44,252.43c-.38-.32-.3-.82-.21-1.26a1.9,1.9,0,0,0,0-1.33c-.22-.39-.6-.51-.95-.75a2.32,2.32,0,0,1-.69-.67,1.07,1.07,0,0,1-.14-.49c0-.15,0-.38,0-.51a.12.12,0,0,0-.11-.08c-.05,0-.08,0-.11,0a.35.35,0,0,0-.06.14,1.56,1.56,0,0,0,.38,1.54c.33.31.78.39,1.12.7a1.31,1.31,0,0,1,.37,1.15c0,.5-.34.87-.11,1.41s.93.77,1.43,1c.09,0,.26-.12.17-.21C199.16,252.82,198.75,252.7,198.44,252.43Zm3-2.65c-.05-.48.42-.84.28-1.36s-.49-.63-.84-.84c-.7-.42-.83-.41-1-1.4s-.28-1.41-1.32-1.58c-.05,0-.17.08-.08.12a1.64,1.64,0,0,1,1.14,1.38c.06.29-.05.6,0,.9.24.67.67.59,1.15.95,1,.75.08,1.6.37,2.49a1.38,1.38,0,0,0,.39.56,3.15,3.15,0,0,1,.24.3l.33-.3A2.38,2.38,0,0,1,201.47,249.78Zm-1.43-.21a1.81,1.81,0,0,0-.74-1,2,2,0,0,1-1.05-1.92,1.56,1.56,0,0,0-1.19-1.69c-.06,0-.18.06-.1.11,1.25.75.82,1.21,1,2.37a2.11,2.11,0,0,0,.78,1.21,2.86,2.86,0,0,1,.73.52,1.84,1.84,0,0,1,.2,1.47,2.35,2.35,0,0,0,0,.7c.15.59.87.91,1.26,1.34l.15-.31c-.14-.16-.31-.28-.49-.46C199.68,251,200.27,250.53,200,249.57Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.62,251c-.75,2.6-4.28,3.87-7.88,2.82s-5.91-4-5.15-6.61,4.29-3.86,7.89-2.82S217.38,248.38,216.62,251Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.7,245.35a9.12,9.12,0,0,0-2.22-1,7.65,7.65,0,0,0-6.17.62,3.89,3.89,0,0,0-1.72,2.2c-.37,1.29.59,2.45,2.11,3.36a6.57,6.57,0,0,1,3.47,0,14.66,14.66,0,0,1,3.16,1.56,3.57,3.57,0,0,0,2.56-1.49A3.94,3.94,0,0,0,213.7,245.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.23,250.36c-.48.09-.83-.28-1.11-.63a1.92,1.92,0,0,0-1.05-.81,2.59,2.59,0,0,0-1.19.27,2.34,2.34,0,0,1-.95.11,1.14,1.14,0,0,1-.47-.19c-.12-.08-.27-.27-.41-.3a.13.13,0,0,0-.17.15.37.37,0,0,0,.07.14,1.59,1.59,0,0,0,1.44.67c.45-.07.79-.37,1.25-.44a1.35,1.35,0,0,1,1.13.44c.38.33.46.81,1,1s1.19-.24,1.66-.5c.09-.05.07-.29-.06-.27C213,250,212.63,250.28,212.23,250.36Zm-.16-4c-.41-.26-.39-.85-.89-1.07a1.55,1.55,0,0,0-1.17.13c-.77.28-.85.39-1.73-.1s-1.26-.66-2.05,0c0,0,0,.18,0,.14a1.62,1.62,0,0,1,1.79,0c.27.14.44.42.74.53.67.24.87-.15,1.46-.3,1.21-.31,1.29.94,2.17,1.27a2,2,0,0,0,.72.08h.37c.08,0,.26,0,.3-.12s0-.19-.12-.24a1.7,1.7,0,0,0-.81-.1A1.6,1.6,0,0,1,212.07,246.33Zm-1.06,1a1.79,1.79,0,0,0-1.25,0,2,2,0,0,1-2.15-.39,1.55,1.55,0,0,0-2.06-.14c-.05,0-.07.18,0,.15,1.37-.5,1.46.12,2.49.7a2.07,2.07,0,0,0,1.43.14,2.81,2.81,0,0,1,.86-.23,1.81,1.81,0,0,1,1.27.76c.23.17.28.31.55.43a1.73,1.73,0,0,0,1.1,0c.19,0,.37-.09.56-.12s.36,0,.3-.16-.24-.18-.37-.16l-.57.08C211.87,248.48,211.9,247.74,211,247.32Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.1,256.08c-.75,2.61-4.28,3.87-7.88,2.82s-5.91-4-5.15-6.6,4.29-3.87,7.89-2.83S197.86,253.48,197.1,256.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18,250.45a9.52,9.52,0,0,0-2.22-1,7.65,7.65,0,0,0-6.17.62,3.88,3.88,0,0,0-1.72,2.21c-.37,1.28.6,2.44,2.11,3.35a9.88,9.88,0,0,0,6.63,1.58,3.57,3.57,0,0,0,2.56-1.49A3.93,3.93,0,0,0,194.18,250.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.71,255.46c-.48.1-.83-.28-1.11-.63a1.92,1.92,0,0,0-1-.81,2.52,2.52,0,0,0-1.18.27,2.59,2.59,0,0,1-1,.12,1.2,1.2,0,0,1-.48-.2c-.12-.08-.27-.27-.41-.3a.14.14,0,0,0-.14,0,.11.11,0,0,0,0,.11.35.35,0,0,0,.06.14,1.56,1.56,0,0,0,1.44.67c.45-.07.79-.37,1.25-.43a1.32,1.32,0,0,1,1.13.43c.38.33.46.81,1,1s1.19-.24,1.66-.5c.09-.05.07-.29-.06-.27C193.47,255.14,193.12,255.38,192.71,255.46Zm-.16-4c-.41-.27-.39-.86-.88-1.07a1.52,1.52,0,0,0-1.18.12c-.77.28-.84.39-1.72-.1s-1.27-.66-2.05,0c0,0-.05.18,0,.14a1.62,1.62,0,0,1,1.79,0c.27.14.44.42.74.53.67.24.87-.15,1.46-.3,1.21-.31,1.29.94,2.17,1.28a2.24,2.24,0,0,0,.73.07,2.32,2.32,0,0,0,.37,0c.07,0,.26,0,.29-.12s-.05-.19-.12-.24a1.55,1.55,0,0,0-.8-.09A1.83,1.83,0,0,1,192.55,251.44Zm-1.06,1a1.77,1.77,0,0,0-1.24,0,2,2,0,0,1-2.16-.39,1.54,1.54,0,0,0-2.06-.14c-.05,0-.07.18,0,.15,1.37-.5,1.46.13,2.49.7a2.07,2.07,0,0,0,1.43.14,2.81,2.81,0,0,1,.86-.23,1.79,1.79,0,0,1,1.27.77c.23.17.28.3.55.42a1.73,1.73,0,0,0,1.1,0l.57-.12c.08,0,.35,0,.29-.16s-.24-.18-.37-.16l-.56.08C192.35,253.58,192.38,252.84,191.49,252.42Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--date--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.85,258.29c-.93,2.54-4.54,3.56-8.06,2.27s-5.62-4.4-4.68-6.94,4.54-3.57,8.06-2.28S214.78,255.74,213.85,258.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.38,254.45c.53-1.44,2.79-1.94,5.05-1.11s3.67,2.67,3.14,4.11-2.79,1.95-5,1.12S202.85,255.9,203.38,254.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.38,254.45c.53-1.44,2.79-1.94,5.05-1.11s3.67,2.67,3.14,4.11-2.79,1.95-5,1.12S202.85,255.9,203.38,254.45Z",
    style: {
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.43,253.34a5.1,5.1,0,0,0-4.08,0c-.21,1.36.94,2.88,2.77,3.55s3.69.25,4.41-.92A5.14,5.14,0,0,0,208.43,253.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,254.56a13.26,13.26,0,0,1,2.63,1.3,5.14,5.14,0,0,0-5.48-2A13.78,13.78,0,0,1,208,254.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M283.64,251a17.7,17.7,0,0,0,15.43,0c4.26-2.36,4.26-6.2,0-8.56a17.7,17.7,0,0,0-15.43,0C279.38,244.79,279.38,248.63,283.64,251Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283,224.21l.74,18.61h0a2.63,2.63,0,0,0,.22.94,4.56,4.56,0,0,0,2,2,12.23,12.23,0,0,0,10.72,0,4.53,4.53,0,0,0,2-2,2.7,2.7,0,0,0,.22-.82h0a1,1,0,0,0,0-.24v0l.74-18.46a3.33,3.33,0,0,0,.62-1.78l-.89,23.17v.26a4.12,4.12,0,0,1-2.34,3.07,12.6,12.6,0,0,1-11.38,0,4,4,0,0,1-2.35-3.2v-.08l-.89-23.22A3.41,3.41,0,0,0,283,224.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,224.21l.74,18.61h0a2.63,2.63,0,0,0,.22.94,4.56,4.56,0,0,0,2,2,12.23,12.23,0,0,0,10.72,0,4.53,4.53,0,0,0,2-2,2.7,2.7,0,0,0,.22-.82h0a1,1,0,0,0,0-.24v0l.74-18.46a3.33,3.33,0,0,0,.62-1.78l-.89,23.17v.26a4.12,4.12,0,0,1-2.34,3.07,12.6,12.6,0,0,1-11.38,0,4,4,0,0,1-2.35-3.2v-.08l-.89-23.22A3.41,3.41,0,0,0,283,224.21Z",
    style: {
      fill: "#fff",
      opacity: 0.8300000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,226a14,14,0,0,0,12.64,0,6,6,0,0,0,2-1.75l-.74,18.46v.26h0a2.7,2.7,0,0,1-.22.82,4.53,4.53,0,0,1-2,2,12.23,12.23,0,0,1-10.72,0,4.56,4.56,0,0,1-2-2,2.63,2.63,0,0,1-.22-.94h0L283,224.21A6,6,0,0,0,285,226Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,226a14,14,0,0,0,12.64,0,6,6,0,0,0,2-1.75l-.74,18.46v.26h0a2.7,2.7,0,0,1-.22.82,4.53,4.53,0,0,1-2,2,12.23,12.23,0,0,1-10.72,0,4.56,4.56,0,0,1-2-2,2.63,2.63,0,0,1-.22-.94h0L283,224.21A6,6,0,0,0,285,226Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.93,242.89a3.74,3.74,0,0,1-2.21,2.85,12.23,12.23,0,0,1-10.72,0,3.78,3.78,0,0,1-2.22-2.85l-.62-15.46c-.07-1.21.73-2.44,2.4-3.36a13.27,13.27,0,0,1,11.6,0c1.67.92,2.47,2.15,2.4,3.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.36,
    cy: 242.74,
    rx: 7.58,
    ry: 4.24,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.93,242.89a3.74,3.74,0,0,1-2.21,2.85,12.23,12.23,0,0,1-10.72,0,3.78,3.78,0,0,1-2.22-2.85l-.62-15.46c-.07-1.21.73-2.44,2.4-3.36a13.27,13.27,0,0,1,11.6,0c1.67.92,2.47,2.15,2.4,3.36Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.16,230.5a13.27,13.27,0,0,1-11.6,0c-3.21-1.77-3.21-4.66,0-6.43a13.27,13.27,0,0,1,11.6,0C300.36,225.84,300.36,228.73,297.16,230.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.56,230.5a13.49,13.49,0,0,0,10.22.62c-4.42.77-8.58-1.29-8.21-4a.51.51,0,0,1,0-.17,10.63,10.63,0,0,1-2.56-1,6.89,6.89,0,0,1-1-.71C282.48,227,283,229.08,285.56,230.5Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.42,222.41v0a3.41,3.41,0,0,0,.62,1.77,6,6,0,0,0,2,1.76,14,14,0,0,0,12.64,0,6,6,0,0,0,2-1.75,3.33,3.33,0,0,0,.62-1.78c.06-1.36-.81-2.73-2.61-3.77a14,14,0,0,0-12.64,0C283.25,219.7,282.38,221.06,282.42,222.41Zm3-3.37a13.52,13.52,0,0,1,11.84,0c3.27,1.81,3.27,4.75,0,6.56a13.52,13.52,0,0,1-11.84,0C282.17,223.79,282.17,220.85,285.44,219Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.42,222.41v0a3.41,3.41,0,0,0,.62,1.77,6,6,0,0,0,2,1.76,14,14,0,0,0,12.64,0,6,6,0,0,0,2-1.75,3.33,3.33,0,0,0,.62-1.78c.06-1.36-.81-2.73-2.61-3.77a14,14,0,0,0-12.64,0C283.25,219.7,282.38,221.06,282.42,222.41Zm3-3.37a13.52,13.52,0,0,1,11.84,0c3.27,1.81,3.27,4.75,0,6.56a13.52,13.52,0,0,1-11.84,0C282.17,223.79,282.17,220.85,285.44,219Z",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.44,225.6a13.52,13.52,0,0,0,11.84,0c3.27-1.81,3.27-4.75,0-6.56a13.52,13.52,0,0,0-11.84,0C282.17,220.85,282.17,223.79,285.44,225.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.44,225.6a13.52,13.52,0,0,0,11.84,0c3.27-1.81,3.27-4.75,0-6.56a13.52,13.52,0,0,0-11.84,0C282.17,220.85,282.17,223.79,285.44,225.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.33,224.89a6.63,6.63,0,0,1-1.05.71,13.52,13.52,0,0,1-11.84,0,6.74,6.74,0,0,1-1.06-.71,6.44,6.44,0,0,1,1.18-.82,13.27,13.27,0,0,1,11.6,0A6,6,0,0,1,298.33,224.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.33,224.89a6.63,6.63,0,0,1-1.05.71,13.52,13.52,0,0,1-11.84,0,6.74,6.74,0,0,1-1.06-.71,6.44,6.44,0,0,1,1.18-.82,13.27,13.27,0,0,1,11.6,0A6,6,0,0,1,298.33,224.89Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.16,224.07l-.31-.17h0l-.5-.23a11.69,11.69,0,0,0-3-.8c-.29,0-.57-.07-.86-.09s-.49,0-.74,0h-.41l-.79,0a13.76,13.76,0,0,0-2.67.4,9.92,9.92,0,0,0-2.34.92l-.32.18-.06,0-.25.16,0,0-.25.19h0l-.25.21a6.74,6.74,0,0,0,1.06.71,9.75,9.75,0,0,0,2.32.91C288.78,224.25,293.36,222.93,297.16,224.07Z",
    style: {
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.82,244l.05,1.48v.11c.1,2.21,3.42,4,7.49,4s7.37-1.76,7.49-4v-.13l0-1.5c-.4,2.08-3.63,3.7-7.54,3.7S284.23,246,283.82,244Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.42,245.89a12.29,12.29,0,0,1-10.42-.15,3.8,3.8,0,0,1-2.22-2.85l-.61-15.14h0a3.52,3.52,0,0,0,1.26,2c.28,6,.33,11,2,13S292.35,247.4,296.42,245.89Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M410.65,309.41a17.7,17.7,0,0,0,15.43,0c4.26-2.36,4.26-6.2,0-8.56a17.7,17.7,0,0,0-15.43,0C406.39,303.21,406.39,307.05,410.65,309.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410,282.63l.75,18.62h0a2.43,2.43,0,0,0,.22.94,4.53,4.53,0,0,0,2,2,12.23,12.23,0,0,0,10.72,0,4.48,4.48,0,0,0,2-2,2.44,2.44,0,0,0,.22-.82h0a1.93,1.93,0,0,0,0-.24h0l.73-18.47a3.43,3.43,0,0,0,.63-1.77L426.41,304v.26a4.12,4.12,0,0,1-2.35,3.07,12.52,12.52,0,0,1-11.37,0,4,4,0,0,1-2.36-3.2v-.08l-.89-23.21A3.4,3.4,0,0,0,410,282.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,282.63l.75,18.62h0a2.43,2.43,0,0,0,.22.94,4.53,4.53,0,0,0,2,2,12.23,12.23,0,0,0,10.72,0,4.48,4.48,0,0,0,2-2,2.44,2.44,0,0,0,.22-.82h0a1.93,1.93,0,0,0,0-.24h0l.73-18.47a3.43,3.43,0,0,0,.63-1.77L426.41,304v.26a4.12,4.12,0,0,1-2.35,3.07,12.52,12.52,0,0,1-11.37,0,4,4,0,0,1-2.36-3.2v-.08l-.89-23.21A3.4,3.4,0,0,0,410,282.63Z",
    style: {
      fill: "#fff",
      opacity: 0.8300000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,284.39a14,14,0,0,0,12.64,0,5.88,5.88,0,0,0,2-1.75l-.73,18.47h0v.24h0a2.44,2.44,0,0,1-.22.82,4.48,4.48,0,0,1-2,2,12.23,12.23,0,0,1-10.72,0,4.53,4.53,0,0,1-2-2,2.43,2.43,0,0,1-.22-.94h0L410,282.63A6.15,6.15,0,0,0,412,284.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,284.39a14,14,0,0,0,12.64,0,5.88,5.88,0,0,0,2-1.75l-.73,18.47h0v.24h0a2.44,2.44,0,0,1-.22.82,4.48,4.48,0,0,1-2,2,12.23,12.23,0,0,1-10.72,0,4.53,4.53,0,0,1-2-2,2.43,2.43,0,0,1-.22-.94h0L410,282.63A6.15,6.15,0,0,0,412,284.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.94,301.31a3.78,3.78,0,0,1-2.22,2.85,12.23,12.23,0,0,1-10.72,0,3.74,3.74,0,0,1-2.21-2.85l-.63-15.46c-.07-1.21.73-2.44,2.4-3.36a13.29,13.29,0,0,1,11.61,0c1.66.92,2.46,2.15,2.4,3.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.72,304.16a12.23,12.23,0,0,1-10.72,0c-3-1.66-3-4.34,0-6a12.16,12.16,0,0,1,10.72,0C426.68,299.82,426.68,302.5,423.72,304.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.94,301.31a3.78,3.78,0,0,1-2.22,2.85,12.23,12.23,0,0,1-10.72,0,3.74,3.74,0,0,1-2.21-2.85l-.63-15.46c-.07-1.21.73-2.44,2.4-3.36a13.29,13.29,0,0,1,11.61,0c1.66.92,2.46,2.15,2.4,3.36Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,288.92a13.29,13.29,0,0,1-11.61,0c-3.2-1.77-3.2-4.66,0-6.43a13.29,13.29,0,0,1,11.61,0C427.37,284.26,427.37,287.15,424.17,288.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.56,288.92a13.52,13.52,0,0,0,10.23.62c-4.43.77-8.58-1.29-8.22-4l0-.17a10.39,10.39,0,0,1-2.56-1,7.33,7.33,0,0,1-1-.71C409.49,285.38,410,287.51,412.56,288.92Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.43,280.83v0a3.4,3.4,0,0,0,.61,1.76,6.15,6.15,0,0,0,2,1.76,14,14,0,0,0,12.64,0,5.88,5.88,0,0,0,2-1.75,3.43,3.43,0,0,0,.63-1.77c.05-1.37-.82-2.74-2.62-3.78a14,14,0,0,0-12.64,0C410.26,278.12,409.39,279.48,409.43,280.83Zm3-3.37a13.52,13.52,0,0,1,11.84,0c3.27,1.81,3.27,4.75,0,6.57a13.59,13.59,0,0,1-11.84,0C409.18,282.21,409.18,279.27,412.44,277.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.43,280.83v0a3.4,3.4,0,0,0,.61,1.76,6.15,6.15,0,0,0,2,1.76,14,14,0,0,0,12.64,0,5.88,5.88,0,0,0,2-1.75,3.43,3.43,0,0,0,.63-1.77c.05-1.37-.82-2.74-2.62-3.78a14,14,0,0,0-12.64,0C410.26,278.12,409.39,279.48,409.43,280.83Zm3-3.37a13.52,13.52,0,0,1,11.84,0c3.27,1.81,3.27,4.75,0,6.57a13.59,13.59,0,0,1-11.84,0C409.18,282.21,409.18,279.27,412.44,277.46Z",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.44,284a13.59,13.59,0,0,0,11.84,0c3.27-1.82,3.27-4.76,0-6.57a13.52,13.52,0,0,0-11.84,0C409.18,279.27,409.18,282.21,412.44,284Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.44,284a13.59,13.59,0,0,0,11.84,0c3.27-1.82,3.27-4.76,0-6.57a13.52,13.52,0,0,0-11.84,0C409.18,279.27,409.18,282.21,412.44,284Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.34,283.31a7,7,0,0,1-1.06.72,13.59,13.59,0,0,1-11.84,0,7.4,7.4,0,0,1-1.05-.72,6,6,0,0,1,1.17-.82,13.29,13.29,0,0,1,11.61,0A6.7,6.7,0,0,1,425.34,283.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.34,283.31a7,7,0,0,1-1.06.72,13.59,13.59,0,0,1-11.84,0,7.4,7.4,0,0,1-1.05-.72,6,6,0,0,1,1.17-.82,13.29,13.29,0,0,1,11.61,0A6.7,6.7,0,0,1,425.34,283.31Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,282.49l-.31-.17h0l-.49-.23a12.2,12.2,0,0,0-3-.8c-.28,0-.57-.07-.85-.09l-.75,0h-.41l-.78,0a14.44,14.44,0,0,0-2.67.4,10,10,0,0,0-2.35.92l-.32.18-.05,0-.25.16,0,0-.25.19h0l-.25.21a7.4,7.4,0,0,0,1.05.72,11.09,11.09,0,0,0,2.32.91C415.79,282.67,420.37,281.35,424.17,282.49Z",
    style: {
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.82,302.39l.05,1.48V304c.1,2.21,3.41,4,7.49,4s7.36-1.76,7.49-4v-.13l.05-1.5c-.41,2.08-3.63,3.7-7.55,3.7S411.24,304.46,410.82,302.39Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.43,304.31a12.28,12.28,0,0,1-10.43-.15,3.74,3.74,0,0,1-2.21-2.85l-.62-15.14h0a3.57,3.57,0,0,0,1.26,2c.28,6,.33,11,2,13S419.36,305.82,423.43,304.31Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M107.25,261.4a17.7,17.7,0,0,0,15.43,0c4.26-2.37,4.26-6.2,0-8.56a17.63,17.63,0,0,0-15.43,0C103,255.2,103,259,107.25,261.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.64,234.62l.74,18.61h0a2.7,2.7,0,0,0,.23.94,4.47,4.47,0,0,0,2,2,12.16,12.16,0,0,0,10.72,0,4.42,4.42,0,0,0,2-2,2.44,2.44,0,0,0,.22-.82h0a2,2,0,0,0,0-.25h0l.73-18.46a3.43,3.43,0,0,0,.63-1.78L123,256v.27a4.13,4.13,0,0,1-2.35,3.07,12.6,12.6,0,0,1-11.38,0,4.06,4.06,0,0,1-2.35-3.2v-.09L106,232.85A3.4,3.4,0,0,0,106.64,234.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.64,234.62l.74,18.61h0a2.7,2.7,0,0,0,.23.94,4.47,4.47,0,0,0,2,2,12.16,12.16,0,0,0,10.72,0,4.42,4.42,0,0,0,2-2,2.44,2.44,0,0,0,.22-.82h0a2,2,0,0,0,0-.25h0l.73-18.46a3.43,3.43,0,0,0,.63-1.78L123,256v.27a4.13,4.13,0,0,1-2.35,3.07,12.6,12.6,0,0,1-11.38,0,4.06,4.06,0,0,1-2.35-3.2v-.09L106,232.85A3.4,3.4,0,0,0,106.64,234.62Z",
    style: {
      fill: "#fff",
      opacity: 0.8300000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.64,236.38a14,14,0,0,0,12.64,0,6,6,0,0,0,2-1.75l-.73,18.46h0v.25h0a2.44,2.44,0,0,1-.22.82,4.42,4.42,0,0,1-2,2,12.16,12.16,0,0,1-10.72,0,4.47,4.47,0,0,1-2-2,2.7,2.7,0,0,1-.23-.94h0l-.74-18.61A6.15,6.15,0,0,0,108.64,236.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.64,236.38a14,14,0,0,0,12.64,0,6,6,0,0,0,2-1.75l-.73,18.46h0v.25h0a2.44,2.44,0,0,1-.22.82,4.42,4.42,0,0,1-2,2,12.16,12.16,0,0,1-10.72,0,4.47,4.47,0,0,1-2-2,2.7,2.7,0,0,1-.23-.94h0l-.74-18.61A6.15,6.15,0,0,0,108.64,236.38Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.54,253.3a3.75,3.75,0,0,1-2.22,2.84,12.16,12.16,0,0,1-10.72,0,3.72,3.72,0,0,1-2.21-2.84l-.63-15.46c-.07-1.22.73-2.44,2.4-3.37a13.36,13.36,0,0,1,11.61,0c1.66.93,2.46,2.15,2.39,3.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.96,
    cy: 253.15,
    rx: 7.58,
    ry: 4.24,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.54,253.3a3.75,3.75,0,0,1-2.22,2.84,12.16,12.16,0,0,1-10.72,0,3.72,3.72,0,0,1-2.21-2.84l-.63-15.46c-.07-1.22.73-2.44,2.4-3.37a13.36,13.36,0,0,1,11.61,0c1.66.93,2.46,2.15,2.39,3.37Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77,240.91a13.29,13.29,0,0,1-11.61,0c-3.2-1.78-3.2-4.66,0-6.44a13.36,13.36,0,0,1,11.61,0C124,236.25,124,239.13,120.77,240.91Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.16,240.91a13.52,13.52,0,0,0,10.23.62c-4.43.77-8.58-1.3-8.22-3.95l0-.17a10.79,10.79,0,0,1-2.56-1,9.29,9.29,0,0,1-1-.71C106.09,237.37,106.6,239.49,109.16,240.91Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,232.82v0a3.4,3.4,0,0,0,.61,1.77,6.15,6.15,0,0,0,2,1.76,14,14,0,0,0,12.64,0,6,6,0,0,0,2-1.75,3.43,3.43,0,0,0,.63-1.78c0-1.36-.82-2.73-2.62-3.77a13.94,13.94,0,0,0-12.64,0C106.86,230.11,106,231.47,106,232.82Zm3-3.38a13.59,13.59,0,0,1,11.84,0c3.27,1.82,3.27,4.76,0,6.57A13.52,13.52,0,0,1,109,236C105.77,234.2,105.77,231.26,109,229.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,232.82v0a3.4,3.4,0,0,0,.61,1.77,6.15,6.15,0,0,0,2,1.76,14,14,0,0,0,12.64,0,6,6,0,0,0,2-1.75,3.43,3.43,0,0,0,.63-1.78c0-1.36-.82-2.73-2.62-3.77a13.94,13.94,0,0,0-12.64,0C106.86,230.11,106,231.47,106,232.82Zm3-3.38a13.59,13.59,0,0,1,11.84,0c3.27,1.82,3.27,4.76,0,6.57A13.52,13.52,0,0,1,109,236C105.77,234.2,105.77,231.26,109,229.44Z",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,236a13.52,13.52,0,0,0,11.84,0c3.27-1.81,3.27-4.75,0-6.57a13.59,13.59,0,0,0-11.84,0C105.77,231.26,105.77,234.2,109,236Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,236a13.52,13.52,0,0,0,11.84,0c3.27-1.81,3.27-4.75,0-6.57a13.59,13.59,0,0,0-11.84,0C105.77,231.26,105.77,234.2,109,236Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.94,235.3a6.74,6.74,0,0,1-1.06.71A13.52,13.52,0,0,1,109,236a6.63,6.63,0,0,1-1.05-.71,6,6,0,0,1,1.17-.83,13.36,13.36,0,0,1,11.61,0A6.73,6.73,0,0,1,121.94,235.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.94,235.3a6.74,6.74,0,0,1-1.06.71A13.52,13.52,0,0,1,109,236a6.63,6.63,0,0,1-1.05-.71,6,6,0,0,1,1.17-.83,13.36,13.36,0,0,1,11.61,0A6.73,6.73,0,0,1,121.94,235.3Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,234.47l-.3-.16h0l-.5-.22a11.58,11.58,0,0,0-3-.8c-.28,0-.57-.07-.86-.09s-.49,0-.74,0H115l-.78,0a13.64,13.64,0,0,0-2.67.4,10,10,0,0,0-2.35.91l-.32.19-.06,0-.24.16,0,0-.25.19h0l-.25.21A6.63,6.63,0,0,0,109,236a9.92,9.92,0,0,0,2.32.91C112.39,234.66,117,233.34,120.76,234.47Z",
    style: {
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,254.37l0,1.49V256c.1,2.21,3.41,4,7.49,4s7.36-1.76,7.48-4v-.13l.05-1.5c-.41,2.08-3.63,3.7-7.55,3.7S107.84,256.45,107.42,254.37Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,256.3a12.28,12.28,0,0,1-10.43-.16,3.73,3.73,0,0,1-2.21-2.84l-.62-15.14h0a3.52,3.52,0,0,0,1.26,2c.28,6,.33,11,2,13S116,257.81,120,256.3Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M268,219.16c7.45,4.3,7.45,11.27,0,15.57s-19.53,4.31-27,0-7.45-11.27,0-15.57S260.5,214.86,268,219.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.51,213.56c0-2.83,1.94-5.66,5.83-7.82,7.79-4.33,20.42-4.35,28.22,0,3.9,2.15,5.85,5,5.86,7.81h1.79c0-3.22-2.13-6.43-6.38-8.87-8.5-4.89-22.27-4.88-30.76,0-4.24,2.46-6.36,5.67-6.36,8.89h1.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.56,205.7c-7.8-4.31-20.43-4.29-28.22,0-3.89,2.16-5.84,5-5.83,7.82s2,5.66,5.85,7.81c7.8,4.31,20.43,4.29,28.22,0,3.89-2.16,5.84-5,5.84-7.82S272.46,207.85,268.56,205.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.34,205.74c-7.79,4.33-7.78,11.33,0,15.63.6.33,1.23.64,1.88.92a12.91,12.91,0,0,1,0-10.44,17,17,0,0,1,12-9.37A29.7,29.7,0,0,0,240.34,205.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.21,213.51c0,3.21-2.12,6.43-6.36,8.88-8.49,4.92-22.26,4.94-30.75.05-4.25-2.45-6.39-5.66-6.39-8.87,0,13.62,9.77,20.42,21.78,20.41s21.72-6.79,21.72-20.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.29,225.38c-8.72,4.85-22.91,4.87-31.64,0a15.76,15.76,0,0,1-4.49-3.58c.24.61.5,1.19.78,1.75a18.43,18.43,0,0,0,3.4,2.4,34.1,34.1,0,0,0,16.08,3.68c5.86,0,11.73-1.24,16.19-3.73a18,18,0,0,0,3.4-2.41,18.5,18.5,0,0,0,.77-1.75A15.5,15.5,0,0,1,270.29,225.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1,222.44c8.49,4.89,22.26,4.87,30.75-.05,4.24-2.45,6.36-5.67,6.36-8.88h-1.79c0,2.83-1.95,5.66-5.84,7.82-7.79,4.33-20.42,4.35-28.22,0-3.9-2.15-5.85-5-5.85-7.81h-1.8C232.72,216.78,234.85,220,239.1,222.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94,215.91a11.35,11.35,0,0,1-5.36,5.42c-7.79,4.33-20.42,4.35-28.22,0-2.8-1.54-4.59-3.43-5.37-5.42a11.4,11.4,0,0,1,5.35-5.42c7.79-4.33,20.42-4.35,28.22,0A11.48,11.48,0,0,1,273.94,215.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94,215.91a11.35,11.35,0,0,1-5.36,5.42c-7.79,4.33-20.42,4.35-28.22,0-2.8-1.54-4.59-3.43-5.37-5.42a11.4,11.4,0,0,1,5.35-5.42c7.79-4.33,20.42-4.35,28.22,0A11.48,11.48,0,0,1,273.94,215.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.94,215.91a11.35,11.35,0,0,1-5.36,5.42c-7.79,4.33-20.42,4.35-28.22,0-2.8-1.54-4.59-3.43-5.37-5.42a11.4,11.4,0,0,1,5.35-5.42c7.79-4.33,20.42-4.35,28.22,0A11.48,11.48,0,0,1,273.94,215.91Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.36,221.37c7.8,4.31,20.43,4.29,28.22,0a16.26,16.26,0,0,0,1.6-1c-7.66,4.51-21.41,2.62-26.82-.52-5.66-3.29-4.59-8.29.58-10.85a23,23,0,0,0-3.6,1.58A11.4,11.4,0,0,0,235,216C235.77,217.94,237.56,219.83,240.36,221.37Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.62,216.13a.34.34,0,0,0-.22,0c-.15.06-.13.15-.14.29a2.47,2.47,0,0,1,0,.61c-.07.2-.17.21-.36.24-.45.08-.37.46-.63.73a1.64,1.64,0,0,1-1.37.31c-.31,0-.62,0-.93,0-.14,0-.51-.06-.57-.23s.06-.22.08-.29a1.94,1.94,0,0,0,.07-.33,1.36,1.36,0,0,1,.18-.68c.15-.16.39-.14.55-.27s.05-.36.15-.52a1,1,0,0,1,.81-.36c.41-.06.93.15,1.33,0,.1,0,.24-.19.23-.3s-.16-.13-.28-.13a4.78,4.78,0,0,0-.75.08c-.44.06-1,.11-1.1-.48-.24,0-1.05,0-1.16-.24-.18-.4.54-.86.29-1.4-.1-.22-.76-.52-.57-.85s1-.1,1.17-.08a5.51,5.51,0,0,1,1.35.38,2.85,2.85,0,0,0,.77,0c.53.07.48.31.64.69s.24.18.68.39,0,.5-.11.72-.2.28-.13.43.42.12.52,0,.11-.46.22-.68.4-.35.7-.42.23-.31.44-.44a2.47,2.47,0,0,1,1.59-.09c.31.05.8.16.75.55a5.81,5.81,0,0,1-.23.75c-.07.29-.05.62-.39.73s-.56-.07-.76.2,0,.39-.12.56-.42.15-.63.26a1,1,0,0,1-.71.05,4.59,4.59,0,0,1-.49-.26c-.07,0-.24-.07-.29,0a6.31,6.31,0,0,0,.36.77c.05.13.23.52,0,.62s-.29-.23-.32-.35C255.17,216.81,255,216.21,254.62,216.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.64,214a1.61,1.61,0,0,0-.49,0,2.54,2.54,0,0,0-.48.09,2.47,2.47,0,0,0-.85.37,3,3,0,0,0-1,1.25,3,3,0,0,0-.53-.74,10.59,10.59,0,0,0-.74-.76A8.47,8.47,0,0,0,252,213s0,.05,0,.07a11.2,11.2,0,0,1,1.54,1.29c.24.24.46.49.67.74l.3.39.13.18a2.17,2.17,0,0,0-.57,0,2.74,2.74,0,0,0-.88.28,4.59,4.59,0,0,0-1.34,1.14s0,0,0,0a13.08,13.08,0,0,1,1.42-.9A3,3,0,0,1,254,216a1.91,1.91,0,0,1,.41,0c.11,0,.22,0,.34,0a.32.32,0,0,0,.27-.19,5,5,0,0,1,.59-.85,3.17,3.17,0,0,1,.39-.34,2.7,2.7,0,0,1,.83-.37,4.27,4.27,0,0,0,.79-.25S257.66,214,257.64,214Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M173.27,226.34c7.45,4.3,7.45,11.28,0,15.58s-19.53,4.3-27,0-7.45-11.28,0-15.58S165.82,222,173.27,226.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.83,220.75c0-2.83,1.94-5.66,5.83-7.83,7.79-4.33,20.43-4.34,28.22,0,3.9,2.16,5.86,5,5.86,7.81h1.79c0-3.21-2.13-6.42-6.38-8.87-8.5-4.89-22.27-4.87-30.75,0-4.25,2.46-6.37,5.68-6.36,8.89h1.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.88,212.88c-7.79-4.3-20.43-4.29-28.22,0-3.89,2.17-5.83,5-5.83,7.83s2,5.65,5.85,7.81c7.8,4.3,20.44,4.29,28.22,0,3.9-2.17,5.84-5,5.84-7.83S177.78,215,173.88,212.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.66,212.92c-7.78,4.33-7.77,11.33,0,15.64.6.33,1.24.63,1.89.91a12.86,12.86,0,0,1,0-10.43,17,17,0,0,1,12-9.37A29.77,29.77,0,0,0,145.66,212.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.53,220.69c0,3.21-2.11,6.43-6.36,8.89-8.48,4.91-22.25,4.93-30.75,0-4.25-2.45-6.38-5.66-6.38-8.87,0,13.63,9.76,20.43,21.77,20.41s21.72-6.78,21.72-20.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.61,232.56c-8.71,4.86-22.9,4.88-31.63,0a15.44,15.44,0,0,1-4.49-3.57,17.23,17.23,0,0,0,.78,1.75,18.31,18.31,0,0,0,3.39,2.39,36.94,36.94,0,0,0,32.27,0,18.59,18.59,0,0,0,3.4-2.41c.28-.56.54-1.15.77-1.75A15.51,15.51,0,0,1,175.61,232.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.42,229.62c8.5,4.89,22.27,4.87,30.75,0,4.25-2.46,6.37-5.68,6.36-8.89h-1.79c0,2.83-1.94,5.66-5.84,7.83-7.78,4.33-20.42,4.34-28.22,0-3.89-2.16-5.85-5-5.85-7.81H138C138,224,140.17,227.17,144.42,229.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,223.1c-.78,2-2.57,3.87-5.36,5.42-7.78,4.32-20.41,4.34-28.22,0-2.79-1.54-4.59-3.43-5.37-5.43a11.48,11.48,0,0,1,5.36-5.42c7.78-4.32,20.41-4.34,28.21,0A11.35,11.35,0,0,1,179.26,223.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,223.1c-.78,2-2.57,3.87-5.36,5.42-7.78,4.32-20.41,4.34-28.22,0-2.79-1.54-4.59-3.43-5.37-5.43a11.48,11.48,0,0,1,5.36-5.42c7.78-4.32,20.41-4.34,28.21,0A11.35,11.35,0,0,1,179.26,223.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,223.1c-.78,2-2.57,3.87-5.36,5.42-7.78,4.32-20.41,4.34-28.22,0-2.79-1.54-4.59-3.43-5.37-5.43a11.48,11.48,0,0,1,5.36-5.42c7.78-4.32,20.41-4.34,28.21,0A11.35,11.35,0,0,1,179.26,223.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.68,228.56c7.81,4.3,20.44,4.28,28.22,0,.58-.33,1.11-.67,1.61-1-7.66,4.51-21.42,2.63-26.83-.52-5.66-3.29-4.59-8.28.58-10.84a22.9,22.9,0,0,0-3.59,1.57,11.48,11.48,0,0,0-5.36,5.42C141.09,225.13,142.89,227,145.68,228.56Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,223.31a.42.42,0,0,0-.22,0c-.14.07-.13.15-.14.29a2.47,2.47,0,0,1,0,.61c-.08.2-.18.21-.36.24-.46.08-.38.46-.64.74a1.65,1.65,0,0,1-1.37.3c-.31,0-.62,0-.93,0-.14,0-.51-.07-.56-.24s0-.22.08-.29a1.8,1.8,0,0,0,.06-.32A1.31,1.31,0,0,1,156,224c.14-.17.39-.15.54-.27s0-.36.16-.53a1.07,1.07,0,0,1,.8-.36c.42-.06.94.15,1.34,0a.42.42,0,0,0,.22-.31c0-.14-.16-.12-.27-.13a6.31,6.31,0,0,0-.76.08c-.44.06-1,.11-1.09-.47-.25,0-1,0-1.17-.25s.55-.86.3-1.39c-.11-.22-.77-.52-.58-.85s1-.11,1.17-.09a5.86,5.86,0,0,1,1.35.39c.29.1.48,0,.78,0,.52.07.47.31.63.68s.25.19.69.39,0,.51-.12.72-.2.28-.13.43.42.13.52-.05.11-.46.23-.67.39-.36.7-.42.23-.31.43-.44a2.47,2.47,0,0,1,1.59-.1c.31.05.8.17.76.55a6.54,6.54,0,0,1-.24.75c-.06.29-.05.62-.39.73s-.56-.07-.76.2,0,.39-.12.56-.41.16-.62.27a1,1,0,0,1-.71.05c-.19-.06-.32-.2-.5-.27s-.23-.07-.28,0a4.56,4.56,0,0,0,.35.77c.06.14.23.52,0,.63s-.29-.23-.31-.36S160.28,223.4,159.94,223.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,221.16a1.15,1.15,0,0,0-.49,0,4,4,0,0,0-.48.08,2.93,2.93,0,0,0-.85.37,3.1,3.1,0,0,0-1,1.25,3.25,3.25,0,0,0-.53-.73c-.24-.27-.49-.52-.75-.76a7.77,7.77,0,0,0-1.62-1.17s-.06.06,0,.07a12.78,12.78,0,0,1,1.55,1.29q.35.36.66.75l.3.38.14.19a1.88,1.88,0,0,0-.58,0,2.4,2.4,0,0,0-.87.28,4.35,4.35,0,0,0-1.35,1.14s0,0,0,0a11.64,11.64,0,0,1,1.42-.89,3.31,3.31,0,0,1,.83-.24,1.86,1.86,0,0,1,.41,0,1.84,1.84,0,0,0,.33,0c.14,0,.2-.07.27-.19a4.15,4.15,0,0,1,.6-.84,1.88,1.88,0,0,1,.39-.35,3,3,0,0,1,.82-.36,3.74,3.74,0,0,0,.8-.26S163,221.16,163,221.16Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M146.6,273.08c7.45,4.3,7.45,11.27,0,15.58s-19.53,4.3-27,0-7.45-11.28,0-15.58S139.15,268.78,146.6,273.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.16,267.49c0-2.83,1.94-5.67,5.83-7.83,7.79-4.33,20.42-4.35,28.22,0,3.9,2.15,5.85,5,5.85,7.81h1.8c0-3.22-2.14-6.43-6.39-8.87-8.49-4.89-22.26-4.87-30.75,0-4.24,2.46-6.36,5.68-6.36,8.89h1.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.21,259.62c-7.8-4.31-20.43-4.29-28.22,0-3.89,2.16-5.84,5-5.83,7.83s2,5.65,5.85,7.8c7.8,4.31,20.43,4.29,28.22,0,3.89-2.17,5.84-5,5.83-7.83S151.11,261.77,147.21,259.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,259.66c-7.79,4.33-7.78,11.33,0,15.63a19.26,19.26,0,0,0,1.88.92,12.91,12.91,0,0,1,0-10.44,17,17,0,0,1,12-9.36A29.58,29.58,0,0,0,119,259.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,267.43c0,3.21-2.12,6.43-6.36,8.88-8.49,4.92-22.26,4.94-30.76.05-4.24-2.45-6.38-5.66-6.38-8.87,0,13.62,9.77,20.42,21.78,20.41s21.72-6.79,21.72-20.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.94,279.3c-8.72,4.86-22.91,4.87-31.64,0a15.44,15.44,0,0,1-4.49-3.57c.24.6.5,1.19.78,1.75a18.4,18.4,0,0,0,3.4,2.39,34,34,0,0,0,16.08,3.68c5.86,0,11.73-1.24,16.19-3.73a18,18,0,0,0,3.4-2.41c.28-.56.53-1.14.77-1.74A15.65,15.65,0,0,1,148.94,279.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.74,276.36c8.5,4.89,22.27,4.87,30.76-.05,4.24-2.45,6.36-5.67,6.36-8.88h-1.8c0,2.83-1.94,5.66-5.83,7.83-7.79,4.32-20.42,4.34-28.22,0-3.9-2.15-5.85-5-5.85-7.8h-1.8C111.37,270.7,113.5,273.91,117.74,276.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.59,269.83a11.39,11.39,0,0,1-5.36,5.42c-7.79,4.33-20.42,4.35-28.22,0a11.35,11.35,0,0,1-5.38-5.42,11.48,11.48,0,0,1,5.36-5.42c7.79-4.33,20.42-4.34,28.22,0A11.48,11.48,0,0,1,152.59,269.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.59,269.83a11.39,11.39,0,0,1-5.36,5.42c-7.79,4.33-20.42,4.35-28.22,0a11.35,11.35,0,0,1-5.38-5.42,11.48,11.48,0,0,1,5.36-5.42c7.79-4.33,20.42-4.34,28.22,0A11.48,11.48,0,0,1,152.59,269.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.59,269.83a11.39,11.39,0,0,1-5.36,5.42c-7.79,4.33-20.42,4.35-28.22,0a11.35,11.35,0,0,1-5.38-5.42,11.48,11.48,0,0,1,5.36-5.42c7.79-4.33,20.42-4.34,28.22,0A11.48,11.48,0,0,1,152.59,269.83Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,275.29c7.8,4.31,20.43,4.29,28.22,0a16.26,16.26,0,0,0,1.6-1c-7.66,4.51-21.41,2.62-26.82-.52-5.66-3.29-4.59-8.29.58-10.84a23,23,0,0,0-3.6,1.57,11.48,11.48,0,0,0-5.36,5.42A11.35,11.35,0,0,0,119,275.29Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,270.05a.34.34,0,0,0-.22,0c-.15.06-.13.15-.14.29a2.47,2.47,0,0,1,0,.61c-.07.2-.17.21-.36.24-.45.08-.37.46-.64.74a1.64,1.64,0,0,1-1.36.3c-.31,0-.62,0-.93,0-.15,0-.51-.07-.57-.24s.06-.22.08-.29a3.2,3.2,0,0,0,.07-.33,1.26,1.26,0,0,1,.18-.68c.15-.16.39-.14.55-.27s.05-.35.15-.52a1.07,1.07,0,0,1,.8-.36c.42-.06.94.15,1.34,0a.38.38,0,0,0,.23-.3c0-.14-.16-.13-.28-.13a4.78,4.78,0,0,0-.75.08c-.44.06-1.05.11-1.1-.48-.24,0-1.05,0-1.16-.24-.18-.4.54-.86.29-1.4-.1-.22-.76-.51-.57-.84s1-.11,1.17-.09a5.51,5.51,0,0,1,1.35.38c.29.11.48,0,.77.05.53.06.48.3.64.68s.24.18.68.39,0,.51-.11.72-.2.28-.13.43.42.12.51-.05.12-.46.23-.67.39-.36.7-.42.23-.32.43-.45a2.56,2.56,0,0,1,1.6-.09c.31.05.8.16.75.55s-.18.5-.23.75-.05.62-.39.73-.57-.07-.76.2,0,.39-.12.56-.42.16-.63.27a1.08,1.08,0,0,1-.71.05c-.18-.06-.32-.2-.49-.27s-.24-.07-.29,0a5.69,5.69,0,0,0,.36.77c.05.13.23.52,0,.63s-.29-.23-.32-.36S133.6,270.13,133.27,270.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.29,267.9a1.16,1.16,0,0,0-.49,0,2.78,2.78,0,0,0-.49.08,2.63,2.63,0,0,0-.84.37,3,3,0,0,0-1,1.25,2.73,2.73,0,0,0-.53-.73,8.85,8.85,0,0,0-.74-.76,8.1,8.1,0,0,0-1.63-1.17s-.06.05,0,.07a12,12,0,0,1,1.54,1.29,9.45,9.45,0,0,1,.67.75l.3.38.13.19a1.83,1.83,0,0,0-.57,0,2.74,2.74,0,0,0-.88.28,4.77,4.77,0,0,0-1.35,1.14s0,0,0,0a11.64,11.64,0,0,1,1.42-.89,2.66,2.66,0,0,1,.82-.24,1.89,1.89,0,0,1,.41,0c.11,0,.22,0,.33,0a.28.28,0,0,0,.27-.19,5.11,5.11,0,0,1,.6-.84,2.57,2.57,0,0,1,.39-.35,2.7,2.7,0,0,1,.83-.37,3.63,3.63,0,0,0,.79-.25S136.31,267.9,136.29,267.9Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-59",
    cx: 375.92,
    cy: 300.42,
    rx: 19.08,
    ry: 11.01,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356,287c0-2.83,1.94-5.66,5.83-7.83,7.79-4.33,20.42-4.34,28.22,0,3.9,2.16,5.85,5,5.86,7.81h1.79c0-3.21-2.13-6.42-6.38-8.87-8.5-4.89-22.27-4.87-30.76,0-4.24,2.46-6.36,5.68-6.35,8.89H356Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,279.17c-7.8-4.3-20.43-4.29-28.22,0-3.89,2.17-5.84,5-5.83,7.83s1.95,5.65,5.85,7.81c7.8,4.3,20.44,4.29,28.22,0,3.9-2.17,5.84-5,5.84-7.83S393.92,281.33,390,279.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.8,279.21c-7.78,4.33-7.78,11.33,0,15.64a20.65,20.65,0,0,0,1.89.91,12.84,12.84,0,0,1,0-10.44,17,17,0,0,1,12-9.36A29.74,29.74,0,0,0,361.8,279.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.67,287c0,3.21-2.12,6.43-6.36,8.89-8.48,4.91-22.25,4.93-30.75,0-4.25-2.45-6.38-5.66-6.38-8.87,0,13.63,9.76,20.43,21.77,20.41s21.72-6.78,21.72-20.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.75,298.85c-8.71,4.86-22.91,4.88-31.63,0a15.31,15.31,0,0,1-4.49-3.57,17.23,17.23,0,0,0,.78,1.75,18.31,18.31,0,0,0,3.39,2.39,37,37,0,0,0,32.27,0,18.59,18.59,0,0,0,3.4-2.41c.28-.56.54-1.15.77-1.75A15.51,15.51,0,0,1,391.75,298.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.56,295.91c8.5,4.89,22.27,4.87,30.75,0,4.24-2.46,6.36-5.68,6.36-8.89h-1.79c0,2.83-1.94,5.66-5.84,7.83-7.78,4.33-20.42,4.34-28.22,0-3.9-2.16-5.85-5-5.85-7.81h-1.79C354.18,290.25,356.31,293.46,360.56,295.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4,289.39c-.78,2-2.57,3.87-5.36,5.42-7.79,4.32-20.42,4.34-28.22,0a11.2,11.2,0,0,1-5.37-5.42A11.45,11.45,0,0,1,361.8,284c7.79-4.32,20.42-4.34,28.22,0A11.41,11.41,0,0,1,395.4,289.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4,289.39c-.78,2-2.57,3.87-5.36,5.42-7.79,4.32-20.42,4.34-28.22,0a11.2,11.2,0,0,1-5.37-5.42A11.45,11.45,0,0,1,361.8,284c7.79-4.32,20.42-4.34,28.22,0A11.41,11.41,0,0,1,395.4,289.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4,289.39c-.78,2-2.57,3.87-5.36,5.42-7.79,4.32-20.42,4.34-28.22,0a11.2,11.2,0,0,1-5.37-5.42A11.45,11.45,0,0,1,361.8,284c7.79-4.32,20.42-4.34,28.22,0A11.41,11.41,0,0,1,395.4,289.39Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.82,294.84c7.8,4.31,20.43,4.29,28.22,0a18.39,18.39,0,0,0,1.6-1c-7.65,4.51-21.41,2.63-26.82-.52-5.66-3.29-4.59-8.28.58-10.84a23.43,23.43,0,0,0-3.6,1.57,11.45,11.45,0,0,0-5.35,5.42A11.2,11.2,0,0,0,361.82,294.84Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.08,289.6a.42.42,0,0,0-.22,0c-.14.06-.13.15-.14.29a3.08,3.08,0,0,1,0,.61c-.08.2-.18.21-.36.24-.46.08-.38.46-.64.74a1.65,1.65,0,0,1-1.37.3c-.31,0-.62,0-.93,0-.14,0-.51-.07-.57-.24s.06-.22.08-.29a1.21,1.21,0,0,0,.07-.33,1.37,1.37,0,0,1,.19-.68c.14-.16.38-.14.54-.26s.05-.36.16-.53a1.07,1.07,0,0,1,.8-.36c.42-.06.94.15,1.34,0a.38.38,0,0,0,.22-.3c0-.14-.16-.13-.27-.13a6.31,6.31,0,0,0-.76.08c-.44.06-1,.11-1.1-.47-.24,0-1,0-1.16-.25s.55-.86.29-1.39c-.1-.22-.76-.52-.57-.85s1-.11,1.17-.09a5.39,5.39,0,0,1,1.35.38c.29.11.48,0,.78.05.52.07.47.31.63.68s.24.19.68.39.05.51-.11.72-.2.28-.13.43.42.13.52-.05.11-.46.22-.67a.82.82,0,0,1,.7-.42c.26,0,.24-.32.44-.44a2.47,2.47,0,0,1,1.59-.1c.31.05.8.17.76.55a6.54,6.54,0,0,1-.24.75c-.06.29-.05.62-.39.73s-.56-.07-.76.2,0,.39-.12.56-.41.16-.63.27a1,1,0,0,1-.71,0c-.18-.06-.32-.2-.49-.27s-.23-.07-.28,0a4.56,4.56,0,0,0,.35.77c.06.14.23.52,0,.63s-.29-.23-.31-.36C376.64,290.28,376.42,289.68,376.08,289.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,287.45a1.15,1.15,0,0,0-.49,0,4,4,0,0,0-.48.08,2.93,2.93,0,0,0-.85.37,3,3,0,0,0-1,1.25,3.25,3.25,0,0,0-.53-.73c-.24-.27-.49-.52-.75-.76a7.83,7.83,0,0,0-1.63-1.17s-.05,0,0,.07a12.78,12.78,0,0,1,1.55,1.29q.35.36.66.75l.3.38.14.19a1.61,1.61,0,0,0-.58,0,2.4,2.4,0,0,0-.87.28,4.34,4.34,0,0,0-1.35,1.13s0,0,0,0a11.64,11.64,0,0,1,1.42-.89,3,3,0,0,1,.82-.24,2,2,0,0,1,.42,0c.1,0,.22,0,.33,0s.2-.08.27-.19a4.15,4.15,0,0,1,.6-.84,2.11,2.11,0,0,1,.38-.35,2.9,2.9,0,0,1,.83-.36,4.4,4.4,0,0,0,.8-.26S379.12,287.45,379.1,287.45Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M257.58,332.41c7.45,4.3,7.45,11.27,0,15.58s-19.53,4.3-27,0-7.45-11.28,0-15.58S250.13,328.11,257.58,332.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--harira-soup--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.13,326.82c0-2.83,1.94-5.67,5.84-7.83,7.79-4.33,20.42-4.35,28.22,0,3.9,2.15,5.85,5,5.85,7.81h1.79c0-3.22-2.13-6.43-6.38-8.87-8.5-4.89-22.26-4.87-30.75,0-4.24,2.46-6.36,5.68-6.36,8.89h1.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.19,319c-7.8-4.31-20.43-4.29-28.22,0-3.9,2.16-5.84,5-5.84,7.83s2,5.65,5.86,7.8c7.8,4.31,20.43,4.29,28.22,0,3.89-2.17,5.84-5,5.83-7.83S262.09,321.1,258.19,319Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,319c-7.79,4.33-7.78,11.33,0,15.63a19.26,19.26,0,0,0,1.88.92,12.91,12.91,0,0,1,0-10.44,17,17,0,0,1,12-9.36A29.58,29.58,0,0,0,230,319Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.83,326.76c0,3.21-2.11,6.43-6.35,8.88-8.49,4.92-22.26,4.94-30.76.05-4.25-2.45-6.38-5.66-6.38-8.87,0,13.62,9.77,20.42,21.78,20.41s21.71-6.79,21.71-20.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.92,338.63c-8.72,4.86-22.91,4.87-31.64,0a15.44,15.44,0,0,1-4.49-3.57c.24.6.5,1.18.78,1.75a18.07,18.07,0,0,0,3.4,2.39,34.1,34.1,0,0,0,16.08,3.68c5.86,0,11.73-1.24,16.18-3.73a17.37,17.37,0,0,0,3.4-2.41,17,17,0,0,0,.77-1.74A15.46,15.46,0,0,1,259.92,338.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.72,335.69c8.5,4.89,22.27,4.87,30.76-.05,4.24-2.45,6.36-5.67,6.35-8.88H264c0,2.83-1.94,5.66-5.83,7.83-7.79,4.32-20.42,4.34-28.22,0-3.9-2.15-5.85-5-5.86-7.8h-1.79C222.35,330,224.47,333.24,228.72,335.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.56,329.16a11.32,11.32,0,0,1-5.35,5.42c-7.79,4.33-20.42,4.35-28.22,0a11.35,11.35,0,0,1-5.38-5.42,11.48,11.48,0,0,1,5.36-5.42c7.79-4.33,20.42-4.34,28.22,0C261,325.29,262.78,327.18,263.56,329.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.56,329.16a11.32,11.32,0,0,1-5.35,5.42c-7.79,4.33-20.42,4.35-28.22,0a11.35,11.35,0,0,1-5.38-5.42,11.48,11.48,0,0,1,5.36-5.42c7.79-4.33,20.42-4.34,28.22,0C261,325.29,262.78,327.18,263.56,329.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.56,329.16a11.32,11.32,0,0,1-5.35,5.42c-7.79,4.33-20.42,4.35-28.22,0a11.35,11.35,0,0,1-5.38-5.42,11.48,11.48,0,0,1,5.36-5.42c7.79-4.33,20.42-4.34,28.22,0C261,325.29,262.78,327.18,263.56,329.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,334.62c7.8,4.31,20.43,4.29,28.22,0a16.26,16.26,0,0,0,1.6-1c-7.66,4.51-21.42,2.62-26.82-.52-5.66-3.29-4.59-8.29.58-10.84a23,23,0,0,0-3.6,1.57,11.48,11.48,0,0,0-5.36,5.42A11.35,11.35,0,0,0,230,334.62Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.25,329.38a.34.34,0,0,0-.22,0c-.15.06-.13.15-.14.29a2.47,2.47,0,0,1,0,.61c-.07.2-.17.21-.36.24-.45.08-.37.46-.64.73a1.61,1.61,0,0,1-1.36.31c-.31,0-.62,0-.93,0-.15,0-.51-.07-.57-.24s.06-.22.08-.29a3.2,3.2,0,0,0,.07-.33,1.26,1.26,0,0,1,.18-.68c.15-.16.39-.14.55-.27s0-.35.15-.52a1.07,1.07,0,0,1,.8-.36c.42-.06.94.15,1.34,0a.38.38,0,0,0,.23-.3c0-.14-.16-.13-.28-.13a4.78,4.78,0,0,0-.75.08c-.44.06-1,.11-1.1-.48-.25,0-1.05,0-1.16-.24s.54-.86.29-1.4c-.1-.22-.76-.51-.57-.84s1-.11,1.17-.09a5.51,5.51,0,0,1,1.35.38c.29.11.47,0,.77.05.53.06.48.3.64.68s.24.18.68.39,0,.5-.11.72-.2.28-.14.43.43.12.52-.05.12-.46.23-.67.39-.36.7-.42.23-.32.43-.45a2.56,2.56,0,0,1,1.6-.09c.31.05.8.16.75.55s-.18.5-.23.75-.06.62-.39.73-.57-.07-.77.2,0,.39-.11.56-.42.16-.63.27a1.08,1.08,0,0,1-.71.05c-.18-.06-.32-.2-.49-.27s-.24-.07-.29,0a4.27,4.27,0,0,0,.36.77c.05.13.23.52,0,.63s-.29-.23-.32-.36S244.58,329.46,244.25,329.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.27,327.23a1.16,1.16,0,0,0-.49,0,2.78,2.78,0,0,0-.49.08,2.54,2.54,0,0,0-.84.37,3,3,0,0,0-1,1.25,2.73,2.73,0,0,0-.53-.73,7.6,7.6,0,0,0-.74-.76,8.1,8.1,0,0,0-1.63-1.17s-.06.05,0,.07a12,12,0,0,1,1.54,1.29,9.32,9.32,0,0,1,.66.75c.11.12.21.25.31.38l.13.19a1.89,1.89,0,0,0-.58,0,2.77,2.77,0,0,0-.87.28,4.77,4.77,0,0,0-1.35,1.14s0,0,0,0a10.92,10.92,0,0,1,1.42-.89,2.66,2.66,0,0,1,.82-.24,1.88,1.88,0,0,1,.41,0c.11,0,.22,0,.33,0a.28.28,0,0,0,.27-.19,5.11,5.11,0,0,1,.6-.84,2.57,2.57,0,0,1,.39-.35,2.76,2.76,0,0,1,.82-.37,3.55,3.55,0,0,0,.8-.25S247.29,327.23,247.27,327.23Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rice--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M168.84,296.76c-8.38,4.84-8.38,12.69,0,17.53s22,4.84,30.36,0,8.38-12.69,0-17.53S177.23,291.92,168.84,296.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.75,287.63a25.28,25.28,0,0,0,50.55,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.75,287.63a25.28,25.28,0,0,0,50.55,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.97 303.44 171.75 306.36 174.44 305.39 171.75 302.4 168.97 303.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.44 305.39 177.33 307.96 180.36 306.53 177.41 304.06 174.44 305.39",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.2 299.22 163.59 301.41 164.77 301.11 163.29 298.83 162.2 299.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,298.1c.27.58.55,1.15.86,1.71l.33-.59-.8-1.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.36 306.53 184.02 309.17 187.68 306.53 184.02 304.29 180.36 306.53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.77 301.11 166.71 303.83 168.97 303.44 166.58 300.46 164.77 301.11",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.28 301.11 204.46 301.41 205.85 299.22 204.75 298.83 203.28 301.11",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.65,297.78l-.8,1.44.33.59c.3-.56.59-1.13.85-1.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.61 305.39 196.3 306.36 199.08 303.44 196.3 302.4 193.61 305.39",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.08 303.44 201.34 303.83 203.28 301.11 201.47 300.46 199.08 303.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.68 306.53 190.72 307.96 193.61 305.39 190.63 304.06 187.68 306.53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.15,277.31c-9.87,5.7-9.87,14.94,0,20.64s25.87,5.71,35.74,0,9.88-14.94,0-20.64S176,271.62,166.15,277.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,278.55c-9.05,5-9.06,13.15,0,18.17s23.74,5,32.8,0,9.06-13.15,0-18.18S176.68,273.53,167.62,278.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,278.55c-9.05,5-9.06,13.15,0,18.17s23.74,5,32.8,0,9.06-13.15,0-18.18S176.68,273.53,167.62,278.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,278.55c-9.05,5-9.06,13.15,0,18.17.7.38,1.43.74,2.19,1.06,0,0,1.06-5.42,2.36-12.46.88-4.75,4.84-9.34,11.62-10.53A34.47,34.47,0,0,0,167.62,278.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.29,289.94a0,0,0,0,1,0,0h0A0,0,0,0,0,203.29,289.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.89,290.52a1.48,1.48,0,0,0,.34-.93,1.49,1.49,0,0,0-2.56-1c0-.15,0-.3,0-.46a4.52,4.52,0,0,0-6.75-3.93,2,2,0,0,0,.16-.79,2,2,0,0,0-2-2,2,2,0,0,0-1,.27,5.36,5.36,0,0,0,0-.7,5.11,5.11,0,0,0-9.66-2.34,1.79,1.79,0,0,0-3.28,0,4,4,0,0,0-7.42,2.11,3.83,3.83,0,0,0,.05.6,1.46,1.46,0,0,0-.94-.34,1.49,1.49,0,0,0-1.48,1.49v0a3.59,3.59,0,0,0-1.78-.48,3.55,3.55,0,0,0-3.53,3.08,2.09,2.09,0,0,0-.79-.14h-.28a.17.17,0,0,0-.1,0,.71.71,0,0,0-.26.06l-.19.07a2.56,2.56,0,0,0-1.39,2.05.87.87,0,0,0,0,.28.77.77,0,0,0,0,.15.51.51,0,0,0,0,.2,2.68,2.68,0,0,0,.07.27.5.5,0,0,1,0,.13,2.66,2.66,0,0,0,.72,1,1.86,1.86,0,0,0,.27.22,4.42,4.42,0,0,0-2.47,2,14.3,14.3,0,0,0,5.81,5.37c9.06,5,23.74,5,32.8,0a13.78,13.78,0,0,0,6-5.74A2.63,2.63,0,0,0,205.89,290.52Zm-2.61-.55v0a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,300.36c-7,.55-14.36-.66-19.74-3.64a14.23,14.23,0,0,1-5.81-5.37h0a4.42,4.42,0,0,1,2.47-2,1.86,1.86,0,0,1-.27-.22,2.66,2.66,0,0,1-.72-1,.5.5,0,0,0,0-.13,2.68,2.68,0,0,1-.07-.27.51.51,0,0,1,0-.2.77.77,0,0,1,0-.15.87.87,0,0,1,0-.28,2.56,2.56,0,0,1,1.39-2.05l.19-.07A.71.71,0,0,1,165,285a.17.17,0,0,1,.1,0h.28a2.09,2.09,0,0,1,.79.14,3.55,3.55,0,0,1,3.53-3.08c-2.2,1.16-2.51,5.38,1.79,6a2,2,0,0,0,.84,1.71,2.86,2.86,0,0,0,2.13.21s-1.74,2.69.32,4.63a4.17,4.17,0,0,0,4.44.87s.1,2.22,1.51,3a2,2,0,0,0,2.24,0s-.48.8.93,1.16a1.66,1.66,0,0,0,2-1A6.06,6.06,0,0,0,187.36,300.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.42,299.13c-.53.15-1.07.28-1.62.41a3.75,3.75,0,0,0,.62-1.34A2,2,0,0,0,194.42,299.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.71,298c-.33.14-.68.27-1,.39a2.7,2.7,0,0,0,.35-.92A3.11,3.11,0,0,0,197.71,298Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.93,298.43a2.47,2.47,0,1,1-2.65-3.83,2.41,2.41,0,0,0-.47,1.44,2.48,2.48,0,0,0,2.47,2.48A2.37,2.37,0,0,0,182.93,298.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.83,298.59a1.61,1.61,0,1,1-3-.69,1.6,1.6,0,0,0,2.67,1A1.43,1.43,0,0,0,185.83,298.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,286.89a2.47,2.47,0,1,1-4.53,1.11,2.42,2.42,0,0,0,1.19,1,2.48,2.48,0,0,0,3.19-1.44A3.4,3.4,0,0,0,176,286.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.15,289.24a1.61,1.61,0,1,1-3,.43,1.63,1.63,0,0,0,.71.69,1.61,1.61,0,0,0,2.16-.72A1.59,1.59,0,0,0,172.15,289.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.73,292.84a2.47,2.47,0,1,1-4.48-1.28,2.44,2.44,0,0,0,.56,1.42,2.48,2.48,0,0,0,3.48.34A2.81,2.81,0,0,0,197.73,292.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.41,291.67a1.61,1.61,0,1,1-3-.69,1.61,1.61,0,0,0,2.68,1A1.75,1.75,0,0,0,200.41,291.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.44,289a1.64,1.64,0,0,1,.87,1.18,1.61,1.61,0,0,1-3.05.94,1.62,1.62,0,0,0,1,.14,1.6,1.6,0,0,0,1.32-1.85A1.48,1.48,0,0,0,193.44,289Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.17,285.2a.4.4,0,0,0-.26,0c-.18.07-.16.18-.17.34a2.92,2.92,0,0,1-.06.73c-.08.24-.2.26-.43.29-.54.09-.44.55-.76.88a2,2,0,0,1-1.64.37c-.37,0-.74,0-1.11,0-.17,0-.61-.08-.68-.28s.07-.27.1-.35a2.45,2.45,0,0,0,.08-.39,1.52,1.52,0,0,1,.22-.81c.17-.2.46-.18.65-.32s.06-.43.19-.63a1.26,1.26,0,0,1,1-.43c.5-.08,1.12.17,1.6,0,.11-.05.28-.23.27-.36s-.19-.16-.33-.16a5.51,5.51,0,0,0-.91.1c-.52.07-1.24.13-1.31-.57-.29,0-1.25,0-1.39-.3-.22-.47.65-1,.35-1.66-.12-.27-.91-.63-.69-1s1.16-.12,1.41-.1a6.21,6.21,0,0,1,1.61.46c.35.12.57,0,.93.05.62.08.57.37.76.81.26.63.29.23.81.47s0,.61-.13.86-.24.34-.16.52.51.15.62-.06.14-.55.27-.81.47-.43.84-.5.28-.38.52-.53a3,3,0,0,1,1.91-.11c.37.06.95.2.9.66a7.61,7.61,0,0,1-.28.89c-.08.35-.06.74-.47.87s-.67-.08-.91.24,0,.47-.14.68-.5.18-.75.31a1.13,1.13,0,0,1-.85.06,4.83,4.83,0,0,1-.59-.32c-.08,0-.28-.08-.34,0s.37.78.42.92.28.62.05.75-.34-.28-.38-.43C185.83,286,185.57,285.3,185.17,285.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.78,282.63a1.42,1.42,0,0,0-.58,0,5.4,5.4,0,0,0-.58.1,3.29,3.29,0,0,0-1,.45,3.54,3.54,0,0,0-1.16,1.49,3.43,3.43,0,0,0-.64-.87,7.65,7.65,0,0,0-.89-.91,9.47,9.47,0,0,0-1.94-1.4s-.07.06,0,.09a13.62,13.62,0,0,1,1.85,1.54,11.15,11.15,0,0,1,.79.89l.36.46.16.22a2.28,2.28,0,0,0-.69,0,3.16,3.16,0,0,0-1,.33,5.33,5.33,0,0,0-1.62,1.37s0,0,0,0a14.27,14.27,0,0,1,1.7-1.07,4.1,4.1,0,0,1,1-.29,2.68,2.68,0,0,1,.49,0,2.85,2.85,0,0,0,.4,0c.17,0,.24-.09.32-.23a6.41,6.41,0,0,1,.72-1,3.07,3.07,0,0,1,.47-.41,3.46,3.46,0,0,1,1-.44,4.46,4.46,0,0,0,1-.3S188.81,282.63,188.78,282.63Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chicken--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plate--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.4,262.85c17,9.83,17,25.75,0,35.57s-44.6,9.82-61.61,0-17-25.74,0-35.57S278.39,253,295.4,262.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.89,262.3c-16.18-9.34-42.41-9.34-58.59,0h0v-1.68c-8.46,4.88-12.49,11.36-12.1,17.75-.39,6.4,3.64,12.87,12.1,17.76,16.18,9.34,42.41,9.34,58.59,0S310.06,271.64,293.89,262.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.89,260.62c16.17,9.34,16.17,24.49,0,33.83s-42.41,9.34-58.59,0-16.18-24.48,0-33.82S277.71,251.28,293.89,260.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.73,267.59c-11.12,6.42-11.12,16.83,0,23.25s29.14,6.42,40.26,0,11.12-16.83,0-23.25S255.85,261.17,244.73,267.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.1,268.38c-10.36,6-10.36,15.68,0,21.67s27.16,6,37.52,0,10.36-15.68,0-21.67S256.46,262.4,246.1,268.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M299,270.34a3.63,3.63,0,0,0-3.84-2.79c-.74.09-1.44.41-2.18.54a4.38,4.38,0,0,1-4.8-3,3.1,3.1,0,0,0,2.85,2.1,6.72,6.72,0,0,0-1.25-4.05,6.24,6.24,0,0,1-1.39-2.28c-.1-.52,0-1.07-.13-1.59-.33-1.34-1.9-1.9-3.24-2.21a194.79,194.79,0,0,0-22.3-3.38l-.21,0c-9.89.29-19.63,2.61-27.18,7a27.15,27.15,0,0,0-9.58,8.65,8,8,0,0,0,2.31,2.34,1.75,1.75,0,0,0-2,2,2.39,2.39,0,0,0,2.58,1.75,2.93,2.93,0,0,0,2.74,4,2.65,2.65,0,0,0,2.25,2.73c-1.22.67-1,2.69.12,3.51a4.59,4.59,0,0,0,4,.33,2.43,2.43,0,0,0,3.31,3.25,3.53,3.53,0,0,0,5.28,3.63,3.87,3.87,0,0,0,6.22,3.36c-.2,1.57,1.27,3,2.83,3.27a9.62,9.62,0,0,0,4.66-.64,3,3,0,0,0,5.71-1.71,5.74,5.74,0,0,0,4,2.49c1.62.09,3.34-1.25,3.16-2.86a3.84,3.84,0,0,0,4-.86c.72,2,3.16,2.78,5.28,2.74a5,5,0,0,0,3.2-1,2.33,2.33,0,0,0,.5-3.05,2.86,2.86,0,0,0,4-1.72,5.31,5.31,0,0,0,4.47-.36,2.36,2.36,0,0,0,.83-.74c.84-1.29-.51-2.87-1.73-3.81a4.09,4.09,0,0,0,4.63-1.7c.85-1.56-.05-3.9-1.81-4.17a3,3,0,0,0,.92-5.49,3.8,3.8,0,0,0-.68-2.18A3.62,3.62,0,0,0,299,270.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leaves--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229,263.78a4.21,4.21,0,0,0-2.11.31,2.29,2.29,0,0,0-1.33,1.59,3,3,0,0,0,.73,2.24,8.45,8.45,0,0,0,2.88,2.5c-1-.2-3.14.15-3,1.59a1.6,1.6,0,0,0,.47.95,6,6,0,0,0,4.15,1.43,1.4,1.4,0,0,0-1.15,1.51,2.21,2.21,0,0,0,1.16,1.67,5.62,5.62,0,0,0,2,.59,10.84,10.84,0,0,0,5.13-.26c2.64-.91.88-4.41,0-6.06C236.16,268.46,233.12,264.11,229,263.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.07,284.36c-1.1-2.45-4.22-3-6.64-3a8.58,8.58,0,0,0-4.68,1,1.56,1.56,0,0,0-.85,1.33c.06.59.66,1,1.22,1.16a5.39,5.39,0,0,0,2,.28,5.45,5.45,0,0,0-.86,1.32,1.82,1.82,0,0,0,0,1.53,1.69,1.69,0,0,0,1.4.82,3.22,3.22,0,0,0,1.63-.42,2.46,2.46,0,0,0,1.25,2.56,3.74,3.74,0,0,0,4.22-.48,5.26,5.26,0,0,0,1.71-4A5,5,0,0,0,249.07,284.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.21,293.93a3,3,0,0,0-1,2.43,2.32,2.32,0,0,0,1.65,1.67,5.25,5.25,0,0,0,2.43,0,14.91,14.91,0,0,0,3.27-.94,2.91,2.91,0,0,0,3.32,2.77,2.17,2.17,0,0,0,1.19-.39,2.23,2.23,0,0,0,.69-1.06,4.66,4.66,0,0,0,.29-1.52,9.88,9.88,0,0,0,3.39,1.33c.78.07,1.73-.13,2-.86a2,2,0,0,0-.55-1.83,11,11,0,0,0-6-3.9,14.38,14.38,0,0,0-7.08.06A8.24,8.24,0,0,0,254.21,293.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.28,265.82a3.31,3.31,0,0,1,2.71-.25,2.07,2.07,0,0,1,1.31,2.22,2.5,2.5,0,0,1,.85-.93,4.74,4.74,0,0,1,4.55.15,2.42,2.42,0,0,1,1.13,1.29,2.17,2.17,0,0,1-.57,2,6.63,6.63,0,0,1-1.76,1.23,7.39,7.39,0,0,1,2,.82,2.5,2.5,0,0,1,1.17,1.73,2.37,2.37,0,0,1-1,2.09,4.55,4.55,0,0,1-2.3.75,11.63,11.63,0,0,1-7.81-2.63,5.44,5.44,0,0,1-2.09-4.87C286.46,267.76,286.71,266.61,288.28,265.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.82,258.86a4.09,4.09,0,0,1,.36-1.37A2.42,2.42,0,0,1,271.6,256c1.74,0,3.19,1.46,4.08,2.81a3.39,3.39,0,0,1,3.29-2.73,4.76,4.76,0,0,1,3.88,2.2,8.18,8.18,0,0,1,1.23,4.43c.23-.82,1.37-1,2.16-.64a4.88,4.88,0,0,1,2.5,3.15,10.14,10.14,0,0,1-.47,7.42,5.14,5.14,0,0,1-1.35,1.84,4.38,4.38,0,0,1-4.2.48,19.21,19.21,0,0,1-4.15-2.51,20.82,20.82,0,0,1-3.47-3.16c-.42-.47-.76-1-1.19-1.45s-1-.92-1.47-1.42a18.61,18.61,0,0,1-2.37-3.21,9.26,9.26,0,0,1-1.14-2.76A5.5,5.5,0,0,1,268.82,258.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.36,296.08c-3.49,4.16-11.46,0-10.88-5.05.28-2.42,2.07-4.38,4-5.85,4.45-3.37,10.92-5.6,16.5-4.64a3.88,3.88,0,0,1,2.43,1.14,2.93,2.93,0,0,1-.66,3.81,8.46,8.46,0,0,1-3.88,1.63,2.83,2.83,0,0,1-.74,4.26,4.57,4.57,0,0,1-5.23-.93,15.32,15.32,0,0,1-.67,3.86A5,5,0,0,1,286.36,296.08Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tomatoes--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290,277.12a3.45,3.45,0,0,0,2,2.84,10.91,10.91,0,0,0,9.83,0,3.47,3.47,0,0,0,2-2.84v-.87a3.46,3.46,0,0,0-2-2.84,10.91,10.91,0,0,0-9.83,0,3.44,3.44,0,0,0-2,2.84Zm1-.68a3.1,3.1,0,0,1,1.56-1.71,9.93,9.93,0,0,1,8.85,0,3.1,3.1,0,0,1,1.56,1.71,3.07,3.07,0,0,1-1.56,1.71,9.85,9.85,0,0,1-8.85,0A3.07,3.07,0,0,1,291,276.44Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.06,273.41a10.07,10.07,0,0,1,5.09-1.17v1.45H297a9.05,9.05,0,0,0-4.42,1,3.1,3.1,0,0,0-1.56,1.71,3.07,3.07,0,0,0,1.56,1.71A9,9,0,0,0,297,279.2h.18v1.93a10.07,10.07,0,0,1-5.09-1.17,3.45,3.45,0,0,1-2-2.84v-.87A3.44,3.44,0,0,1,292.06,273.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,273.88a9.93,9.93,0,0,1,8.85,0A2.71,2.71,0,0,1,303,276s0,.09,0,.14h0a.28.28,0,0,0,0,.09s0,.05,0,.08,0,.07,0,.1a3.07,3.07,0,0,1-1.56,1.71,9.85,9.85,0,0,1-8.85,0,3.07,3.07,0,0,1-1.56-1.71l0-.13v0a.5.5,0,0,1,0-.12h0a.71.71,0,0,1,0-.14A2.71,2.71,0,0,1,292.55,273.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,273.88a9.93,9.93,0,0,1,8.85,0A2.71,2.71,0,0,1,303,276s0,.09,0,.14h0a.28.28,0,0,0,0,.09s0,.05,0,.08,0,.07,0,.1a3.07,3.07,0,0,1-1.56,1.71,9.85,9.85,0,0,1-8.85,0,3.07,3.07,0,0,1-1.56-1.71l0-.13v0a.5.5,0,0,1,0-.12h0a.71.71,0,0,1,0-.14A2.71,2.71,0,0,1,292.55,273.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.09,276.25a3.43,3.43,0,0,0,2,2.81,10.76,10.76,0,0,0,9.73,0,3,3,0,0,0,0-5.62,10.76,10.76,0,0,0-9.73,0A3.4,3.4,0,0,0,290.09,276.25ZM303,276v.06a.49.49,0,0,1-.52.46l-4.05-.32c-.14,0-.19-.11-.08-.16l.84-.39a.82.82,0,0,1,.28-.06l.23,0a.8.8,0,0,0,.33-.09h0a.25.25,0,0,0,0-.46l-1-.57a.85.85,0,0,0-.53-.09c-.24,0-.4.15-.42.28l0,.13a.25.25,0,0,1-.12.16l-.67.49c-.08.06-.26,0-.28-.05l-.45-1.93a.48.48,0,0,1,.47-.59h0a9,9,0,0,1,4.39,1A2.68,2.68,0,0,1,303,276Zm-8.25,2.91a.49.49,0,0,1-.19-.86l1.82-1.36c.09-.07.26,0,.28,0l.16.62a.19.19,0,0,1,0,.17l-.09.12a.18.18,0,0,0,0,.21c.06.17.35.28.64.23l1.39-.21a.52.52,0,0,0,.4-.22c.07-.14,0-.27-.2-.35l-.18-.08a.41.41,0,0,1-.19-.14l-.39-.58c-.06-.07.07-.15.2-.12l3.1.74a.48.48,0,0,1,.16.87,1.37,1.37,0,0,0-.2.13,9,9,0,0,1-4.39,1A10.3,10.3,0,0,1,294.71,278.93ZM291,276a2.68,2.68,0,0,1,1.6-2.12,8,8,0,0,1,2-.77.51.51,0,0,1,.51.19l1.51,2.12c.05.08-.08.15-.21.12l-1-.23a.67.67,0,0,1-.24-.1l-.14-.11a.63.63,0,0,0-.3-.12h0c-.3,0-.61.08-.68.25l-.36.76c0,.12,0,.24.15.32a.88.88,0,0,0,.6.07l.21-.06a1,1,0,0,1,.3,0l1.07.09c.14,0,.18.11.07.16L292.83,278a.49.49,0,0,1-.46,0A2.51,2.51,0,0,1,291,276Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.09,276.25a3.43,3.43,0,0,0,2,2.81,10.76,10.76,0,0,0,9.73,0,3,3,0,0,0,0-5.62,10.76,10.76,0,0,0-9.73,0A3.4,3.4,0,0,0,290.09,276.25ZM303,276v.06a.49.49,0,0,1-.52.46l-4.05-.32c-.14,0-.19-.11-.08-.16l.84-.39a.82.82,0,0,1,.28-.06l.23,0a.8.8,0,0,0,.33-.09h0a.25.25,0,0,0,0-.46l-1-.57a.85.85,0,0,0-.53-.09c-.24,0-.4.15-.42.28l0,.13a.25.25,0,0,1-.12.16l-.67.49c-.08.06-.26,0-.28-.05l-.45-1.93a.48.48,0,0,1,.47-.59h0a9,9,0,0,1,4.39,1A2.68,2.68,0,0,1,303,276Zm-8.25,2.91a.49.49,0,0,1-.19-.86l1.82-1.36c.09-.07.26,0,.28,0l.16.62a.19.19,0,0,1,0,.17l-.09.12a.18.18,0,0,0,0,.21c.06.17.35.28.64.23l1.39-.21a.52.52,0,0,0,.4-.22c.07-.14,0-.27-.2-.35l-.18-.08a.41.41,0,0,1-.19-.14l-.39-.58c-.06-.07.07-.15.2-.12l3.1.74a.48.48,0,0,1,.16.87,1.37,1.37,0,0,0-.2.13,9,9,0,0,1-4.39,1A10.3,10.3,0,0,1,294.71,278.93ZM291,276a2.68,2.68,0,0,1,1.6-2.12,8,8,0,0,1,2-.77.51.51,0,0,1,.51.19l1.51,2.12c.05.08-.08.15-.21.12l-1-.23a.67.67,0,0,1-.24-.1l-.14-.11a.63.63,0,0,0-.3-.12h0c-.3,0-.61.08-.68.25l-.36.76c0,.12,0,.24.15.32a.88.88,0,0,0,.6.07l.21-.06a1,1,0,0,1,.3,0l1.07.09c.14,0,.18.11.07.16L292.83,278a.49.49,0,0,1-.46,0A2.51,2.51,0,0,1,291,276Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297,272.38a10,10,0,0,1,4.85,1.15,2.86,2.86,0,0,1,0,5.43,10.7,10.7,0,0,1-9.69,0,2.86,2.86,0,0,1,0-5.43,9.9,9.9,0,0,1,4.84-1.15m0-.14a10.1,10.1,0,0,0-4.91,1.17,3,3,0,0,0,0,5.67,10.83,10.83,0,0,0,9.83,0,3,3,0,0,0,0-5.67,10.11,10.11,0,0,0-4.92-1.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Seeds--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.44,275.38c-.22,0-.37.13-.33.24s.24.18.46.15.37-.13.33-.24S301.66,275.35,301.44,275.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,274.3c-.18.07-.25.21-.14.3a.58.58,0,0,0,.52,0c.18-.08.25-.21.14-.31A.55.55,0,0,0,300.63,274.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.83,273.62c-.08.12,0,.26.17.3a.43.43,0,0,0,.45-.16c.09-.12,0-.26-.16-.3A.45.45,0,0,0,298.83,273.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.09,273.9c0,.14.1.26.28.27a.36.36,0,0,0,.39-.22c0-.13-.1-.25-.28-.26A.35.35,0,0,0,297.09,273.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,278.3c.07-.13,0-.26-.19-.29a.43.43,0,0,0-.45.16c-.07.13,0,.26.19.3A.46.46,0,0,0,296,278.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.82,278.57a.34.34,0,0,0-.37-.22c-.18,0-.32.12-.3.26a.33.33,0,0,0,.36.22C297.7,278.82,297.83,278.71,297.82,278.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.65,278.05a.54.54,0,0,0-.52-.07c-.14.07-.14.21,0,.32a.55.55,0,0,0,.51.06C299.79,278.29,299.79,278.15,299.65,278.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.57,277.28a.53.53,0,0,0-.52,0c-.12.09-.06.22.11.31a.57.57,0,0,0,.53,0C300.8,277.5,300.75,277.36,300.57,277.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.34,274.39a.54.54,0,0,0,.52.05c.14-.07.14-.21,0-.31a.54.54,0,0,0-.52-.05C294.19,274.15,294.2,274.29,294.34,274.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.85,274.86a.53.53,0,0,0,.51-.08c.08-.1,0-.23-.23-.28a.53.53,0,0,0-.51.07C292.54,274.67,292.64,274.8,292.85,274.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.41,276.22c.22,0,.37-.12.35-.23s-.23-.18-.46-.16-.37.12-.35.23S292.18,276.24,292.41,276.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.73,277.05c.21-.05.32-.18.25-.28a.53.53,0,0,0-.5-.09c-.21.05-.32.18-.25.28A.53.53,0,0,0,293.73,277.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.13,278.3a.55.55,0,0,0,.51.06c.15-.07.15-.21,0-.31a.54.54,0,0,0-.52-.07C299,278.05,299,278.19,299.13,278.3Zm-.3-4.68c-.08.12,0,.26.17.3a.43.43,0,0,0,.45-.16c.09-.12,0-.26-.16-.3A.45.45,0,0,0,298.83,273.62Zm2.28,2c0,.11.24.18.46.15s.37-.13.33-.24-.24-.18-.46-.15S301.07,275.51,301.11,275.62Zm-9.16.44c0,.11.23.18.46.16s.37-.12.35-.23-.23-.18-.46-.16S291.93,276,292,276.06Zm2.39-1.67a.54.54,0,0,0,.52.05c.14-.07.14-.21,0-.31a.54.54,0,0,0-.52-.05C294.19,274.15,294.2,274.29,294.34,274.39Zm1.06,3.78c-.07.13,0,.26.19.3a.46.46,0,0,0,.45-.17c.07-.13,0-.26-.19-.29A.43.43,0,0,0,295.4,278.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.05,277.29c-.12.09-.06.22.11.31a.57.57,0,0,0,.53,0c.11-.08.06-.22-.12-.3A.53.53,0,0,0,300.05,277.29Zm-2.9,1.32a.33.33,0,0,0,.36.22c.19,0,.32-.12.31-.26a.34.34,0,0,0-.37-.22C297.27,278.36,297.13,278.47,297.15,278.61Zm3.86-4c.18-.08.25-.21.14-.31a.55.55,0,0,0-.52,0c-.18.07-.25.21-.14.3A.58.58,0,0,0,301,274.63Zm-3.92-.73c0,.14.1.26.28.27a.36.36,0,0,0,.39-.22c0-.13-.1-.25-.28-.26A.35.35,0,0,0,297.09,273.9ZM293.23,277a.53.53,0,0,0,.5.09c.21-.05.32-.18.25-.28a.53.53,0,0,0-.5-.09C293.27,276.73,293.16,276.86,293.23,277Zm-.38-2.1a.53.53,0,0,0,.51-.08c.08-.1,0-.23-.23-.28a.53.53,0,0,0-.51.07C292.54,274.67,292.64,274.8,292.85,274.86Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.84,284.65a3.47,3.47,0,0,0-1.51-3.14,8.75,8.75,0,0,0-9.07-.44,4.17,4.17,0,0,0-2.26,3c0,.15-.09.78-.11.94a3.44,3.44,0,0,0,1.5,3.14,8.77,8.77,0,0,0,9.08.43,4.14,4.14,0,0,0,2.25-3Zm-2.59,1.94a7.88,7.88,0,0,1-4.22.93,6.93,6.93,0,0,1-3.95-1.32,2.9,2.9,0,0,1-1.21-1.91,3.58,3.58,0,0,1,1.66-1.77,7.81,7.81,0,0,1,4.23-.94,7,7,0,0,1,3.95,1.33,2.88,2.88,0,0,1,1.21,1.91A3.56,3.56,0,0,1,291.25,286.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.26,281.07a8.63,8.63,0,0,1,4.73-1l-.19,1.56h0a7.81,7.81,0,0,0-4.23.94,3.58,3.58,0,0,0-1.66,1.77,2.9,2.9,0,0,0,1.21,1.91,6.93,6.93,0,0,0,3.95,1.32h0l-.26,2.08a7.78,7.78,0,0,1-4.42-1.48,3.44,3.44,0,0,1-1.5-3.14c0-.16.09-.79.11-.94A4.17,4.17,0,0,1,283.26,281.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,282a6.93,6.93,0,0,0-3.95-1.32,7.88,7.88,0,0,0-4.22.93,3.2,3.2,0,0,0-1.78,2.23.76.76,0,0,0,0,.15h0a.41.41,0,0,0,0,.11v.07a.49.49,0,0,0,0,.12,2.9,2.9,0,0,0,1.21,1.91,6.93,6.93,0,0,0,3.95,1.32,7.79,7.79,0,0,0,4.22-.93,3.6,3.6,0,0,0,1.67-1.77l.05-.14v0a.28.28,0,0,0,0-.13h0a.77.77,0,0,0,0-.15A2.69,2.69,0,0,0,291.82,282Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,282a6.93,6.93,0,0,0-3.95-1.32,7.88,7.88,0,0,0-4.22.93,3.2,3.2,0,0,0-1.78,2.23.76.76,0,0,0,0,.15h0a.41.41,0,0,0,0,.11v.07a.49.49,0,0,0,0,.12,2.9,2.9,0,0,0,1.21,1.91,6.93,6.93,0,0,0,3.95,1.32,7.79,7.79,0,0,0,4.22-.93,3.6,3.6,0,0,0,1.67-1.77l.05-.14v0a.28.28,0,0,0,0-.13h0a.77.77,0,0,0,0-.15A2.69,2.69,0,0,0,291.82,282Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.29,281.53a8.67,8.67,0,0,0-9-.43,4.12,4.12,0,0,0-2.24,2.94,3.43,3.43,0,0,0,1.49,3.11,8.67,8.67,0,0,0,9,.43,4.11,4.11,0,0,0,2.24-2.93A3.45,3.45,0,0,0,292.29,281.53Zm-8.61.1a7.77,7.77,0,0,1,4.19-.93h0a.47.47,0,0,1,.35.66l-.67,2.06a.17.17,0,0,1-.26,0l-.56-.56a.25.25,0,0,1-.08-.17v-.15c0-.14-.14-.26-.35-.31a.7.7,0,0,0-.5.07l-1,.57a.29.29,0,0,0-.08.49h0a.69.69,0,0,0,.29.12l.21,0a.5.5,0,0,1,.25.09l.73.45c.09.06,0,.17-.1.17l-3.77.16a.44.44,0,0,1-.43-.52.13.13,0,0,0,0-.06A3.17,3.17,0,0,1,283.68,281.63Zm3.35,5.86a6.87,6.87,0,0,1-3.91-1.31L283,286a.57.57,0,0,1,.26-.93l3-.66c.12,0,.23.06.18.14l-.45.6a.37.37,0,0,1-.18.14l-.19.08a.33.33,0,0,0-.23.37.46.46,0,0,0,.35.25l1.25.29a.54.54,0,0,0,.63-.22.24.24,0,0,0,0-.22l-.07-.14a.25.25,0,0,1,0-.19l.23-.65a.16.16,0,0,1,.26,0l1.5,1.54a.58.58,0,0,1-.28.92A8.33,8.33,0,0,1,287,287.49Zm4.41-1.06a.38.38,0,0,1-.43,0l-2.84-1.72c-.09-.06,0-.16.09-.17l1-.05a.61.61,0,0,1,.27,0l.19.06a.75.75,0,0,0,.57,0,.29.29,0,0,0,.17-.34l-.22-.83a.56.56,0,0,0-.6-.3h0a.57.57,0,0,0-.3.11l-.14.11a.55.55,0,0,1-.23.11l-1,.2c-.12,0-.23-.06-.17-.14l1.67-2.21a.47.47,0,0,1,.5-.19,6.06,6.06,0,0,1,1.77.92,2.67,2.67,0,0,1,1.2,2.35A3,3,0,0,1,291.44,286.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.29,281.53a8.67,8.67,0,0,0-9-.43,4.12,4.12,0,0,0-2.24,2.94,3.43,3.43,0,0,0,1.49,3.11,8.67,8.67,0,0,0,9,.43,4.11,4.11,0,0,0,2.24-2.93A3.45,3.45,0,0,0,292.29,281.53Zm-8.61.1a7.77,7.77,0,0,1,4.19-.93h0a.47.47,0,0,1,.35.66l-.67,2.06a.17.17,0,0,1-.26,0l-.56-.56a.25.25,0,0,1-.08-.17v-.15c0-.14-.14-.26-.35-.31a.7.7,0,0,0-.5.07l-1,.57a.29.29,0,0,0-.08.49h0a.69.69,0,0,0,.29.12l.21,0a.5.5,0,0,1,.25.09l.73.45c.09.06,0,.17-.1.17l-3.77.16a.44.44,0,0,1-.43-.52.13.13,0,0,0,0-.06A3.17,3.17,0,0,1,283.68,281.63Zm3.35,5.86a6.87,6.87,0,0,1-3.91-1.31L283,286a.57.57,0,0,1,.26-.93l3-.66c.12,0,.23.06.18.14l-.45.6a.37.37,0,0,1-.18.14l-.19.08a.33.33,0,0,0-.23.37.46.46,0,0,0,.35.25l1.25.29a.54.54,0,0,0,.63-.22.24.24,0,0,0,0-.22l-.07-.14a.25.25,0,0,1,0-.19l.23-.65a.16.16,0,0,1,.26,0l1.5,1.54a.58.58,0,0,1-.28.92A8.33,8.33,0,0,1,287,287.49Zm4.41-1.06a.38.38,0,0,1-.43,0l-2.84-1.72c-.09-.06,0-.16.09-.17l1-.05a.61.61,0,0,1,.27,0l.19.06a.75.75,0,0,0,.57,0,.29.29,0,0,0,.17-.34l-.22-.83a.56.56,0,0,0-.6-.3h0a.57.57,0,0,0-.3.11l-.14.11a.55.55,0,0,1-.23.11l-1,.2c-.12,0-.23-.06-.17-.14l1.67-2.21a.47.47,0,0,1,.5-.19,6.06,6.06,0,0,1,1.77.92,2.67,2.67,0,0,1,1.2,2.35A3,3,0,0,1,291.44,286.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.93,280.18a7.59,7.59,0,0,1,4.32,1.45,3.34,3.34,0,0,1,1.46,3,4,4,0,0,1-2.18,2.84,8.57,8.57,0,0,1-4.62,1,7.6,7.6,0,0,1-4.32-1.46,3.32,3.32,0,0,1-1.46-3,4,4,0,0,1,2.18-2.83,8.4,8.4,0,0,1,4.62-1m0-.15a8.69,8.69,0,0,0-4.69,1,4.17,4.17,0,0,0-2.26,3,3.48,3.48,0,0,0,1.51,3.14,7.8,7.8,0,0,0,4.38,1.48,8.61,8.61,0,0,0,4.69-1.05,4.16,4.16,0,0,0,2.26-3,3.47,3.47,0,0,0-1.51-3.14A7.65,7.65,0,0,0,288,280Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--seeds--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.41,283.21c.2,0,.32.16.28.28a.42.42,0,0,1-.45.14c-.2,0-.33-.16-.28-.28A.42.42,0,0,1,283.41,283.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.3,282.08c.16.09.2.24.09.34a.46.46,0,0,1-.48,0c-.16-.09-.21-.24-.1-.33A.45.45,0,0,1,284.3,282.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.05,281.43a.24.24,0,0,1-.19.32.36.36,0,0,1-.4-.19.23.23,0,0,1,.19-.32A.37.37,0,0,1,286.05,281.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.62,281.81a.28.28,0,0,1-.29.28.3.3,0,0,1-.33-.25.28.28,0,0,1,.29-.28A.31.31,0,0,1,287.62,281.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,286.59a.24.24,0,0,1,.21-.31.37.37,0,0,1,.4.2.24.24,0,0,1-.21.31A.37.37,0,0,1,288,286.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.33,286.81a.34.34,0,0,1,.37-.23.25.25,0,0,1,.25.29.34.34,0,0,1-.37.23A.25.25,0,0,1,286.33,286.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.71,286.16a.45.45,0,0,1,.48-.05c.13.08.11.24,0,.34a.46.46,0,0,1-.49.05C284.55,286.42,284.57,286.27,284.71,286.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,285.29a.46.46,0,0,1,.49,0c.09.1,0,.24-.16.32a.45.45,0,0,1-.48,0C283.72,285.52,283.79,285.37,284,285.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.09,282.46a.44.44,0,0,1-.48,0c-.12-.08-.1-.23.05-.33a.46.46,0,0,1,.49,0C290.27,282.21,290.24,282.36,290.09,282.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.41,283c-.19.05-.4,0-.46-.1s.05-.25.25-.3a.41.41,0,0,1,.46.1C291.72,282.84,291.61,283,291.41,283Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.64,284.52c-.2,0-.33-.15-.29-.27s.24-.19.44-.16.33.16.29.27S291.84,284.55,291.64,284.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.31,285.35c-.19-.06-.27-.2-.19-.31a.44.44,0,0,1,.47-.08c.19.07.27.21.19.31A.42.42,0,0,1,290.31,285.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,286.11a.45.45,0,0,0-.48.05c-.14.11-.16.26,0,.34a.46.46,0,0,0,.49-.05C285.3,286.35,285.32,286.19,285.19,286.11Zm.46-4.87a.23.23,0,0,0-.19.32.36.36,0,0,0,.4.19.24.24,0,0,0,.19-.32A.37.37,0,0,0,285.65,281.24Zm-2.24,2a.42.42,0,0,0-.45.14c0,.12.08.24.28.28a.42.42,0,0,0,.45-.14C283.73,283.37,283.61,283.25,283.41,283.21Zm8.38.88c-.2,0-.4,0-.44.16s.09.24.29.27.4,0,.44-.16S292,284.13,291.79,284.09Zm-1.64-2a.46.46,0,0,0-.49,0c-.15.1-.17.25-.05.33a.44.44,0,0,0,.48,0C290.24,282.36,290.27,282.21,290.15,282.12Zm-1.93,4.16a.24.24,0,0,0-.21.31.37.37,0,0,0,.4.2.24.24,0,0,0,.21-.31A.37.37,0,0,0,288.22,286.28Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,285.29c-.17.08-.24.23-.15.33a.45.45,0,0,0,.48,0c.18-.08.25-.22.16-.32A.46.46,0,0,0,284,285.29Zm2.74,1.29a.34.34,0,0,0-.37.23.25.25,0,0,0,.25.29.34.34,0,0,0,.37-.23A.25.25,0,0,0,286.7,286.58Zm-2.31-4.16c.11-.1.07-.25-.09-.34a.45.45,0,0,0-.49,0c-.11.09-.06.24.1.33A.46.46,0,0,0,284.39,282.42Zm2.9-.86a.28.28,0,0,0-.29.28.3.3,0,0,0,.33.25.28.28,0,0,0,.29-.28A.31.31,0,0,0,287.29,281.56Zm3.3,3.4a.44.44,0,0,0-.47.08c-.08.11,0,.25.19.31a.42.42,0,0,0,.47-.08C290.86,285.17,290.78,285,290.59,285Zm1.07-2.23a.41.41,0,0,0-.46-.1c-.2.05-.31.18-.25.3s.27.15.46.1S291.72,282.84,291.66,282.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.91,273.75c.32.9,1.36,1.62,3,2a13.38,13.38,0,0,0,10.27-2.56c1.17-1,1.56-2.12,1.23-3l-.27-.77c-.33-.9-1.36-1.62-3-2A13.37,13.37,0,0,0,284.87,270c-1.18,1-1.56,2.12-1.24,3Zm.79-.85a2.68,2.68,0,0,1,1.09-1.91,10.47,10.47,0,0,1,4.3-2.07,11.57,11.57,0,0,1,5-.23,3.47,3.47,0,0,1,2.17,1.1,2.61,2.61,0,0,1-1.09,1.9,10.18,10.18,0,0,1-4.29,2.07,11.78,11.78,0,0,1-5,.24A3.58,3.58,0,0,1,284.7,272.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87,270a11.55,11.55,0,0,1,4.94-2.35l.46,1.27-.18,0a10.47,10.47,0,0,0-4.3,2.07,2.68,2.68,0,0,0-1.09,1.91,3.58,3.58,0,0,0,2.17,1.1,11.78,11.78,0,0,0,5-.24l.18-.05.61,1.7a13.2,13.2,0,0,1-5.69.3c-1.66-.34-2.7-1.06-3-2l-.28-.77C283.31,272.08,283.69,271,284.87,270Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.53,270.25a10.18,10.18,0,0,1,4.29-2.07,11.74,11.74,0,0,1,4.95-.24c1.29.26,2.13.78,2.37,1.46,0,0,0,.08,0,.12h0s0,.06,0,.09a.2.2,0,0,0,0,.07v.1a2.61,2.61,0,0,1-1.09,1.9,10.31,10.31,0,0,1-4.29,2.08,11.93,11.93,0,0,1-5,.23,3.58,3.58,0,0,1-2.17-1.1l-.07-.1v0a.31.31,0,0,1-.05-.1h0a.69.69,0,0,1-.05-.13C284.26,271.86,284.62,271.05,285.53,270.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.53,270.25a10.18,10.18,0,0,1,4.29-2.07,11.74,11.74,0,0,1,4.95-.24c1.29.26,2.13.78,2.37,1.46,0,0,0,.08,0,.12h0s0,.06,0,.09a.2.2,0,0,0,0,.07v.1a2.61,2.61,0,0,1-1.09,1.9,10.31,10.31,0,0,1-4.29,2.08,11.93,11.93,0,0,1-5,.23,3.58,3.58,0,0,1-2.17-1.1l-.07-.1v0a.31.31,0,0,1-.05-.1h0a.69.69,0,0,1-.05-.13C284.26,271.86,284.62,271.05,285.53,270.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7,273c.32.9,1.35,1.61,3,2a13.27,13.27,0,0,0,10.17-2.54c1.16-1,1.54-2.1,1.22-3s-1.34-1.61-3-1.94A13.29,13.29,0,0,0,284.92,270C283.76,271,283.38,272.07,283.7,273Zm13.18-2.13-4.72.21c-.14,0-.17-.09-.05-.15l.93-.46a1.06,1.06,0,0,1,.3-.1l.24,0a.91.91,0,0,0,.35-.13h0c.25-.14.28-.33.08-.42l-.94-.43a.93.93,0,0,0-.53,0,.66.66,0,0,0-.48.31l-.05.13a.37.37,0,0,1-.15.16l-.77.54c-.1.07-.27.07-.28,0L290.6,268a11.11,11.11,0,0,1,4.17-.07c1.29.26,2.13.78,2.37,1.46,0,0,0,.08,0,.12h0s0,.06,0,.09a.2.2,0,0,0,0,.07v.1A1.77,1.77,0,0,1,296.88,270.83Zm-10,3.17-.05,0,3.15-2.24c.1-.07.27-.07.28,0l.07.56a.2.2,0,0,1-.07.17l-.11.13c-.06.07-.09.14-.06.2s.31.22.62.14l1.48-.37a.72.72,0,0,0,.45-.25c.09-.13,0-.25-.15-.3l-.18-.06a.27.27,0,0,1-.17-.11l-.32-.5c0-.06.11-.15.24-.13l4.11.44,0,0a10.31,10.31,0,0,1-4.29,2.08A11.93,11.93,0,0,1,286.87,274Zm-2.31-1.34a.43.43,0,0,1-.05-.12c-.25-.68.11-1.49,1-2.29a9.65,9.65,0,0,1,3.53-1.86l1.41,2.11c0,.07-.1.16-.23.14l-1-.09a.52.52,0,0,1-.23-.08l-.12-.08a.6.6,0,0,0-.3-.08h0a1,1,0,0,0-.74.32l-.49.76c-.08.11-.05.23.1.29a1,1,0,0,0,.61,0l.23-.07a1.13,1.13,0,0,1,.31-.06l1.09,0c.14,0,.17.09.05.15l-4.08,2a2.51,2.51,0,0,1-1-.72l-.07-.1v0a.31.31,0,0,1-.05-.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.7,273c.32.9,1.35,1.61,3,2a13.27,13.27,0,0,0,10.17-2.54c1.16-1,1.54-2.1,1.22-3s-1.34-1.61-3-1.94A13.29,13.29,0,0,0,284.92,270C283.76,271,283.38,272.07,283.7,273Zm13.18-2.13-4.72.21c-.14,0-.17-.09-.05-.15l.93-.46a1.06,1.06,0,0,1,.3-.1l.24,0a.91.91,0,0,0,.35-.13h0c.25-.14.28-.33.08-.42l-.94-.43a.93.93,0,0,0-.53,0,.66.66,0,0,0-.48.31l-.05.13a.37.37,0,0,1-.15.16l-.77.54c-.1.07-.27.07-.28,0L290.6,268a11.11,11.11,0,0,1,4.17-.07c1.29.26,2.13.78,2.37,1.46,0,0,0,.08,0,.12h0s0,.06,0,.09a.2.2,0,0,0,0,.07v.1A1.77,1.77,0,0,1,296.88,270.83Zm-10,3.17-.05,0,3.15-2.24c.1-.07.27-.07.28,0l.07.56a.2.2,0,0,1-.07.17l-.11.13c-.06.07-.09.14-.06.2s.31.22.62.14l1.48-.37a.72.72,0,0,0,.45-.25c.09-.13,0-.25-.15-.3l-.18-.06a.27.27,0,0,1-.17-.11l-.32-.5c0-.06.11-.15.24-.13l4.11.44,0,0a10.31,10.31,0,0,1-4.29,2.08A11.93,11.93,0,0,1,286.87,274Zm-2.31-1.34a.43.43,0,0,1-.05-.12c-.25-.68.11-1.49,1-2.29a9.65,9.65,0,0,1,3.53-1.86l1.41,2.11c0,.07-.1.16-.23.14l-1-.09a.52.52,0,0,1-.23-.08l-.12-.08a.6.6,0,0,0-.3-.08h0a1,1,0,0,0-.74.32l-.49.76c-.08.11-.05.23.1.29a1,1,0,0,0,.61,0l.23-.07a1.13,1.13,0,0,1,.31-.06l1.09,0c.14,0,.17.09.05.15l-4.08,2a2.51,2.51,0,0,1-1-.72l-.07-.1v0a.31.31,0,0,1-.05-.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,267.77a12.83,12.83,0,0,1,5.43-.24c1.56.31,2.59,1,2.91,1.87s-.1,1.92-1.19,2.9a11.41,11.41,0,0,1-4.7,2.27,12.84,12.84,0,0,1-5.43.25c-1.55-.32-2.59-1-2.91-1.88s.1-1.92,1.2-2.89a11.31,11.31,0,0,1,4.69-2.28m0-.12a11.46,11.46,0,0,0-4.76,2.31c-1.18,1-1.56,2.12-1.24,3s1.36,1.63,3,2a12.77,12.77,0,0,0,5.5-.25,11.5,11.5,0,0,0,4.77-2.31c1.17-1,1.55-2.12,1.23-3s-1.36-1.62-3-2a13.13,13.13,0,0,0-5.51.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--seeds--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.43,269.88c-.23.05-.41.18-.39.28s.22.14.46.09.42-.18.4-.28S295.67,269.83,295.43,269.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.75,268.94c-.21.09-.3.23-.2.31a.68.68,0,0,0,.55,0c.21-.1.3-.24.2-.31A.61.61,0,0,0,294.75,268.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,268.5c-.11.13,0,.25.13.27a.69.69,0,0,0,.51-.21c.1-.13,0-.25-.13-.27A.66.66,0,0,0,293,268.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.08,269c-.06.13.06.23.25.23a.53.53,0,0,0,.44-.26c.05-.13-.06-.23-.25-.22A.5.5,0,0,0,291.08,269Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.24,273.35c.1-.13,0-.25-.14-.26a.63.63,0,0,0-.51.21c-.09.13,0,.25.15.26A.61.61,0,0,0,289.24,273.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.08,273.4c0-.13-.16-.21-.35-.18s-.36.16-.36.29.15.21.35.18S291.07,273.53,291.08,273.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.1,272.67a.55.55,0,0,0-.53,0c-.16.08-.19.22-.06.3a.55.55,0,0,0,.53,0C293.21,272.89,293.23,272.75,293.1,272.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.2,271.82a.68.68,0,0,0-.56.07c-.13.1-.09.23.08.28a.67.67,0,0,0,.56-.07C294.41,272,294.38,271.87,294.2,271.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.09,269.78a.6.6,0,0,0,.54,0c.16-.09.18-.22,0-.3a.6.6,0,0,0-.54,0C288,269.57,288,269.7,288.09,269.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.43,270.41a.71.71,0,0,0,.56-.13c.1-.11,0-.22-.19-.25a.71.71,0,0,0-.56.14C286.14,270.27,286.23,270.38,286.43,270.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.74,271.78c.24,0,.43-.16.41-.27s-.21-.15-.45-.1-.42.17-.41.27S285.51,271.83,285.74,271.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,272.42c.23-.07.37-.21.31-.3s-.29-.1-.52,0-.36.2-.31.29S286.78,272.5,287,272.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.51,273a.55.55,0,0,0,.53,0c.17-.08.19-.22.06-.3a.55.55,0,0,0-.53,0C292.41,272.75,292.38,272.89,292.51,273Zm.45-4.47c-.11.13,0,.25.13.27a.69.69,0,0,0,.51-.21c.1-.13,0-.25-.13-.27A.66.66,0,0,0,293,268.5Zm2.08,1.66c0,.1.22.14.46.09s.42-.18.4-.28-.23-.14-.47-.09S295,270.06,295,270.16Zm-9.75,1.52c0,.1.22.15.45.1s.43-.16.41-.27-.21-.15-.45-.1S285.28,271.58,285.29,271.68Zm2.8-1.9a.6.6,0,0,0,.54,0c.16-.09.18-.22,0-.3a.6.6,0,0,0-.54,0C288,269.57,288,269.7,288.09,269.78Zm.5,3.52c-.09.13,0,.25.15.26a.61.61,0,0,0,.5-.21c.1-.13,0-.25-.14-.26A.63.63,0,0,0,288.59,273.3Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.64,271.89c-.13.1-.09.23.08.28a.67.67,0,0,0,.56-.07c.13-.1.1-.23-.08-.28A.68.68,0,0,0,293.64,271.89Zm-3.27,1.62c0,.13.15.21.35.18s.35-.16.36-.29-.16-.21-.35-.18S290.37,273.38,290.37,273.51Zm4.73-4.3c.21-.1.3-.24.2-.31a.61.61,0,0,0-.55,0c-.21.09-.3.23-.2.31A.68.68,0,0,0,295.1,269.21Zm-4-.23c-.06.13.06.23.25.23a.53.53,0,0,0,.44-.26c.05-.13-.06-.23-.25-.22A.5.5,0,0,0,291.08,269Zm-4.59,3.41c.06.09.29.11.52,0s.37-.21.31-.3-.29-.1-.52,0S286.44,272.3,286.49,272.39Zm-.06-2a.71.71,0,0,0,.56-.13c.1-.11,0-.22-.19-.25a.71.71,0,0,0-.56.14C286.14,270.27,286.23,270.38,286.43,270.41Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tomatoes--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.75,294.45a3.45,3.45,0,0,0-1.77-3,10.87,10.87,0,0,0-9.79-.86,3.46,3.46,0,0,0-2.28,2.65c0,.14-.06.72-.07.87a3.44,3.44,0,0,0,1.78,3,10.84,10.84,0,0,0,9.78.86,3.46,3.46,0,0,0,2.28-2.65Zm-2.68,1.68a9.85,9.85,0,0,1-8.81-.77,3.18,3.18,0,0,1-1.41-1.84,3.14,3.14,0,0,1,1.71-1.57,9.84,9.84,0,0,1,8.81.77,3.13,3.13,0,0,1,1.41,1.84A3.1,3.1,0,0,1,261.07,296.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,291.45a10.1,10.1,0,0,0-5-1.61l-.13,1.44h.18a9.07,9.07,0,0,1,4.31,1.43,3.13,3.13,0,0,1,1.41,1.84,3.1,3.1,0,0,1-1.71,1.57,9.06,9.06,0,0,1-4.49.66l-.18,0-.17,1.92a10.11,10.11,0,0,0,5.17-.72,3.46,3.46,0,0,0,2.28-2.65l.07-.87A3.45,3.45,0,0,0,262,291.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.45,291.88a8.89,8.89,0,0,0-4.32-1.43,9,9,0,0,0-4.5.65,2.71,2.71,0,0,0-1.8,2v.14h0v.1s0,.05,0,.07,0,.07,0,.11a3.18,3.18,0,0,0,1.41,1.84,9.11,9.11,0,0,0,4.32,1.43,9,9,0,0,0,4.49-.66,3.07,3.07,0,0,0,1.71-1.57s0-.08,0-.12a0,0,0,0,1,0,0,.52.52,0,0,0,0-.11v0a.59.59,0,0,0,0-.14A2.68,2.68,0,0,0,261.45,291.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.45,291.88a8.89,8.89,0,0,0-4.32-1.43,9,9,0,0,0-4.5.65,2.71,2.71,0,0,0-1.8,2v.14h0v.1s0,.05,0,.07,0,.07,0,.11a3.18,3.18,0,0,0,1.41,1.84,9.11,9.11,0,0,0,4.32,1.43,9,9,0,0,0,4.49-.66,3.07,3.07,0,0,0,1.71-1.57s0-.08,0-.12a0,0,0,0,1,0,0,.52.52,0,0,0,0-.11v0a.59.59,0,0,0,0-.14A2.68,2.68,0,0,0,261.45,291.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,291.47a10.77,10.77,0,0,0-9.7-.85,3,3,0,0,0-.49,5.6,10.77,10.77,0,0,0,9.7.85,3,3,0,0,0,.49-5.6Zm-9.26-.34a8.85,8.85,0,0,1,4.46-.65h0a.49.49,0,0,1,.42.63l-.62,1.89c0,.07-.2.09-.29,0l-.62-.55a.28.28,0,0,1-.1-.17l0-.13c0-.13-.16-.26-.39-.31a.89.89,0,0,0-.54,0l-1,.48a.25.25,0,0,0-.06.46h0a1,1,0,0,0,.32.12l.23,0a1.07,1.07,0,0,1,.27.09l.81.46c.1.06,0,.16-.1.16l-4,0a.48.48,0,0,1-.48-.51v0A2.66,2.66,0,0,1,252.67,291.13Zm3.91,5.63a9,9,0,0,1-4.28-1.42l-.19-.14a.48.48,0,0,1,.23-.85l3.15-.46c.14,0,.26.06.2.13l-.44.54a.41.41,0,0,1-.2.13l-.19.06c-.19.06-.29.19-.23.33a.53.53,0,0,0,.38.25l1.37.34a.59.59,0,0,0,.66-.18.2.2,0,0,0,0-.21l-.08-.13a.15.15,0,0,1,0-.17l.21-.6c0-.08.2-.09.28,0l1.7,1.51a.48.48,0,0,1-.27.84A10,10,0,0,1,256.58,296.76Zm4.69-.77a.45.45,0,0,1-.46,0l-3.15-1.74c-.1-.06-.05-.16.09-.16h1.07a1,1,0,0,1,.3.05l.21.07a.83.83,0,0,0,.6,0,.23.23,0,0,0,.17-.31l-.28-.79a.71.71,0,0,0-.66-.3h0a.71.71,0,0,0-.31.09l-.15.1a.57.57,0,0,1-.25.08l-1,.14c-.13,0-.25-.07-.19-.14l1.69-2a.48.48,0,0,1,.52-.14,7.52,7.52,0,0,1,1.95.94,2.7,2.7,0,0,1,1.42,2.25A2.5,2.5,0,0,1,261.27,296Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.93,291.47a10.77,10.77,0,0,0-9.7-.85,3,3,0,0,0-.49,5.6,10.77,10.77,0,0,0,9.7.85,3,3,0,0,0,.49-5.6Zm-9.26-.34a8.85,8.85,0,0,1,4.46-.65h0a.49.49,0,0,1,.42.63l-.62,1.89c0,.07-.2.09-.29,0l-.62-.55a.28.28,0,0,1-.1-.17l0-.13c0-.13-.16-.26-.39-.31a.89.89,0,0,0-.54,0l-1,.48a.25.25,0,0,0-.06.46h0a1,1,0,0,0,.32.12l.23,0a1.07,1.07,0,0,1,.27.09l.81.46c.1.06,0,.16-.1.16l-4,0a.48.48,0,0,1-.48-.51v0A2.66,2.66,0,0,1,252.67,291.13Zm3.91,5.63a9,9,0,0,1-4.28-1.42l-.19-.14a.48.48,0,0,1,.23-.85l3.15-.46c.14,0,.26.06.2.13l-.44.54a.41.41,0,0,1-.2.13l-.19.06c-.19.06-.29.19-.23.33a.53.53,0,0,0,.38.25l1.37.34a.59.59,0,0,0,.66-.18.2.2,0,0,0,0-.21l-.08-.13a.15.15,0,0,1,0-.17l.21-.6c0-.08.2-.09.28,0l1.7,1.51a.48.48,0,0,1-.27.84A10,10,0,0,1,256.58,296.76Zm4.69-.77a.47.47,0,0,1-.46,0l-3.15-1.74c-.1-.06-.05-.16.09-.16h1.07a1,1,0,0,1,.3.05l.21.07a.83.83,0,0,0,.6,0,.23.23,0,0,0,.17-.31l-.28-.79a.71.71,0,0,0-.66-.3h0a.71.71,0,0,0-.31.09l-.15.1a.57.57,0,0,1-.25.08l-1,.14c-.13,0-.25-.07-.19-.14l1.69-2a.48.48,0,0,1,.52-.14,7.52,7.52,0,0,1,1.95.94,2.7,2.7,0,0,1,1.42,2.25A2.5,2.5,0,0,1,261.27,296Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.17,290a9.94,9.94,0,0,1,4.73,1.57,3.37,3.37,0,0,1,1.72,2.88,3.3,3.3,0,0,1-2.2,2.53,10.74,10.74,0,0,1-9.65-.84,2.86,2.86,0,0,1,.48-5.41,9.83,9.83,0,0,1,4.92-.73m0-.14a10.1,10.1,0,0,0-5,.74,3,3,0,0,0-.5,5.65,10.86,10.86,0,0,0,9.79.86,3,3,0,0,0,.5-5.65,10.11,10.11,0,0,0-4.8-1.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--seeds--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.46,292.59c.22.05.36.17.31.27s-.26.16-.47.11-.36-.16-.32-.27S252.24,292.55,252.46,292.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.36,291.58c.18.1.23.24.12.32a.59.59,0,0,1-.53,0c-.17-.09-.23-.23-.11-.32A.57.57,0,0,1,253.36,291.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.21,291.06c.07.14,0,.26-.19.29a.46.46,0,0,1-.44-.19c-.07-.14,0-.26.19-.29A.46.46,0,0,1,255.21,291.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,291.5c0,.14-.12.24-.3.24a.35.35,0,0,1-.37-.25c0-.13.12-.24.31-.24A.35.35,0,0,1,256.92,291.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.59,296c-.06-.13,0-.25.21-.28a.45.45,0,0,1,.43.21c.06.13,0,.26-.21.28A.42.42,0,0,1,257.59,296Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.79,296.09a.33.33,0,0,1,.39-.19c.18,0,.3.15.27.28a.32.32,0,0,1-.38.19C255.89,296.35,255.76,296.22,255.79,296.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,295.4a.56.56,0,0,1,.52,0c.14.09.13.23,0,.32a.56.56,0,0,1-.52,0C253.85,295.64,253.86,295.5,254,295.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.16,294.56a.57.57,0,0,1,.52.05c.11.1,0,.23-.14.3a.56.56,0,0,1-.53-.06C252.91,294.75,253,294.62,253.16,294.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.61,292.23a.53.53,0,0,1-.52,0c-.13-.08-.11-.22,0-.31a.58.58,0,0,1,.53,0C259.79,292,259.77,292.14,259.61,292.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.06,292.82a.53.53,0,0,1-.5-.12c-.07-.1,0-.22.25-.26a.52.52,0,0,1,.5.12C261.38,292.67,261.27,292.78,261.06,292.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,294.22c-.22,0-.37-.16-.33-.26s.24-.17.46-.13.37.16.33.27S261.6,294.26,261.39,294.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,294.93c-.2-.07-.3-.2-.22-.3a.51.51,0,0,1,.51-.05c.2.07.3.21.22.3A.51.51,0,0,1,260,294.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.53,295.38a.56.56,0,0,0-.52,0c-.15.1-.16.24,0,.32a.56.56,0,0,0,.52,0C254.66,295.61,254.67,295.47,254.53,295.38Zm.24-4.51c-.18,0-.26.15-.19.29a.46.46,0,0,0,.44.19c.18,0,.26-.15.19-.29A.46.46,0,0,0,254.77,290.87Zm-2.31,1.72c-.22,0-.43,0-.48.11s.1.23.32.27.43,0,.47-.11S252.68,292.64,252.46,292.59Zm9.06,1.24c-.22,0-.43,0-.46.13s.11.22.33.26.42,0,.46-.12S261.74,293.87,261.52,293.83Zm-1.86-1.92a.58.58,0,0,0-.53,0c-.15.09-.17.23,0,.31a.53.53,0,0,0,.52,0C259.77,292.14,259.79,292,259.66,291.91Zm-1.86,3.78c-.18,0-.27.15-.21.28a.42.42,0,0,0,.43.21c.18,0,.27-.15.21-.28A.45.45,0,0,0,257.8,295.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.16,294.56c-.19.06-.25.19-.15.29a.56.56,0,0,0,.53.06c.18-.07.25-.2.14-.3A.57.57,0,0,0,253.16,294.56Zm3,1.34a.33.33,0,0,0-.39.19c0,.13.1.26.28.28a.32.32,0,0,0,.38-.19C256.48,296.05,256.36,295.92,256.18,295.9Zm-2.7-4c.11-.08.06-.22-.12-.32a.57.57,0,0,0-.52,0c-.12.09-.06.23.11.32A.59.59,0,0,0,253.48,291.9Zm3.08-.65c-.19,0-.32.11-.31.24a.35.35,0,0,0,.37.25c.18,0,.32-.1.3-.24A.35.35,0,0,0,256.56,291.25Zm3.72,3.33a.51.51,0,0,0-.51.05c-.08.1,0,.23.22.3a.51.51,0,0,0,.51-.05C260.58,294.79,260.48,294.65,260.28,294.58Zm1-2a.52.52,0,0,0-.5-.12c-.21,0-.32.16-.25.26a.53.53,0,0,0,.5.12C261.27,292.78,261.38,292.67,261.31,292.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.66,269.71a4.14,4.14,0,0,0,2.25,3,8.74,8.74,0,0,0,9.08-.43,3.44,3.44,0,0,0,1.5-3.14l-.11-.94a4.17,4.17,0,0,0-2.26-3,8.75,8.75,0,0,0-9.07.44,3.48,3.48,0,0,0-1.51,3.14Zm.8-.77a2.9,2.9,0,0,1,1.21-1.91,6.93,6.93,0,0,1,4-1.32,7.7,7.7,0,0,1,4.22.93,3.56,3.56,0,0,1,1.67,1.77,2.9,2.9,0,0,1-1.21,1.91,6.93,6.93,0,0,1-4,1.32,7.79,7.79,0,0,1-4.22-.93A3.56,3.56,0,0,1,229.46,268.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.12,265.19a8.76,8.76,0,0,0-4.73-1l.19,1.56h0a7.7,7.7,0,0,1,4.22.93,3.56,3.56,0,0,1,1.67,1.77,2.9,2.9,0,0,1-1.21,1.91,6.93,6.93,0,0,1-4,1.32h0l.26,2.08a7.78,7.78,0,0,0,4.42-1.48,3.44,3.44,0,0,0,1.5-3.14l-.11-.94A4.17,4.17,0,0,0,239.12,265.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.56,266.11a7.06,7.06,0,0,1,3.95-1.32,7.88,7.88,0,0,1,4.22.93,3.22,3.22,0,0,1,1.78,2.23.76.76,0,0,1,0,.15h0v.19a.45.45,0,0,1,0,.11,2.9,2.9,0,0,1-1.21,1.91,6.93,6.93,0,0,1-4,1.32,7.79,7.79,0,0,1-4.22-.93,3.56,3.56,0,0,1-1.67-1.77l-.05-.14v0a.27.27,0,0,1,0-.12v0a.77.77,0,0,1,0-.15A2.69,2.69,0,0,1,230.56,266.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.56,266.11a7.06,7.06,0,0,1,3.95-1.32,7.88,7.88,0,0,1,4.22.93,3.22,3.22,0,0,1,1.78,2.23.76.76,0,0,1,0,.15h0v.19a.45.45,0,0,1,0,.11,2.9,2.9,0,0,1-1.21,1.91,6.93,6.93,0,0,1-4,1.32,7.79,7.79,0,0,1-4.22-.93,3.56,3.56,0,0,1-1.67-1.77l-.05-.14v0a.27.27,0,0,1,0-.12v0a.77.77,0,0,1,0-.15A2.69,2.69,0,0,1,230.56,266.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,268.77a4.11,4.11,0,0,0,2.24,2.93,8.67,8.67,0,0,0,9-.43,3.44,3.44,0,0,0,1.49-3.11,4.11,4.11,0,0,0-2.24-2.93,8.67,8.67,0,0,0-9,.42A3.45,3.45,0,0,0,228.6,268.77Zm11.86-.82V268a.43.43,0,0,1-.42.51l-3.78-.16c-.13,0-.18-.11-.09-.17l.73-.45a.81.81,0,0,1,.25-.09l.21,0a.69.69,0,0,0,.29-.12h0a.29.29,0,0,0-.08-.49l-1-.56a.71.71,0,0,0-.5-.08c-.21.05-.34.17-.35.31v.15a.29.29,0,0,1-.08.18l-.56.55c-.07.07-.24.05-.26,0l-.67-2.06a.46.46,0,0,1,.35-.65h0a7.68,7.68,0,0,1,4.19.92A3.19,3.19,0,0,1,240.46,268Zm-7.24,3.5a.58.58,0,0,1-.28-.92l1.5-1.54a.17.17,0,0,1,.26,0l.23.66a.23.23,0,0,1,0,.18l-.07.14a.24.24,0,0,0,0,.23.56.56,0,0,0,.63.22l1.25-.3a.46.46,0,0,0,.35-.25.33.33,0,0,0-.23-.37l-.19-.07a.54.54,0,0,1-.18-.14l-.45-.61c-.06-.08.06-.16.18-.14l3,.66a.57.57,0,0,1,.26.93l-.17.14a6.9,6.9,0,0,1-3.91,1.31A8.33,8.33,0,0,1,233.22,271.45Zm-3.82-3a2.62,2.62,0,0,1,1.2-2.34,6.07,6.07,0,0,1,1.77-.93.47.47,0,0,1,.5.19l1.67,2.21c.06.08,0,.17-.17.14l-1-.2a.55.55,0,0,1-.23-.11l-.15-.11a.76.76,0,0,0-.29-.11h0a.56.56,0,0,0-.6.3l-.22.83a.29.29,0,0,0,.17.34.67.67,0,0,0,.57,0l.19-.06a.77.77,0,0,1,.27,0l1,.05c.13,0,.18.12.09.17l-2.84,1.72a.39.39,0,0,1-.44,0A3,3,0,0,1,229.4,268.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.6,268.77a4.11,4.11,0,0,0,2.24,2.93,8.67,8.67,0,0,0,9-.43,3.44,3.44,0,0,0,1.49-3.11,4.11,4.11,0,0,0-2.24-2.93,8.67,8.67,0,0,0-9,.42A3.45,3.45,0,0,0,228.6,268.77Zm11.86-.82V268a.43.43,0,0,1-.42.51l-3.78-.16c-.13,0-.18-.11-.09-.17l.73-.45a.81.81,0,0,1,.25-.09l.21,0a.69.69,0,0,0,.29-.12h0a.29.29,0,0,0-.08-.49l-1-.56a.71.71,0,0,0-.5-.08c-.21.05-.34.17-.35.31v.15a.29.29,0,0,1-.08.18l-.56.55c-.07.07-.24.05-.26,0l-.67-2.06a.46.46,0,0,1,.35-.65h0a7.68,7.68,0,0,1,4.19.92A3.19,3.19,0,0,1,240.46,268Zm-7.24,3.5a.58.58,0,0,1-.28-.92l1.5-1.54a.17.17,0,0,1,.26,0l.23.66a.23.23,0,0,1,0,.18l-.07.14a.24.24,0,0,0,0,.23.56.56,0,0,0,.63.22l1.25-.3a.46.46,0,0,0,.35-.25.33.33,0,0,0-.23-.37l-.19-.07a.54.54,0,0,1-.18-.14l-.45-.61c-.06-.08.06-.16.18-.14l3,.66a.57.57,0,0,1,.26.93l-.17.14a6.9,6.9,0,0,1-3.91,1.31A8.33,8.33,0,0,1,233.22,271.45Zm-3.82-3a2.62,2.62,0,0,1,1.2-2.34,6.07,6.07,0,0,1,1.77-.93.47.47,0,0,1,.5.19l1.67,2.21c.06.08,0,.17-.17.14l-1-.2a.55.55,0,0,1-.23-.11l-.15-.11a.76.76,0,0,0-.29-.11h0a.56.56,0,0,0-.6.3l-.22.83a.29.29,0,0,0,.17.34.67.67,0,0,0,.57,0l.19-.06a.77.77,0,0,1,.27,0l1,.05c.13,0,.18.12.09.17l-2.84,1.72a.39.39,0,0,1-.44,0A3,3,0,0,1,229.4,268.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.45,264.3a8.48,8.48,0,0,1,4.62,1,4,4,0,0,1,2.18,2.83,3.34,3.34,0,0,1-1.46,3,7.6,7.6,0,0,1-4.32,1.46,8.48,8.48,0,0,1-4.62-1,4,4,0,0,1-2.18-2.84,3.34,3.34,0,0,1,1.46-3,7.67,7.67,0,0,1,4.32-1.45m0-.15a7.8,7.8,0,0,0-4.38,1.48,3.48,3.48,0,0,0-1.51,3.14,4.14,4.14,0,0,0,2.26,3,8.61,8.61,0,0,0,4.69,1,7.8,7.8,0,0,0,4.38-1.48,3.48,3.48,0,0,0,1.51-3.14,4.17,4.17,0,0,0-2.26-3,8.71,8.71,0,0,0-4.69-1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--seeds--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239,267.33c-.2,0-.32.16-.28.28s.25.18.45.14.33-.16.28-.27S239.17,267.3,239,267.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.08,266.2c-.16.09-.2.24-.09.34a.46.46,0,0,0,.48,0c.16-.09.21-.24.1-.33A.47.47,0,0,0,238.08,266.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.33,265.55a.23.23,0,0,0,.19.32.37.37,0,0,0,.4-.19.22.22,0,0,0-.19-.31A.35.35,0,0,0,236.33,265.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.76,265.94a.28.28,0,0,0,.29.27.3.3,0,0,0,.33-.25.28.28,0,0,0-.3-.27A.29.29,0,0,0,234.76,265.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.36,270.72a.23.23,0,0,0-.2-.31.34.34,0,0,0-.4.19.24.24,0,0,0,.21.31A.34.34,0,0,0,234.36,270.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,270.93a.33.33,0,0,0-.36-.23.25.25,0,0,0-.25.29.34.34,0,0,0,.37.23C236,271.2,236.08,271.07,236,270.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.67,270.28a.46.46,0,0,0-.49,0c-.12.08-.1.24,0,.34a.45.45,0,0,0,.48.05C237.83,270.54,237.81,270.39,237.67,270.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.42,269.41a.46.46,0,0,0-.49,0c-.09.1,0,.24.16.32a.45.45,0,0,0,.48,0C238.66,269.64,238.59,269.49,238.42,269.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.29,266.58a.45.45,0,0,0,.48,0c.12-.09.1-.24-.05-.34a.46.46,0,0,0-.49,0C232.11,266.33,232.14,266.48,232.29,266.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,267.15a.42.42,0,0,0,.47-.1c.06-.11-.05-.25-.25-.3s-.4,0-.46.1S230.77,267.1,231,267.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.74,268.64c.2,0,.33-.15.29-.27s-.24-.19-.44-.15-.33.15-.29.26S230.53,268.67,230.74,268.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.07,269.47c.19-.06.27-.2.19-.31a.44.44,0,0,0-.47-.08c-.19.07-.27.21-.2.32A.46.46,0,0,0,232.07,269.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.22,270.57a.45.45,0,0,0,.48.05c.13-.08.11-.23,0-.34a.46.46,0,0,0-.49,0C237.06,270.31,237.08,270.47,237.22,270.57Zm-.89-5a.23.23,0,0,0,.19.32.37.37,0,0,0,.4-.19.22.22,0,0,0-.19-.31A.35.35,0,0,0,236.33,265.55Zm2.36,2.06c.05.12.25.18.45.14s.33-.16.28-.27-.25-.18-.45-.15S238.65,267.49,238.69,267.61Zm-8.39.87c0,.12.23.19.44.16s.33-.15.29-.27-.24-.19-.44-.15S230.26,268.37,230.3,268.48Zm2-1.9a.45.45,0,0,0,.48,0c.12-.09.1-.24-.05-.34a.46.46,0,0,0-.49,0C232.11,266.33,232.14,266.48,232.29,266.58Zm1.47,4a.24.24,0,0,0,.21.31.34.34,0,0,0,.39-.19.23.23,0,0,0-.2-.31A.34.34,0,0,0,233.76,270.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,269.45c-.09.1,0,.24.16.32a.45.45,0,0,0,.48,0c.09-.1,0-.25-.15-.33A.46.46,0,0,0,237.93,269.45Zm-2.5,1.54a.34.34,0,0,0,.37.23c.17,0,.28-.15.24-.29a.33.33,0,0,0-.36-.23A.25.25,0,0,0,235.43,271Zm3-4.45c.16-.09.21-.24.1-.33a.47.47,0,0,0-.49,0c-.16.09-.2.24-.09.34A.46.46,0,0,0,238.47,266.54Zm-3.71-.6a.28.28,0,0,0,.29.27.3.3,0,0,0,.33-.25.28.28,0,0,0-.3-.27A.29.29,0,0,0,234.76,265.94Zm-3.17,3.46a.46.46,0,0,0,.48.07c.19-.06.27-.2.19-.31a.44.44,0,0,0-.47-.08C231.6,269.15,231.52,269.29,231.59,269.4Zm-.63-2.25a.42.42,0,0,0,.47-.1c.06-.11-.05-.25-.25-.3s-.4,0-.46.1S230.77,267.1,231,267.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240,294.72c.24.93,1.21,1.74,2.84,2.22,3.26,1,7.94.22,10.45-1.65,1.26-.94,1.74-2,1.49-2.9,0-.13-.17-.66-.21-.79-.24-.93-1.21-1.74-2.84-2.22-3.26-.95-7.94-.22-10.45,1.65-1.26.94-1.73,2-1.49,2.9C239.83,294.07,240,294.59,240,294.72Zm.86-.77a2.65,2.65,0,0,1,1.25-1.81,10.41,10.41,0,0,1,4.46-1.68,11.44,11.44,0,0,1,5,.2,3.52,3.52,0,0,1,2.07,1.28,2.66,2.66,0,0,1-1.26,1.8,10.23,10.23,0,0,1-4.46,1.69,11.7,11.7,0,0,1-4.95-.2A3.54,3.54,0,0,1,240.87,294Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.29,291a11.77,11.77,0,0,1,5.13-1.91l.35,1.31-.19,0a10.41,10.41,0,0,0-4.46,1.68,2.65,2.65,0,0,0-1.25,1.81,3.54,3.54,0,0,0,2.07,1.28,11.7,11.7,0,0,0,4.95.2l.19,0,.46,1.74a13.18,13.18,0,0,1-5.69-.2c-1.63-.48-2.6-1.29-2.84-2.22,0-.13-.18-.65-.21-.79C239.56,293,240,292,241.29,291Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.92,291.38a10.28,10.28,0,0,1,4.46-1.69,11.75,11.75,0,0,1,5,.2c1.25.37,2,1,2.23,1.65a.69.69,0,0,1,0,.13h0a.28.28,0,0,1,0,.09.17.17,0,0,1,0,.07v.1a2.66,2.66,0,0,1-1.26,1.8,10.23,10.23,0,0,1-4.46,1.69,11.71,11.71,0,0,1-4.95-.2,3.57,3.57,0,0,1-2.07-1.28l-.06-.11a0,0,0,0,1,0,0l-.05-.1h0a.5.5,0,0,1,0-.13C240.52,292.88,241,292.1,241.92,291.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.92,291.38a10.28,10.28,0,0,1,4.46-1.69,11.75,11.75,0,0,1,5,.2c1.25.37,2,1,2.23,1.65a.69.69,0,0,1,0,.13h0a.28.28,0,0,1,0,.09.17.17,0,0,1,0,.07v.1a2.66,2.66,0,0,1-1.26,1.8,10.23,10.23,0,0,1-4.46,1.69,11.71,11.71,0,0,1-4.95-.2,3.57,3.57,0,0,1-2.07-1.28l-.06-.11a0,0,0,0,1,0,0l-.05-.1h0a.5.5,0,0,1,0-.13C240.52,292.88,241,292.1,241.92,291.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.87,293.92c.24.92,1.2,1.73,2.81,2.2,3.23.95,7.87.22,10.36-1.64,1.24-.92,1.72-2,1.48-2.87s-1.2-1.72-2.82-2.2a13.31,13.31,0,0,0-10.36,1.64C240.1,292,239.63,293,239.87,293.92Zm13.31-1-4.71-.21c-.15,0-.17-.1-.05-.15l1-.38a1.55,1.55,0,0,1,.31-.07l.24,0a1.12,1.12,0,0,0,.37-.09h0c.25-.12.3-.31.11-.42l-.9-.5A.87.87,0,0,0,249,291a.66.66,0,0,0-.5.27l-.06.12a.49.49,0,0,1-.16.16l-.82.47c-.1.06-.28,0-.28,0v-2.42a11.26,11.26,0,0,1,4.17.3c1.25.37,2,1,2.23,1.65a.69.69,0,0,1,0,.13h0a.28.28,0,0,1,0,.09.17.17,0,0,1,0,.07v.1A1.88,1.88,0,0,1,253.18,293Zm-10.24,2.28-.05,0,3.33-2c.1-.06.28,0,.28,0l0,.56a.27.27,0,0,1-.08.17l-.13.11a.21.21,0,0,0-.08.2c0,.15.3.24.62.19l1.49-.23a.83.83,0,0,0,.48-.22c.1-.12,0-.25-.13-.31l-.17-.07a.31.31,0,0,1-.16-.13l-.27-.52c0-.07.12-.14.24-.12l4.06.8,0,0a10.23,10.23,0,0,1-4.46,1.69A11.71,11.71,0,0,1,242.94,295.23Zm-2.19-1.53a.5.5,0,0,1,0-.13c-.19-.69.24-1.47,1.21-2.19a9.62,9.62,0,0,1,3.68-1.54l1.23,2.23c0,.06-.11.14-.24.11l-1-.18a.56.56,0,0,1-.22-.09l-.12-.1a.59.59,0,0,0-.29-.1h0a1,1,0,0,0-.77.25l-.55.71a.19.19,0,0,0,.07.3,1,1,0,0,0,.61,0l.24-.06a1.08,1.08,0,0,1,.31,0L246,293c.14,0,.17.1,0,.15l-4.23,1.62a2.34,2.34,0,0,1-.91-.8l-.06-.11a0,0,0,0,1,0,0l-.05-.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.87,293.92c.24.92,1.2,1.73,2.81,2.2,3.23.95,7.87.22,10.36-1.64,1.24-.92,1.72-2,1.48-2.87s-1.2-1.72-2.82-2.2a13.31,13.31,0,0,0-10.36,1.64C240.1,292,239.63,293,239.87,293.92Zm13.31-1-4.71-.21c-.15,0-.17-.1-.05-.15l1-.38a1.55,1.55,0,0,1,.31-.07l.24,0a1.12,1.12,0,0,0,.37-.09h0c.25-.12.3-.31.11-.42l-.9-.5A.87.87,0,0,0,249,291a.66.66,0,0,0-.5.27l-.06.12a.49.49,0,0,1-.16.16l-.82.47c-.1.06-.28,0-.28,0v-2.42a11.26,11.26,0,0,1,4.17.3c1.25.37,2,1,2.23,1.65a.69.69,0,0,1,0,.13h0a.28.28,0,0,1,0,.09.17.17,0,0,1,0,.07v.1A1.88,1.88,0,0,1,253.18,293Zm-10.24,2.28-.05,0,3.33-2c.1-.06.28,0,.28,0l0,.56a.27.27,0,0,1-.08.17l-.13.11a.21.21,0,0,0-.08.2c0,.15.3.24.62.19l1.49-.23a.83.83,0,0,0,.48-.22c.1-.12,0-.25-.13-.31l-.17-.07a.31.31,0,0,1-.16-.13l-.27-.52c0-.07.12-.14.24-.12l4.06.8,0,0a10.23,10.23,0,0,1-4.46,1.69A11.71,11.71,0,0,1,242.94,295.23Zm-2.19-1.53a.5.5,0,0,1,0-.13c-.19-.69.24-1.47,1.21-2.19a9.62,9.62,0,0,1,3.68-1.54l1.23,2.23c0,.06-.11.14-.24.11l-1-.18a.56.56,0,0,1-.22-.09l-.12-.1a.59.59,0,0,0-.29-.1h0a1,1,0,0,0-.77.25l-.55.71a.19.19,0,0,0,.07.3,1,1,0,0,0,.61,0l.24-.06a1.08,1.08,0,0,1,.31,0L246,293c.14,0,.17.1,0,.15l-4.23,1.62a2.34,2.34,0,0,1-.91-.8l-.06-.11a0,0,0,0,1,0,0l-.05-.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.27,289.27a13,13,0,0,1,5.43.23c1.52.45,2.49,1.2,2.74,2.12s-.27,1.91-1.45,2.78a11.33,11.33,0,0,1-4.88,1.86,12.59,12.59,0,0,1-5.42-.23c-1.53-.45-2.5-1.2-2.74-2.12s.27-1.91,1.44-2.78a11.33,11.33,0,0,1,4.88-1.86m0-.12a11.62,11.62,0,0,0-5,1.88c-1.26.94-1.73,2-1.49,2.9s1.21,1.74,2.84,2.22a13.12,13.12,0,0,0,5.51.24,11.53,11.53,0,0,0,4.94-1.89c1.26-.93,1.74-2,1.49-2.9s-1.21-1.74-2.84-2.22a12.92,12.92,0,0,0-5.5-.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--seeds--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.82,291.88c-.24,0-.42.14-.41.24s.21.16.45.13.43-.14.42-.24S252.06,291.85,251.82,291.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.23,290.88c-.22.07-.32.2-.23.29a.63.63,0,0,0,.55,0c.22-.08.32-.21.23-.29A.6.6,0,0,0,251.23,290.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.48,290.28c-.11.12-.07.25.1.28a.63.63,0,0,0,.53-.16c.12-.12.07-.24-.1-.28A.68.68,0,0,0,249.48,290.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.56,290.6c-.06.13,0,.24.23.25a.56.56,0,0,0,.47-.22c.06-.13,0-.24-.24-.25A.54.54,0,0,0,247.56,290.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.35,294.79c.11-.12.06-.24-.12-.27a.61.61,0,0,0-.52.17c-.11.12-.05.24.12.27A.61.61,0,0,0,245.35,294.79Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.18,295c0-.13-.14-.22-.34-.2s-.37.12-.38.25.14.22.33.21S247.16,295.13,247.18,295Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,294.45a.61.61,0,0,0-.53-.05c-.17.07-.21.21-.09.3a.57.57,0,0,0,.53.05C249.34,294.68,249.38,294.55,249.26,294.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43,293.7a.68.68,0,0,0-.56,0c-.14.09-.12.22,0,.29a.72.72,0,0,0,.56,0C250.62,293.9,250.6,293.77,250.43,293.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.52,291.14a.6.6,0,0,0,.54,0c.17-.07.19-.2.06-.3a.63.63,0,0,0-.54,0C244.42,290.91,244.39,291.05,244.52,291.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.81,291.62a.72.72,0,0,0,.56-.08c.11-.1,0-.22-.16-.27a.68.68,0,0,0-.56.09C242.54,291.45,242.61,291.57,242.81,291.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,292.92c.24,0,.43-.12.43-.23s-.2-.16-.44-.14-.44.13-.43.23S241.77,293,242,292.92Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.21,293.67c.24-.05.38-.17.33-.27s-.28-.13-.51-.07-.38.18-.33.27S243,293.73,243.21,293.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.64,294.7a.57.57,0,0,0,.53.05c.17-.07.21-.2.09-.3a.61.61,0,0,0-.53-.05C248.56,294.47,248.52,294.61,248.64,294.7Zm.84-4.42c-.11.12-.07.25.1.28a.63.63,0,0,0,.53-.16c.12-.12.07-.24-.1-.28A.68.68,0,0,0,249.48,290.28Zm1.93,1.84c0,.1.21.16.45.13s.43-.14.42-.24-.22-.16-.46-.13S251.4,292,251.41,292.12Zm-9.84.66c0,.11.2.17.44.14s.43-.12.43-.23-.2-.16-.44-.14S241.56,292.68,241.57,292.78Zm3-1.64a.6.6,0,0,0,.54,0c.17-.07.19-.2.06-.3a.63.63,0,0,0-.54,0C244.42,290.91,244.39,291.05,244.52,291.14Zm.19,3.55c-.11.12-.05.24.12.27a.61.61,0,0,0,.52-.17c.11-.12.06-.24-.12-.27A.61.61,0,0,0,244.71,294.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87,293.72c-.14.09-.12.22,0,.29a.72.72,0,0,0,.56,0c.14-.09.12-.22,0-.29A.68.68,0,0,0,249.87,293.72Zm-3.41,1.33c0,.13.14.22.33.21s.37-.13.39-.26-.14-.22-.34-.2S246.47,294.92,246.46,295.05Zm5.09-3.87c.22-.08.32-.21.23-.29a.6.6,0,0,0-.55,0c-.22.07-.32.2-.23.29A.63.63,0,0,0,251.55,291.18Zm-4-.58c-.06.13,0,.24.23.25a.56.56,0,0,0,.47-.22c.06-.13,0-.24-.24-.25A.54.54,0,0,0,247.56,290.6Zm-4.86,3c.05.1.28.13.51.07s.38-.17.33-.27-.28-.13-.51-.07S242.65,293.51,242.7,293.6Zm.11-2a.72.72,0,0,0,.56-.08c.11-.1,0-.22-.16-.27a.68.68,0,0,0-.56.09C242.54,291.45,242.61,291.57,242.81,291.62Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onions--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.62,282.22a3.82,3.82,0,0,0,2.14,2.9,9.78,9.78,0,0,0,9.46-.22,3.44,3.44,0,0,0,1.77-3l-.06-.9a3.79,3.79,0,0,0-2.14-2.9,9.78,9.78,0,0,0-9.46.21,3.44,3.44,0,0,0-1.77,3Zm.74-.7a3.07,3.07,0,0,1,1.43-1.85,8.14,8.14,0,0,1,4.28-1.21,8.63,8.63,0,0,1,4.44,1,3.44,3.44,0,0,1,1.65,1.79,3.08,3.08,0,0,1-1.42,1.85,8.11,8.11,0,0,1-4.29,1.21,8.56,8.56,0,0,1-4.43-1A3.42,3.42,0,0,1,238.36,281.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.62,282.22a3.82,3.82,0,0,0,2.14,2.9,9.78,9.78,0,0,0,9.46-.22,3.44,3.44,0,0,0,1.77-3l-.06-.9a3.79,3.79,0,0,0-2.14-2.9,9.78,9.78,0,0,0-9.46.21,3.44,3.44,0,0,0-1.77,3Zm.74-.7a3.07,3.07,0,0,1,1.43-1.85,8.14,8.14,0,0,1,4.28-1.21,8.63,8.63,0,0,1,4.44,1,3.44,3.44,0,0,1,1.65,1.79,3.08,3.08,0,0,1-1.42,1.85,8.11,8.11,0,0,1-4.29,1.21,8.56,8.56,0,0,1-4.43-1A3.42,3.42,0,0,1,238.36,281.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.31,284.9l.25.07.05.9-.25-.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.78,285.22l.25,0,.06.91-.25,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,286.23h-.25l-.05-.91h.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,284.23a3.58,3.58,0,0,1-.27-.29l-.05-.91a3.58,3.58,0,0,0,.26.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,284a2.55,2.55,0,0,1-.23.24l-.05-.9.23-.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.81,284.27l.25.13.06.9-.25-.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.84,285.13l-.24.13-.06-.9.24-.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.69,285.23l.24,0,.06.91-.25,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.12,284.92l.24-.07.06.9-.24.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.51,279.47a8.63,8.63,0,0,0-4.44-1,8.14,8.14,0,0,0-4.28,1.21,3.07,3.07,0,0,0-1.43,1.85,1.33,1.33,0,0,1-.08-.45,2.68,2.68,0,0,1,1.45-2.3,8.09,8.09,0,0,1,4.29-1.22,8.69,8.69,0,0,1,4.43,1,3,3,0,0,1,1.74,2.23,1.78,1.78,0,0,1,0,.46A3.44,3.44,0,0,0,248.51,279.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.51,279.47a8.63,8.63,0,0,0-4.44-1,8.14,8.14,0,0,0-4.28,1.21,3.07,3.07,0,0,0-1.43,1.85,1.33,1.33,0,0,1-.08-.45,2.68,2.68,0,0,1,1.45-2.3,8.09,8.09,0,0,1,4.29-1.22,8.69,8.69,0,0,1,4.43,1,3,3,0,0,1,1.74,2.23,1.78,1.78,0,0,1,0,.46A3.44,3.44,0,0,0,248.51,279.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.56,281.31a3.78,3.78,0,0,0,2.15,2.9,9.76,9.76,0,0,0,9.45-.21,3.44,3.44,0,0,0,1.77-3,3.79,3.79,0,0,0-2.14-2.9,9.78,9.78,0,0,0-9.46.21A3.44,3.44,0,0,0,237.56,281.31Zm.72-.24a2.68,2.68,0,0,1,1.45-2.3,8.09,8.09,0,0,1,4.29-1.22,8.69,8.69,0,0,1,4.43,1,3,3,0,0,1,1.74,2.23,2.73,2.73,0,0,1-1.45,2.31,8.11,8.11,0,0,1-4.29,1.21,8.56,8.56,0,0,1-4.43-1A3,3,0,0,1,238.28,281.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.56,281.31a3.78,3.78,0,0,0,2.15,2.9,9.76,9.76,0,0,0,9.45-.21,3.44,3.44,0,0,0,1.77-3,3.79,3.79,0,0,0-2.14-2.9,9.78,9.78,0,0,0-9.46.21A3.44,3.44,0,0,0,237.56,281.31Zm.72-.24a2.68,2.68,0,0,1,1.45-2.3,8.09,8.09,0,0,1,4.29-1.22,8.69,8.69,0,0,1,4.43,1,3,3,0,0,1,1.74,2.23,2.73,2.73,0,0,1-1.45,2.31,8.11,8.11,0,0,1-4.29,1.21,8.56,8.56,0,0,1-4.43-1A3,3,0,0,1,238.28,281.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244,277.14a9.26,9.26,0,0,1,4.74,1.09A3.68,3.68,0,0,1,250.8,281a3.31,3.31,0,0,1-1.72,2.86,8.67,8.67,0,0,1-4.58,1.31,9.18,9.18,0,0,1-4.74-1.1,3.61,3.61,0,0,1-2.06-2.77,3.27,3.27,0,0,1,1.71-2.86,8.58,8.58,0,0,1,4.58-1.31m0-.14a8.79,8.79,0,0,0-4.65,1.32,3.44,3.44,0,0,0-1.77,3,3.78,3.78,0,0,0,2.15,2.9,9.35,9.35,0,0,0,4.8,1.11,8.88,8.88,0,0,0,4.65-1.32,3.44,3.44,0,0,0,1.77-3,3.79,3.79,0,0,0-2.14-2.9A9.31,9.31,0,0,0,244,277Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244,277.14a9.26,9.26,0,0,1,4.74,1.09A3.68,3.68,0,0,1,250.8,281a3.31,3.31,0,0,1-1.72,2.86,8.67,8.67,0,0,1-4.58,1.31,9.18,9.18,0,0,1-4.74-1.1,3.61,3.61,0,0,1-2.06-2.77,3.27,3.27,0,0,1,1.71-2.86,8.58,8.58,0,0,1,4.58-1.31m0-.14a8.79,8.79,0,0,0-4.65,1.32,3.44,3.44,0,0,0-1.77,3,3.78,3.78,0,0,0,2.15,2.9,9.35,9.35,0,0,0,4.8,1.11,8.88,8.88,0,0,0,4.65-1.32,3.44,3.44,0,0,0,1.77-3,3.79,3.79,0,0,0-2.14-2.9A9.31,9.31,0,0,0,244,277Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.57,282.48c.27.92,1.23,1.7,2.8,2.13a12.24,12.24,0,0,0,9.91-2c1.16-1,1.57-2,1.3-2.94l-.23-.78c-.27-.91-1.23-1.7-2.81-2.13a12.22,12.22,0,0,0-9.9,2c-1.16,1-1.57,2-1.3,2.94Zm.65-.74a2.68,2.68,0,0,1,1.15-1.88,9.82,9.82,0,0,1,4.28-1.87,11,11,0,0,1,4.86.06,3.47,3.47,0,0,1,2.07,1.24,2.66,2.66,0,0,1-1.14,1.89,9.69,9.69,0,0,1-4.29,1.86,10.8,10.8,0,0,1-4.85-.05A3.5,3.5,0,0,1,227.22,281.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.57,282.48c.27.92,1.23,1.7,2.8,2.13a12.24,12.24,0,0,0,9.91-2c1.16-1,1.57-2,1.3-2.94l-.23-.78c-.27-.91-1.23-1.7-2.81-2.13a12.22,12.22,0,0,0-9.9,2c-1.16,1-1.57,2-1.3,2.94Zm.65-.74a2.68,2.68,0,0,1,1.15-1.88,9.82,9.82,0,0,1,4.28-1.87,11,11,0,0,1,4.86.06,3.47,3.47,0,0,1,2.07,1.24,2.66,2.66,0,0,1-1.14,1.89,9.69,9.69,0,0,1-4.29,1.86,10.8,10.8,0,0,1-4.85-.05A3.5,3.5,0,0,1,227.22,281.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231,284.13l.27,0,.23.78-.27,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.57,284.14l.27,0,.23.78-.27,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.62,284.69l-.26,0-.23-.78.26,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,284.06l-.33-.21-.23-.78.33.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.17,281.69a2.48,2.48,0,0,1-.19.26l-.23-.78a2.48,2.48,0,0,0,.19-.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.26,283.86l.29.07.24.78-.29-.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.92,282.93l-.22.15-.23-.78.22-.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.63,283.6l.24-.08.24.78-.25.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.08,283.06l.24-.11.23.78-.24.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.51,278.05a11,11,0,0,0-4.86-.06,9.82,9.82,0,0,0-4.28,1.87,2.68,2.68,0,0,0-1.15,1.88,1.17,1.17,0,0,1-.17-.38c-.21-.71.17-1.52,1.09-2.28a9.77,9.77,0,0,1,4.28-1.87,11,11,0,0,1,4.86.06c1.24.34,2,.92,2.25,1.62a1.1,1.1,0,0,1,.05.4A3.47,3.47,0,0,0,237.51,278.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.51,278.05a11,11,0,0,0-4.86-.06,9.82,9.82,0,0,0-4.28,1.87,2.68,2.68,0,0,0-1.15,1.88,1.17,1.17,0,0,1-.17-.38c-.21-.71.17-1.52,1.09-2.28a9.77,9.77,0,0,1,4.28-1.87,11,11,0,0,1,4.86.06c1.24.34,2,.92,2.25,1.62a1.1,1.1,0,0,1,.05.4A3.47,3.47,0,0,0,237.51,278.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.34,281.7c.27.92,1.23,1.7,2.8,2.13a12.24,12.24,0,0,0,9.91-2c1.16-1,1.57-2,1.3-2.94s-1.23-1.7-2.81-2.13a12.22,12.22,0,0,0-9.9,2C226.48,279.73,226.07,280.79,226.34,281.7Zm.71-.34c-.21-.71.17-1.52,1.09-2.28a9.77,9.77,0,0,1,4.28-1.87,11,11,0,0,1,4.86.06c1.24.34,2,.92,2.25,1.62s-.18,1.52-1.09,2.29a9.69,9.69,0,0,1-4.29,1.86,10.8,10.8,0,0,1-4.85-.05C228.06,282.65,227.26,282.07,227.05,281.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.34,281.7c.27.92,1.23,1.7,2.8,2.13a12.24,12.24,0,0,0,9.91-2c1.16-1,1.57-2,1.3-2.94s-1.23-1.7-2.81-2.13a12.22,12.22,0,0,0-9.9,2C226.48,279.73,226.07,280.79,226.34,281.7Zm.71-.34c-.21-.71.17-1.52,1.09-2.28a9.77,9.77,0,0,1,4.28-1.87,11,11,0,0,1,4.86.06c1.24.34,2,.92,2.25,1.62s-.18,1.52-1.09,2.29a9.69,9.69,0,0,1-4.29,1.86,10.8,10.8,0,0,1-4.85-.05C228.06,282.65,227.26,282.07,227.05,281.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.32,276.86a11.57,11.57,0,0,1,5.19.07c1.47.4,2.43,1.12,2.7,2s-.18,1.91-1.27,2.82a10.41,10.41,0,0,1-4.57,2,11.71,11.71,0,0,1-5.19-.07c-1.47-.4-2.43-1.12-2.7-2s.18-1.92,1.26-2.82a10.28,10.28,0,0,1,4.58-2m0-.13a10.67,10.67,0,0,0-4.64,2c-1.16,1-1.57,2-1.3,2.94s1.23,1.7,2.8,2.13a11.82,11.82,0,0,0,5.27.07,10.55,10.55,0,0,0,4.64-2c1.16-1,1.57-2,1.3-2.94s-1.23-1.7-2.81-2.13a11.92,11.92,0,0,0-5.26-.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.32,276.86a11.57,11.57,0,0,1,5.19.07c1.47.4,2.43,1.12,2.7,2s-.18,1.91-1.27,2.82a10.41,10.41,0,0,1-4.57,2,11.71,11.71,0,0,1-5.19-.07c-1.47-.4-2.43-1.12-2.7-2s.18-1.92,1.26-2.82a10.28,10.28,0,0,1,4.58-2m0-.13a10.67,10.67,0,0,0-4.64,2c-1.16,1-1.57,2-1.3,2.94s1.23,1.7,2.8,2.13a11.82,11.82,0,0,0,5.27.07,10.55,10.55,0,0,0,4.64-2c1.16-1,1.57-2,1.3-2.94s-1.23-1.7-2.81-2.13a11.92,11.92,0,0,0-5.26-.07Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.64,285.1a3.47,3.47,0,0,0,2,2.84,10.91,10.91,0,0,0,9.83,0,3.47,3.47,0,0,0,2-2.84v-.87a3.46,3.46,0,0,0-2-2.84,10.91,10.91,0,0,0-9.83,0,3.46,3.46,0,0,0-2,2.84Zm.81-.65a3.18,3.18,0,0,1,1.6-1.75,10.15,10.15,0,0,1,9.07,0,1.76,1.76,0,0,1,0,3.5,10.06,10.06,0,0,1-9.07,0A3.18,3.18,0,0,1,232.45,284.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.64,285.1a3.47,3.47,0,0,0,2,2.84,10.91,10.91,0,0,0,9.83,0,3.47,3.47,0,0,0,2-2.84v-.87a3.46,3.46,0,0,0-2-2.84,10.91,10.91,0,0,0-9.83,0,3.46,3.46,0,0,0-2,2.84Zm.81-.65a3.18,3.18,0,0,1,1.6-1.75,10.15,10.15,0,0,1,9.07,0,1.76,1.76,0,0,1,0,3.5,10.06,10.06,0,0,1-9.07,0A3.18,3.18,0,0,1,232.45,284.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.29,287.76l.25.07v.87l-.25-.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8,288.1l.25,0V289l-.25,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.57,289.11h-.26v-.87h.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.52,287.06a3.23,3.23,0,0,1-.25-.29v-.87a2.18,2.18,0,0,0,.25.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.6,287.11l-.25.23v-.87l.25-.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.78,287.12l.25.13v.88l-.25-.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.09,288.15l-.25.12v-.87l.25-.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.81,288.17a2.3,2.3,0,0,0,.26,0V289l-.26,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,287.91l.25-.07v.88l-.25.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.12,282.7a10.15,10.15,0,0,0-9.07,0,3.18,3.18,0,0,0-1.6,1.75,1.59,1.59,0,0,1-.06-.43,2.76,2.76,0,0,1,1.66-2.19,10.06,10.06,0,0,1,9.07,0,2.76,2.76,0,0,1,1.66,2.19,1.59,1.59,0,0,1-.06.43A3.18,3.18,0,0,0,243.12,282.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.12,282.7a10.15,10.15,0,0,0-9.07,0,3.18,3.18,0,0,0-1.6,1.75,1.59,1.59,0,0,1-.06-.43,2.76,2.76,0,0,1,1.66-2.19,10.06,10.06,0,0,1,9.07,0,2.76,2.76,0,0,1,1.66,2.19,1.59,1.59,0,0,1-.06.43A3.18,3.18,0,0,0,243.12,282.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.64,284.23a3.45,3.45,0,0,0,2,2.83,10.85,10.85,0,0,0,9.83,0,3,3,0,0,0,0-5.67,10.91,10.91,0,0,0-9.83,0A3.46,3.46,0,0,0,231.64,284.23Zm.75-.21a2.76,2.76,0,0,1,1.66-2.19,10.06,10.06,0,0,1,9.07,0,2.27,2.27,0,0,1,0,4.37,10.06,10.06,0,0,1-9.07,0A2.74,2.74,0,0,1,232.39,284Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.64,284.23a3.45,3.45,0,0,0,2,2.83,10.85,10.85,0,0,0,9.83,0,3,3,0,0,0,0-5.67,10.91,10.91,0,0,0-9.83,0A3.46,3.46,0,0,0,231.64,284.23Zm.75-.21a2.76,2.76,0,0,1,1.66-2.19,10.06,10.06,0,0,1,9.07,0,2.27,2.27,0,0,1,0,4.37,10.06,10.06,0,0,1-9.07,0A2.74,2.74,0,0,1,232.39,284Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.59,280.36a9.9,9.9,0,0,1,4.84,1.15,2.86,2.86,0,0,1,0,5.43,10.7,10.7,0,0,1-9.69,0,2.86,2.86,0,0,1,0-5.43,9.91,9.91,0,0,1,4.85-1.15m0-.14a10.11,10.11,0,0,0-4.92,1.17,3,3,0,0,0,0,5.67,10.83,10.83,0,0,0,9.83,0,3,3,0,0,0,0-5.67,10.1,10.1,0,0,0-4.91-1.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.59,280.36a9.9,9.9,0,0,1,4.84,1.15,2.86,2.86,0,0,1,0,5.43,10.7,10.7,0,0,1-9.69,0,2.86,2.86,0,0,1,0-5.43,9.91,9.91,0,0,1,4.85-1.15m0-.14a10.11,10.11,0,0,0-4.92,1.17,3,3,0,0,0,0,5.67,10.83,10.83,0,0,0,9.83,0,3,3,0,0,0,0-5.67,10.1,10.1,0,0,0-4.91-1.17Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onions--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.9,292a3.79,3.79,0,0,0,2.14,2.89,9.78,9.78,0,0,0,9.46-.21,3.42,3.42,0,0,0,1.77-3l-.06-.9a3.79,3.79,0,0,0-2.14-2.9,9.76,9.76,0,0,0-9.45.21,3.43,3.43,0,0,0-1.78,3Zm.74-.7a3.07,3.07,0,0,1,1.43-1.85,8.15,8.15,0,0,1,4.29-1.21,8.59,8.59,0,0,1,4.43,1,3.44,3.44,0,0,1,1.65,1.79,3,3,0,0,1-1.42,1.85,8.18,8.18,0,0,1-4.29,1.21,8.59,8.59,0,0,1-4.43-1A3.42,3.42,0,0,1,273.64,291.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.9,292a3.79,3.79,0,0,0,2.14,2.89,9.78,9.78,0,0,0,9.46-.21,3.42,3.42,0,0,0,1.77-3l-.06-.9a3.79,3.79,0,0,0-2.14-2.9,9.76,9.76,0,0,0-9.45.21,3.43,3.43,0,0,0-1.78,3Zm.74-.7a3.07,3.07,0,0,1,1.43-1.85,8.15,8.15,0,0,1,4.29-1.21,8.59,8.59,0,0,1,4.43,1,3.44,3.44,0,0,1,1.65,1.79,3,3,0,0,1-1.42,1.85,8.18,8.18,0,0,1-4.29,1.21,8.59,8.59,0,0,1-4.43-1A3.42,3.42,0,0,1,273.64,291.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276.59,294.63l.25.07.05.91-.24-.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.07,295l.24,0,.06.9a1.07,1.07,0,0,1-.25,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.83,296h-.24l-.06-.91h.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.88,294c-.1-.1-.18-.2-.26-.29l-.06-.91a3.58,3.58,0,0,0,.26.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.5,293.76l-.22.24-.06-.9.23-.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.09,294l.26.13,0,.9-.25-.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.12,294.87l-.24.13-.05-.91.23-.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,295l.24,0,.06.91-.24,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.41,294.66l.23-.07.06.9-.24.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.79,289.21a8.59,8.59,0,0,0-4.43-1,8.15,8.15,0,0,0-4.29,1.21,3.07,3.07,0,0,0-1.43,1.85,2.23,2.23,0,0,1-.08-.45,2.68,2.68,0,0,1,1.45-2.3,8.09,8.09,0,0,1,4.29-1.22,8.69,8.69,0,0,1,4.43,1,3,3,0,0,1,1.74,2.23,1.78,1.78,0,0,1,0,.46A3.44,3.44,0,0,0,283.79,289.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.79,289.21a8.59,8.59,0,0,0-4.43-1,8.15,8.15,0,0,0-4.29,1.21,3.07,3.07,0,0,0-1.43,1.85,2.23,2.23,0,0,1-.08-.45,2.68,2.68,0,0,1,1.45-2.3,8.09,8.09,0,0,1,4.29-1.22,8.69,8.69,0,0,1,4.43,1,3,3,0,0,1,1.74,2.23,1.78,1.78,0,0,1,0,.46A3.44,3.44,0,0,0,283.79,289.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.84,291.05A3.78,3.78,0,0,0,275,294a9.74,9.74,0,0,0,9.45-.22,3.41,3.41,0,0,0,1.77-3,3.79,3.79,0,0,0-2.14-2.9,9.76,9.76,0,0,0-9.45.21A3.43,3.43,0,0,0,272.84,291.05Zm.72-.24a2.68,2.68,0,0,1,1.45-2.3,8.09,8.09,0,0,1,4.29-1.22,8.69,8.69,0,0,1,4.43,1,3,3,0,0,1,1.74,2.23,2.73,2.73,0,0,1-1.45,2.31,8.18,8.18,0,0,1-4.29,1.21,8.59,8.59,0,0,1-4.43-1A3,3,0,0,1,273.56,290.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.84,291.05A3.78,3.78,0,0,0,275,294a9.74,9.74,0,0,0,9.45-.22,3.41,3.41,0,0,0,1.77-3,3.79,3.79,0,0,0-2.14-2.9,9.76,9.76,0,0,0-9.45.21A3.43,3.43,0,0,0,272.84,291.05Zm.72-.24a2.68,2.68,0,0,1,1.45-2.3,8.09,8.09,0,0,1,4.29-1.22,8.69,8.69,0,0,1,4.43,1,3,3,0,0,1,1.74,2.23,2.73,2.73,0,0,1-1.45,2.31,8.18,8.18,0,0,1-4.29,1.21,8.59,8.59,0,0,1-4.43-1A3,3,0,0,1,273.56,290.81Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.27,286.88A9.23,9.23,0,0,1,284,288a3.66,3.66,0,0,1,2.07,2.78,3.29,3.29,0,0,1-1.72,2.86,8.67,8.67,0,0,1-4.58,1.31,9.12,9.12,0,0,1-4.73-1.1,3.62,3.62,0,0,1-2.07-2.77,3.27,3.27,0,0,1,1.71-2.86,8.58,8.58,0,0,1,4.58-1.31m0-.14a8.73,8.73,0,0,0-4.64,1.32,3.43,3.43,0,0,0-1.78,3A3.78,3.78,0,0,0,275,294a9.35,9.35,0,0,0,4.8,1.11,8.77,8.77,0,0,0,4.65-1.33,3.41,3.41,0,0,0,1.77-3,3.79,3.79,0,0,0-2.14-2.9,9.31,9.31,0,0,0-4.81-1.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.27,286.88A9.23,9.23,0,0,1,284,288a3.66,3.66,0,0,1,2.07,2.78,3.29,3.29,0,0,1-1.72,2.86,8.67,8.67,0,0,1-4.58,1.31,9.12,9.12,0,0,1-4.73-1.1,3.62,3.62,0,0,1-2.07-2.77,3.27,3.27,0,0,1,1.71-2.86,8.58,8.58,0,0,1,4.58-1.31m0-.14a8.73,8.73,0,0,0-4.64,1.32,3.43,3.43,0,0,0-1.78,3A3.78,3.78,0,0,0,275,294a9.35,9.35,0,0,0,4.8,1.11,8.77,8.77,0,0,0,4.65-1.33,3.41,3.41,0,0,0,1.77-3,3.79,3.79,0,0,0-2.14-2.9,9.31,9.31,0,0,0-4.81-1.11Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.59,295a3.45,3.45,0,0,0,2,2.83,10.83,10.83,0,0,0,9.82,0,3.45,3.45,0,0,0,2-2.83v-.88a3.45,3.45,0,0,0-2-2.83,10.83,10.83,0,0,0-9.82,0,3.45,3.45,0,0,0-2,2.83Zm.82-.65a3.14,3.14,0,0,1,1.6-1.75,10,10,0,0,1,9.06,0,1.76,1.76,0,0,1,0,3.5,10.12,10.12,0,0,1-9.06,0A3.14,3.14,0,0,1,267.41,294.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.59,295a3.45,3.45,0,0,0,2,2.83,10.83,10.83,0,0,0,9.82,0,3.45,3.45,0,0,0,2-2.83v-.88a3.45,3.45,0,0,0-2-2.83,10.83,10.83,0,0,0-9.82,0,3.45,3.45,0,0,0-2,2.83Zm.82-.65a3.14,3.14,0,0,1,1.6-1.75,10,10,0,0,1,9.06,0,1.76,1.76,0,0,1,0,3.5,10.12,10.12,0,0,1-9.06,0A3.14,3.14,0,0,1,267.41,294.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.25,297.61l.25.07v.87l-.25-.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.76,298l.25,0v.88l-.25,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,299h-.25v-.87h.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.48,296.9a3.32,3.32,0,0,1-.26-.28v-.88a2.35,2.35,0,0,0,.26.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.56,297l-.26.24v-.87l.26-.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.73,297l.26.13V298l-.26-.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,298l-.25.12v-.88a1.15,1.15,0,0,0,.25-.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.77,298l.25,0v.87l-.25,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.28,297.76l.25-.07v.87l-.25.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.07,292.55a10,10,0,0,0-9.06,0,3.14,3.14,0,0,0-1.6,1.75,1.67,1.67,0,0,1-.06-.44,2.77,2.77,0,0,1,1.66-2.19,10.12,10.12,0,0,1,9.06,0,2.77,2.77,0,0,1,1.66,2.19,1.67,1.67,0,0,1-.06.44A3.11,3.11,0,0,0,278.07,292.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.07,292.55a10,10,0,0,0-9.06,0,3.14,3.14,0,0,0-1.6,1.75,1.67,1.67,0,0,1-.06-.44,2.77,2.77,0,0,1,1.66-2.19,10.12,10.12,0,0,1,9.06,0,2.77,2.77,0,0,1,1.66,2.19,1.67,1.67,0,0,1-.06.44A3.11,3.11,0,0,0,278.07,292.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.59,294.07a3.45,3.45,0,0,0,2,2.84,10.83,10.83,0,0,0,9.82,0,3,3,0,0,0,0-5.67,10.83,10.83,0,0,0-9.82,0A3.45,3.45,0,0,0,266.59,294.07Zm.76-.21a2.77,2.77,0,0,1,1.66-2.19,10.12,10.12,0,0,1,9.06,0,2.27,2.27,0,0,1,0,4.38,10.12,10.12,0,0,1-9.06,0A2.76,2.76,0,0,1,267.35,293.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.59,294.07a3.45,3.45,0,0,0,2,2.84,10.83,10.83,0,0,0,9.82,0,3,3,0,0,0,0-5.67,10.83,10.83,0,0,0-9.82,0A3.45,3.45,0,0,0,266.59,294.07Zm.76-.21a2.77,2.77,0,0,1,1.66-2.19,10.12,10.12,0,0,1,9.06,0,2.27,2.27,0,0,1,0,4.38,10.12,10.12,0,0,1-9.06,0A2.76,2.76,0,0,1,267.35,293.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.54,290.2a9.79,9.79,0,0,1,4.84,1.16,2.86,2.86,0,0,1,0,5.43,10.68,10.68,0,0,1-9.68,0,2.86,2.86,0,0,1,0-5.43,9.79,9.79,0,0,1,4.84-1.16m0-.14a10,10,0,0,0-4.91,1.18,3,3,0,0,0,0,5.67,10.81,10.81,0,0,0,9.82,0,3,3,0,0,0,0-5.67,10,10,0,0,0-4.91-1.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.54,290.2a9.79,9.79,0,0,1,4.84,1.16,2.86,2.86,0,0,1,0,5.43,10.68,10.68,0,0,1-9.68,0,2.86,2.86,0,0,1,0-5.43,9.79,9.79,0,0,1,4.84-1.16m0-.14a10,10,0,0,0-4.91,1.18,3,3,0,0,0,0,5.67,10.81,10.81,0,0,0,9.82,0,3,3,0,0,0,0-5.67,10,10,0,0,0-4.91-1.18Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chicken--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.57,258.93s-1-8.32-8.21-11-10.08-1-14.32-2.27-3.62-2.41-6.16-3-4.46-1.28-5.23.31.39,2.28-.63,2.94,1,1.63,2.1,2.53a15.45,15.45,0,0,0,3.83,1.93,49.28,49.28,0,0,1,5.14,3.66A23.1,23.1,0,0,0,265,258.88Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.68,243h0c.34.1.68.2,1,.32-1,3.63,1.77,3,2.8,4.55,2,2.9,4.16,3,9.07,2.28a26.74,26.74,0,0,1,11.94,1.34c3.51,1.19,8.68,2.59,9.06,7.44l-9.48,0a24.09,24.09,0,0,1-14.18-4.9,48.46,48.46,0,0,0-5-3.52,15.45,15.45,0,0,1-3.83-1.93c-1.13-.9-3.12-1.87-2.1-2.53S239.83,244.64,240.68,243Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.57,247.18c2.38.42,4.64.14,7.09.71a15.46,15.46,0,0,1,3.5,1.22,6.41,6.41,0,0,1,1.13.66c.14.11.81.68.76.88-.09.37-.92-.25-1.15-.36a8.6,8.6,0,0,0-1.56-.58,27.43,27.43,0,0,0-4.4-.79c-1.34-.13-2.71,0-4.06-.1-.61,0-3.43-.56-2.51-1.67.33-.4.82-.11,1.2,0",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.12,244.5c.49,0,1,.08,1.45.09a4.35,4.35,0,0,0,.81-.05c.17,0,.54-.11.62-.27a.24.24,0,0,0,0-.23c-.11-.2-.45-.27-.65-.35l-.71-.24a10.73,10.73,0,0,0-1.59-.35c-1.05-.13-2.53,0-2.75,1.24a7.32,7.32,0,0,1,0,.81c-.09.32-.35.49-.43.74-.25.72.22.75.8.4C242.65,245.65,242.72,244.51,244.12,244.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.18,247.56a.18.18,0,0,1,.12-.05,3.09,3.09,0,0,1,.43,0l1,.08a7.63,7.63,0,0,0,.83,0c.33,0,.67,0,1,0a21.18,21.18,0,0,1,3.37.46A8.53,8.53,0,0,1,267,249.3c.07,0,.06.25,0,.21a21.16,21.16,0,0,0-6.94-1.38,10.13,10.13,0,0,1-1.46-.06,4.12,4.12,0,0,1-1.34-.38.14.14,0,0,1-.07-.08A.08.08,0,0,1,257.18,247.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.49,260.07l10.45,10.39.38.38s0-.22.05-.59v-.06q0-.4,0-1h0c0-.09,0-.19,0-.28h0A9.74,9.74,0,0,0,286.5,263c-2.5-2.93-3.44-4.39-3.79-5.6l0,2.41s-6.74-9.75-9.25-11.72c-.26-.21-.43-.24-.51-.12C272.26,248.93,277.49,260.07,277.49,260.07Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.49,260.07l10.45,10.39.38.33s0-.2.05-.54v-.06s0-.06,0-.09c-.42-.14-.05-.4,0-.9h0a.89.89,0,0,0,0-.28h0a8.58,8.58,0,0,0-4-6.23,14.09,14.09,0,0,1-4.44-3.9c-1.75-2.33-3.09-3.93-4.35-5.91s-1.69-3.56-2.72-4.92C272.26,248.93,277.49,260.07,277.49,260.07Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.33,253s7.07-4.37,18.6-.58,25.14,13.87,26.7,22.94-7.56,14.25-7.56,14.25a9.13,9.13,0,0,1-4.27,2.72c-2.3.45-4.38,2.71-6.92,3.4s-14.84.74-19.84-5.11C243.22,279.13,238.74,261,246.33,253Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245,267.39a31.71,31.71,0,0,0,12.55,15.19c3.46,2.17,7.59,6.41,11.75,6.81,5.9.57,8-4.95,11.67-6.35,2.86-1.09,5.08-1.41,6.63-4.21a17.13,17.13,0,0,0,2.27-8.13,14.48,14.48,0,0,1,1.76,4.65c1.56,9.07-7.56,14.25-7.56,14.25a9.13,9.13,0,0,1-4.27,2.72c-2.3.45-4.38,2.71-6.92,3.4s-14.84.74-19.84-5.11c-7.56-8.84-11.95-21.63-10.11-30.69A36.29,36.29,0,0,0,245,267.39Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.69,276c0,.22-.05.44-.08.65-.51,3.35-1,5-3.42,7.39-2.65,2.63-4,3.27-7.3,4.84-1.75.83-5.16,4.25-8.67,4.87a16.73,16.73,0,0,1-6.19-.17c-7.78-1.3-13.77-6.34-17.8-12.93a42,42,0,0,1-4.35-10.18,49.71,49.71,0,0,1-1.36-5.57.92.92,0,0,1,0,.16c0,.34,0,.69,0,1l.09,1.14c0,.06,0,.11,0,.17A44.88,44.88,0,0,0,253,290.61c5,5.85,17.29,5.8,19.84,5.11s4.62-3,6.92-3.4a9.13,9.13,0,0,0,4.27-2.72s6.9-3.92,7.67-10.91a1.94,1.94,0,0,1,0-.24c0-.09,0-.19,0-.29A11.08,11.08,0,0,0,291.69,276Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.32,259a34.72,34.72,0,0,1,3.86,1.62,22.08,22.08,0,0,1,4.36,3c1.49,1.23,3.09,2.22,4.52,3.45,1.19,1,3.53,2.25,4.85.8,1.63-1.8-1-4.8-2.09-6.19-.74-1-2.93-2.63-1.17-3.32s6.06,2,7.39,2.89a31.22,31.22,0,0,1,8.51,8.25c1.45,2.06,2.54,5.53-.4,6.79-2.35,1-5.37-.62-7.4,1.42-1.64,1.64-1.81,5.08-5.37,6.27-3.76,1.25-5.32-4.66-6.59-6.95a63.79,63.79,0,0,0-4.3-7.48,53.62,53.62,0,0,0-7.54-7.82c-1.49-1.3-4.09-4.24,0-3.13C253.44,258.73,253.88,258.87,254.32,259Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.79,252.33c2.24-.65,9.13-1.28,9.12-.19,0,.92-2.91.35-6.12,1.08-1.41.32-4.08,1.88-5.19.87-.58-1,1.53-1.47,2.19-1.76",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.26,268.47c1.44,0,2.36.81,3.47,1.66a13.91,13.91,0,0,1,3.23,3.31c1.21,1.8,2.61,6,.12,7.24-.48.25-1.26.4-1.59-.19a4.62,4.62,0,0,1-.46-2.6,8.78,8.78,0,0,0-.69-2.8,15.83,15.83,0,0,0-1.25-2.42c-.84-1.43-2.17-2.31-2.91-3.77C265.13,268.81,265.07,268.47,265.26,268.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.49,264.13c3.48,1.18,7,4,7.35,7.92a1.72,1.72,0,0,1-1.82,1.71c-2,.1-1.93-2.15-2.47-3.51a36,36,0,0,0-3.13-5.79C276.38,264.4,276.32,264.07,276.49,264.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.27,284.71c0,.09-.05.18-.07.26v0a3.81,3.81,0,0,0-.08.59h0c0,.2,0,.41,0,.61a4.21,4.21,0,0,0,0,.62c0,.1,0,.21.05.31l0,.15c0,.15.07.3.11.45s0,.09,0,.14,0,.09,0,.14l.06.14a3.32,3.32,0,0,0,.65,1.06c1.68,1.77,6.89,5.45,9.92,5.94s4.55-2.09,4.37-2.94.53-3.07.21-5.2a19.51,19.51,0,0,0-.92-4.6.41.41,0,0,0,0-.09.89.89,0,0,0-.24-.29.26.26,0,0,0-.21-.07.23.23,0,0,0-.11,0,1,1,0,0,0-.3.28l0,.05a2.58,2.58,0,0,0-.22.37l-.08.16-.06.12a.89.89,0,0,1-.08.17,12.21,12.21,0,0,0-.49,1.4h0c0-.13-.31-4.24-.48-6.54-.1-1.48.05-3,0-4.73,0-2.29-.28-3.93-.84-3.78-.33.08-.75.74-1.31,2.18-.32.83-.68,1.93-1.09,3.33-1.3,4.44,0,11.42,0,11.71h0c-2.78-1.46-4.25-3.16-6.78-3.63C246.24,282.87,245.56,283.64,245.27,284.71Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.27,284.71c0,.09-.05.18-.07.26v0a3.81,3.81,0,0,0-.08.59h0c0,.2,0,.41,0,.61s0,.41,0,.62,0,.21.05.31l0,.15c0,.15.07.3.11.45s0,.09,0,.14,0,.09,0,.14l.06.14a3.32,3.32,0,0,0,.65,1.06c1.68,1.77,6.89,5.45,9.92,5.94s4.55-2.09,4.37-2.94.53-3.07.21-5.2a19.51,19.51,0,0,0-.92-4.6.41.41,0,0,0,0-.09,1,1,0,0,0-.24-.29.3.3,0,0,0-.21-.07.23.23,0,0,0-.11,0,1,1,0,0,0-.3.28l0,.05a2.58,2.58,0,0,0-.22.37l-.08.16-.06.12a.89.89,0,0,1-.08.17,12.21,12.21,0,0,0-.49,1.4h0c0-.13-.31-4.24-.48-6.54-.1-1.48.05-3,0-4.73-.05-3.6-.62-5.57-2.15-1.6,1.58-1.62,1.13,5.5,1.1,7.91-.06,4.61.55,7.05.42,10.43-.08,2-.82,2.31-1.61,2.23C251.18,291.87,247.08,288.21,245.27,284.71Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.24,287.22a18.85,18.85,0,0,0,2.13,1.25,7.66,7.66,0,0,0,2.15.66.25.25,0,0,0,.12,0,.18.18,0,0,0,.06-.09c.27-.75-1.81-1.92-2.34-2.26a23.15,23.15,0,0,0-3.06-1.66,9.65,9.65,0,0,0-1.16-.46c-.2-.06-.47-.11-.61.06a.13.13,0,0,0,0,.09c0,.5.75,1,1.1,1.27C249.13,286.47,249.67,286.87,250.24,287.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.05,275c-1.3,4.44,0,11.42,0,11.71a44.9,44.9,0,0,1,.2-8.86c.6-4.1,1.51-7.67,2.15-8.36-.33.08-.75.74-1.31,2.18C254.82,272.49,254.46,273.59,254.05,275Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,282.69c5.76-2.76,5.69-11.26-.36-16.44s-8.21-5.09-9-8.56-1.43-5.73-5.17-7.76-1.76.52-3.52,1-2.21,2.71-.57,4.54,4.71,4.35,5.17,7.77-.46,5.84,1,12.27C235.28,280.18,239.84,285.92,246.58,282.69Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228,255.51c1.5,1.69,4.2,3.94,5,6.93a7.34,7.34,0,0,1,.17.84q.06.44.09.87c.23,3-.4,5.46.9,11.19,0,.07,0,.14.05.21,1.08,4.63,5.63,10.37,12.37,7.14,3.28-1.58,4.67-5,4.14-8.63a1.57,1.57,0,0,1,0-.23c0-.08,0-.16-.05-.24,0-.26-.11-.51-.17-.76a12.18,12.18,0,0,0-1.64-3.64c.06.3.11.59.15.9a7,7,0,0,1-2.41,5.93,4.9,4.9,0,0,1-5.42.71c-4-2-4.14-8.22-4.5-11.93a20.07,20.07,0,0,0-2.11-8,17.39,17.39,0,0,0-2-2.77c-.24-.21-.46-.43-.68-.65a23.4,23.4,0,0,1-1.59-1.74l-.72-.73a1.66,1.66,0,0,1-.31-.4,1.15,1.15,0,0,1-.66.48,2.14,2.14,0,0,0-1.46,1.37,2.62,2.62,0,0,0-.07,1.37.29.29,0,0,1,0,.09A4.07,4.07,0,0,0,228,255.51Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228,255.34c1.53,1.72,4.3,4,5,7.1.05.22.1.44.13.67s.09.7.13,1c.37,2.88.54,5.32.9,11.19,0,.07,0,.14.05.21,1.08,4.63,5.63,10.37,12.37,7.14,3.28-1.58,4.67-5,4.14-8.63a1.57,1.57,0,0,1,0-.23c0-.08,0-.16-.05-.24,0-.26-.11-.51-.17-.76a11,11,0,0,1-.82,3.33,7.28,7.28,0,0,1-10.7,3c-3.8-2.39-4.55-7.54-5-11.61-.4-3.34-.7-6.58-2.2-9.65a12.34,12.34,0,0,0-3-3.89,11,11,0,0,1-1.65-1.7l-.07-.09a2.68,2.68,0,0,0,0,1.46.29.29,0,0,1,0,.09A4.19,4.19,0,0,0,228,255.34Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.05,269.7c.41,1.71-.64,5.67-3.15,4.59-1.12-.48-1.4-1.93-1.71-3a18.08,18.08,0,0,0-1.78-4.28c-.59-1-1.29-1.88-1.88-2.85a11.05,11.05,0,0,1-.89-1.79,2,2,0,0,1-.2-1c.06-.4.39-.35.63-.1a13.57,13.57,0,0,0,2.18,1.9c.83.55,1.69,1,2.53,1.55a8.85,8.85,0,0,1,4,4.12A7.29,7.29,0,0,1,247.05,269.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.24,250.83c1.07-.08,2.78,1.41,3.43,2.22a3.87,3.87,0,0,1,.83,1.88c.12,1-.37.81-1,.1a6.36,6.36,0,0,0-3.09-2.23c-1.27-.52-2-1.89-.21-2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.36,264.33c.21-.17.66.26.85.36a15,15,0,0,1,3.21,2,6.83,6.83,0,0,1,1,1.1c1,1.43,1.93,3.5,0,4.5-.23.11-.53.14-.63-.16-.41-1.22-.18-2.1-.95-3.3a8.6,8.6,0,0,0-2.05-2.33,5.41,5.41,0,0,1-1.11-1,1.49,1.49,0,0,1-.36-.92A.41.41,0,0,1,240.36,264.33Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gola-kabab--inject-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-59",
    cx: 299.35,
    cy: 324.49,
    rx: 29.32,
    ry: 16.93,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plate--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.7,309.27c-10.69-6.17-28-6.17-38.7,0-5.34,3.08-8,7.13-8,11.17v2c0,4,2.66,8.08,8,11.17,10.69,6.17,28,6.17,38.7,0,5.34-3.09,8-7.13,8-11.17v-2C326.71,316.4,324,312.35,318.7,309.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,331.61c-10.68-6.17-10.68-16.17,0-22.34s28-6.17,38.7,0,10.68,16.17,0,22.34S290.69,337.78,280,331.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.35,308.51c6.64,0,12.83,1.46,17.41,4.11,3.93,2.26,6.09,5,6.09,7.82s-2.16,5.56-6.09,7.82c-4.59,2.65-10.77,4.11-17.41,4.11s-12.82-1.46-17.41-4.11c-3.93-2.26-6.09-5-6.09-7.82s2.16-5.56,6.09-7.82c4.59-2.65,10.77-4.11,17.41-4.11m0-1.55c-6.91,0-13.37,1.54-18.19,4.32-4.42,2.55-6.85,5.8-6.85,9.16s2.43,6.61,6.85,9.16c4.82,2.79,11.28,4.32,18.19,4.32s13.37-1.53,18.19-4.32c4.42-2.55,6.85-5.8,6.85-9.16s-2.43-6.61-6.85-9.16c-4.82-2.78-11.28-4.32-18.19-4.32Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lettuce--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--letuce--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.2,318c-.08-.05-.63.4-.68.48a1,1,0,0,0-.1.62c.05.52.4,1,.38,1.53a2.81,2.81,0,0,1-.85,2.14c-.69.62-1.64.71-2.19,1.48s-.8,1.74-1.31,2.54c-1.1,1.71-3.11,0-4.37,1.07a4.14,4.14,0,0,0-.76,1.32,2.74,2.74,0,0,1-1,1.07,4.73,4.73,0,0,1-3.22.93,6.49,6.49,0,0,0-1.74-.22,4.09,4.09,0,0,0-2.15,1.51,4.82,4.82,0,0,1-2.8,1.66c-1.14.09-2.3-.28-3.42,0-.45.13-.85.37-1.29.53a3.89,3.89,0,0,1-2.19.15,7.54,7.54,0,0,0-2.3-.5,9.76,9.76,0,0,0-1.18.31,3.21,3.21,0,0,1-3.92-2.94c0-.42,0-.84,0-1.26,0-1.06-.8-1.87-.66-3a3.37,3.37,0,0,1,1.71-2.43,15.88,15.88,0,0,0,1.45-.82,1.82,1.82,0,0,0,.82-1.33,5.91,5.91,0,0,1,.19-1.82,3,3,0,0,1,1.75-1.66,7.63,7.63,0,0,1,2.43-.45,3.05,3.05,0,0,0,2-.55,7.84,7.84,0,0,0,.5-.64,3.77,3.77,0,0,1,2.93-1.23,16.4,16.4,0,0,1,3.25.45,2.73,2.73,0,0,0,1.65-.05,5.42,5.42,0,0,0,1-.77,4.48,4.48,0,0,1,3.74-.5,6.15,6.15,0,0,0,2.83.37,20.82,20.82,0,0,1,2.07-.78,4.68,4.68,0,0,1,2.49.8,3.64,3.64,0,0,0,2.63.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.2,318c-.08-.05-.63.4-.68.48a1,1,0,0,0-.1.62c.05.52.4,1,.38,1.53a2.81,2.81,0,0,1-.85,2.14c-.69.62-1.64.71-2.19,1.48s-.8,1.74-1.31,2.54c-1.1,1.71-3.11,0-4.37,1.07a4.14,4.14,0,0,0-.76,1.32,2.74,2.74,0,0,1-1,1.07,4.73,4.73,0,0,1-3.22.93,6.49,6.49,0,0,0-1.74-.22,4.09,4.09,0,0,0-2.15,1.51,4.82,4.82,0,0,1-2.8,1.66c-1.14.09-2.3-.28-3.42,0-.45.13-.85.37-1.29.53a3.89,3.89,0,0,1-2.19.15,7.54,7.54,0,0,0-2.3-.5,9.76,9.76,0,0,0-1.18.31,3.21,3.21,0,0,1-3.92-2.94c0-.42,0-.84,0-1.26,0-1.06-.8-1.87-.66-3a3.37,3.37,0,0,1,1.71-2.43,15.88,15.88,0,0,0,1.45-.82,1.82,1.82,0,0,0,.82-1.33,5.91,5.91,0,0,1,.19-1.82,3,3,0,0,1,1.75-1.66,7.63,7.63,0,0,1,2.43-.45,3.05,3.05,0,0,0,2-.55,7.84,7.84,0,0,0,.5-.64,3.77,3.77,0,0,1,2.93-1.23,16.4,16.4,0,0,1,3.25.45,2.73,2.73,0,0,0,1.65-.05,5.42,5.42,0,0,0,1-.77,4.48,4.48,0,0,1,3.74-.5,6.15,6.15,0,0,0,2.83.37,20.82,20.82,0,0,1,2.07-.78,4.68,4.68,0,0,1,2.49.8,3.64,3.64,0,0,0,2.63.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,327.72a7.64,7.64,0,0,1-2.44-.44c.07,0,.26,0,.35,0h.42l.81,0c.53,0,1.06-.06,1.6-.11s1.06-.1,1.6-.17a8.76,8.76,0,0,0,1.45-.23c.32-.09.63-.2,1-.28s.84-.27,1.26-.41a1,1,0,0,0-.34,0,8.68,8.68,0,0,1-1,0l-.95-.09a1.35,1.35,0,0,0-.49,0,3.18,3.18,0,0,1,.62-.07c.27,0,.54-.09.81-.13s.76-.11,1.13-.18a14.18,14.18,0,0,0,1.7-.45l.89-.28.46-.15a2,2,0,0,1,.43-.15.65.65,0,0,0-.2,0l-.91,0a7.12,7.12,0,0,1-1.66-.21c.15-.13.59-.13.78-.17s.47-.15.71-.2c-.21-.07-.47-.08-.7-.13-.61-.14-1.23-.27-1.85-.39l-1-.2a4.1,4.1,0,0,1-.77-.18,1.68,1.68,0,0,1,.55,0h1.06c.66,0,1.31,0,2,0s1.1,0,1.64-.09c.18,0,.94,0,1-.16a9.47,9.47,0,0,0-1.11-.27c-.28-.1-.57-.23-.84-.3.74,0,1.47.15,2.21.14s1.49,0,2.23-.11l1.47-.2a7.12,7.12,0,0,0,1.14-.17,1.58,1.58,0,0,0-.58-.18,9.21,9.21,0,0,1-1.16-.37,11.64,11.64,0,0,1-2-.84c.7.07,1.4.26,2.1.35a14.64,14.64,0,0,0,3.62.12,3.08,3.08,0,0,0,1.83-.54,3.11,3.11,0,0,0-1.1-.14,2.67,2.67,0,0,1-1.29-.27,1.48,1.48,0,0,1,.42,0,5.84,5.84,0,0,0,.73-.05,4.05,4.05,0,0,0,.71-.13,4.19,4.19,0,0,0-.59-.22,1.33,1.33,0,0,1,.45,0l.69-.09a3.27,3.27,0,0,0,.7-.09,2.16,2.16,0,0,0-.47-.15,12.07,12.07,0,0,1-1.36-.46c-.33-.15-.65-.27-1-.39-.11,0-.42-.11-.44-.24a1.47,1.47,0,0,1,.46.11c.29.08.6.15.9.21.53.09,1.07.14,1.6.21a15.37,15.37,0,0,0,1.92.15,15.74,15.74,0,0,0,1.82-.12c.34,0,.67-.13,1-.15.12,0,.35-.05.34.11a2,2,0,0,1-.26.35l-.5.72a34.89,34.89,0,0,0-2,3.13,13.22,13.22,0,0,1,.44-1.52,5.08,5.08,0,0,0,.26-.9c-.27.09-.44.35-.68.47a3.54,3.54,0,0,1,.46-.8,7.59,7.59,0,0,1,.46-.65c-.42,0-.91.45-1.27.64s-.95.54-1.42.82a10.15,10.15,0,0,0-1.19.88,21.18,21.18,0,0,0-1.89,1.9,1.37,1.37,0,0,1-.36.36c.16-.44.34-.87.53-1.3s.28-.56.43-.84.2-.31.3-.47a1.57,1.57,0,0,0,.19-.33,3.61,3.61,0,0,0-.66.44,9.09,9.09,0,0,0-.91.73l-.94.82c-.2.19-.41.37-.59.57a9,9,0,0,1-1.05,1.08c.05-.08.07-.18.11-.26.11-.23.24-.45.36-.67s.28-.51.43-.74.31-.36.34-.6a9.39,9.39,0,0,0-3.18,1.88l-.84.76a6.65,6.65,0,0,1-.66.64,4,4,0,0,1,.4-.93c.11-.19.25-.36.37-.55a.35.35,0,0,0,.1-.21,1.62,1.62,0,0,0-.61.46l-.79.78c-.41.42-.79.85-1.21,1.25s-.77.8-1.18,1.17c-.25.24-.46.55-.73.77a4.91,4.91,0,0,1,.8-1.62,17.5,17.5,0,0,1,1.12-1.59,2.25,2.25,0,0,1-.44.21,3.25,3.25,0,0,1-.45.25c-.33.15-.69.23-1,.39s-.87.5-1.32.74a6,6,0,0,0-1.13.69c-.24.19-.48.38-.71.59-.57.49-1.11,1-1.64,1.53a8.74,8.74,0,0,0-.8.93c-.18.24-.44.48-.59.73.11-.12.14-.39.21-.54.19-.44.38-.9.61-1.32s.56-.86.85-1.27c0-.08.22-.22.22-.32l-.38,0C297.17,327.74,296.52,327.78,295.88,327.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.88,331.5c9.89-6.11,25.71-12.35,30.32-13.53a4.2,4.2,0,0,0-2.35-1.65S302,324.53,292.88,331.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.88,331.5c9.89-6.11,25.71-12.35,30.32-13.53a4.2,4.2,0,0,0-2.35-1.65S302,324.53,292.88,331.5Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,317.74a5,5,0,0,0-1.53-1.2,196.56,196.56,0,0,0-24.37,12.27C307.74,323.2,320,318.38,323,317.74Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.22,327.77a3.09,3.09,0,0,0-.81.72c-.2.21-.38.47-.56.7a6.23,6.23,0,0,0-.74,1.17,15.34,15.34,0,0,0-.76,1.83c-.08.23-.18.48-.29.73a11.84,11.84,0,0,1,.18-1.67,8.84,8.84,0,0,1,.46-1.57c-.63.35-.88,1.32-1.13,1.94s-.51,1.44-.78,2.16c-.12.3-.22.64-.35,1l.22-.07c.44-.16.84-.4,1.29-.53a5.91,5.91,0,0,1,2.14-.07,2.29,2.29,0,0,1-.08-.28,2.54,2.54,0,0,1,0-1,8.24,8.24,0,0,1,.25-1.22,7.35,7.35,0,0,1,.59-1.48,2.78,2.78,0,0,0-.7.75,3.73,3.73,0,0,0-.53.9c.05-.24.06-.41.1-.6a6.52,6.52,0,0,1,.22-.87,10.53,10.53,0,0,1,.38-1.12c.11-.25.26-.47.39-.71S302,327.88,302.22,327.77Zm-7,4.06a7.44,7.44,0,0,1,.74-1.35c-1,.42-1.74,1.83-2.17,2.79a5,5,0,0,1,.05-1.28,9.76,9.76,0,0,0-1.33,2.49,3.75,3.75,0,0,1,.68-.16,4.07,4.07,0,0,1,1.63.31h0A6,6,0,0,1,295.2,331.83Zm13.26-2.63a9.25,9.25,0,0,0-.63.9,21.57,21.57,0,0,1,.6-2.84,12.31,12.31,0,0,1,1-2.67A17.58,17.58,0,0,0,307,328.3a12.47,12.47,0,0,0-.86,1.81c-.12.32-.29.86-.38,1.1a7,7,0,0,1,.05-2.16,6.8,6.8,0,0,0-.89,1.69c-.27.68-.56,1.33-.8,2a6.14,6.14,0,0,1-.36.82,6.92,6.92,0,0,0,1.37-1.14,4.09,4.09,0,0,1,2.15-1.51,4.67,4.67,0,0,1,1.52.19V331a15.57,15.57,0,0,1,.22-1.67,10.13,10.13,0,0,1,.28-1.12A4.85,4.85,0,0,0,308.46,329.2Zm13.48-9.43a5.11,5.11,0,0,0-1.22,2c-.1.3-.39,1.17-.56,1.62a5.78,5.78,0,0,1,0-1.95,9.61,9.61,0,0,0-.58,2c-.14.56-.23,1.13-.34,1.7a5.71,5.71,0,0,1,.49-.87,3.36,3.36,0,0,1,1.35-1A12.87,12.87,0,0,1,321.94,319.77Zm-5.54,6.32a9.89,9.89,0,0,1,.66-2,3.06,3.06,0,0,0-1,1.34,12.89,12.89,0,0,1,.73-3.58,9.79,9.79,0,0,0-2,3.24c-.21.5-.44,1-.61,1.55a1.7,1.7,0,0,1-.13.4c0-.35,0-.75,0-1.07a33.2,33.2,0,0,1-2,4.37l-.07.1a2.68,2.68,0,0,0,.28-.18,2.74,2.74,0,0,0,1-1.07,4.14,4.14,0,0,1,.76-1.32,2.7,2.7,0,0,1,2.18-.31A5.74,5.74,0,0,1,316.4,326.09Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.86,321.45a25.17,25.17,0,0,1-5.87-1.66,12.59,12.59,0,0,1-2.77-1.32,7.52,7.52,0,0,1-1-.77l0,0a7.84,7.84,0,0,1-.5.64,3.05,3.05,0,0,1-2,.55c-.33,0-.65.05-1,.09a9.08,9.08,0,0,1,1.62.31c1.27.36,2.46,1,3.7,1.4a13.27,13.27,0,0,0,3.4.75,11.24,11.24,0,0,1-3.15-1.44C304.54,321.43,307.37,321.56,307.86,321.45Zm-15.13,1.39a5.1,5.1,0,0,1-1.31-.63c0,.21,0,.42,0,.64a1.82,1.82,0,0,1-.82,1.33,15.88,15.88,0,0,1-1.45.82l-.11.07a7.17,7.17,0,0,1,.81,0c2,.08,4.94.73,6.91.34a11,11,0,0,1-4.09-.91,20.25,20.25,0,0,0,3.9.38c1.68,0,3.29-.23,5-.32-1.24-.08-2.48-.13-3.71-.23a26,26,0,0,1-3.1-.53,10.83,10.83,0,0,0,3.28-.45A13.88,13.88,0,0,1,292.73,322.84Zm-4.66,5.86-.52-.13a7,7,0,0,1,.53,1.86c0,.37,0,.74,0,1.11a11.61,11.61,0,0,1,1.17-.42c.77-.23,1.55-.42,2.32-.66a7.09,7.09,0,0,0,2.08-.81,9,9,0,0,1-2.25.4,8,8,0,0,1-2-.22,13.3,13.3,0,0,0,2.46-.36,19.78,19.78,0,0,0,2.27-.82,21.16,21.16,0,0,1-2.66.32A13.63,13.63,0,0,1,288.07,328.7Zm28.79-11.56a12.79,12.79,0,0,1-1.89-.73,8.23,8.23,0,0,1-.92-.54,3,3,0,0,1-.39.13,5.1,5.1,0,0,1-2.49-.29c.9.51,1.68.9,2.64,1.34a13.26,13.26,0,0,0,3,.94,6.23,6.23,0,0,1-2.35-1.33A8.18,8.18,0,0,0,316.86,317.14Zm-3.72,2.12a11.1,11.1,0,0,1-4.37-1.79,7.43,7.43,0,0,1-1.4-1.53l-.28.19a5.42,5.42,0,0,1-1,.77,2,2,0,0,1-1,.14c.83.45,1.64.92,2.48,1.37a10.55,10.55,0,0,0,4.25,1.55,8.64,8.64,0,0,1-3.37-1.78A12.66,12.66,0,0,0,313.14,319.26Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lettuce--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--letuce--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.49,322.75c0-.09.74-.13.83-.1a.92.92,0,0,1,.49.4c.31.41.38,1,.75,1.38a2.8,2.8,0,0,0,2.06,1c.93,0,1.69-.58,2.62-.38s1.76.75,2.68,1c1.95.53,2.28-2.1,4-2.14a4.13,4.13,0,0,1,1.44.47,2.8,2.8,0,0,0,1.49.09,4.7,4.7,0,0,0,3-1.47,6.67,6.67,0,0,1,1.14-1.33,4.11,4.11,0,0,1,2.61-.33,4.83,4.83,0,0,0,3.19-.65c.9-.7,1.51-1.76,2.56-2.27.42-.2.88-.3,1.31-.47a4.05,4.05,0,0,0,1.73-1.36,7.2,7.2,0,0,1,1.37-1.92c.33-.23.72-.36,1.07-.56a3.2,3.2,0,0,0,.94-4.81c-.27-.33-.59-.6-.86-.93-.68-.81-.66-1.92-1.52-2.66a3.42,3.42,0,0,0-2.91-.66,14.63,14.63,0,0,1-1.62.37,1.84,1.84,0,0,1-1.5-.43,5.64,5.64,0,0,0-1.36-1.22,3.05,3.05,0,0,0-2.41-.06,7.37,7.37,0,0,0-2.1,1.3,3,3,0,0,1-1.83.91,5.22,5.22,0,0,1-.79-.14,3.84,3.84,0,0,0-3,1.05,17.1,17.1,0,0,0-2.1,2.53,2.81,2.81,0,0,1-1.25,1.07,5.53,5.53,0,0,1-1.29.11,4.51,4.51,0,0,0-3.1,2.14,6.16,6.16,0,0,1-1.85,2.18,19.63,19.63,0,0,0-2.06.82,4.52,4.52,0,0,0-1.3,2.26,3.68,3.68,0,0,1-1.75,2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.49,322.75c0-.09.74-.13.83-.1a.92.92,0,0,1,.49.4c.31.41.38,1,.75,1.38a2.8,2.8,0,0,0,2.06,1c.93,0,1.69-.58,2.62-.38s1.76.75,2.68,1c1.95.53,2.28-2.1,4-2.14a4.13,4.13,0,0,1,1.44.47,2.8,2.8,0,0,0,1.49.09,4.7,4.7,0,0,0,3-1.47,6.67,6.67,0,0,1,1.14-1.33,4.11,4.11,0,0,1,2.61-.33,4.83,4.83,0,0,0,3.19-.65c.9-.7,1.51-1.76,2.56-2.27.42-.2.88-.3,1.31-.47a4.05,4.05,0,0,0,1.73-1.36,7.2,7.2,0,0,1,1.37-1.92c.33-.23.72-.36,1.07-.56a3.2,3.2,0,0,0,.94-4.81c-.27-.33-.59-.6-.86-.93-.68-.81-.66-1.92-1.52-2.66a3.42,3.42,0,0,0-2.91-.66,14.63,14.63,0,0,1-1.62.37,1.84,1.84,0,0,1-1.5-.43,5.64,5.64,0,0,0-1.36-1.22,3.05,3.05,0,0,0-2.41-.06,7.37,7.37,0,0,0-2.1,1.3,3,3,0,0,1-1.83.91,5.22,5.22,0,0,1-.79-.14,3.84,3.84,0,0,0-3,1.05,17.1,17.1,0,0,0-2.1,2.53,2.81,2.81,0,0,1-1.25,1.07,5.53,5.53,0,0,1-1.29.11,4.51,4.51,0,0,0-3.1,2.14,6.16,6.16,0,0,1-1.85,2.18,19.63,19.63,0,0,0-2.06.82,4.52,4.52,0,0,0-1.3,2.26,3.68,3.68,0,0,1-1.75,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M300.29,311.62a7.91,7.91,0,0,0,1.51-2c0,.08-.2.18-.26.24l-.32.28-.61.52c-.41.34-.83.68-1.25,1s-.86.64-1.3.94a9.17,9.17,0,0,1-1.24.82c-.29.14-.6.26-.89.43s-.81.36-1.21.54a1.09,1.09,0,0,1,.24-.24,7,7,0,0,0,.76-.68l.65-.69c.1-.11.21-.29.35-.36a4.74,4.74,0,0,0-.51.37c-.22.16-.46.3-.69.45s-.63.43-.95.63a13.63,13.63,0,0,1-1.57.8c-.28.14-.56.27-.85.39l-.44.2c-.06,0-.39.12-.41.18a.58.58,0,0,1,.13-.15l.64-.64a6.65,6.65,0,0,0,1.1-1.27c-.2,0-.53.3-.7.4s-.45.2-.66.33c.11-.2.3-.38.43-.57.37-.51.73-1,1.11-1.53l.62-.83a3.54,3.54,0,0,0,.44-.65,1.7,1.7,0,0,0-.42.34c-.27.24-.54.47-.79.72-.47.46-1,.88-1.46,1.31s-.85.71-1.28,1c-.14.11-.69.64-.85.56a8.41,8.41,0,0,1,.65-1c.14-.26.26-.55.42-.79-.54.5-1,1.1-1.55,1.59a21.13,21.13,0,0,1-1.72,1.41l-1.23.84a5.53,5.53,0,0,1-1,.64,1.75,1.75,0,0,1,.31-.52,7.35,7.35,0,0,0,.61-1.05,12.06,12.06,0,0,0,.92-2c-.47.52-.87,1.13-1.33,1.67a14.1,14.1,0,0,1-2.6,2.52,3.09,3.09,0,0,1-1.72.83c.1-.31.51-.61.73-.85s.73-.7.77-1.06c-.12.05-.22.2-.32.28a4,4,0,0,1-.57.45,4.48,4.48,0,0,1-.61.39,3,3,0,0,1,.29-.56c-.13,0-.25.17-.37.26s-.38.27-.57.4a3.37,3.37,0,0,1-.58.41,1.77,1.77,0,0,1,.25-.44,11.75,11.75,0,0,0,.7-1.25c.14-.33.3-.63.47-.95,0-.11.24-.37.16-.48a2.09,2.09,0,0,0-.27.39c-.16.26-.34.52-.52.76-.33.42-.7.82-1,1.23a13.57,13.57,0,0,1-1.33,1.4,15.4,15.4,0,0,1-1.42,1.14c-.28.2-.59.35-.85.57-.09.07-.3.19-.18.31s.34.06.42.08l.86.2a36.7,36.7,0,0,1,3.55,1,13,13,0,0,0-1.34-.83,4.68,4.68,0,0,1-.8-.5,8,8,0,0,1,.82-.1,3.35,3.35,0,0,0-.88-.28,5.19,5.19,0,0,0-.78-.18,3.78,3.78,0,0,1,1.38-.38c.53-.13,1.06-.23,1.6-.34a9,9,0,0,1,1.47-.15,19.82,19.82,0,0,1,2.67.14,1.53,1.53,0,0,0,.52,0c-.41-.23-.84-.42-1.27-.61s-.59-.23-.88-.34-.36-.09-.54-.14a1.46,1.46,0,0,1-.37-.12,3.51,3.51,0,0,1,.8-.12c.38,0,.77-.06,1.15-.07l1.25,0a7.68,7.68,0,0,1,.83,0,9.37,9.37,0,0,0,1.5.09c-.09,0-.17-.09-.26-.12-.24-.1-.48-.17-.72-.25s-.54-.19-.82-.27a1.51,1.51,0,0,1-.65-.21,8.73,8.73,0,0,1,2.23-.63,9.3,9.3,0,0,1,1.39-.11h1.14a5.55,5.55,0,0,0,.91,0,3.34,3.34,0,0,0-.92-.42c-.21-.07-.43-.11-.64-.16a.43.43,0,0,1-.22-.09,1.78,1.78,0,0,1,.76-.07l1.11.05c.58,0,1.16.1,1.74.11s1.11.08,1.66.08c.35,0,.71.09,1.06.07a5.08,5.08,0,0,0-1.68-.66,17.91,17.91,0,0,0-1.9-.42c.1,0,.35-.11.46-.14l.51-.12c.34-.11.66-.29,1-.39s1-.22,1.47-.34a8.07,8.07,0,0,1,1.3-.25l.93,0c.75,0,1.49,0,2.24,0a8,8,0,0,1,1.21.15,6.94,6.94,0,0,1,.93.15,3.23,3.23,0,0,1-.52-.27,13.9,13.9,0,0,0-1.33-.56c-.49-.16-1-.26-1.49-.38-.09,0-.31,0-.37-.09l.25-.27C299.34,312.5,299.85,312.1,300.29,311.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.05,312.41c-11.44,2.11-27.35,8.11-31.56,10.34a4.18,4.18,0,0,1,.64-2.8S293.58,313.4,305.05,312.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.05,312.41c-11.44,2.11-27.35,8.11-31.56,10.34a4.18,4.18,0,0,1,.64-2.8S293.58,313.4,305.05,312.41Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.49,322.44a5.1,5.1,0,0,1,.33-1.92,196.86,196.86,0,0,1,26.3-7.28C288.47,316.24,276.18,320.87,273.49,322.44Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.43,316.1c.26.09.52.16.76.27a10.5,10.5,0,0,1,1,.57,5.43,5.43,0,0,1,.75.5l.48.38a3.77,3.77,0,0,0-1-.32,3,3,0,0,0-1-.09,8.05,8.05,0,0,1,1.42.7,9.36,9.36,0,0,1,1,.74,2.62,2.62,0,0,1,.69.72c.05.08.09.17.13.25a6,6,0,0,1,1.63-1.38c.42-.2.88-.3,1.31-.47l.22-.1c-.32-.15-.62-.33-.91-.48l-2-1.07c-.6-.3-1.44-.85-2.14-.68a9,9,0,0,1,1.4.86,11,11,0,0,1,1.25,1.11l-.71-.34a15.25,15.25,0,0,0-1.78-.85,6.35,6.35,0,0,0-1.34-.37c-.29-.05-.59-.12-.88-.15a3.62,3.62,0,0,0-1.09,0A1.92,1.92,0,0,1,296.43,316.1Zm9.29-.09h0a4.3,4.3,0,0,1,1-1.33,4.47,4.47,0,0,1,.61-.33,10.11,10.11,0,0,0-2.66-1,5.52,5.52,0,0,1,.89.91c-1-.41-2.44-1-3.48-.6a7.44,7.44,0,0,1,1.46.5A6.19,6.19,0,0,1,305.72,316Zm-15.07,5a8.69,8.69,0,0,1,1,.63,13.6,13.6,0,0,1,1.29,1.1l.07.07a5,5,0,0,1,1-1.15,4.11,4.11,0,0,1,2.61-.33,7.14,7.14,0,0,0,1.78-.07,5.82,5.82,0,0,1-.81-.37c-.64-.35-1.3-.64-2-1a6.93,6.93,0,0,0-1.79-.66c.43.36,1.45,1.3,1.49,1.58l-1-.57a12.09,12.09,0,0,0-1.86-.76,17.26,17.26,0,0,0-4.29-1.11,11.84,11.84,0,0,1,2.57,1.27,22.27,22.27,0,0,1,2.35,1.71,10.22,10.22,0,0,0-1.07-.26A4.48,4.48,0,0,0,290.65,321Zm-12,4.23a3.39,3.39,0,0,1,1.64-.2,5.28,5.28,0,0,1,.95.31c-.47-.35-.92-.7-1.4-1a9,9,0,0,0-1.75-1.07,5.76,5.76,0,0,1,1.32,1.42c-.42-.22-1.22-.67-1.5-.83a5.25,5.25,0,0,0-2.22-.63A12.78,12.78,0,0,1,278.6,325.27Zm6.45-.1c.52-.59,1-1.22,1.83-1.24a4.13,4.13,0,0,1,1.44.47,2.8,2.8,0,0,0,1.49.09l.33-.05-.12,0a32.45,32.45,0,0,1-4.42-1.89c.18.26.5.51.72.79a1.48,1.48,0,0,1-.37-.2c-.48-.28-1-.51-1.5-.75a9.94,9.94,0,0,0-3.62-1.08,12.64,12.64,0,0,1,2.94,2.17,3,3,0,0,0-1.64-.32A10.15,10.15,0,0,1,284,324.2,5.41,5.41,0,0,1,285.05,325.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.8,308.93a11,11,0,0,1-1.37,3.19,13.45,13.45,0,0,0,2-2.84c.62-1.16,1.1-2.41,1.8-3.52a8.12,8.12,0,0,1,1-1.32c-.27.19-.53.39-.78.59a3,3,0,0,1-1.83.91,5.22,5.22,0,0,1-.79-.14h0a6.9,6.9,0,0,1-.2,1.22,12.4,12.4,0,0,1-1.16,2.83,24.82,24.82,0,0,1-3.24,5.17C287.63,314.77,289.64,312.78,291.8,308.93Zm4,.86a10.66,10.66,0,0,0,2.74-1.87,22.79,22.79,0,0,1-1.95,2.47c-.84.91-1.72,1.78-2.58,2.67,1.29-1.06,2.66-1.94,3.88-3.1a20.44,20.44,0,0,0,2.64-2.9,11.21,11.21,0,0,1-2.42,3.42c1.71-1,3.47-3.5,4.89-4.89.21-.21.41-.38.6-.54l-.13,0a14.63,14.63,0,0,1-1.62.37,1.84,1.84,0,0,1-1.5-.43c-.15-.15-.29-.31-.44-.47a5,5,0,0,1-.55,1.35A13.83,13.83,0,0,1,295.78,309.79Zm8.63-.22a20.35,20.35,0,0,1-2.19,1.55,20.67,20.67,0,0,0,2.24-.92,12.59,12.59,0,0,0,2.06-1.39,7.77,7.77,0,0,1-1.34,1.51,8.89,8.89,0,0,1-1.93,1.23,7.05,7.05,0,0,0,2.08-.8c.73-.34,1.44-.72,2.16-1.07a10.28,10.28,0,0,1,1.15-.47c-.25-.28-.53-.53-.76-.82a7,7,0,0,1-.85-1.73l-.3.45A13.87,13.87,0,0,1,304.41,309.57Zm-25.3,6.32a6.24,6.24,0,0,1-.85,2.57,13.48,13.48,0,0,0,1.57-2.69c.42-1,.74-1.79,1.06-2.78a5.06,5.06,0,0,1-1.65,1.89,2.59,2.59,0,0,1-.38.17,6.91,6.91,0,0,1-.32,1,13,13,0,0,1-.9,1.82A8.39,8.39,0,0,0,279.11,315.89Zm5.51-2.94a8.7,8.7,0,0,1-1.31,3.58,10.42,10.42,0,0,0,2.11-4c.32-.89.61-1.79.92-2.68a2.07,2.07,0,0,1-.86.6,5.53,5.53,0,0,1-1.29.11,1.91,1.91,0,0,0-.33.06,7.36,7.36,0,0,1,0,2.07,11,11,0,0,1-2,4.25A12.69,12.69,0,0,0,284.62,313Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onions--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.41,325.53a2.93,2.93,0,0,0-1.82-2.37,8.39,8.39,0,0,0-8.08.8,3.21,3.21,0,0,0-1.52,2.69c0,.13,0,.65,0,.78a2.93,2.93,0,0,0,1.82,2.36,8.39,8.39,0,0,0,8.08-.79,3.24,3.24,0,0,0,1.52-2.69C314.45,326.18,314.42,325.66,314.41,325.53Zm-1.89,2a7.22,7.22,0,0,1-3.67,1.32,7,7,0,0,1-3.78-.59,2.58,2.58,0,0,1-1.4-1.43,2.93,2.93,0,0,1,1.22-1.69,7.44,7.44,0,0,1,3.67-1.32,7,7,0,0,1,3.78.59,2.63,2.63,0,0,1,1.41,1.43A2.88,2.88,0,0,1,312.52,327.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.41,325.53a2.93,2.93,0,0,0-1.82-2.37,8.39,8.39,0,0,0-8.08.8,3.21,3.21,0,0,0-1.52,2.69c0,.13,0,.65,0,.78a2.93,2.93,0,0,0,1.82,2.36,8.39,8.39,0,0,0,8.08-.79,3.24,3.24,0,0,0,1.52-2.69C314.45,326.18,314.42,325.66,314.41,325.53Zm-1.89,2a7.22,7.22,0,0,1-3.67,1.32,7,7,0,0,1-3.78-.59,2.58,2.58,0,0,1-1.4-1.43,2.93,2.93,0,0,1,1.22-1.69,7.44,7.44,0,0,1,3.67-1.32,7,7,0,0,1,3.78.59,2.63,2.63,0,0,1,1.41,1.43A2.88,2.88,0,0,1,312.52,327.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M311.59,329l-.21.08.05.78.2-.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.36,329.4l-.2.05,0,.78.21-.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,330.44l.21,0,0-.78-.21,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.83,328.12l.19-.27,0-.78-.2.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.9,329.14l.22.19-.05-.78-.22-.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.8,328.28l-.2.14,0,.77.2-.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.2,330l.21.08-.05-.78-.21-.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,329.7h-.21l0,.78h.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.63,329.59l-.21,0,.05.78.21,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.89,325.09a7.44,7.44,0,0,1,3.67-1.32,7,7,0,0,1,3.78.59,2.63,2.63,0,0,1,1.41,1.43,2.56,2.56,0,0,0,0-.39,2.35,2.35,0,0,0-1.48-1.82,7,7,0,0,0-3.78-.59,7.41,7.41,0,0,0-3.67,1.32,2.59,2.59,0,0,0-1.25,2.09,1.22,1.22,0,0,0,.07.38A2.93,2.93,0,0,1,304.89,325.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.89,325.09a7.44,7.44,0,0,1,3.67-1.32,7,7,0,0,1,3.78.59,2.63,2.63,0,0,1,1.41,1.43,2.56,2.56,0,0,0,0-.39,2.35,2.35,0,0,0-1.48-1.82,7,7,0,0,0-3.78-.59,7.41,7.41,0,0,0-3.67,1.32,2.59,2.59,0,0,0-1.25,2.09,1.22,1.22,0,0,0,.07.38A2.93,2.93,0,0,1,304.89,325.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.59,323.16a8.39,8.39,0,0,0-8.08.8,3.21,3.21,0,0,0-1.52,2.69A2.94,2.94,0,0,0,304.8,329a8.39,8.39,0,0,0,8.08-.79,3.25,3.25,0,0,0,1.53-2.69A2.93,2.93,0,0,0,312.59,323.16Zm-.07,4.32a7.22,7.22,0,0,1-3.67,1.32,7,7,0,0,1-3.78-.59,2.32,2.32,0,0,1-1.47-1.81,2.59,2.59,0,0,1,1.25-2.09,7.41,7.41,0,0,1,3.67-1.32,7,7,0,0,1,3.78.59,2.35,2.35,0,0,1,1.48,1.82A2.57,2.57,0,0,1,312.52,327.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.59,323.16a8.39,8.39,0,0,0-8.08.8,3.21,3.21,0,0,0-1.52,2.69A2.94,2.94,0,0,0,304.8,329a8.39,8.39,0,0,0,8.08-.79,3.25,3.25,0,0,0,1.53-2.69A2.93,2.93,0,0,0,312.59,323.16Zm-.07,4.32a7.22,7.22,0,0,1-3.67,1.32,7,7,0,0,1-3.78-.59,2.32,2.32,0,0,1-1.47-1.81,2.59,2.59,0,0,1,1.25-2.09,7.41,7.41,0,0,1,3.67-1.32,7,7,0,0,1,3.78.59,2.35,2.35,0,0,1,1.48,1.82A2.57,2.57,0,0,1,312.52,327.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,322.64a7.41,7.41,0,0,1,4,.64,2.81,2.81,0,0,1,1.75,2.26,3.11,3.11,0,0,1-1.47,2.58,7.92,7.92,0,0,1-3.92,1.42,7.39,7.39,0,0,1-4-.64,2.83,2.83,0,0,1-1.76-2.26,3.11,3.11,0,0,1,1.48-2.58,7.85,7.85,0,0,1,3.92-1.42m0-.13a8.11,8.11,0,0,0-4,1.45,3.21,3.21,0,0,0-1.52,2.69A2.94,2.94,0,0,0,304.8,329a7.52,7.52,0,0,0,4.1.65,8,8,0,0,0,4-1.44,3.25,3.25,0,0,0,1.53-2.69,2.93,2.93,0,0,0-1.82-2.37,7.7,7.7,0,0,0-4.1-.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.5,322.64a7.41,7.41,0,0,1,4,.64,2.81,2.81,0,0,1,1.75,2.26,3.11,3.11,0,0,1-1.47,2.58,7.92,7.92,0,0,1-3.92,1.42,7.39,7.39,0,0,1-4-.64,2.83,2.83,0,0,1-1.76-2.26,3.11,3.11,0,0,1,1.48-2.58,7.85,7.85,0,0,1,3.92-1.42m0-.13a8.11,8.11,0,0,0-4,1.45,3.21,3.21,0,0,0-1.52,2.69A2.94,2.94,0,0,0,304.8,329a7.52,7.52,0,0,0,4.1.65,8,8,0,0,0,4-1.44,3.25,3.25,0,0,0,1.53-2.69,2.93,2.93,0,0,0-1.82-2.37,7.7,7.7,0,0,0-4.1-.65Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324,324.71a2.47,2.47,0,0,0-1.41-2.38,10.5,10.5,0,0,0-8.64-.64c-1.3.52-2,1.29-2.17,2.1l-.12.69a2.49,2.49,0,0,0,1.41,2.37,10.56,10.56,0,0,0,8.65.65c1.29-.53,2-1.3,2.16-2.11Zm-2.39,1.39a9.21,9.21,0,0,1-4.13.55,8.37,8.37,0,0,1-3.84-1.14,2.33,2.33,0,0,1-1.17-1.49,3,3,0,0,1,1.64-1.28,9.52,9.52,0,0,1,4.13-.55,8.49,8.49,0,0,1,3.84,1.15,2.28,2.28,0,0,1,1.17,1.49A3,3,0,0,1,321.62,326.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324,324.71a2.47,2.47,0,0,0-1.41-2.38,10.5,10.5,0,0,0-8.64-.64c-1.3.52-2,1.29-2.17,2.1l-.12.69a2.49,2.49,0,0,0,1.41,2.37,10.56,10.56,0,0,0,8.65.65c1.29-.53,2-1.3,2.16-2.11Zm-2.39,1.39a9.21,9.21,0,0,1-4.13.55,8.37,8.37,0,0,1-3.84-1.14,2.33,2.33,0,0,1-1.17-1.49,3,3,0,0,1,1.64-1.28,9.52,9.52,0,0,1,4.13-.55,8.49,8.49,0,0,1,3.84,1.15,2.28,2.28,0,0,1,1.17,1.49A3,3,0,0,1,321.62,326.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320.33,327.25l-.24,0L320,328l.23,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,327.42h-.23l-.11.69h.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.26,328.1h.23l.12-.69h-.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,326.88l.26-.21.11-.69a3,3,0,0,1-.26.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.22,326.12a1.89,1.89,0,0,0,.2.2l.11-.68-.19-.21Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.74,326.85l-.24.08-.12.69.25-.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.41,327.05l.21.11.12-.69-.21-.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,327.28l-.22,0-.11.69.22,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,327l-.21-.07-.12.69.21.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.12,322.74a9.52,9.52,0,0,1,4.13-.55,8.49,8.49,0,0,1,3.84,1.15,2.28,2.28,0,0,1,1.17,1.49.9.9,0,0,0,.11-.34c.11-.63-.3-1.28-1.16-1.84a8.37,8.37,0,0,0-3.85-1.14,9.18,9.18,0,0,0-4.12.55c-1,.41-1.65,1-1.76,1.61a1,1,0,0,0,0,.35A3,3,0,0,1,314.12,322.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.12,322.74a9.52,9.52,0,0,1,4.13-.55,8.49,8.49,0,0,1,3.84,1.15,2.28,2.28,0,0,1,1.17,1.49.9.9,0,0,0,.11-.34c.11-.63-.3-1.28-1.16-1.84a8.37,8.37,0,0,0-3.85-1.14,9.18,9.18,0,0,0-4.12.55c-1,.41-1.65,1-1.76,1.61a1,1,0,0,0,0,.35A3,3,0,0,1,314.12,322.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.6,322.33a10.5,10.5,0,0,0-8.64-.64c-1.3.52-2,1.29-2.17,2.1a2.45,2.45,0,0,0,1.41,2.37,10.46,10.46,0,0,0,8.64.65c1.3-.53,2-1.29,2.17-2.1A2.47,2.47,0,0,0,322.6,322.33Zm-1,3.77a9.21,9.21,0,0,1-4.13.55,8.37,8.37,0,0,1-3.84-1.14c-.86-.56-1.27-1.21-1.17-1.84s.73-1.2,1.76-1.61a9.18,9.18,0,0,1,4.12-.55,8.37,8.37,0,0,1,3.85,1.14c.86.56,1.27,1.21,1.16,1.84S322.65,325.69,321.62,326.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.6,322.33a10.5,10.5,0,0,0-8.64-.64c-1.3.52-2,1.29-2.17,2.1a2.45,2.45,0,0,0,1.41,2.37,10.46,10.46,0,0,0,8.64.65c1.3-.53,2-1.29,2.17-2.1A2.47,2.47,0,0,0,322.6,322.33Zm-1,3.77a9.21,9.21,0,0,1-4.13.55,8.37,8.37,0,0,1-3.84-1.14c-.86-.56-1.27-1.21-1.17-1.84s.73-1.2,1.76-1.61a9.18,9.18,0,0,1,4.12-.55,8.37,8.37,0,0,1,3.85,1.14c.86.56,1.27,1.21,1.16,1.84S322.65,325.69,321.62,326.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.42,321.19a8.78,8.78,0,0,1,4.1,1.24,2.37,2.37,0,0,1,1.37,2.27c-.14.8-.88,1.52-2.09,2a10.09,10.09,0,0,1-4.42.59,8.9,8.9,0,0,1-4.1-1.23,2.38,2.38,0,0,1-1.37-2.27c.14-.81.88-1.52,2.09-2a9.94,9.94,0,0,1,4.42-.6m0-.11a10.28,10.28,0,0,0-4.48.61c-1.3.52-2,1.29-2.17,2.1a2.45,2.45,0,0,0,1.41,2.37,9.09,9.09,0,0,0,4.16,1.25,10.13,10.13,0,0,0,4.48-.6c1.3-.53,2-1.29,2.17-2.1a2.47,2.47,0,0,0-1.41-2.38,9.21,9.21,0,0,0-4.16-1.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.42,321.19a8.78,8.78,0,0,1,4.1,1.24,2.37,2.37,0,0,1,1.37,2.27c-.14.8-.88,1.52-2.09,2a10.09,10.09,0,0,1-4.42.59,8.9,8.9,0,0,1-4.1-1.23,2.38,2.38,0,0,1-1.37-2.27c.14-.81.88-1.52,2.09-2a9.94,9.94,0,0,1,4.42-.6m0-.11a10.28,10.28,0,0,0-4.48.61c-1.3.52-2,1.29-2.17,2.1a2.45,2.45,0,0,0,1.41,2.37,9.09,9.09,0,0,0,4.16,1.25,10.13,10.13,0,0,0,4.48-.6c1.3-.53,2-1.29,2.17-2.1a2.47,2.47,0,0,0-1.41-2.38,9.21,9.21,0,0,0-4.16-1.25Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--onion--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.76,327.4a3,3,0,0,0-2-2.2,9.28,9.28,0,0,0-8.37,1,2.94,2.94,0,0,0-1.44,2.63l.09.74a3,3,0,0,0,2,2.21,9.33,9.33,0,0,0,8.38-1,3,3,0,0,0,1.44-2.62Zm-1.86,1.94a8.66,8.66,0,0,1-7.72.93,2.67,2.67,0,0,1-1.54-1.33,2.72,2.72,0,0,1,1.18-1.66,8,8,0,0,1,3.75-1.38,7.83,7.83,0,0,1,4,.45,2.73,2.73,0,0,1,1.55,1.33A2.78,2.78,0,0,1,317.9,329.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.76,327.4a3,3,0,0,0-2-2.2,9.28,9.28,0,0,0-8.37,1,2.94,2.94,0,0,0-1.44,2.63l.09.74a3,3,0,0,0,2,2.21,9.33,9.33,0,0,0,8.38-1,3,3,0,0,0,1.44-2.62Zm-1.86,1.94a8.66,8.66,0,0,1-7.72.93,2.67,2.67,0,0,1-1.54-1.33,2.72,2.72,0,0,1,1.18-1.66,8,8,0,0,1,3.75-1.38,7.83,7.83,0,0,1,4,.45,2.73,2.73,0,0,1,1.55,1.33A2.78,2.78,0,0,1,317.9,329.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317,330.79l-.21.09.09.74.21-.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.76,331.24l-.22.05.09.75.22-.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.36,332.28l.21,0-.09-.75-.21,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,329.91a2.68,2.68,0,0,0,.18-.28l-.09-.74c-.05.09-.12.18-.18.27Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,331.19l.24.18-.09-.75a1.46,1.46,0,0,1-.24-.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.23,330.09l-.2.14.09.74.2-.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.4,331.93l.23.07-.09-.74-.23-.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.2,331.61H313l.09.74h.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.88,331.54l-.22,0,.09.74.22,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.82,327.28a8,8,0,0,1,3.75-1.38,7.83,7.83,0,0,1,4,.45,2.73,2.73,0,0,1,1.55,1.33,1.61,1.61,0,0,0,0-.38c-.08-.68-.66-1.28-1.64-1.69a7.83,7.83,0,0,0-4-.45,8,8,0,0,0-3.75,1.38,2.37,2.37,0,0,0-1.19,2,1.21,1.21,0,0,0,.1.36A2.72,2.72,0,0,1,309.82,327.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.82,327.28a8,8,0,0,1,3.75-1.38,7.83,7.83,0,0,1,4,.45,2.73,2.73,0,0,1,1.55,1.33,1.61,1.61,0,0,0,0-.38c-.08-.68-.66-1.28-1.64-1.69a7.83,7.83,0,0,0-4-.45,8,8,0,0,0-3.75,1.38,2.37,2.37,0,0,0-1.19,2,1.21,1.21,0,0,0,.1.36A2.72,2.72,0,0,1,309.82,327.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.73,325.2a9.28,9.28,0,0,0-8.37,1,2.57,2.57,0,0,0,.58,4.83,9.33,9.33,0,0,0,8.38-1,3,3,0,0,0,1.44-2.63A3,3,0,0,0,317.73,325.2Zm.17,4.14a8.66,8.66,0,0,1-7.72.93c-1-.42-1.56-1-1.64-1.69a2.37,2.37,0,0,1,1.19-2,8,8,0,0,1,3.75-1.38,7.83,7.83,0,0,1,4,.45c1,.41,1.56,1,1.64,1.69A2.37,2.37,0,0,1,317.9,329.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.73,325.2a9.28,9.28,0,0,0-8.37,1,2.57,2.57,0,0,0,.58,4.83,9.33,9.33,0,0,0,8.38-1,3,3,0,0,0,1.44-2.63A3,3,0,0,0,317.73,325.2Zm.17,4.14a8.66,8.66,0,0,1-7.72.93c-1-.42-1.56-1-1.64-1.69a2.37,2.37,0,0,1,1.19-2,8,8,0,0,1,3.75-1.38,7.83,7.83,0,0,1,4,.45c1,.41,1.56,1,1.64,1.69A2.37,2.37,0,0,1,317.9,329.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.44,324.82a8.32,8.32,0,0,1,4.24.49,2.45,2.45,0,0,1,.56,4.62,9.15,9.15,0,0,1-8.25,1,2.46,2.46,0,0,1-.56-4.63,8.55,8.55,0,0,1,4-1.48m0-.12a8.54,8.54,0,0,0-4.06,1.51,2.57,2.57,0,0,0,.58,4.83,9.3,9.3,0,0,0,8.38-1,3,3,0,0,0,1.44-2.63,3,3,0,0,0-2-2.2,8.64,8.64,0,0,0-4.31-.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.44,324.82a8.32,8.32,0,0,1,4.24.49,2.45,2.45,0,0,1,.56,4.62,9.15,9.15,0,0,1-8.25,1,2.46,2.46,0,0,1-.56-4.63,8.55,8.55,0,0,1,4-1.48m0-.12a8.54,8.54,0,0,0-4.06,1.51,2.57,2.57,0,0,0,.58,4.83,9.3,9.3,0,0,0,8.38-1,3,3,0,0,0,1.44-2.63,3,3,0,0,0-2-2.2,8.64,8.64,0,0,0-4.31-.5Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--kabab--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270,321.46l48.36-11.89a.67.67,0,0,1,.16.93l-48,13.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,321.46c-.83.2-.29,2.43.5,2.22S270.74,321.28,270,321.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.39,319.89a3,3,0,0,1,0-2.12c.23-.42.81-.52,1.09-.88.43-.54.48-1.37.9-1.92a3,3,0,0,1,2.07-1,6.72,6.72,0,0,1,2.15.11c.71.12,1.43.06,2.15.11a3.33,3.33,0,0,1,1.63.62c1,.63,1.18,1.69,1.56,2.7a6.33,6.33,0,0,1,.63,1.77,4.4,4.4,0,0,1-.48,2,3.35,3.35,0,0,1-.2.61,6.23,6.23,0,0,1-.67.79c-.3.36-.5.77-.77,1.16a1.54,1.54,0,0,1-.94.67,6.24,6.24,0,0,1-5.23.24c-.71-.13-1.72-.11-2.22-.72a4.06,4.06,0,0,0-.36-.46,2.2,2.2,0,0,1-.41-.45,1.7,1.7,0,0,1-.24-1.31A1.32,1.32,0,0,0,276.39,319.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.39,319.89a3,3,0,0,1,0-2.12c.23-.42.81-.52,1.09-.88.43-.54.48-1.37.9-1.92a3,3,0,0,1,2.07-1,6.72,6.72,0,0,1,2.15.11c.71.12,1.43.06,2.15.11a3.33,3.33,0,0,1,1.63.62c1,.63,1.18,1.69,1.56,2.7a6.33,6.33,0,0,1,.63,1.77,4.4,4.4,0,0,1-.48,2,3.35,3.35,0,0,1-.2.61,6.23,6.23,0,0,1-.67.79c-.3.36-.5.77-.77,1.16a1.54,1.54,0,0,1-.94.67,6.24,6.24,0,0,1-5.23.24c-.71-.13-1.72-.11-2.22-.72a4.06,4.06,0,0,0-.36-.46,2.2,2.2,0,0,1-.41-.45,1.7,1.7,0,0,1-.24-1.31A1.32,1.32,0,0,0,276.39,319.89Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,325.22a10.56,10.56,0,0,0,2.5-.69,1.54,1.54,0,0,0,.94-.67c.27-.39.47-.8.77-1.16a6.23,6.23,0,0,0,.67-.79l.05-.12c-.5.15-1,.21-1.5.4-1,.4-1.55,1.22-2.69,1.14a1.43,1.43,0,0,1-1.11-.52,4.42,4.42,0,0,0-.83-1,3.38,3.38,0,0,0-1.31-.56c-.39-.06-.85,0-1.16-.29a3.11,3.11,0,0,1-.82-2.09c.07-.43.29-.82.34-1.24a6.28,6.28,0,0,0-.14-1.06,2.38,2.38,0,0,1,.7-1.82,2.79,2.79,0,0,1,.74-.68,2.79,2.79,0,0,0-1.78.9c-.42.55-.47,1.38-.9,1.92-.28.36-.86.46-1.09.88a3,3,0,0,0,0,2.12,1.32,1.32,0,0,1,.65,1.94,1.7,1.7,0,0,0,.24,1.31,2,2,0,0,0,.42.45,5.55,5.55,0,0,1,.35.46c.5.61,1.51.59,2.22.72A10.6,10.6,0,0,0,283,325.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,316.81a4.06,4.06,0,0,1,.15-3.08c.35-.55.9-.9,1.22-1.47a2.83,2.83,0,0,1,2.25-1.58,9.43,9.43,0,0,1,1.84,0c.52.08,1,.3,1.54.4a2.88,2.88,0,0,1,1.21.51,13.18,13.18,0,0,1,2,1.62,4.36,4.36,0,0,1,.95,2.5,10.3,10.3,0,0,1,0,1.47,4.71,4.71,0,0,1-.06,1.19,6.3,6.3,0,0,1-.38,1c-.21.38-.44.8-.68,1.16a1.59,1.59,0,0,1-.94.67,6.25,6.25,0,0,1-5.23.24c-.71-.13-1.72-.11-2.22-.72a4.06,4.06,0,0,0-.36-.46,2.2,2.2,0,0,1-.41-.45,1.66,1.66,0,0,1-.24-1.31A1,1,0,0,0,288.94,316.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,316.81a4.06,4.06,0,0,1,.15-3.08c.35-.55.9-.9,1.22-1.47a2.83,2.83,0,0,1,2.25-1.58,9.43,9.43,0,0,1,1.84,0c.52.08,1,.3,1.54.4a2.88,2.88,0,0,1,1.21.51,13.18,13.18,0,0,1,2,1.62,4.36,4.36,0,0,1,.95,2.5,10.3,10.3,0,0,1,0,1.47,4.71,4.71,0,0,1-.06,1.19,6.3,6.3,0,0,1-.38,1c-.21.38-.44.8-.68,1.16a1.59,1.59,0,0,1-.94.67,6.25,6.25,0,0,1-5.23.24c-.71-.13-1.72-.11-2.22-.72a4.06,4.06,0,0,0-.36-.46,2.2,2.2,0,0,1-.41-.45,1.66,1.66,0,0,1-.24-1.31A1,1,0,0,0,288.94,316.81Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.07,318.8a4.52,4.52,0,0,0-.63.08c-.32.08-.46.29-.73.46a2,2,0,0,1-1.75.13,1.88,1.88,0,0,0-.74-.27c-.31,0-.61.05-.92,0-.75,0-1.11-.34-1.1-1.11,0-.54.28-1.14-.06-1.64s-.69-.44-.75-1a1.69,1.69,0,0,0-.2-.82,2.26,2.26,0,0,1-.35-.67c-.24-1.25,1.14-2.23,2.11-2.63a5.14,5.14,0,0,1,2.15-.4c.34,0,.68.14,1,.18l-.18,0c-.52-.1-1-.32-1.54-.4a9.43,9.43,0,0,0-1.84,0,2.83,2.83,0,0,0-2.25,1.58c-.32.57-.87.92-1.22,1.47a4.06,4.06,0,0,0-.15,3.08,1,1,0,0,1,.59,1.66,1.66,1.66,0,0,0,.24,1.31,2.2,2.2,0,0,0,.41.45,4.06,4.06,0,0,1,.36.46c.5.61,1.51.59,2.22.72a6.25,6.25,0,0,0,5.23-.24,1.59,1.59,0,0,0,.94-.67c.24-.36.47-.78.68-1.16a6.3,6.3,0,0,0,.38-1,1.85,1.85,0,0,0,.06-.63,1.33,1.33,0,0,1-.2.22A2.89,2.89,0,0,1,298.07,318.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.9,312c0-.16.05-.32.08-.48a7.29,7.29,0,0,1,.81-2.17,3.28,3.28,0,0,1,2.48-1.61,18.08,18.08,0,0,1,2.94-.29,3.09,3.09,0,0,1,2,.59,16.1,16.1,0,0,1,1.31,1.17,6,6,0,0,1,1.26,1.36,4,4,0,0,1-.19,3.69,9.65,9.65,0,0,1-1,1.42,7.79,7.79,0,0,1-.93,1.23,5.73,5.73,0,0,1-2.64,1,5.44,5.44,0,0,1-4.43-1.29,2.46,2.46,0,0,1-.7-.66c-.09-.18-.46-.62-.33-.84,0-.05.13-.07.18-.11a.6.6,0,0,0,.26-.59,1,1,0,0,0-.48-.66c-.1,0-.24,0-.33,0s-.24-.59-.27-.79A3.94,3.94,0,0,1,300.9,312Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.9,312c0-.16.05-.32.08-.48a7.29,7.29,0,0,1,.81-2.17,3.28,3.28,0,0,1,2.48-1.61,18.08,18.08,0,0,1,2.94-.29,3.09,3.09,0,0,1,2,.59,16.1,16.1,0,0,1,1.31,1.17,6,6,0,0,1,1.26,1.36,4,4,0,0,1-.19,3.69,9.65,9.65,0,0,1-1,1.42,7.79,7.79,0,0,1-.93,1.23,5.73,5.73,0,0,1-2.64,1,5.44,5.44,0,0,1-4.43-1.29,2.46,2.46,0,0,1-.7-.66c-.09-.18-.46-.62-.33-.84,0-.05.13-.07.18-.11a.6.6,0,0,0,.26-.59,1,1,0,0,0-.48-.66c-.1,0-.24,0-.33,0s-.24-.59-.27-.79A3.94,3.94,0,0,1,300.9,312Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.49,315.8a9,9,0,0,0-.95.29,9.55,9.55,0,0,0-1,.51,2,2,0,0,1-1.3.15,5.84,5.84,0,0,0-1.23-.31c-.47,0-.81.26-1.18-.1a2.88,2.88,0,0,1-.6-1,1.63,1.63,0,0,1,0-1.13,1.1,1.1,0,0,0-.12-1.07c-.27-.31-.71-.32-1-.64a9.3,9.3,0,0,1-.59-.9c-.68-1.1.42-2.44,1.35-3a9.61,9.61,0,0,1,1.72-.64,1.66,1.66,0,0,0,.66-.42c-.69.05-1.38.14-2,.25a3.28,3.28,0,0,0-2.48,1.61,7.29,7.29,0,0,0-.81,2.17c0,.16-.06.32-.08.48a3.94,3.94,0,0,0,0,1c0,.2.07.69.27.79s.23,0,.33,0a1,1,0,0,1,.48.66.6.6,0,0,1-.26.59c-.05,0-.15.06-.18.11-.13.22.24.66.33.84a2.46,2.46,0,0,0,.7.66A5.44,5.44,0,0,0,307,318a5.73,5.73,0,0,0,2.64-1A6.68,6.68,0,0,0,310.49,315.8Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--kabab--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.41,327.75l48.06-13a.66.66,0,0,1,.19.92L276,330Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.41,327.75c-.83.22-.24,2.44.55,2.21S276.12,327.56,275.41,327.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.73,326a3,3,0,0,1-.06-2.12c.22-.42.8-.53,1.07-.9.41-.55.45-1.38.86-1.94a3,3,0,0,1,2-1,7.1,7.1,0,0,1,2.16.05,19.13,19.13,0,0,0,2.14.07,3.28,3.28,0,0,1,1.65.58c1,.61,1.21,1.66,1.62,2.66a6.35,6.35,0,0,1,.67,1.76,18.22,18.22,0,0,1-.61,2.59,6.23,6.23,0,0,1-.66.8c-.29.38-.48.78-.74,1.18a1.58,1.58,0,0,1-.92.7,11.11,11.11,0,0,1-2.49.74,10.23,10.23,0,0,1-2.74-.38c-.71-.12-1.72-.07-2.23-.67-.15-.16-.21-.3-.37-.45a2.19,2.19,0,0,1-.42-.44,1.66,1.66,0,0,1-.27-1.31A1.32,1.32,0,0,0,281.73,326Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.73,326a3,3,0,0,1-.06-2.12c.22-.42.8-.53,1.07-.9.41-.55.45-1.38.86-1.94a3,3,0,0,1,2-1,7.1,7.1,0,0,1,2.16.05,19.13,19.13,0,0,0,2.14.07,3.28,3.28,0,0,1,1.65.58c1,.61,1.21,1.66,1.62,2.66a6.35,6.35,0,0,1,.67,1.76,18.22,18.22,0,0,1-.61,2.59,6.23,6.23,0,0,1-.66.8c-.29.38-.48.78-.74,1.18a1.58,1.58,0,0,1-.92.7,11.11,11.11,0,0,1-2.49.74,10.23,10.23,0,0,1-2.74-.38c-.71-.12-1.72-.07-2.23-.67-.15-.16-.21-.3-.37-.45a2.19,2.19,0,0,1-.42-.44,1.66,1.66,0,0,1-.27-1.31A1.32,1.32,0,0,0,281.73,326Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.46,331.2a11.11,11.11,0,0,0,2.49-.74,1.58,1.58,0,0,0,.92-.7c.26-.4.45-.8.74-1.18a6.23,6.23,0,0,0,.66-.8s0-.08,0-.12c-.49.16-1,.23-1.49.43-1,.43-1.52,1.26-2.67,1.21a1.53,1.53,0,0,1-1.12-.49,4,4,0,0,0-.85-1,3.33,3.33,0,0,0-1.32-.54c-.39-.05-.85,0-1.16-.26a3.13,3.13,0,0,1-.88-2.07c.06-.42.28-.82.31-1.25a6.19,6.19,0,0,0-.16-1,2.33,2.33,0,0,1,.66-1.83,2.69,2.69,0,0,1,.72-.71,2.75,2.75,0,0,0-1.75.95c-.41.56-.45,1.39-.86,1.94-.27.37-.85.48-1.07.9a3,3,0,0,0,.06,2.12,1.32,1.32,0,0,1,.7,1.92,1.66,1.66,0,0,0,.27,1.31,2.19,2.19,0,0,0,.42.44c.16.15.22.29.37.45.51.6,1.52.55,2.23.67A10.23,10.23,0,0,0,288.46,331.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.21,322.65a4,4,0,0,1,.08-3.07c.33-.57.87-.92,1.18-1.51a2.84,2.84,0,0,1,2.21-1.63,10.29,10.29,0,0,1,1.84,0c.52.06,1,.28,1.54.36a3,3,0,0,1,1.22.48,12.31,12.31,0,0,1,2,1.58,4.31,4.31,0,0,1,1,2.47,9.15,9.15,0,0,1,0,1.48,4.73,4.73,0,0,1,0,1.19,5.72,5.72,0,0,1-.35,1c-.2.39-.42.81-.65,1.17a1.63,1.63,0,0,1-.93.7,10.81,10.81,0,0,1-2.49.74,10.58,10.58,0,0,1-2.73-.38c-.71-.12-1.72-.07-2.24-.67a5.07,5.07,0,0,0-.36-.45,2.24,2.24,0,0,1-.43-.44,1.7,1.7,0,0,1-.27-1.31A1,1,0,0,0,294.21,322.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.21,322.65a4,4,0,0,1,.08-3.07c.33-.57.87-.92,1.18-1.51a2.84,2.84,0,0,1,2.21-1.63,10.29,10.29,0,0,1,1.84,0c.52.06,1,.28,1.54.36a3,3,0,0,1,1.22.48,12.31,12.31,0,0,1,2,1.58,4.31,4.31,0,0,1,1,2.47,9.15,9.15,0,0,1,0,1.48,4.73,4.73,0,0,1,0,1.19,5.72,5.72,0,0,1-.35,1c-.2.39-.42.81-.65,1.17a1.63,1.63,0,0,1-.93.7,10.81,10.81,0,0,1-2.49.74,10.58,10.58,0,0,1-2.73-.38c-.71-.12-1.72-.07-2.24-.67a5.07,5.07,0,0,0-.36-.45,2.24,2.24,0,0,1-.43-.44,1.7,1.7,0,0,1-.27-1.31A1,1,0,0,0,294.21,322.65Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.38,324.44a3.3,3.3,0,0,0-.63.09c-.32.09-.45.3-.72.48a2,2,0,0,1-1.74.16,2.14,2.14,0,0,0-.75-.25c-.31,0-.61.07-.92.06-.75,0-1.12-.32-1.12-1.09,0-.54.24-1.14-.11-1.64s-.7-.42-.77-1a1.64,1.64,0,0,0-.22-.81,2.29,2.29,0,0,1-.36-.67c-.28-1.24,1.08-2.26,2-2.68a5.22,5.22,0,0,1,2.13-.45c.34,0,.69.13,1,.16l-.19,0c-.52-.08-1-.3-1.54-.36a10.29,10.29,0,0,0-1.84,0,2.84,2.84,0,0,0-2.21,1.63c-.31.59-.85.94-1.18,1.51a4,4,0,0,0-.08,3.07,1,1,0,0,1,.62,1.65,1.7,1.7,0,0,0,.27,1.31,2.24,2.24,0,0,0,.43.44,5.07,5.07,0,0,1,.36.45c.52.6,1.53.55,2.24.67a10.58,10.58,0,0,0,2.73.38,10.81,10.81,0,0,0,2.49-.74,1.63,1.63,0,0,0,.93-.7c.23-.36.45-.78.65-1.17a5.72,5.72,0,0,0,.35-1,1.94,1.94,0,0,0,.06-.64,1.43,1.43,0,0,1-.2.23A2.93,2.93,0,0,1,303.38,324.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.05,317.59c0-.16,0-.32.07-.48a7.17,7.17,0,0,1,.75-2.2,3.32,3.32,0,0,1,2.45-1.66,17.91,17.91,0,0,1,2.93-.36,3.1,3.1,0,0,1,2,.54,16.13,16.13,0,0,1,1.34,1.14,5.85,5.85,0,0,1,1.29,1.34,4,4,0,0,1-.1,3.69,9.43,9.43,0,0,1-1,1.44,7.75,7.75,0,0,1-.9,1.25,5.78,5.78,0,0,1-2.62,1.11,5.51,5.51,0,0,1-4.46-1.19,2.59,2.59,0,0,1-.71-.65c-.09-.17-.47-.6-.35-.82,0-.05.13-.08.18-.12a.58.58,0,0,0,.24-.6.89.89,0,0,0-.49-.64c-.1,0-.24,0-.33,0s-.26-.58-.29-.78A3.5,3.5,0,0,1,306.05,317.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.05,317.59c0-.16,0-.32.07-.48a7.17,7.17,0,0,1,.75-2.2,3.32,3.32,0,0,1,2.45-1.66,17.91,17.91,0,0,1,2.93-.36,3.1,3.1,0,0,1,2,.54,16.13,16.13,0,0,1,1.34,1.14,5.85,5.85,0,0,1,1.29,1.34,4,4,0,0,1-.1,3.69,9.43,9.43,0,0,1-1,1.44,7.75,7.75,0,0,1-.9,1.25,5.78,5.78,0,0,1-2.62,1.11,5.51,5.51,0,0,1-4.46-1.19,2.59,2.59,0,0,1-.71-.65c-.09-.17-.47-.6-.35-.82,0-.05.13-.08.18-.12a.58.58,0,0,0,.24-.6.89.89,0,0,0-.49-.64c-.1,0-.24,0-.33,0s-.26-.58-.29-.78A3.5,3.5,0,0,1,306.05,317.59Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.72,321.14a6.45,6.45,0,0,0-.94.32,7.28,7.28,0,0,0-.94.53,2,2,0,0,1-1.29.17,6.73,6.73,0,0,0-1.24-.28c-.47,0-.8.29-1.18-.07a2.86,2.86,0,0,1-.63-1,1.69,1.69,0,0,1-.05-1.13,1.07,1.07,0,0,0-.14-1.07c-.27-.3-.72-.31-1-.62a8.2,8.2,0,0,1-.61-.89c-.71-1.07.36-2.44,1.27-3a9.23,9.23,0,0,1,1.71-.68,1.67,1.67,0,0,0,.65-.44,18.7,18.7,0,0,0-2,.3,3.32,3.32,0,0,0-2.45,1.66,7.17,7.17,0,0,0-.75,2.2c0,.16-.05.32-.07.48a3.5,3.5,0,0,0,0,1c0,.2.08.69.29.78s.23,0,.33,0a.89.89,0,0,1,.49.64.58.58,0,0,1-.24.6c-.05,0-.15.07-.18.12-.12.22.26.65.35.82a2.59,2.59,0,0,0,.71.65,5.51,5.51,0,0,0,4.46,1.19,5.78,5.78,0,0,0,2.62-1.11A6.64,6.64,0,0,0,315.72,321.14Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dallah--inject-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.51,
    cy: 212.2,
    rx: 19.73,
    ry: 11.39,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.75,180.59c-2.53-1.38-6.52-.33-9.41,5.47l1.23.9-3.22-2.25c3.13-6.29,7.49-6.89,10-5.06C228.75,179.92,229.32,180.3,229.75,180.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.75,180.59c-2.53-1.38-6.52-.33-9.41,5.47l1.23.9-3.22-2.25c3.13-6.29,7.49-6.89,10-5.06C228.75,179.92,229.32,180.3,229.75,180.59Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.88,187c-1,2.43-4.83,6.4-5.55,9.32l.5,2.23L222.34,195c.72-2.92,4.5-6.89,5.55-9.32a4.62,4.62,0,0,0,.09-4.16,2.61,2.61,0,0,1,1.18.46C230.3,182.76,230.93,184.59,229.88,187Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.88,187c-1,2.43-4.83,6.4-5.55,9.32l.5,2.23L222.34,195c.72-2.92,4.5-6.89,5.55-9.32a4.62,4.62,0,0,0,.09-4.16,2.61,2.61,0,0,1,1.18.46C230.3,182.76,230.93,184.59,229.88,187Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.54,188.67c-1.19,2-4.79,6.78-5.71,9.9l-.5-2.23c.72-2.92,4.5-6.89,5.55-9.32s.42-4.26-.72-5.05a2.61,2.61,0,0,0-1.18-.46c-1.88-.26-4.32,1.4-6.41,5.45l-1.23-.9c2.89-5.8,6.88-6.85,9.41-5.47h0a3.87,3.87,0,0,1,.58.38,0,0,0,0,0,0,0C232.82,182.92,231.9,186.41,230.54,188.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.54,188.67c-1.19,2-4.79,6.78-5.71,9.9l-.5-2.23c.72-2.92,4.5-6.89,5.55-9.32s.42-4.26-.72-5.05a2.61,2.61,0,0,0-1.18-.46c-1.88-.26-4.32,1.4-6.41,5.45l-1.23-.9c2.89-5.8,6.88-6.85,9.41-5.47h0a3.87,3.87,0,0,1,.58.38,0,0,0,0,0,0,0C232.82,182.92,231.9,186.41,230.54,188.67Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.83,183.82c-.16.29-.33.58-.48.89l3.22,2.25-1.23-.9c.21-.42.42-.8.64-1.17A18.72,18.72,0,0,0,218.83,183.82Z",
    style: {
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.12
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.94,192.64a9.08,9.08,0,0,0-.67-1.55,18.16,18.16,0,0,0-2.94,5.25l.27,1.2c.19-.06.44-.16.72-.27A35.29,35.29,0,0,1,227.94,192.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221,184.89c-.22.37-.43.75-.64,1.17l1.23.9c.23-.45.47-.86.71-1.25C221.87,185.42,221.43,185.15,221,184.89Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.51,
    cy: 212.2,
    rx: 15.3,
    ry: 8.83,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,177l-.67-25.43a3,3,0,0,0-2.64-2.92,2.84,2.84,0,0,0-3.05,2.69l-1.39,26.25a8,8,0,0,1-4.41,6.83,19.68,19.68,0,0,0-11.05,17.89c.07,8.17,6.34,14.91,14.4,16.29,13.19,2.27,25.06-3.85,25.06-16.48a19.72,19.72,0,0,0-11.61-18A8,8,0,0,1,213,177Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,177l-.67-25.43a3,3,0,0,0-2.64-2.92,2.84,2.84,0,0,0-3.05,2.69l-1.39,26.25a8,8,0,0,1-4.41,6.83,19.68,19.68,0,0,0-11.05,17.89c.07,8.17,6.34,14.91,14.4,16.29,13.19,2.27,25.06-3.85,25.06-16.48a19.72,19.72,0,0,0-11.61-18A8,8,0,0,1,213,177Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.81,148a1.31,1.31,0,0,1-2.61,0,1.31,1.31,0,1,1,2.61,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,147.44c.41-.08,1.07.07,1.48-.38h0a1.31,1.31,0,0,0-2.23.93,1.3,1.3,0,0,0,2.31.81,1.46,1.46,0,0,1-1.28.13C208.51,148.65,208.55,147.53,209,147.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.72,144.85a2.22,2.22,0,0,1-4.43,0c0-1.22,1.93-3.72,2.22-3.72S211.72,143.63,211.72,144.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.65,144.4a1.64,1.64,0,0,1-3.27-.06,6.46,6.46,0,0,1,1.13-3.21c-.29,0-2.22,2.5-2.22,3.72a2.39,2.39,0,0,0,.1.66,2.22,2.22,0,0,0,4.23,0,2.07,2.07,0,0,0,.1-.66A1.9,1.9,0,0,0,211.65,144.4Z",
    style: {
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67,207.35c-.35-3.28-2.71-6.56-4.71-7.62-1.6.41-2.46,2.22-2.79,3.85s-.86,1.93-1.45,2c-1.1.06-2-.74-3-3.07-.61-1.43-.73-4.18-.95-5.61-1.1-7-4-7.71-5.47-7.58s-2.79,1.37-2.54,1.92c.46.95,1.1.32,2.48.79s1.55,1.76,1.3,5.44a25.53,25.53,0,0,0,.31,6.26,14.33,14.33,0,0,0,1.32,4,9.82,9.82,0,0,0,4.78,4.62,6.86,6.86,0,0,0,.83.34l.54.18.61.17h0a11,11,0,0,0,5.47,0C196.44,212.43,198,210.63,197.67,207.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.67,207.35c-.35-3.28-2.71-6.56-4.71-7.62-1.6.41-2.46,2.22-2.79,3.85s-.86,1.93-1.45,2c-1.1.06-2-.74-3-3.07-.61-1.43-.73-4.18-.95-5.61-1.1-7-4-7.71-5.47-7.58s-2.79,1.37-2.54,1.92c.46.95,1.1.32,2.48.79s1.55,1.76,1.3,5.44a25.53,25.53,0,0,0,.31,6.26,14.33,14.33,0,0,0,1.32,4,9.82,9.82,0,0,0,4.78,4.62,6.86,6.86,0,0,0,.83.34l.54.18.61.17h0a11,11,0,0,0,5.47,0C196.44,212.43,198,210.63,197.67,207.35Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74,190.41a2.08,2.08,0,0,0-2.07-.52c-.92.26-1.19,1-1.08,1.1a2.81,2.81,0,0,0,2,.28A1.74,1.74,0,0,0,180.74,190.41Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66,207.35s0-.1,0-.15a9.1,9.1,0,0,0-.16-.91,2.68,2.68,0,0,0-.07-.27c-.08-.33-.19-.65-.3-1,0-.1-.07-.19-.11-.28-.13-.31-.26-.63-.42-.93l-.12-.22c-.13-.25-.27-.5-.42-.73l-.16-.26-.39-.54a7.39,7.39,0,0,1,.16,6.2,4.83,4.83,0,0,1-5,2.77,8.86,8.86,0,0,1-6.48-3.54,14.15,14.15,0,0,1-2.55-8.48c-.1-3.44.37-6.63-2.39-7,1.46.5,1.55,1.76,1.3,5.44a25.53,25.53,0,0,0,.31,6.26,14.33,14.33,0,0,0,1.32,4,9.82,9.82,0,0,0,4.78,4.62,6.86,6.86,0,0,0,.83.34l.54.18.61.17h0a11,11,0,0,0,5.47,0,4.94,4.94,0,0,0,1.87-1.14A5.38,5.38,0,0,0,197.66,207.35Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.66,173.89a.73.73,0,0,0-.73.74c0,.41-.35.85-1,1.2a6.33,6.33,0,0,1-5.63,0c-.61-.35-1-.79-1-1.2a.73.73,0,0,0-1.46,0,2.9,2.9,0,0,0,1.68,2.47,7.7,7.7,0,0,0,7.11,0,2.9,2.9,0,0,0,1.68-2.47A.73.73,0,0,0,213.66,173.89Zm-7.52-7a6.89,6.89,0,0,0,6.33,0,2.6,2.6,0,0,0,1.5-2.2.65.65,0,0,0-.65-.65.66.66,0,0,0-.66.65c0,.37-.3.76-.84,1.07a5.61,5.61,0,0,1-5,0c-.54-.31-.85-.7-.85-1.07a.66.66,0,0,0-1.31,0A2.6,2.6,0,0,0,206.14,166.9Zm.51-9.85a6,6,0,0,0,5.57,0,2.3,2.3,0,0,0,1.32-1.94.58.58,0,0,0-1.15,0c0,.33-.27.67-.75.95a5,5,0,0,1-4.42,0c-.47-.28-.74-.62-.74-.95a.57.57,0,0,0-.58-.57.56.56,0,0,0-.57.57A2.3,2.3,0,0,0,206.65,157.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.66,173.89a.73.73,0,0,0-.73.74c0,.41-.35.85-1,1.2a6.33,6.33,0,0,1-5.63,0c-.61-.35-1-.79-1-1.2a.73.73,0,0,0-1.46,0,2.9,2.9,0,0,0,1.68,2.47,7.7,7.7,0,0,0,7.11,0,2.9,2.9,0,0,0,1.68-2.47A.73.73,0,0,0,213.66,173.89Zm-7.52-7a6.89,6.89,0,0,0,6.33,0,2.6,2.6,0,0,0,1.5-2.2.65.65,0,0,0-.65-.65.66.66,0,0,0-.66.65c0,.37-.3.76-.84,1.07a5.61,5.61,0,0,1-5,0c-.54-.31-.85-.7-.85-1.07a.66.66,0,0,0-1.31,0A2.6,2.6,0,0,0,206.14,166.9Zm.51-9.85a6,6,0,0,0,5.57,0,2.3,2.3,0,0,0,1.32-1.94.58.58,0,0,0-1.15,0c0,.33-.27.67-.75.95a5,5,0,0,1-4.42,0c-.47-.28-.74-.62-.74-.95a.57.57,0,0,0-.58-.57.56.56,0,0,0-.57.57A2.3,2.3,0,0,0,206.65,157.05Z",
    style: {
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.64,206.85c-.74-1.69-.71-3.57-1.41-5.29a17.19,17.19,0,0,0-4.1-5.51c-1.35-1.32-2.82-3.13-2.64-5.1.35-3.77,3.57-4.13,7.59-1.53a11.67,11.67,0,0,1,3.45,4,14.57,14.57,0,0,1,1.65,4.08,17.22,17.22,0,0,1,.53,4.11,9.91,9.91,0,0,1-1.09,4.77C224.76,207.84,222.54,208.88,221.64,206.85Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.27,209.31c-1.19.15-2.54,1.45-2.3,2.62s2.24,1.44,3.11.83a2.22,2.22,0,0,0,.7-2.54A1.33,1.33,0,0,0,221.27,209.31Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rice--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M343.27,331.86c-8.38,4.84-8.38,12.69,0,17.53s22,4.84,30.35,0,8.39-12.69,0-17.53S351.66,327,343.27,331.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18,322.73a25.28,25.28,0,1,0,50.55,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18,322.73a25.28,25.28,0,1,0,50.55,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.4 338.54 346.18 341.46 348.87 340.49 346.18 337.5 343.4 338.54",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.87 340.49 351.76 343.06 354.79 341.63 351.84 339.16 348.87 340.49",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.63 334.31 338.02 336.51 339.2 336.21 337.72 333.93 336.63 334.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.44,333.2c.27.58.55,1.15.86,1.71l.33-.59-.8-1.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.79 341.63 358.45 344.27 362.12 341.63 358.45 339.39 354.79 341.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.2 336.21 341.14 338.93 343.4 338.54 341.01 335.56 339.2 336.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.71 336.21 378.89 336.51 380.28 334.31 379.19 333.93 377.71 336.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.08,332.88l-.8,1.44.33.59c.31-.56.59-1.13.85-1.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.04 340.49 370.73 341.46 373.51 338.54 370.73 337.5 368.04 340.49",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.51 338.54 375.77 338.93 377.71 336.21 375.9 335.56 373.51 338.54",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.12 341.63 365.14 343.06 368.04 340.49 365.06 339.16 362.12 341.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.58,312.41c-9.87,5.7-9.87,14.94,0,20.64s25.87,5.7,35.74,0,9.88-14.94,0-20.64S350.46,306.71,340.58,312.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.06,313.64c-9.06,5-9.07,13.16,0,18.18s23.74,5,32.8,0,9.06-13.16,0-18.18S351.12,308.63,342.06,313.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.06,313.64c-9.06,5-9.07,13.16,0,18.18s23.74,5,32.8,0,9.06-13.16,0-18.18S351.12,308.63,342.06,313.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.06,313.64c-9.06,5-9.07,13.16,0,18.18.7.38,1.43.74,2.19,1.06,0,0,1.06-5.42,2.36-12.46.88-4.75,4.84-9.34,11.62-10.53A34.58,34.58,0,0,0,342.06,313.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.72,325a0,0,0,0,1,0,0h0A0,0,0,0,0,377.72,325Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.32,325.61a1.43,1.43,0,0,0,.34-.92,1.49,1.49,0,0,0-1.49-1.49,1.45,1.45,0,0,0-1.07.46c0-.15,0-.31,0-.46a4.52,4.52,0,0,0-6.75-3.93,2,2,0,0,0,.16-.79,2,2,0,0,0-2-2,2,2,0,0,0-1,.27,5.36,5.36,0,0,0,.05-.7,5.11,5.11,0,0,0-9.66-2.34,1.79,1.79,0,0,0-3.28,0,4,4,0,0,0-7.42,2.11,3.83,3.83,0,0,0,.05.6,1.45,1.45,0,0,0-.93-.34,1.49,1.49,0,0,0-1.49,1.49v0a3.56,3.56,0,0,0-5.31,2.6,2.09,2.09,0,0,0-.79-.14h-.28a.17.17,0,0,0-.1,0,.71.71,0,0,0-.26.06l-.19.07a2.56,2.56,0,0,0-1.39,2,2.44,2.44,0,0,0,0,.28.77.77,0,0,0,0,.15.79.79,0,0,0,0,.2,2.68,2.68,0,0,0,.07.27l.06.13a2.52,2.52,0,0,0,.71,1,1.51,1.51,0,0,0,.28.22,4.43,4.43,0,0,0-2.48,1.94,14.25,14.25,0,0,0,5.81,5.38c9.06,5,23.74,5,32.8,0a13.83,13.83,0,0,0,6-5.74A3,3,0,0,0,380.32,325.61Zm-2.61-.54v0a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.79,335.46c-7,.55-14.36-.66-19.74-3.64a14.23,14.23,0,0,1-5.81-5.37h0a4.43,4.43,0,0,1,2.48-1.94,1.51,1.51,0,0,1-.28-.22,2.52,2.52,0,0,1-.71-1l-.06-.13a2.68,2.68,0,0,1-.07-.27.79.79,0,0,1,0-.2.77.77,0,0,1,0-.15,2.44,2.44,0,0,1,0-.28,2.56,2.56,0,0,1,1.39-2l.19-.07a.71.71,0,0,1,.26-.06.17.17,0,0,1,.1,0h.28a2.09,2.09,0,0,1,.79.14,3.56,3.56,0,0,1,3.53-3.08c-2.2,1.16-2.51,5.38,1.79,6a2.06,2.06,0,0,0,.84,1.71,2.87,2.87,0,0,0,2.13.21s-1.74,2.69.32,4.63a4.17,4.17,0,0,0,4.44.87s.1,2.22,1.51,3a2,2,0,0,0,2.24,0s-.48.8.93,1.16a1.67,1.67,0,0,0,2-1A6.06,6.06,0,0,0,361.79,335.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.85,334.22c-.53.16-1.07.29-1.62.42a3.75,3.75,0,0,0,.62-1.34A2,2,0,0,0,368.85,334.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.14,333.11c-.33.14-.68.27-1,.39a2.54,2.54,0,0,0,.35-.92A3.11,3.11,0,0,0,372.14,333.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.36,333.53a2.47,2.47,0,1,1-2.65-3.83,2.39,2.39,0,0,0-.47,1.44,2.47,2.47,0,0,0,2.47,2.47A2.75,2.75,0,0,0,357.36,333.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.26,333.69a1.61,1.61,0,0,1-2.79,1.25,1.59,1.59,0,0,1-.16-1.94,1.6,1.6,0,0,0,2.68,1A1.64,1.64,0,0,0,360.26,333.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.41,322a2.47,2.47,0,1,1-4.53,1.11,2.53,2.53,0,0,0,1.19,1,2.48,2.48,0,0,0,3.19-1.44A2.88,2.88,0,0,0,350.41,322Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.58,324.33a1.65,1.65,0,0,1,0,1.47,1.61,1.61,0,0,1-2.16.72,1.6,1.6,0,0,1-.86-1.75,1.56,1.56,0,0,0,.7.69,1.61,1.61,0,0,0,2.16-.72A1.53,1.53,0,0,0,346.58,324.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.16,327.94a2.47,2.47,0,1,1-4.48-1.28,2.5,2.5,0,0,0,.56,1.42,2.47,2.47,0,0,0,3.48.33A2.43,2.43,0,0,0,372.16,327.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.84,326.77a1.61,1.61,0,1,1-2.95-.69,1.6,1.6,0,0,0,2.67,1A1.75,1.75,0,0,0,374.84,326.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.87,324.05a1.64,1.64,0,0,1,.87,1.18,1.61,1.61,0,0,1-3.05.94,1.62,1.62,0,0,0,1,.14,1.6,1.6,0,0,0,1.32-1.85A1.48,1.48,0,0,0,367.87,324.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.6,320.3a.4.4,0,0,0-.26,0c-.18.07-.16.18-.17.34a3.49,3.49,0,0,1-.05.73c-.09.24-.21.26-.44.29-.54.09-.44.55-.76.88a2,2,0,0,1-1.64.37c-.37,0-.74,0-1.11,0-.17,0-.61-.08-.67-.28s.06-.27.09-.35a2.7,2.7,0,0,0,.08-.39,1.52,1.52,0,0,1,.22-.81c.17-.2.47-.18.65-.33s.06-.42.19-.63a1.28,1.28,0,0,1,1-.42c.5-.08,1.12.17,1.6,0,.11,0,.28-.23.27-.36s-.19-.16-.33-.16a7,7,0,0,0-.91.09c-.52.08-1.24.14-1.31-.56-.29,0-1.25,0-1.39-.3-.21-.47.65-1,.35-1.67-.12-.26-.91-.62-.68-1s1.15-.13,1.4-.1a6.49,6.49,0,0,1,1.61.45c.35.13.57,0,.93.06.63.08.57.37.76.81.26.63.29.23.82.47s.05.61-.14.86-.24.34-.16.52.51.14.62-.06.14-.55.27-.81.47-.43.84-.5.28-.38.52-.53a3,3,0,0,1,1.91-.11c.37.06,1,.19.9.66a7.61,7.61,0,0,1-.28.89c-.08.35-.06.74-.47.87s-.67-.08-.91.24,0,.47-.14.68-.5.18-.75.31a1.13,1.13,0,0,1-.85.06c-.22-.07-.38-.24-.59-.32s-.28-.08-.34,0,.37.79.43.92.27.63,0,.76-.34-.28-.38-.43C360.26,321.12,360,320.4,359.6,320.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.21,317.73a1.42,1.42,0,0,0-.58,0,5.4,5.4,0,0,0-.58.1,3.07,3.07,0,0,0-1,.45,3.54,3.54,0,0,0-1.16,1.49,3.92,3.92,0,0,0-.63-.88c-.28-.32-.58-.62-.89-.91a10.18,10.18,0,0,0-1.95-1.39s-.07.06,0,.08a14.47,14.47,0,0,1,1.85,1.55,11.15,11.15,0,0,1,.79.89l.36.46.16.22a2.28,2.28,0,0,0-.69,0,3.16,3.16,0,0,0-1,.33,5.18,5.18,0,0,0-1.61,1.37s0,0,0,0a14.27,14.27,0,0,1,1.7-1.07,3.69,3.69,0,0,1,1-.29,2.69,2.69,0,0,1,.49,0,2.85,2.85,0,0,0,.4,0c.17,0,.24-.09.33-.23a5.76,5.76,0,0,1,.71-1,3.07,3.07,0,0,1,.47-.41,3.46,3.46,0,0,1,1-.44,5.1,5.1,0,0,0,1-.3S363.24,317.73,363.21,317.73Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M292,381.52a17.63,17.63,0,0,0,15.43,0c4.26-2.36,4.26-6.19,0-8.56A17.7,17.7,0,0,0,292,373C287.75,375.33,287.75,379.16,292,381.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sharbat--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.41,354.74l.74,18.62h0a2.41,2.41,0,0,0,.23.94,4.43,4.43,0,0,0,2,2,12.16,12.16,0,0,0,10.72,0,4.43,4.43,0,0,0,2-2,2.7,2.7,0,0,0,.22-.82h0a1.93,1.93,0,0,0,0-.24h0l.73-18.46a3.36,3.36,0,0,0,.62-1.78l-.89,23.16v.26a4.12,4.12,0,0,1-2.34,3.07,12.54,12.54,0,0,1-11.38,0,4,4,0,0,1-2.35-3.2v-.08l-.9-23.21A3.35,3.35,0,0,0,291.41,354.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.41,354.74l.74,18.62h0a2.41,2.41,0,0,0,.23.94,4.43,4.43,0,0,0,2,2,12.16,12.16,0,0,0,10.72,0,4.43,4.43,0,0,0,2-2,2.7,2.7,0,0,0,.22-.82h0a1.93,1.93,0,0,0,0-.24h0l.73-18.46a3.36,3.36,0,0,0,.62-1.78l-.89,23.16v.26a4.12,4.12,0,0,1-2.34,3.07,12.54,12.54,0,0,1-11.38,0,4,4,0,0,1-2.35-3.2v-.08l-.9-23.21A3.35,3.35,0,0,0,291.41,354.74Z",
    style: {
      fill: "#fff",
      opacity: 0.8300000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.41,356.5a13.94,13.94,0,0,0,12.64,0,6.07,6.07,0,0,0,2-1.74l-.73,18.46h0v.24h0a2.7,2.7,0,0,1-.22.82,4.43,4.43,0,0,1-2,2,12.16,12.16,0,0,1-10.72,0,4.43,4.43,0,0,1-2-2,2.41,2.41,0,0,1-.23-.94h0l-.74-18.62A6,6,0,0,0,293.41,356.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.41,356.5a13.94,13.94,0,0,0,12.64,0,6.07,6.07,0,0,0,2-1.74l-.73,18.46h0v.24h0a2.7,2.7,0,0,1-.22.82,4.43,4.43,0,0,1-2,2,12.16,12.16,0,0,1-10.72,0,4.43,4.43,0,0,1-2-2,2.41,2.41,0,0,1-.23-.94h0l-.74-18.62A6,6,0,0,0,293.41,356.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.3,373.42a3.73,3.73,0,0,1-2.21,2.85,12.16,12.16,0,0,1-10.72,0,3.77,3.77,0,0,1-2.22-2.85L291.53,358c-.07-1.21.73-2.44,2.4-3.36a13.27,13.27,0,0,1,11.6,0c1.67.92,2.47,2.15,2.4,3.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.09,376.27a12.16,12.16,0,0,1-10.72,0c-3-1.66-3-4.34,0-6a12.23,12.23,0,0,1,10.72,0C308.05,371.93,308.05,374.61,305.09,376.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.3,373.42a3.73,3.73,0,0,1-2.21,2.85,12.16,12.16,0,0,1-10.72,0,3.77,3.77,0,0,1-2.22-2.85L291.53,358c-.07-1.21.73-2.44,2.4-3.36a13.27,13.27,0,0,1,11.6,0c1.67.92,2.47,2.15,2.4,3.36Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.53,361a13.33,13.33,0,0,1-11.6,0c-3.21-1.78-3.21-4.66,0-6.44a13.27,13.27,0,0,1,11.6,0C308.74,356.38,308.74,359.26,305.53,361Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.93,361a13.49,13.49,0,0,0,10.22.61c-4.42.77-8.57-1.29-8.21-3.95a1.22,1.22,0,0,1,0-.17,10.23,10.23,0,0,1-2.56-1,6.89,6.89,0,0,1-1-.71C290.85,357.49,291.37,359.62,293.93,361Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.79,352.94v0a3.35,3.35,0,0,0,.62,1.76,6,6,0,0,0,2,1.76,13.94,13.94,0,0,0,12.64,0,6.07,6.07,0,0,0,2-1.74,3.36,3.36,0,0,0,.62-1.78c.06-1.36-.81-2.74-2.61-3.77a13.94,13.94,0,0,0-12.64,0C291.62,350.24,290.75,351.59,290.79,352.94Zm3-3.37a13.59,13.59,0,0,1,11.84,0c3.27,1.81,3.27,4.75,0,6.57a13.59,13.59,0,0,1-11.84,0C290.54,354.32,290.54,351.38,293.81,349.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.79,352.94v0a3.35,3.35,0,0,0,.62,1.76,6,6,0,0,0,2,1.76,13.94,13.94,0,0,0,12.64,0,6.07,6.07,0,0,0,2-1.74,3.36,3.36,0,0,0,.62-1.78c.06-1.36-.81-2.74-2.61-3.77a13.94,13.94,0,0,0-12.64,0C291.62,350.24,290.75,351.59,290.79,352.94Zm3-3.37a13.59,13.59,0,0,1,11.84,0c3.27,1.81,3.27,4.75,0,6.57a13.59,13.59,0,0,1-11.84,0C290.54,354.32,290.54,351.38,293.81,349.57Z",
    style: {
      fill: "#fff",
      opacity: 0.88
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.81,356.14a13.59,13.59,0,0,0,11.84,0c3.27-1.82,3.27-4.76,0-6.57a13.59,13.59,0,0,0-11.84,0C290.54,351.38,290.54,354.32,293.81,356.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.81,356.14a13.59,13.59,0,0,0,11.84,0c3.27-1.82,3.27-4.76,0-6.57a13.59,13.59,0,0,0-11.84,0C290.54,351.38,290.54,354.32,293.81,356.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.71,355.42a8.16,8.16,0,0,1-1.06.72,13.59,13.59,0,0,1-11.84,0,8.16,8.16,0,0,1-1.06-.72,6.44,6.44,0,0,1,1.18-.82,13.27,13.27,0,0,1,11.6,0A6.44,6.44,0,0,1,306.71,355.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.71,355.42a8.16,8.16,0,0,1-1.06.72,13.59,13.59,0,0,1-11.84,0,8.16,8.16,0,0,1-1.06-.72,6.44,6.44,0,0,1,1.18-.82,13.27,13.27,0,0,1,11.6,0A6.44,6.44,0,0,1,306.71,355.42Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.53,354.6l-.3-.16h0l-.5-.23a12,12,0,0,0-3-.8c-.28,0-.57-.07-.86-.09l-.74,0h-.41c-.26,0-.53,0-.79,0a13,13,0,0,0-2.67.4,9.91,9.91,0,0,0-2.34.91,3.37,3.37,0,0,0-.32.19l-.06,0c-.08.06-.17.11-.24.17l-.05,0-.24.19h0l-.25.21a7.53,7.53,0,0,0,1.06.72,10.19,10.19,0,0,0,2.32.91C297.16,354.78,301.73,353.46,305.53,354.6Z",
    style: {
      opacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.19,374.5l.05,1.49v.1c.1,2.21,3.42,4,7.49,4s7.37-1.77,7.49-4V376l0-1.5c-.4,2.08-3.62,3.7-7.54,3.7S292.6,376.57,292.19,374.5Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.79,376.42a12.25,12.25,0,0,1-10.42-.15,3.77,3.77,0,0,1-2.22-2.85l-.61-15.13h0a3.57,3.57,0,0,0,1.26,2c.28,6,.33,11,2,13S300.72,377.93,304.79,376.42Z",
    style: {
      opacity: 0.1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.34,389.85c-1.61-8.54-2.57-23.93-.69-30.64,1.12-4,6.23-5.84,11.17-4.39,7.74,2.27,24.21,12,24.21,12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34,389.85c-1.61-8.54-2.57-23.93-.69-30.64,1.12-4,6.23-5.84,11.17-4.39,7.74,2.27,24.21,12,24.21,12Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25,373.18,101,378.52l1.27-.11-1.7-4.26c13.78-1.47,36.79-11.89,48.71-5.77,6,3.09,8.52,12,4.9,18.23-2.94,5-12.79,11.68-22.48,15.92-11.08,4.85-18.41,8-27.27,8.46-10.84.54-15.94-2.23-20.82-4.67-5.1-2.55-12.55-4.52-14.09-14.91A53.21,53.21,0,0,1,70.25,373.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25,373.18,101,378.52l1.27-.11-1.7-4.26c13.78-1.47,36.79-11.89,48.71-5.77,6,3.09,8.52,12,4.9,18.23-2.94,5-12.79,11.68-22.48,15.92-11.08,4.85-18.41,8-27.27,8.46-10.84.54-15.94-2.23-20.82-4.67-5.1-2.55-12.55-4.52-14.09-14.91A53.21,53.21,0,0,1,70.25,373.18Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.11,369.47c-6.57.91-7.32,6.08-7.32,6.08l-25.14,3.18-.54-1.88L132,374C134.08,370.67,136.3,368.79,142.11,369.47Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78,321.05c-5.26,3.62-4.31,21.94-1.66,31.36S94.25,323,78,321.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,378.68c3.08-36.06,2.22-40,4.06-48.16S83.1,314.89,90,316.35l2.85.53c0,4.7,9.11,6.4,18,3.79,2.46.68,9.38,2.8,9.38,2.8,6.16,4,7.47,8.24,6.83,24.72s-2.26,28.81-2.76,38.54C110.1,396.5,80.16,389.25,73.43,378.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,378.68c3.08-36.06,2.22-40,4.06-48.16S83.1,314.89,90,316.35l2.85.53c0,4.7,9.11,6.4,18,3.79,2.46.68,9.38,2.8,9.38,2.8,6.16,4,7.47,8.24,6.83,24.72s-2.26,28.81-2.76,38.54C110.1,396.5,80.16,389.25,73.43,378.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.34,291.32s5.16,6.45,5,7.62c-.25,1.53-3.87,1.89-3.87,1.89Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.69 314.86 109.02 331.85 91.19 329.55 93.9 309.12 111.69 314.86",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.59,275.91c4,1.72,10.3,4.92,10.51,18.61,4.79,12.62-.26,18.15-2.44,19.87-2.47,1.94-7.94,2.93-11.65,2.07-4.64-1.09-14.83-5.24-20-12.47-6.06-8.5-4.93-19.56,1-24.66C98.37,272.15,109.19,274.45,112.59,275.91Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.94,298.22a5.18,5.18,0,0,0-2.12-2.32,4.4,4.4,0,0,0-4.64.29c-3.91,2.39-.83,8.07,1.68,9.73,2,1.35,4.31.62,4.9-.48.1,3.64-2.91,7.91-5.63,9-7.09,1.39-10.38-1.27-10.38-1.27-2-4.43-7.12-7.06-10.08-14.39-2.21-5.46-2.67-12.53,2.09-14.32,0,0-.42-8.24,11.92-12.05,10.62-3.28,20.25,1,22.31,9.43,0,0-1.18,1.39-5.87,2.47,0,0,1,7.51-2,9.36,0,0,2.62,5-1.27,6.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,284.12c2.1,2.7,1.78,8.64,1.1,9.62,0,0,3,.55,4.53-1.39,1-2.47.17-6.17.17-6.17s1.8,2.76,1.21,5.48c0,0,3.43-1,5-3a13.71,13.71,0,0,0-4.07-13.59c-4-3.49-10.21-4.7-13.72-3.42C112.07,274.4,114,284.12,114,284.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4,316.76l.47-2.43s5.72,1.27,9-.13C118.81,316,114.77,316.88,111.4,316.76Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.72,361.58c-2.1-7.17-4.69-14.14-8.64-24.39-3.83-10-6.32-12-14.59-13.77-7.73,6.86-1,25.11.94,29.83S127.88,370,131.65,376c2.45,3.92,8,6,12.12,2.55S145.59,368,143.72,361.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.35,271.4c6.31,1.3,1.27,25.5,1.27,25.5A59.63,59.63,0,0,0,107.35,307c0,4.31-.93,10.45,6.33,13.28,5.77,2.25,12.89,5,12.89,5s-2.87-.06-8.49,4-12.58,14.81-25.53,12.64-16.39-16.77-16.17-21.17c.26-5.23,3.25-18.5,3.36-30.76C79.83,280.5,90.24,267.75,107.35,271.4Z",
    style: {
      fill: "#BA68C8"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.35,445.65c-3-7.09-4-34.48-1.56-43.14,1.45-5.17,8.05-7.53,14.41-5.67,10,2.94,31.25,15.43,31.25,15.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.49,414l39,13.4,1.64-.15-2.2-5.49c17.79-1.9,47.49-15.35,62.87-7.45,7.77,4,11,15.51,6.32,23.53-3.79,6.51-16.51,15.07-29,20.55-14.3,6.25-23.76,10.34-35.2,10.92-14,.69-20.57-2.89-26.86-6-6.58-3.3-13.7-7.87-17.58-17.21C153.25,440.65,154,426.61,156.49,414Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.59,415.75c-8.47,1.17-9.44,7.84-9.44,7.84l-32.44,4.11-.71-2.42,29.49-3.63C238.23,417.29,241.1,414.88,248.59,415.75Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.51,341.9c-13.08-4.65-19.75,3.89-25.44,13.72-3.93,6.78-12.23,23.1-14.39,29.62s-2.55,10.7,2.95,13.3S185,416.76,185,416.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.71,392.3c4.68.54,8.33-1.27,10.54-4.73l1,8.64Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.96 341.45 214.53 359.22 194.43 352.83 197.97 334.92 218.96 341.45",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,316.18s5.6,8.1,5,8.92-4.56,1.64-4.56,1.64Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.61,300.9c7.69,1.43,11.35,4.21,12.7,14.41.17,1.32-.31,3.14.11,4.67,3.57,12.94-.59,18.87-2.43,20.84-1.25,1.33-8.31,1.73-11.9.83-4.49-1.13-14.66-4.47-19.55-11.58-5.76-8.37-7.48-19.84-1.64-24.7C204.12,298.54,215.08,300.23,218.61,300.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.71,304.46l-5.24-2.93a3,3,0,1,1,5.24,2.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.69,426c2.05-24.4,6.14-46.76,13.06-64.12,6.48-16.23,17.42-24,29.4-18.28l-.73,2c-1.09,3.36,11.72,8.06,20.17,5.27,3.71,1.77,6.5,2.85,9.22,4.46,9.3,5.52,6.2,22,2.79,30-3.61,8.42-6.77,18.94-7.19,26.36a95.56,95.56,0,0,0,.48,16s-1.88.81-6.25,5.83c-4.21,4.84-13.06,14.3-32.95,10.06C168.5,440.56,155.63,433.53,154.69,426Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.82,351l.77-4a31.27,31.27,0,0,1-12.49-.55c-6.81-1.71-8.56-4.68-8.56-4.68l-1,3.88s.8,3,4.87,4.85A19.85,19.85,0,0,0,216.82,351Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.62,306.51c2.41-1.68,4.2-4.5,3.93-7.42a4.13,4.13,0,0,0-1.27-2.77,4,4,0,0,0-3.17-.71,12,12,0,0,0-3.14,1.15,5.35,5.35,0,0,0,.27-4,3,3,0,0,0-1.07-1.9,2.8,2.8,0,0,0-2.48,0c-1.44.52-2.73,1.37-4.13,2-6.67,2.86-13.84-1.47-20.74.28-5,1.27-9.31,3.87-10,9.46-7.65,3.44-7.61,14.62-1.31,26.29,2.29,4.24,3.69,7.58,7.9,10a23.15,23.15,0,0,0,14.1,1.78c1.94-.89,4.32-4.66,4.74-6.26.24-.93,1.27-.73,1.7.14a9.82,9.82,0,0,1,.85,7.41c4.61,2.28,10.56.34,12.33-1.73s1.36-6.84,1.36-6.84-1,.27-.85-2.16,1.78-3.09,1.07-4.56c-1.57.27-5.53,4.23-7.64,2.13s-3.48-8.2-2.33-11.62c.15-.39.27-.74.35-1a16.92,16.92,0,0,0,1.23-6.85,19.58,19.58,0,0,0,8.29-2.82Zm-14.53,22.17h0s-2.92,3.12-6.77-2c-2.69-3.6-2.44-9.17,2.05-9.94,2.72-.47,4,1.27,5.43,3.19h0C219,327,218.09,328.68,218.09,328.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.09,293.17A10.48,10.48,0,0,0,204,292l0,0-4.37-.91-.57.94c-4.95,1-10,4.74-13.29,10.43-3.08,5.33-3.89,11.14-2.66,15.78l-.57.95,2.67,3.53.05.06.12.16v0a10.64,10.64,0,0,0,3,2.61c6.6,3.8,16.12-.35,21.28-9.29S213.68,297,207.09,293.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.09,293.17A10.48,10.48,0,0,0,204,292l0,0-4.37-.91-.57.94c-4.95,1-10,4.74-13.29,10.43-3.08,5.33-3.89,11.14-2.66,15.78l-.57.95,2.67,3.53.05.06.12.16v0a10.64,10.64,0,0,0,3,2.61c6.6,3.8,16.12-.35,21.28-9.29S213.68,297,207.09,293.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.56,
    cy: 307.29,
    rx: 17.21,
    ry: 13.78,
    transform: "translate(-168.84 322.14) rotate(-60)",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.35,408.21c-1.4-8.64-4.21-19-7.08-33-2.79-13.7-3.87-16.37-12.82-20-17.84,7.28-12.45,29.53-10.93,36.06A233.56,233.56,0,0,0,223.7,420c2.32,5.6,10,12.87,16,9.35S246.75,416.85,245.35,408.21Z",
    style: {
      fill: "#BA68C8"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lanterns--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lantern--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lantern--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lantern--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.18,324.34c0-2.3,1.52-4.6,4.56-6.35,6.08-3.51,15.93-3.51,22,0,3,1.75,4.56,4.05,4.56,6.35v2c0,2.3-1.52,4.6-4.56,6.36-6.08,3.51-15.93,3.51-22,0-3-1.76-4.56-4.06-4.56-6.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.18,324.34v2c0,2.31,1.52,4.61,4.56,6.36,6.08,3.51,15.93,3.51,22,0,3-1.75,4.56-4.05,4.56-6.36v-2c0,2.3-1.52,4.6-4.56,6.36-6.08,3.51-15.93,3.51-22,0C25.7,328.94,24.18,326.64,24.18,324.34Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M50.75,318c3,1.75,4.56,4.05,4.56,6.35s-1.52,4.6-4.56,6.36c-6.08,3.51-15.93,3.51-22,0-3-1.76-4.56-4.06-4.56-6.36s1.52-4.6,4.56-6.35C34.82,314.48,44.67,314.48,50.75,318Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.46,319.92c.07-.1.16-.19.24-.29a14.47,14.47,0,0,1,22.09,0l.25.29a4.81,4.81,0,0,1,1.15,3c0,1.83-1.22,3.67-3.65,5.07-4.85,2.81-12.73,2.81-17.59,0-2.43-1.4-3.65-3.23-3.65-5.07A4.82,4.82,0,0,1,28.46,319.92Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.46,319.92c.07-.1.16-.19.24-.29a14.47,14.47,0,0,1,22.09,0l.25.29a4.81,4.81,0,0,1,1.15,3c0,1.83-1.22,3.67-3.65,5.07-4.85,2.81-12.73,2.81-17.59,0-2.43-1.4-3.65-3.23-3.65-5.07A4.82,4.82,0,0,1,28.46,319.92Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.35,325.83A8.63,8.63,0,0,0,31,328a14.89,14.89,0,0,0,3.89,1.53l4.91-13.93Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.84,329.55a21.12,21.12,0,0,0,9.81,0l-4.9-13.93Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3,323a4.74,4.74,0,0,0,1.05,2.88l11.4-10.21L29,319.33l-.27.3-.24.29A4.82,4.82,0,0,0,27.3,323Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.75,315.62l4.9,13.93a15,15,0,0,0,3.9-1.53,8.46,8.46,0,0,0,2.59-2.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.75,315.62l11.39,10.21a4.74,4.74,0,0,0,1-2.88,4.81,4.81,0,0,0-1.15-3l-.25-.29c-.09-.1-.17-.2-.27-.3Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,319.33h0a14.45,14.45,0,0,1,21.55,0h0l-10.77-3.71Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.52,319.33h0l-10.77-3.71,6,.22A14.55,14.55,0,0,1,50.52,319.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.52,319.33h0l-10.77-3.71,6,.22A14.55,14.55,0,0,1,50.52,319.33Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8,315.84h0l-6-.22v-1.11A14.39,14.39,0,0,1,45.8,315.84Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7,315.84h0l6-.22v-1.11A14.39,14.39,0,0,0,33.7,315.84Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.48,314.74c0-2.11,1.39-4.21,4.18-5.82,5.57-3.22,14.6-3.22,20.17,0,2.79,1.61,4.18,3.71,4.18,5.82v1.81c0,2.1-1.39,4.21-4.18,5.82-5.57,3.22-14.6,3.22-20.17,0-2.79-1.61-4.18-3.72-4.18-5.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.48,314.74v1.81c0,2.11,1.39,4.22,4.18,5.82,5.57,3.22,14.6,3.22,20.17,0,2.79-1.6,4.18-3.71,4.18-5.82v-1.81c0,2.11-1.39,4.21-4.18,5.83-5.57,3.21-14.6,3.21-20.17,0C26.87,319,25.48,316.85,25.48,314.74Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M49.83,308.92c2.79,1.61,4.18,3.71,4.18,5.82s-1.39,4.22-4.18,5.82c-5.57,3.22-14.6,3.22-20.17,0-2.79-1.6-4.18-3.71-4.18-5.82s1.39-4.21,4.18-5.82C35.23,305.7,44.26,305.7,49.83,308.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.76,297.94v18.45a1.12,1.12,0,0,0,1.12,1.12h.23a.94.94,0,0,0,.64,1.41,6.69,6.69,0,0,1,1.66.48c.3.19.18.47.33.47s0-.28.34-.47a6.69,6.69,0,0,1,1.66-.48.94.94,0,0,0,.64-1.41h.23a1.12,1.12,0,0,0,1.12-1.12V297.94a1.12,1.12,0,0,0-1.12-1.11h-.23a.94.94,0,0,0-.64-1.41,6.67,6.67,0,0,1-1.66-.49c-.3-.18-.18-.47-.34-.47s0,.29-.33.47a6.67,6.67,0,0,1-1.66.49.94.94,0,0,0-.64,1.41h-.23A1.12,1.12,0,0,0,35.76,297.94Zm10.31.14v17c0,.72.37,1.08.83.81l.18-.1c-.28.91,0,1.43.48,1.34A3.19,3.19,0,0,1,48.8,317c.22.08.13.47.25.4s0-.35.25-.69a9.28,9.28,0,0,1,1.24-1.28,1.82,1.82,0,0,0,.48-1.9l.18-.1a2.21,2.21,0,0,0,.83-1.77v-17c0-.71-.37-1.08-.83-.81l-.18.11c.28-.92,0-1.43-.48-1.35a3.19,3.19,0,0,1-1.24.15c-.22-.08-.13-.47-.25-.4s0,.35-.25.69a9.28,9.28,0,0,1-1.24,1.28,1.82,1.82,0,0,0-.48,1.9l-.18.1A2.21,2.21,0,0,0,46.07,298.08Zm-18.61-3.44v17a2.21,2.21,0,0,0,.83,1.77l.18.1a1.82,1.82,0,0,0,.48,1.9,9.28,9.28,0,0,1,1.24,1.28c.22.34.13.62.25.69s0-.32.25-.4a3.19,3.19,0,0,1,1.24.15c.47.09.76-.43.48-1.34l.18.1c.46.27.83-.09.83-.81v-17a2.21,2.21,0,0,0-.83-1.77l-.18-.1a1.82,1.82,0,0,0-.48-1.9A9.28,9.28,0,0,1,30.69,293c-.22-.34-.13-.62-.25-.69s0,.32-.25.4a3.19,3.19,0,0,1-1.24-.15c-.47-.08-.76.43-.48,1.35l-.18-.11C27.83,293.56,27.46,293.93,27.46,294.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.76,297.94v18.45a1.12,1.12,0,0,0,1.12,1.12h.23a.94.94,0,0,0,.64,1.41,6.69,6.69,0,0,1,1.66.48c.3.19.18.47.33.47s0-.28.34-.47a6.69,6.69,0,0,1,1.66-.48.94.94,0,0,0,.64-1.41h.23a1.12,1.12,0,0,0,1.12-1.12V297.94a1.12,1.12,0,0,0-1.12-1.11h-.23a.94.94,0,0,0-.64-1.41,6.67,6.67,0,0,1-1.66-.49c-.3-.18-.18-.47-.34-.47s0,.29-.33.47a6.67,6.67,0,0,1-1.66.49.94.94,0,0,0-.64,1.41h-.23A1.12,1.12,0,0,0,35.76,297.94Zm10.31.14v17c0,.72.37,1.08.83.81l.18-.1c-.28.91,0,1.43.48,1.34A3.19,3.19,0,0,1,48.8,317c.22.08.13.47.25.4s0-.35.25-.69a9.28,9.28,0,0,1,1.24-1.28,1.82,1.82,0,0,0,.48-1.9l.18-.1a2.21,2.21,0,0,0,.83-1.77v-17c0-.71-.37-1.08-.83-.81l-.18.11c.28-.92,0-1.43-.48-1.35a3.19,3.19,0,0,1-1.24.15c-.22-.08-.13-.47-.25-.4s0,.35-.25.69a9.28,9.28,0,0,1-1.24,1.28,1.82,1.82,0,0,0-.48,1.9l-.18.1A2.21,2.21,0,0,0,46.07,298.08Zm-18.61-3.44v17a2.21,2.21,0,0,0,.83,1.77l.18.1a1.82,1.82,0,0,0,.48,1.9,9.28,9.28,0,0,1,1.24,1.28c.22.34.13.62.25.69s0-.32.25-.4a3.19,3.19,0,0,1,1.24.15c.47.09.76-.43.48-1.34l.18.1c.46.27.83-.09.83-.81v-17a2.21,2.21,0,0,0-.83-1.77l-.18-.1a1.82,1.82,0,0,0-.48-1.9A9.28,9.28,0,0,1,30.69,293c-.22-.34-.13-.62-.25-.69s0,.32-.25.4a3.19,3.19,0,0,1-1.24-.15c-.47-.08-.76.43-.48,1.35l-.18-.11C27.83,293.56,27.46,293.93,27.46,294.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.35,307.17a11.39,11.39,0,1,0,11.39-11.39A11.39,11.39,0,0,0,28.35,307.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.74,
    cy: 307.17,
    r: 7.7,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.76,307.17a4,4,0,1,0,4-4A4,4,0,0,0,35.76,307.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.43,289.47v31.58H45.06V289.47Zm1.33,8.47a1.12,1.12,0,0,1,1.12-1.11h.23a.94.94,0,0,1,.64-1.41,6.67,6.67,0,0,0,1.66-.49c.3-.18.18-.47.33-.47s0,.29.34.47a6.67,6.67,0,0,0,1.66.49.94.94,0,0,1,.64,1.41h.23a1.12,1.12,0,0,1,1.12,1.11v18.45a1.12,1.12,0,0,1-1.12,1.12h-.23a.94.94,0,0,1-.64,1.41,6.69,6.69,0,0,0-1.66.48c-.3.19-.18.47-.34.47s0-.28-.33-.47a6.69,6.69,0,0,0-1.66-.48.94.94,0,0,1-.64-1.41h-.23a1.12,1.12,0,0,1-1.12-1.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.43,289.47v31.58H45.06V289.47Zm1.33,8.47a1.12,1.12,0,0,1,1.12-1.11h.23a.94.94,0,0,1,.64-1.41,6.67,6.67,0,0,0,1.66-.49c.3-.18.18-.47.33-.47s0,.29.34.47a6.67,6.67,0,0,0,1.66.49.94.94,0,0,1,.64,1.41h.23a1.12,1.12,0,0,1,1.12,1.11v18.45a1.12,1.12,0,0,1-1.12,1.12h-.23a.94.94,0,0,1-.64,1.41,6.69,6.69,0,0,0-1.66.48c-.3.19-.18.47-.34.47s0-.28-.33-.47a6.69,6.69,0,0,0-1.66-.48.94.94,0,0,1-.64-1.41h-.23a1.12,1.12,0,0,1-1.12-1.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.06,289.47v31.58l8-4.6V284.87Zm1,8.61a2.21,2.21,0,0,1,.83-1.77l.18-.1a1.82,1.82,0,0,1,.48-1.9A9.28,9.28,0,0,0,48.8,293c.22-.34.13-.62.25-.69s0,.32.25.4a3.19,3.19,0,0,0,1.24-.15c.47-.08.76.43.48,1.35l.18-.11c.46-.27.83.1.83.81v17a2.21,2.21,0,0,1-.83,1.77l-.18.1a1.82,1.82,0,0,1-.48,1.9,9.28,9.28,0,0,0-1.24,1.28c-.22.34-.13.62-.25.69s0-.32-.25-.4a3.19,3.19,0,0,0-1.24.15c-.47.09-.76-.43-.48-1.34l-.18.1c-.46.27-.83-.09-.83-.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.06,289.47v31.58l8-4.6V284.87Zm1,8.61a2.21,2.21,0,0,1,.83-1.77l.18-.1a1.82,1.82,0,0,1,.48-1.9A9.28,9.28,0,0,0,48.8,293c.22-.34.13-.62.25-.69s0,.32.25.4a3.19,3.19,0,0,0,1.24-.15c.47-.08.76.43.48,1.35l.18-.11c.46-.27.83.1.83.81v17a2.21,2.21,0,0,1-.83,1.77l-.18.1a1.82,1.82,0,0,1-.48,1.9,9.28,9.28,0,0,0-1.24,1.28c-.22.34-.13.62-.25.69s0-.32-.25-.4a3.19,3.19,0,0,0-1.24.15c-.47.09-.76-.43-.48-1.34l-.18.1c-.46.27-.83-.09-.83-.81Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.45,284.87v31.58l8,4.6V289.47Zm1,9.77c0-.71.37-1.08.83-.81l.18.11c-.28-.92,0-1.43.48-1.35a3.19,3.19,0,0,0,1.24.15c.22-.08.13-.47.25-.4s0,.35.25.69a9.28,9.28,0,0,0,1.24,1.28,1.82,1.82,0,0,1,.48,1.9l.18.1a2.21,2.21,0,0,1,.83,1.77v17c0,.72-.37,1.08-.83.81l-.18-.1c.28.91,0,1.43-.48,1.34a3.19,3.19,0,0,0-1.24-.15c-.22.08-.13.47-.25.4s0-.35-.25-.69A9.28,9.28,0,0,0,29,315.42a1.82,1.82,0,0,1-.48-1.9l-.18-.1a2.21,2.21,0,0,1-.83-1.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.48,283.5c0-2.11,1.39-4.21,4.18-5.82,5.57-3.22,14.6-3.22,20.17,0,2.79,1.61,4.18,3.71,4.18,5.82v1.81c0,2.11-1.39,4.21-4.18,5.82-5.57,3.22-14.6,3.22-20.17,0-2.79-1.61-4.18-3.71-4.18-5.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.48,283.5v1.81c0,2.11,1.39,4.22,4.18,5.82,5.57,3.22,14.6,3.22,20.17,0,2.79-1.6,4.18-3.71,4.18-5.82V283.5c0,2.11-1.39,4.22-4.18,5.83-5.57,3.21-14.6,3.21-20.17,0C26.87,287.72,25.48,285.61,25.48,283.5Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M49.83,277.68c2.79,1.61,4.18,3.71,4.18,5.82s-1.39,4.22-4.18,5.83c-5.57,3.21-14.6,3.21-20.17,0-2.79-1.61-4.18-3.72-4.18-5.83s1.39-4.21,4.18-5.82C35.23,274.46,44.26,274.46,49.83,277.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.06 288.13 44.1 278.46 39.74 267.52 35.39 278.46 34.43 288.13 45.06 288.13",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.06 288.13 44.1 278.46 39.74 267.52 35.39 278.46 34.43 288.13 45.06 288.13",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.45 283.52 30.12 275.2 39.74 267.52 35.39 278.46 34.43 288.13 26.45 283.52",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.03 283.52 49.36 275.2 39.74 267.52 44.1 278.46 45.06 288.13 53.03 283.52",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.03 283.52 49.36 275.2 39.74 267.52 44.1 278.46 45.06 288.13 53.03 283.52",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.36 275.2 44.1 278.46 35.39 278.46 30.12 275.2 39.74 267.52 49.36 275.2",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.56 274.37 47.95 271.26 42.56 268.15 36.93 268.15 31.54 271.26 36.93 274.37 42.56 274.37",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.56 274.37 47.95 271.26 42.56 268.15 36.93 268.15 31.54 271.26 36.93 274.37 42.56 274.37",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.82 273.72 48.72 270.32 42.82 266.91 36.67 266.91 30.77 270.32 36.67 273.72 42.82 273.72",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.82 273.72 48.72 270.32 42.82 266.91 36.67 266.91 30.77 270.32 36.67 273.72 42.82 273.72",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.92 267.88 42.56 267.88 46.79 270.32 42.56 272.76 36.92 272.76 32.7 270.32 36.92 267.88",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.56 272.76 42.05 268.29 39.74 263.31 37.44 268.29 36.92 272.76 42.56 272.76",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.56 272.76 42.05 268.29 39.74 263.31 37.44 268.29 36.92 272.76 42.56 272.76",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.7 270.32 34.64 266.56 39.74 263.31 37.44 268.29 36.92 272.76 32.7 270.32",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.79 270.32 44.84 266.56 39.74 263.31 42.05 268.29 42.56 272.76 46.79 270.32",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.79 270.32 44.84 266.56 39.74 263.31 42.05 268.29 42.56 272.76 46.79 270.32",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.54,271.26a1.19,1.19,0,0,0-.77-.94l5.9,3.4a1.11,1.11,0,0,1,.26.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,271.26a1.17,1.17,0,0,1,.77-.94l-5.9,3.4a1.11,1.11,0,0,0-.26.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,271.26a1.17,1.17,0,0,1,.77-.94l-5.9,3.4a1.11,1.11,0,0,0-.26.65Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.84 266.56 42.05 268.29 37.44 268.29 34.64 266.56 32.7 270.32 36.92 272.76 42.56 272.76 46.79 270.32 44.84 266.56",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.64,262.31a2.1,2.1,0,1,0,2.1-2.09A2.1,2.1,0,0,0,37.64,262.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.83,263.46a1.88,1.88,0,0,0,1.37-2.65,2.05,2.05,0,0,1,.64,1.5,2.1,2.1,0,0,1-4.19.13A1.75,1.75,0,0,0,39.83,263.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.16,261.4a.25.25,0,0,1,.32,0,1.09,1.09,0,0,1,.4.52c.12.31.38.91,0,1.16s-.66,0-.82-.31a1.26,1.26,0,0,1-.16-.92A.76.76,0,0,1,38.16,261.4Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3,259.49a1.45,1.45,0,1,0,1.44-1.44A1.44,1.44,0,0,0,38.3,259.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81,260.28a1.3,1.3,0,0,0,.94-1.83,1.45,1.45,0,1,1-2.45,1.13A1.23,1.23,0,0,0,39.81,260.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.65,258.86a.18.18,0,0,1,.22,0,.77.77,0,0,1,.28.36c.08.21.26.63,0,.8s-.46,0-.57-.21a.86.86,0,0,1-.1-.64A.5.5,0,0,1,38.65,258.86Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lantern--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lantern--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lantern--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.69,415.17c0-2.3,1.52-4.6,4.56-6.36,6.08-3.5,15.93-3.5,22,0,3,1.76,4.56,4.06,4.56,6.36v2c0,2.3-1.52,4.6-4.56,6.35-6.08,3.51-15.93,3.51-22,0-3-1.75-4.56-4.05-4.56-6.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.69,415.17v2c0,2.3,1.52,4.6,4.56,6.35,6.08,3.51,15.93,3.51,22,0,3-1.75,4.57-4.05,4.57-6.35v-2c0,2.3-1.53,4.6-4.57,6.36-6.08,3.51-15.93,3.51-22,0C425.21,419.77,423.69,417.47,423.69,415.17Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M450.26,408.81c3,1.76,4.56,4.06,4.56,6.36s-1.52,4.6-4.56,6.35c-6.08,3.51-15.93,3.51-22,0-3-1.75-4.56-4-4.56-6.35s1.52-4.6,4.56-6.36C434.33,405.31,444.18,405.31,450.26,408.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,410.75l.24-.29a14.47,14.47,0,0,1,22.09,0l.25.29a4.78,4.78,0,0,1,1.15,3c0,1.84-1.21,3.68-3.64,5.08-4.86,2.81-12.74,2.81-17.6,0-2.43-1.4-3.64-3.24-3.64-5.08A4.78,4.78,0,0,1,428,410.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,410.75l.24-.29a14.47,14.47,0,0,1,22.09,0l.25.29a4.78,4.78,0,0,1,1.15,3c0,1.84-1.21,3.68-3.64,5.08-4.86,2.81-12.74,2.81-17.6,0-2.43-1.4-3.64-3.24-3.64-5.08A4.78,4.78,0,0,1,428,410.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.86,416.65a8.51,8.51,0,0,0,2.6,2.2,15,15,0,0,0,3.9,1.53l4.9-13.94Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.36,420.38a21.08,21.08,0,0,0,9.8,0l-4.9-13.94Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.81,413.77a4.69,4.69,0,0,0,1.05,2.88l11.4-10.21-10.77,3.72a3.65,3.65,0,0,0-.27.3l-.25.29A4.8,4.8,0,0,0,426.81,413.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.26,406.44l4.9,13.94a15,15,0,0,0,3.9-1.53,8.35,8.35,0,0,0,2.59-2.2Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.26,406.44l11.39,10.21a4.69,4.69,0,0,0,1.05-2.88,4.78,4.78,0,0,0-1.15-3l-.25-.29a3.65,3.65,0,0,0-.27-.3Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.49,410.16h0a14.44,14.44,0,0,1,21.54,0h0l-10.77-3.72Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,410.16h0l-10.77-3.72,6.05.23A14.55,14.55,0,0,1,450,410.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,410.16h0l-10.77-3.72,6.05.23A14.55,14.55,0,0,1,450,410.16Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.31,406.67h0l-6.05-.23v-1.1A14.39,14.39,0,0,1,445.31,406.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.21,406.67h0l6.05-.23v-1.1A14.39,14.39,0,0,0,433.21,406.67Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,405.57c0-2.11,1.39-4.22,4.18-5.82,5.57-3.22,14.6-3.22,20.17,0,2.79,1.6,4.18,3.71,4.18,5.82v1.8c0,2.11-1.39,4.22-4.18,5.83-5.57,3.21-14.6,3.21-20.17,0-2.79-1.61-4.18-3.72-4.18-5.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,405.57v1.81c0,2.1,1.39,4.21,4.18,5.82,5.57,3.21,14.6,3.21,20.17,0,2.79-1.61,4.18-3.72,4.18-5.82v-1.81c0,2.1-1.39,4.21-4.18,5.82-5.57,3.22-14.6,3.22-20.17,0C426.38,409.78,425,407.67,425,405.57Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M449.34,399.75c2.79,1.6,4.18,3.71,4.18,5.82s-1.39,4.21-4.18,5.82c-5.57,3.22-14.6,3.22-20.17,0-2.79-1.61-4.18-3.71-4.18-5.82s1.39-4.22,4.18-5.82C434.74,396.53,443.77,396.53,449.34,399.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.28,388.77v18.45a1.12,1.12,0,0,0,1.11,1.12h.23a.93.93,0,0,0,.65,1.4,7,7,0,0,1,1.65.49c.31.18.18.47.33.47s0-.29.34-.47a7.12,7.12,0,0,1,1.66-.49.93.93,0,0,0,.64-1.4h.23a1.12,1.12,0,0,0,1.12-1.12V388.77a1.11,1.11,0,0,0-1.12-1.11h-.23a.94.94,0,0,0-.64-1.41,7.12,7.12,0,0,1-1.66-.49c-.3-.18-.18-.47-.34-.47s0,.29-.33.47a7,7,0,0,1-1.65.49.94.94,0,0,0-.65,1.41h-.23A1.11,1.11,0,0,0,435.28,388.77Zm10.3.14v17c0,.71.37,1.07.84.8l.17-.1c-.28.92,0,1.43.48,1.35a3,3,0,0,1,1.24-.15c.22.08.13.46.25.4s0-.35.25-.69a8.75,8.75,0,0,1,1.24-1.28,1.84,1.84,0,0,0,.48-1.91l.18-.1a2.19,2.19,0,0,0,.83-1.76v-17c0-.72-.37-1.08-.83-.81l-.18.1c.28-.91,0-1.42-.48-1.35a3,3,0,0,1-1.24.16c-.22-.08-.13-.47-.25-.4s0,.35-.25.69a9.26,9.26,0,0,1-1.24,1.28,1.82,1.82,0,0,0-.48,1.9l-.17.1A2.19,2.19,0,0,0,445.58,388.91ZM427,385.47v17a2.19,2.19,0,0,0,.83,1.76l.18.1a1.86,1.86,0,0,0,.48,1.91,8.26,8.26,0,0,1,1.24,1.28c.23.34.13.62.25.69s0-.32.25-.4a3,3,0,0,1,1.24.15c.47.08.76-.43.48-1.35l.18.1c.46.27.84-.09.84-.8v-17a2.22,2.22,0,0,0-.84-1.77l-.18-.1a1.82,1.82,0,0,0-.48-1.9,9.88,9.88,0,0,1-1.24-1.28c-.22-.34-.13-.62-.25-.69s0,.32-.25.4a3.06,3.06,0,0,1-1.24-.16c-.47-.07-.75.44-.48,1.35l-.18-.1C427.34,384.39,427,384.75,427,385.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.28,388.77v18.45a1.12,1.12,0,0,0,1.11,1.12h.23a.93.93,0,0,0,.65,1.4,7,7,0,0,1,1.65.49c.31.18.18.47.33.47s0-.29.34-.47a7.12,7.12,0,0,1,1.66-.49.93.93,0,0,0,.64-1.4h.23a1.12,1.12,0,0,0,1.12-1.12V388.77a1.11,1.11,0,0,0-1.12-1.11h-.23a.94.94,0,0,0-.64-1.41,7.12,7.12,0,0,1-1.66-.49c-.3-.18-.18-.47-.34-.47s0,.29-.33.47a7,7,0,0,1-1.65.49.94.94,0,0,0-.65,1.41h-.23A1.11,1.11,0,0,0,435.28,388.77Zm10.3.14v17c0,.71.37,1.07.84.8l.17-.1c-.28.92,0,1.43.48,1.35a3,3,0,0,1,1.24-.15c.22.08.13.46.25.4s0-.35.25-.69a8.75,8.75,0,0,1,1.24-1.28,1.84,1.84,0,0,0,.48-1.91l.18-.1a2.19,2.19,0,0,0,.83-1.76v-17c0-.72-.37-1.08-.83-.81l-.18.1c.28-.91,0-1.42-.48-1.35a3,3,0,0,1-1.24.16c-.22-.08-.13-.47-.25-.4s0,.35-.25.69a9.26,9.26,0,0,1-1.24,1.28,1.82,1.82,0,0,0-.48,1.9l-.17.1A2.19,2.19,0,0,0,445.58,388.91ZM427,385.47v17a2.19,2.19,0,0,0,.83,1.76l.18.1a1.86,1.86,0,0,0,.48,1.91,8.26,8.26,0,0,1,1.24,1.28c.23.34.13.62.25.69s0-.32.25-.4a3,3,0,0,1,1.24.15c.47.08.76-.43.48-1.35l.18.1c.46.27.84-.09.84-.8v-17a2.22,2.22,0,0,0-.84-1.77l-.18-.1a1.82,1.82,0,0,0-.48-1.9,9.88,9.88,0,0,1-1.24-1.28c-.22-.34-.13-.62-.25-.69s0,.32-.25.4a3.06,3.06,0,0,1-1.24-.16c-.47-.07-.75.44-.48,1.35l-.18-.1C427.34,384.39,427,384.75,427,385.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.86,398a11.39,11.39,0,1,0,11.39-11.39A11.39,11.39,0,0,0,427.86,398Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.25,
    cy: 397.99,
    r: 7.7,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.28,398a4,4,0,1,0,4-4A4,4,0,0,0,435.28,398Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.94,380.3v31.58h10.63V380.3Zm1.34,8.47a1.11,1.11,0,0,1,1.11-1.11h.23a.94.94,0,0,1,.65-1.41,7,7,0,0,0,1.65-.49c.31-.18.18-.47.33-.47s0,.29.34.47a7.12,7.12,0,0,0,1.66.49.94.94,0,0,1,.64,1.41h.23a1.11,1.11,0,0,1,1.12,1.11v18.45a1.12,1.12,0,0,1-1.12,1.12h-.23a.93.93,0,0,1-.64,1.4,7.12,7.12,0,0,0-1.66.49c-.3.18-.18.47-.34.47s0-.29-.33-.47a7,7,0,0,0-1.65-.49.93.93,0,0,1-.65-1.4h-.23a1.12,1.12,0,0,1-1.11-1.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.94,380.3v31.58h10.63V380.3Zm1.34,8.47a1.11,1.11,0,0,1,1.11-1.11h.23a.94.94,0,0,1,.65-1.41,7,7,0,0,0,1.65-.49c.31-.18.18-.47.33-.47s0,.29.34.47a7.12,7.12,0,0,0,1.66.49.94.94,0,0,1,.64,1.41h.23a1.11,1.11,0,0,1,1.12,1.11v18.45a1.12,1.12,0,0,1-1.12,1.12h-.23a.93.93,0,0,1-.64,1.4,7.12,7.12,0,0,0-1.66.49c-.3.18-.18.47-.34.47s0-.29-.33-.47a7,7,0,0,0-1.65-.49.93.93,0,0,1-.65-1.4h-.23a1.12,1.12,0,0,1-1.11-1.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.57,380.3v31.58l8-4.61V375.69Zm1,8.61a2.19,2.19,0,0,1,.84-1.77l.17-.1a1.82,1.82,0,0,1,.48-1.9,9.26,9.26,0,0,0,1.24-1.28c.22-.34.13-.62.25-.69s0,.32.25.4a3,3,0,0,0,1.24-.16c.47-.07.76.44.48,1.35l.18-.1c.46-.27.83.09.83.81v17a2.19,2.19,0,0,1-.83,1.76l-.18.1a1.84,1.84,0,0,1-.48,1.91,8.75,8.75,0,0,0-1.24,1.28c-.22.34-.13.62-.25.69s0-.32-.25-.4a3,3,0,0,0-1.24.15c-.47.08-.76-.43-.48-1.35l-.17.1c-.47.27-.84-.09-.84-.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.57,380.3v31.58l8-4.61V375.69Zm1,8.61a2.19,2.19,0,0,1,.84-1.77l.17-.1a1.82,1.82,0,0,1,.48-1.9,9.26,9.26,0,0,0,1.24-1.28c.22-.34.13-.62.25-.69s0,.32.25.4a3,3,0,0,0,1.24-.16c.47-.07.76.44.48,1.35l.18-.1c.46-.27.83.09.83.81v17a2.19,2.19,0,0,1-.83,1.76l-.18.1a1.84,1.84,0,0,1-.48,1.91,8.75,8.75,0,0,0-1.24,1.28c-.22.34-.13.62-.25.69s0-.32-.25-.4a3,3,0,0,0-1.24.15c-.47.08-.76-.43-.48-1.35l-.17.1c-.47.27-.84-.09-.84-.8Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,375.69v31.58l8,4.61V380.3Zm1,9.78c0-.72.37-1.08.83-.81l.18.1c-.27-.91,0-1.42.48-1.35a3.06,3.06,0,0,0,1.24.16c.23-.08.13-.47.25-.4s0,.35.25.69a9.88,9.88,0,0,0,1.24,1.28,1.82,1.82,0,0,1,.48,1.9l.18.1a2.22,2.22,0,0,1,.84,1.77v17c0,.71-.38,1.07-.84.8l-.18-.1c.28.92,0,1.43-.48,1.35a3,3,0,0,0-1.24-.15c-.22.08-.13.46-.25.4s0-.35-.25-.69a8.26,8.26,0,0,0-1.24-1.28,1.86,1.86,0,0,1-.48-1.91l-.18-.1a2.19,2.19,0,0,1-.83-1.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,374.33c0-2.11,1.39-4.22,4.18-5.82,5.57-3.22,14.6-3.22,20.17,0,2.79,1.6,4.18,3.71,4.18,5.82v1.81c0,2.1-1.39,4.21-4.18,5.82-5.57,3.22-14.6,3.22-20.17,0-2.79-1.61-4.18-3.72-4.18-5.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,374.33v1.81c0,2.11,1.39,4.21,4.18,5.82,5.57,3.21,14.6,3.21,20.17,0,2.79-1.61,4.18-3.71,4.18-5.82v-1.81c0,2.11-1.39,4.21-4.18,5.83-5.57,3.21-14.6,3.21-20.17,0C426.38,378.54,425,376.44,425,374.33Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M449.34,368.51c2.79,1.6,4.18,3.71,4.18,5.82s-1.39,4.21-4.18,5.82c-5.57,3.22-14.6,3.22-20.17,0-2.79-1.6-4.18-3.71-4.18-5.82s1.39-4.22,4.18-5.82C434.74,365.29,443.77,365.29,449.34,368.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.57 378.95 443.61 369.29 439.25 358.35 434.9 369.29 433.94 378.95 444.57 378.95",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.57 378.95 443.61 369.29 439.25 358.35 434.9 369.29 433.94 378.95 444.57 378.95",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.96 374.35 429.63 366.03 439.25 358.35 434.9 369.29 433.94 378.95 425.96 374.35",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.55 374.35 448.87 366.03 439.25 358.35 443.61 369.29 444.57 378.95 452.55 374.35",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.55 374.35 448.87 366.03 439.25 358.35 443.61 369.29 444.57 378.95 452.55 374.35",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.87 366.03 443.61 369.29 434.9 369.29 429.63 366.03 439.25 358.35 448.87 366.03",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.07 365.2 447.46 362.09 442.07 358.98 436.44 358.98 431.05 362.09 436.44 365.2 442.07 365.2",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.07 365.2 447.46 362.09 442.07 358.98 436.44 358.98 431.05 362.09 436.44 365.2 442.07 365.2",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.33 364.55 448.23 361.14 442.33 357.74 436.18 357.74 430.28 361.14 436.18 364.55 442.33 364.55",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.33 364.55 448.23 361.14 442.33 357.74 436.18 357.74 430.28 361.14 436.18 364.55 442.33 364.55",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.44 358.7 442.07 358.7 446.3 361.14 442.07 363.58 436.44 363.58 432.21 361.14 436.44 358.7",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.07 363.58 441.56 359.12 439.25 354.14 436.95 359.12 436.44 363.58 442.07 363.58",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.07 363.58 441.56 359.12 439.25 354.14 436.95 359.12 436.44 363.58 442.07 363.58",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.21 361.14 434.15 357.39 439.25 354.14 436.95 359.12 436.44 363.58 432.21 361.14",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.3 361.14 444.35 357.39 439.25 354.14 441.56 359.12 442.07 363.58 446.3 361.14",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.3 361.14 444.35 357.39 439.25 354.14 441.56 359.12 442.07 363.58 446.3 361.14",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.05,362.09a1.2,1.2,0,0,0-.77-.95l5.9,3.41a1.11,1.11,0,0,1,.26.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.46,362.09a1.2,1.2,0,0,1,.77-.95l-5.9,3.41a1.11,1.11,0,0,0-.26.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.46,362.09a1.2,1.2,0,0,1,.77-.95l-5.9,3.41a1.11,1.11,0,0,0-.26.65Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.35 357.39 441.56 359.12 436.95 359.12 434.15 357.39 432.21 361.14 436.44 363.58 442.07 363.58 446.3 361.14 444.35 357.39",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.16,353.14a2.1,2.1,0,1,0,2.09-2.1A2.1,2.1,0,0,0,437.16,353.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.35,354.29a1.88,1.88,0,0,0,1.37-2.65,2.1,2.1,0,1,1-3.56,1.63A1.77,1.77,0,0,0,439.35,354.29Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.67,352.23a.27.27,0,0,1,.32,0,1.12,1.12,0,0,1,.4.53c.12.31.38.91,0,1.16s-.66-.05-.82-.31a1.26,1.26,0,0,1-.16-.92A.76.76,0,0,1,437.67,352.23Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.81,350.32a1.45,1.45,0,1,0,1.44-1.45A1.44,1.44,0,0,0,437.81,350.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.32,351.11a1.3,1.3,0,0,0,.94-1.83,1.44,1.44,0,1,1-2.45,1.13A1.23,1.23,0,0,0,439.32,351.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.16,349.69a.18.18,0,0,1,.22,0,.72.72,0,0,1,.28.36c.08.21.26.62,0,.79s-.46,0-.56-.21A.79.79,0,0,1,438,350,.5.5,0,0,1,438.16,349.69Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lantern--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lantern--inject-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lantern--inject-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.88,431.32c0-2.17,1.44-4.34,4.3-6,5.74-3.31,15-3.31,20.77,0,2.86,1.65,4.3,3.82,4.3,6v1.86c0,2.17-1.44,4.34-4.3,6-5.74,3.31-15,3.31-20.77,0-2.86-1.65-4.3-3.82-4.3-6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.88,431.32v1.86c0,2.17,1.43,4.34,4.3,6,5.74,3.31,15,3.31,20.77,0,2.86-1.65,4.3-3.82,4.3-6v-1.86c0,2.17-1.44,4.34-4.3,6-5.74,3.31-15,3.31-20.77,0C396.31,435.66,394.88,433.49,394.88,431.32Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M420,425.33c2.86,1.65,4.3,3.82,4.3,6s-1.44,4.34-4.3,6c-5.74,3.31-15,3.31-20.77,0-2.86-1.66-4.3-3.83-4.3-6s1.44-4.34,4.3-6C404.92,422,414.21,422,420,425.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.92,427.15l.23-.27a13.65,13.65,0,0,1,20.84,0l.23.27A4.56,4.56,0,0,1,421.3,430c0,1.74-1.14,3.47-3.43,4.79-4.59,2.65-12,2.65-16.6,0-2.29-1.32-3.44-3.05-3.44-4.79A4.51,4.51,0,0,1,398.92,427.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.92,427.15l.23-.27a13.65,13.65,0,0,1,20.84,0l.23.27A4.56,4.56,0,0,1,421.3,430c0,1.74-1.14,3.47-3.43,4.79-4.59,2.65-12,2.65-16.6,0-2.29-1.32-3.44-3.05-3.44-4.79A4.51,4.51,0,0,1,398.92,427.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.82,432.72a7.91,7.91,0,0,0,2.45,2.07,13.83,13.83,0,0,0,3.67,1.44l4.63-13.14Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.94,436.23a19.81,19.81,0,0,0,9.25,0l-4.62-13.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.83,430a4.44,4.44,0,0,0,1,2.71l10.75-9.63-10.16,3.5a3.4,3.4,0,0,0-.26.29l-.23.27A4.52,4.52,0,0,0,397.83,430Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.57,423.09l4.62,13.14a13.77,13.77,0,0,0,3.68-1.44,8.15,8.15,0,0,0,2.45-2.07Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.57,423.09l10.75,9.63a4.49,4.49,0,0,0,1-2.71,4.56,4.56,0,0,0-1.08-2.86c-.08-.09-.15-.18-.24-.27l-.25-.29Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.41,426.59h0a13.64,13.64,0,0,1,20.32,0h0l-10.16-3.5Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.73,426.59h0l-10.16-3.5,5.7.21A13.72,13.72,0,0,1,419.73,426.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.73,426.59h0l-10.16-3.5,5.7.21A13.72,13.72,0,0,1,419.73,426.59Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.27,423.3h0l-5.7-.21v-1A13.54,13.54,0,0,1,415.27,423.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.86,423.3h0l5.71-.21v-1A13.62,13.62,0,0,0,403.86,423.3Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.11,422.27c0-2,1.31-4,3.94-5.5,5.26-3,13.77-3,19,0,2.63,1.52,3.94,3.51,3.94,5.49V424c0,2-1.31,4-3.94,5.49-5.26,3-13.77,3-19,0-2.63-1.52-3.94-3.5-3.94-5.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.11,422.26V424c0,2,1.31,4,3.94,5.49,5.25,3,13.77,3,19,0C421.71,428,423,426,423,424v-1.71c0,2-1.31,4-3.94,5.5-5.26,3-13.78,3-19,0C397.42,426.24,396.11,424.25,396.11,422.26Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M419.08,416.77c2.63,1.52,3.94,3.51,3.94,5.49s-1.31,4-3.94,5.5c-5.26,3-13.77,3-19,0-2.63-1.52-3.94-3.51-3.94-5.49s1.31-4,3.94-5.5C405.31,413.74,413.82,413.74,419.08,416.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.81,406.42v17.4a1.06,1.06,0,0,0,1.05,1.06h.22a.88.88,0,0,0,.61,1.32,6.8,6.8,0,0,1,1.55.46c.3.17.18.45.32.45s0-.28.32-.45a7.06,7.06,0,0,1,1.56-.46.88.88,0,0,0,.61-1.32h.22a1.06,1.06,0,0,0,1.05-1.06v-17.4a1,1,0,0,0-1.05-1.05h-.22a.88.88,0,0,0-.61-1.33,6.56,6.56,0,0,1-1.56-.46c-.29-.17-.17-.44-.32-.44s0,.27-.32.44a6.33,6.33,0,0,1-1.55.46.88.88,0,0,0-.61,1.33h-.22A1,1,0,0,0,405.81,406.42Zm9.72.13V422.6c0,.67.35,1,.79.76l.16-.1c-.26.86,0,1.35.46,1.27s.86-.25,1.16-.14.13.44.24.37,0-.32.24-.65a7.74,7.74,0,0,1,1.17-1.2,1.74,1.74,0,0,0,.45-1.8l.17-.09a2.1,2.1,0,0,0,.79-1.67V403.3c0-.67-.36-1-.79-.76l-.17.1c.26-.86,0-1.34-.45-1.27s-.87.25-1.17.14-.13-.44-.24-.37,0,.32-.24.65a8.66,8.66,0,0,1-1.16,1.2,1.75,1.75,0,0,0-.46,1.8l-.16.09A2.07,2.07,0,0,0,415.53,406.55ZM398,403.3v16.05a2.1,2.1,0,0,0,.79,1.67l.17.09a1.74,1.74,0,0,0,.45,1.8,7.74,7.74,0,0,1,1.17,1.2c.21.33.13.59.24.65s0-.3.24-.37.73.07,1.16.14.72-.41.46-1.27l.16.1c.44.25.79-.09.79-.76V406.55a2.07,2.07,0,0,0-.79-1.67l-.16-.09a1.75,1.75,0,0,0-.46-1.8,8.66,8.66,0,0,1-1.16-1.2c-.22-.33-.13-.59-.24-.65s0,.3-.24.37-.73-.07-1.17-.14-.71.41-.45,1.27l-.17-.1C398.33,402.29,398,402.63,398,403.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.81,406.42v17.4a1.06,1.06,0,0,0,1.05,1.06h.22a.88.88,0,0,0,.61,1.32,6.8,6.8,0,0,1,1.55.46c.3.17.18.45.32.45s0-.28.32-.45a7.06,7.06,0,0,1,1.56-.46.88.88,0,0,0,.61-1.32h.22a1.06,1.06,0,0,0,1.05-1.06v-17.4a1,1,0,0,0-1.05-1.05h-.22a.88.88,0,0,0-.61-1.33,6.56,6.56,0,0,1-1.56-.46c-.29-.17-.17-.44-.32-.44s0,.27-.32.44a6.33,6.33,0,0,1-1.55.46.88.88,0,0,0-.61,1.33h-.22A1,1,0,0,0,405.81,406.42Zm9.72.13V422.6c0,.67.35,1,.79.76l.16-.1c-.26.86,0,1.35.46,1.27s.86-.25,1.16-.14.13.44.24.37,0-.32.24-.65a7.74,7.74,0,0,1,1.17-1.2,1.74,1.74,0,0,0,.45-1.8l.17-.09a2.1,2.1,0,0,0,.79-1.67V403.3c0-.67-.36-1-.79-.76l-.17.1c.26-.86,0-1.34-.45-1.27s-.87.25-1.17.14-.13-.44-.24-.37,0,.32-.24.65a8.66,8.66,0,0,1-1.16,1.2,1.75,1.75,0,0,0-.46,1.8l-.16.09A2.07,2.07,0,0,0,415.53,406.55ZM398,403.3v16.05a2.1,2.1,0,0,0,.79,1.67l.17.09a1.74,1.74,0,0,0,.45,1.8,7.74,7.74,0,0,1,1.17,1.2c.21.33.13.59.24.65s0-.3.24-.37.73.07,1.16.14.72-.41.46-1.27l.16.1c.44.25.79-.09.79-.76V406.55a2.07,2.07,0,0,0-.79-1.67l-.16-.09a1.75,1.75,0,0,0-.46-1.8,8.66,8.66,0,0,1-1.16-1.2c-.22-.33-.13-.59-.24-.65s0,.3-.24.37-.73-.07-1.17-.14-.71.41-.45,1.27l-.17-.1C398.33,402.29,398,402.63,398,403.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.56,
    cy: 415.12,
    r: 10.74,
    transform: "translate(-84.42 105.2) rotate(-13.28)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.56,
    cy: 415.12,
    r: 7.26,
    transform: "translate(-84.42 105.2) rotate(-13.28)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.81,415.12a3.76,3.76,0,1,0,3.75-3.75A3.75,3.75,0,0,0,405.81,415.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.55,398.43v29.79h10V398.43Zm1.26,8a1,1,0,0,1,1.05-1.05h.22a.88.88,0,0,1,.61-1.33,6.33,6.33,0,0,0,1.55-.46c.3-.17.18-.44.32-.44s0,.27.32.44a6.56,6.56,0,0,0,1.56.46.88.88,0,0,1,.61,1.33h.22a1,1,0,0,1,1.05,1.05v17.4a1.06,1.06,0,0,1-1.05,1.06h-.22a.88.88,0,0,1-.61,1.32,7.06,7.06,0,0,0-1.56.46c-.29.17-.17.45-.32.45s0-.28-.32-.45a6.8,6.8,0,0,0-1.55-.46.88.88,0,0,1-.61-1.32h-.22a1.06,1.06,0,0,1-1.05-1.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.55,398.43v29.79h10V398.43Zm1.26,8a1,1,0,0,1,1.05-1.05h.22a.88.88,0,0,1,.61-1.33,6.33,6.33,0,0,0,1.55-.46c.3-.17.18-.44.32-.44s0,.27.32.44a6.56,6.56,0,0,0,1.56.46.88.88,0,0,1,.61,1.33h.22a1,1,0,0,1,1.05,1.05v17.4a1.06,1.06,0,0,1-1.05,1.06h-.22a.88.88,0,0,1-.61,1.32,7.06,7.06,0,0,0-1.56.46c-.29.17-.17.45-.32.45s0-.28-.32-.45a6.8,6.8,0,0,0-1.55-.46.88.88,0,0,1-.61-1.32h-.22a1.06,1.06,0,0,1-1.05-1.06Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.58,398.43v29.79l7.52-4.35V394.09Zm.95,8.12a2.07,2.07,0,0,1,.79-1.67l.16-.09a1.75,1.75,0,0,1,.46-1.8,8.66,8.66,0,0,0,1.16-1.2c.22-.33.13-.59.24-.65s0,.3.24.37.73-.07,1.17-.14.71.41.45,1.27l.17-.1c.43-.25.79.09.79.76v16.05a2.1,2.1,0,0,1-.79,1.67l-.17.09a1.74,1.74,0,0,1-.45,1.8,7.74,7.74,0,0,0-1.17,1.2c-.21.33-.13.59-.24.65s0-.3-.24-.37-.73.07-1.16.14-.72-.41-.46-1.27l-.16.1c-.44.25-.79-.09-.79-.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.58,398.43v29.79l7.52-4.35V394.09Zm.95,8.12a2.07,2.07,0,0,1,.79-1.67l.16-.09a1.75,1.75,0,0,1,.46-1.8,8.66,8.66,0,0,0,1.16-1.2c.22-.33.13-.59.24-.65s0,.3.24.37.73-.07,1.17-.14.71.41.45,1.27l.17-.1c.43-.25.79.09.79.76v16.05a2.1,2.1,0,0,1-.79,1.67l-.17.09a1.74,1.74,0,0,1-.45,1.8,7.74,7.74,0,0,0-1.17,1.2c-.21.33-.13.59-.24.65s0-.3-.24-.37-.73.07-1.16.14-.72-.41-.46-1.27l-.16.1c-.44.25-.79-.09-.79-.76Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,394.09v29.78l7.53,4.35V398.43Zm1,9.21c0-.67.36-1,.79-.76l.17.1c-.26-.86,0-1.34.45-1.27s.87.25,1.17.14.13-.44.24-.37,0,.32.24.65a8.66,8.66,0,0,0,1.16,1.2,1.75,1.75,0,0,1,.46,1.8l.16.09a2.07,2.07,0,0,1,.79,1.67V422.6c0,.67-.35,1-.79.76l-.16-.1c.26.86,0,1.35-.46,1.27s-.86-.25-1.16-.14-.13.44-.24.37,0-.32-.24-.65a7.74,7.74,0,0,0-1.17-1.2,1.74,1.74,0,0,1-.45-1.8l-.17-.09a2.1,2.1,0,0,1-.79-1.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.11,392.8c0-2,1.31-4,3.94-5.49,5.26-3,13.77-3,19,0,2.63,1.51,3.94,3.5,3.94,5.49v1.7c0,2-1.31,4-3.94,5.5-5.26,3-13.77,3-19,0-2.63-1.52-3.94-3.51-3.94-5.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.11,392.8v1.7c0,2,1.31,4,3.94,5.49,5.25,3,13.77,3,19,0,2.63-1.51,3.94-3.5,3.94-5.49v-1.7c0,2-1.31,4-3.94,5.49-5.26,3-13.78,3-19,0C397.42,396.77,396.11,394.78,396.11,392.8Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-59",
    d: "M419.08,387.31c2.63,1.51,3.94,3.5,3.94,5.49s-1.31,4-3.94,5.49c-5.26,3-13.77,3-19,0-2.63-1.51-3.94-3.5-3.94-5.49s1.31-4,3.94-5.49C405.31,384.27,413.82,384.27,419.08,387.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.58 397.16 413.67 388.04 409.56 377.72 405.46 388.04 404.55 397.16 414.58 397.16",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.58 397.16 413.67 388.04 409.56 377.72 405.46 388.04 404.55 397.16 414.58 397.16",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.02 392.82 400.49 384.97 409.56 377.72 405.46 388.04 404.55 397.16 397.02 392.82",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.1 392.82 418.64 384.97 409.56 377.72 413.67 388.04 414.58 397.16 422.1 392.82",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.1 392.82 418.64 384.97 409.56 377.72 413.67 388.04 414.58 397.16 422.1 392.82",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.64 384.97 413.67 388.04 405.46 388.04 400.49 384.97 409.56 377.72 418.64 384.97",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.22 384.19 417.3 381.25 412.22 378.32 406.91 378.32 401.82 381.25 406.91 384.19 412.22 384.19",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.22 384.19 417.3 381.25 412.22 378.32 406.91 378.32 401.82 381.25 406.91 384.19 412.22 384.19",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.46 383.57 418.03 380.36 412.46 377.15 406.66 377.15 401.1 380.36 406.66 383.57 412.46 383.57",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.46 383.57 418.03 380.36 412.46 377.15 406.66 377.15 401.1 380.36 406.66 383.57 412.46 383.57",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.9 378.06 412.22 378.06 416.21 380.36 412.22 382.66 406.9 382.66 402.92 380.36 406.9 378.06",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.22 382.66 411.74 378.45 409.56 373.76 407.39 378.45 406.9 382.66 412.22 382.66",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.22 382.66 411.74 378.45 409.56 373.76 407.39 378.45 406.9 382.66 412.22 382.66",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.92 380.36 404.75 376.82 409.56 373.76 407.39 378.45 406.9 382.66 402.92 380.36",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.21 380.36 414.37 376.82 409.56 373.76 411.74 378.45 412.22 382.66 416.21 380.36",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.21 380.36 414.37 376.82 409.56 373.76 411.74 378.45 412.22 382.66 416.21 380.36",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.82,381.25a1.12,1.12,0,0,0-.72-.89l5.56,3.21a1.07,1.07,0,0,1,.25.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.3,381.25a1.13,1.13,0,0,1,.73-.89l-5.57,3.21a1,1,0,0,0-.24.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.3,381.25a1.13,1.13,0,0,1,.73-.89l-5.57,3.21a1,1,0,0,0-.24.62Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.37 376.82 411.74 378.45 407.39 378.45 404.75 376.82 402.92 380.36 406.9 382.66 412.22 382.66 416.21 380.36 414.37 376.82",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.58,372.81a2,2,0,1,0,2-2A2,2,0,0,0,407.58,372.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.65,373.9a1.78,1.78,0,0,0,1.29-2.51,2,2,0,1,1-3.35,1.54A1.66,1.66,0,0,0,409.65,373.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.07,372a.24.24,0,0,1,.3,0,1.09,1.09,0,0,1,.38.49c.11.3.35.86,0,1.09s-.63,0-.78-.28a1.14,1.14,0,0,1-.14-.87A.67.67,0,0,1,408.07,372Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,370.15a1.37,1.37,0,1,0,1.36-1.36A1.36,1.36,0,0,0,408.2,370.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.62,370.9a1.23,1.23,0,0,0,.89-1.73,1.36,1.36,0,1,1-2.31,1.06A1.16,1.16,0,0,0,409.62,370.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.53,369.56a.18.18,0,0,1,.21,0,.67.67,0,0,1,.26.34c.08.21.25.6,0,.76s-.43,0-.53-.2a.81.81,0,0,1-.1-.6A.49.49,0,0,1,408.53,369.56Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/night.69d05e37df42ba5532d00440cd391e1a.svg";